var _videos = [
  {
    code: "1",
    name: "古诗词鉴赏《约客》",
    grade: "三年级",
    subject: "语文",
    tcode: "1",
    teacher: "卜哲媛",
    tags: "科班出身|阅读理解控|有亲和力",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=1",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/c899a65c5285890792407887806/v.f30.mp4"
  },
  {
    code: "2",
    name: "亿有多大",
    grade: "四年级",
    subject: "数学",
    tcode: "2",
    teacher: "戴朋",
    tags: "8年教龄 | 逻辑清晰 | 善于引导",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=2",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/be4bd1d65285890792258396270/v.f30.mp4"
  },
  {
    code: "3",
    name: "亿有多大",
    grade: "五年级",
    subject: "数学",
    tcode: "3",
    teacher: "戴朋",
    tags: "8年教龄 | 逻辑清晰 | 善于引导",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=3",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/be4bd1d65285890792258396270/v.f30.mp4"
  },
  {
    code: "4",
    name: "论高效记忆可数名词复数变化的方法",
    grade: "六年级",
    subject: "英语",
    tcode: "4",
    teacher: "Olivia",
    tags: "小学霸主 | 授之以渔 | 英文歌能手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=4",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/6c0776b45285890792613952347/v.f30.mp4"
  },
  {
    code: "5",
    name: "成语常考点精讲",
    grade: "五年级",
    subject: "语文",
    tcode: "5",
    teacher: "崔明杰",
    tags: "6年教龄|4年教研|解题达人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=5",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/9cf6d3765285890793278462840/v.f30.mp4"
  },
  {
    code: "6",
    name: "英语试题课",
    grade: "四年级",
    subject: "英语",
    tcode: "6",
    teacher: "王奕奕",
    tags: "8年教学|英式发音|趣味教学",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=6",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e17f27145285890792737486005/v.f30.mp4"
  },
  {
    code: "7",
    name: "Phonics拼读大挑战",
    grade: "五年级",
    subject: "英语",
    tcode: "7",
    teacher: "王奕奕",
    tags: "8年教学|英式发音|趣味教学",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=7",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/89b74a925285890792247591037/v.f30.mp4"
  },
  {
    code: "8",
    name: "语文试听课",
    grade: "五年级",
    subject: "语文",
    tcode: "8",
    teacher: "李燕军",
    tags: "中文专业硕士|五年辅导经验|御姐老师",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=8",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/32f9ab5c5285890790134298869/v.f30.mp4"
  },
  {
    code: "9",
    name: "小学五年级语文试听课",
    grade: "五年级",
    subject: "语文",
    tcode: "9",
    teacher: "史逸华",
    tags: "985中哲硕士|国学达人|汉字爱好者",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=9",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/fd3865c25285890789386706765/v.f30.mp4"
  },
  {
    code: "10",
    name: "一分钟构思一篇精彩作文",
    grade: "五年级",
    subject: "语文",
    tcode: "17",
    teacher: "郭昊晨",
    tags: "高考作文满分|酷爱读书",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=10",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/349ad6f55285890789702517490/v.f30.mp4"
  },
  {
    code: "11",
    name: "试听课：循环小数",
    grade: "五年级",
    subject: "数学",
    tcode: "10",
    teacher: "耿云喆",
    tags: "小学升学专家|全能学霸|学习规划师",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=11",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/00ed2a985285890791269919306/v.f30.mp4"
  },
  {
    code: "12",
    name: "试听课：分数的乘法",
    grade: "六年级",
    subject: "数学",
    tcode: "11",
    teacher: "耿云喆",
    tags: "小学升学专家|全能学霸|学习规划师",
    version: "不分版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=12",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ff27a13f5285890791269897065/v.f30.mp4"
  },
  {
    code: "13",
    name: "亿有多大",
    grade: "四年级",
    subject: "数学",
    tcode: "12",
    teacher: "王春玮",
    tags: "高效教学|兴趣培养|移动表情包",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=13",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/11dc90935285890789050916705/v.f30.mp4"
  },
  {
    code: "14",
    name: "亿有多大",
    grade: "五年级",
    subject: "数学",
    tcode: "13",
    teacher: "王春玮",
    tags: "高效教学|兴趣培养|移动表情包",
    version: "北师",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=14",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/11dc90935285890789050916705/v.f30.mp4"
  },
  {
    code: "15",
    name: "写作是个什么样？",
    grade: "三年级",
    subject: "语文",
    tcode: "14",
    teacher: "任小叶",
    tags: "教育世家|作文满分|文娱小达人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=15",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/324d2d7c5285890788095394409/v.f30.mp4"
  },
  {
    code: "16",
    name: "青蛙和大雁",
    grade: "四年级",
    subject: "语文",
    tcode: "15",
    teacher: "于双",
    tags: "破题小能手|思维风暴|兴趣激发师",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=16",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/68f433b55285890788248506632/v.f30.mp4"
  },
  {
    code: "17",
    name: "试听课",
    grade: "四年级",
    subject: "语文",
    tcode: "16",
    teacher: "郭昊晨",
    tags: "高考作文满分|酷爱读书",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=17",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/e9ff671d5285890788094598135/v.f30.mp4"
  },
  {
    code: "18",
    name: "阅读课：草木有节",
    grade: "六年级",
    subject: "语文",
    tcode: "18",
    teacher: "车英琦",
    tags: "高考131分|双学位在手|文学发烧友",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=18",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/6284f11b5285890788248285607/v.f30.mp4"
  },
  {
    code: "19",
    name: "圆的认识（北师版）",
    grade: "六年级",
    subject: "数学",
    tcode: "19",
    teacher: "徐佳超",
    tags: "提分小能手|循循善诱|温暖阳光",
    version: "北师",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=19",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/85fd76bd5285890788096652754/v.f30.mp4"
  },
  {
    code: "20",
    name: "圆的认识（人教版）",
    grade: "六年级",
    subject: "数学",
    tcode: "19",
    teacher: "徐佳超",
    tags: "提分小能手|循循善诱|温暖阳光",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=20",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/85fd76bd5285890788096652754/v.f30.mp4"
  },
  {
    code: "21",
    name: "英语试听课",
    grade: "四年级",
    subject: "英语",
    tcode: "20",
    teacher: "Jane",
    tags: "4年教龄|兴趣教学|课堂活泼",
    version: "不分版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=21",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/91c4b5d85285890787527080486/v.f30.mp4"
  },
  {
    code: "22",
    name: "英语试听课",
    grade: "四年级",
    subject: "英语",
    tcode: "21",
    teacher: "Lisa",
    tags: "十年教龄|人气孩子王|语法剪刀手",
    version: "不分版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=22",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/938d6c505285890787527108072/v.f30.mp4"
  },
  {
    code: "24",
    name: "排队问题",
    grade: "三年级",
    subject: "数学",
    tcode: "23",
    teacher: "赵一一",
    tags: "课堂生动|寓教于乐|偶像实力派",
    version: "不分版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=24",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/0dc32cb55285890793052486447/v.f30.mp4"
  },
  {
    code: "25",
    name: "这数究竟有多大",
    grade: "四年级",
    subject: "数学",
    tcode: "24",
    teacher: "赵一一",
    tags: "课堂生动|寓教于乐|偶像实力派",
    version: "不分版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=25",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/69509a335285890785910951822/v.f30.mp4"
  },
  {
    code: "26",
    name: "这数究竟有多大",
    grade: "四年级",
    subject: "数学",
    tcode: "24",
    teacher: "赵一一",
    tags: "课堂生动|寓教于乐|偶像实力派",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=26",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a34af2965285890785911108947/v.f30.mp4"
  },
  {
    code: "27",
    name: "亿有多大（人教版）",
    grade: "四年级",
    subject: "数学",
    tcode: "26",
    teacher: "申奇",
    tags: "9年教龄|形象生动|清晰易懂",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=27",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a5bfcae55285890785911220206/v.f30.mp4"
  },
  {
    code: "28",
    name: "亿有多大（北师版）",
    grade: "四年级",
    subject: "数学",
    tcode: "26",
    teacher: "申奇",
    tags: "9年教龄|形象生动|清晰易懂",
    version: "北师",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=28",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a84fbaba5285890785911358890/v.f30.mp4"
  },
  {
    code: "29",
    name: "咦？前前后后有几人？排队问题",
    grade: "三年级",
    subject: "数学",
    tcode: "25",
    teacher: "申奇",
    tags: "9年教龄|形象生动|清晰易懂",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=29",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/da22b8235285890791221321490/v.f30.mp4"
  },
  {
    code: "30",
    name: "穿衣戴帽来计算--基准数法巧算",
    grade: "四年级",
    subject: "数学",
    tcode: "27",
    teacher: "谢小紫",
    tags: "逻辑超强|小学顶级名师|兴趣激发师",
    version: "不分版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=30",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/06d5e3c75285890785858678528/v.f30.mp4"
  },
  {
    code: "31",
    name: "例题讲解",
    grade: "五年级",
    subject: "数学",
    tcode: "28",
    teacher: "谢小紫",
    tags: "逻辑超强|小学顶级名师|兴趣激发师",
    version: "北师",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=31",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/4f6876395285890781530259599/v.f30.mp4"
  },
  {
    code: "32",
    name: "分数",
    grade: "五年级",
    subject: "数学",
    tcode: "28",
    teacher: "谢小紫",
    tags: "逻辑超强|小学顶级名师|兴趣激发师",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=32",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/779569d95285890785870680833/v.f30.mp4"
  },
  {
    code: "33",
    name: "圆的认识",
    grade: "六年级",
    subject: "数学",
    tcode: "29",
    teacher: "冯毅辰",
    tags: "小升初精讲名师|幽默风趣|押题准",
    version: "北师",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=33",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/af6ef4ed5285890785911670520/v.f30.mp4"
  },
  {
    code: "34",
    name: "分数乘法",
    grade: "六年级",
    subject: "数学",
    tcode: "29",
    teacher: "冯毅辰",
    tags: "小升初精讲名师|幽默风趣|押题准",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=34",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/b1d757135285890785911782702/v.f30.mp4"
  },
  {
    code: "35",
    name: "初中必备现代文阅读体裁",
    grade: "初一",
    subject: "语文",
    tcode: "74",
    teacher: "许蓁",
    tags: "考点雷达|提升成绩|国学达人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=35",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/1347f5585285890794996613233/v.f30.mp4"
  },
  {
    code: "41",
    name: "有理数的定义与分类",
    grade: "初一",
    subject: "数学",
    tcode: "78",
    teacher: "张佳镁",
    tags: "北大学神|中考状元名师|懂学生爱学生",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=41",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/d6cff67d5285890792391971397/v.f30.mp4"
  },
  {
    code: "42",
    name: "三角形",
    grade: "初二",
    subject: "数学",
    tcode: "79",
    teacher: "张佳镁",
    tags: "北大学神|中考状元名师|懂学生爱学生",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=42",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/d6e67d9e5285890792391989605/v.f30.mp4"
  },
  {
    code: "43",
    name: "二次函数的解析式与图像变换",
    grade: "初三",
    subject: "数学",
    tcode: "80",
    teacher: "张佳镁",
    tags: "北大学神|中考状元名师|懂学生爱学生",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=43",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/9cfa9de35285890793278469585/v.f30.mp4"
  },
  {
    code: "44",
    name: "有理数的基本概念",
    grade: "初一",
    subject: "数学",
    tcode: "35",
    teacher: "陈超",
    tags: "中考提分能手|总结型名师|风趣幽默",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=44",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/d6d2aad85285890792391976117/v.f30.mp4"
  },
  {
    code: "45",
    name: "有理数的定义（北师版）",
    grade: "初一",
    subject: "数学",
    tcode: "48",
    teacher: "黄其若",
    tags: "数学名师|高分制造者|萌贱大哥哥",
    version: "北师版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=45",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b9a6b1575285890793387809412/v.f30.mp4"
  },
  {
    code: "46",
    name: "位置与坐标同步（北师版）",
    grade: "初二",
    subject: "数学",
    tcode: "49",
    teacher: "黄其若",
    tags: "数学名师|高分制造者|萌贱大哥哥",
    version: "北师版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=46",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b9ebd67c5285890793387843761/v.f30.mp4"
  },
  {
    code: "47",
    name: "二次函数的图像和性质（北师版）",
    grade: "初三",
    subject: "数学",
    tcode: "50",
    teacher: "黄其若",
    tags: "数学名师|高分制造者|萌贱大哥哥",
    version: "北师版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=47",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ba11a3a15285890793387866527/v.f30.mp4"
  },
  {
    code: "48",
    name: "有理数的必考概念（人教版）",
    grade: "初一",
    subject: "数学",
    tcode: "38",
    teacher: "高明东",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=48",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b9ef252c5285890793387849879/v.f30.mp4"
  },
  {
    code: "49",
    name: "有理数的必考概念（苏科版）",
    grade: "初一",
    subject: "数学",
    tcode: "38",
    teacher: "高明东",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    version: "苏科版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=49",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b9ef252c5285890793387849879/v.f30.mp4"
  },
  {
    code: "50",
    name: "一元二次方程初步",
    grade: "初三",
    subject: "数学",
    tcode: "40",
    teacher: "高明东",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=50",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/c03163745285890794108883136/v.f30.mp4"
  },
  {
    code: "51",
    name: "二次函数的定义",
    grade: "初三",
    subject: "数学",
    tcode: "36",
    teacher: "陈超",
    tags: "中考提分能手|总结型名师|风趣幽默",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=51",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/c96fdacb5285890788589756477/v.f30.mp4"
  },
  {
    code: "52",
    name: "二次函数的图像和性质",
    grade: "初三",
    subject: "数学",
    tcode: "50",
    teacher: "黄其若",
    tags: "数学名师|高分制造者|萌贱大哥哥",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=52",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/f4f0c9165285890785827656006/v.f30.mp4"
  },
  {
    code: "53",
    name: "白气不是气你敢信？——物态变化  物理试听课",
    grade: "初二",
    subject: "物理",
    tcode: "53",
    teacher: "李路宁",
    tags: "化繁为简|举例小能手|温柔小姐姐",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=53",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/3f16328b5285890791205757321/v.f30.mp4"
  },
  {
    code: "54",
    name: "声现象",
    grade: "初二",
    subject: "物理",
    tcode: "54",
    teacher: "李宁",
    tags: "提分达人|985硕士|套路大咖",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=54",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/cb4a88d55285890791034616679/v.f30.mp4"
  },
  {
    code: "55",
    name: "声音的产生与传播",
    grade: "初二",
    subject: "物理",
    tcode: "76",
    teacher: "于斐",
    tags: "命题克星|奖学金收割机|亲和力UP",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=55",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b811dc645285890790869952748/v.f30.mp4"
  },
  {
    code: "56",
    name: "正负数（人教版）",
    grade: "初一",
    subject: "数学",
    tcode: "75",
    teacher: "轩冉",
    tags: "南开学霸|精算背景|宁夏支教",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=56",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/f73777355285890788590308047/v.f30.mp4"
  },
  {
    code: "57",
    name: "正负数（浙教版）",
    grade: "初一",
    subject: "数学",
    tcode: "75",
    teacher: "轩冉",
    tags: "南开学霸|精算背景|宁夏支教",
    version: "浙教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=57",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/f4e043da5285890788590204984/v.f30.mp4"
  },
  {
    code: "58",
    name: "有理数的必考概念（一）（人教版）",
    grade: "初一",
    subject: "数学",
    tcode: "51",
    teacher: "纪晓斐",
    tags: "统计学硕士|教研员|逻辑超强",
    version: "人教",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=58",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/c9b7b0aa5285890788589795491/v.f30.mp4"
  },
  {
    code: "59",
    name: "有理数的必考概念（一）（北师版）",
    grade: "初一",
    subject: "数学",
    tcode: "51",
    teacher: "纪晓斐",
    tags: "统计学硕士|教研员|逻辑超强",
    version: "北师",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=59",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/cb6753855285890788589800949/v.f30.mp4"
  },
  {
    code: "60",
    name: "i提分英语体系",
    grade: "初一",
    subject: "英语",
    tcode: "57",
    teacher: "刘浩哲",
    tags: "高考英语142|可严可甜|英语心理学",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=60",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/ce08282d5285890788589946928/v.f30.mp4"
  },
  {
    code: "61",
    name: "认识丰富的物态变化",
    grade: "初二",
    subject: "物理",
    tcode: "53",
    teacher: "李路宁",
    tags: "化繁为简|举例小能手|温柔小姐姐",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=61",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/cbd8ce155285890788589869797/v.f30.mp4"
  },
  {
    code: "62",
    name: "新初一班课试听课",
    grade: "初一",
    subject: "英语",
    tcode: "61",
    teacher: "路露",
    tags: "中考状元名师|功底大咖|雅思8.5",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=62",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/caca14be5285890788270739836/v.f30.mp4"
  },
  {
    code: "63",
    name: "新初一暑假英语满分班 英语试听课",
    grade: "初一",
    subject: "英语",
    tcode: "85",
    teacher: "赵静",
    tags: "口语达人|功底女侠|电动小马达",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=63",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/02ed10585285890788091579224/v.f30.mp4"
  },
  {
    code: "64",
    name: "声现象",
    grade: "初二",
    subject: "物理",
    tcode: "82",
    teacher: "张雪峰",
    tags: "4年教龄|江湖派教师|提分能手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=64",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/324b9e5d5285890788095391962/v.f30.mp4"
  },
  {
    code: "65",
    name: "阅读成长类（写作）",
    grade: "初一",
    subject: "语文",
    tcode: "84",
    teacher: "张殷然",
    tags: "作文状元|高分输送|解题实力派",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=65",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/b43312a25285890788076916695/v.f30.mp4"
  },
  {
    code: "66",
    name: "金属的物理、化学性质",
    grade: "初三",
    subject: "化学",
    tcode: "81",
    teacher: "张宁杰",
    tags: "交心好朋友|填坑小能手|中考化学满分",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=66",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/f75323715285890788091085009/v.f30.mp4"
  },
  {
    code: "67",
    name: "文言文专题",
    grade: "初一",
    subject: "语文",
    tcode: "68",
    teacher: "王迪",
    tags: "试题终结者|专克命题人|逗比王",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=67",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/85ee8f815285890788096648195/v.f30.mp4"
  },
  {
    code: "68",
    name: "分子动理论",
    grade: "初三",
    subject: "物理",
    tcode: "59",
    teacher: "刘京林",
    tags: "满分教练|物理科班出身|",
    version: "苏教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=68",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/0a0f281f5285890787525824669/v.f30.mp4"
  },
  {
    code: "69",
    name: "几何中的计算证明",
    grade: "初三",
    subject: "数学",
    tcode: "77",
    teacher: "占航",
    tags: "黄冈骨干教师|实力派|中考权威代表",
    version: "实验班",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=69",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/414584cc5285890791205834308/v.f30.mp4"
  },
  {
    code: "70",
    name: "轴对称初步",
    grade: "初二",
    subject: "数学",
    tcode: "60",
    teacher: "刘治华",
    tags: "7年教龄|挖坑小能手|福利大礼包",
    version: "实验班",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=70",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/54ea27905285890787034225727/v.f30.mp4"
  },
  {
    code: "71",
    name: "有理数混合运算与巧算",
    grade: "初一",
    subject: "数学",
    tcode: "43",
    teacher: "韩欢欢",
    tags: "资深教研|13年教龄|提分诸葛",
    version: "浙教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=71",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a76fe5765285890787517128716/v.f30.mp4"
  },
  {
    code: "72",
    name: "电荷与电路",
    grade: "初三",
    subject: "物理",
    tcode: "83",
    teacher: "张雪峰",
    tags: "4年教龄|江湖派教师|提分能手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=72",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/ca7be5ee5285890787521323851/v.f30.mp4"
  },
  {
    code: "73",
    name: "固体压强专项强化",
    grade: "初二",
    subject: "物理",
    tcode: "82",
    teacher: "张雪峰",
    tags: "4年教龄|江湖派教师|提分能手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=73",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/cad4bf2f5285890787521370922/v.f30.mp4"
  },
  {
    code: "74",
    name: "新初一暑假满分班试听课",
    grade: "初一",
    subject: "英语",
    tcode: "61",
    teacher: "路露",
    tags: "中考状元名师|功底大咖|雅思8.5",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=74",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/4d60a6495285890787801263032/v.f30.mp4"
  },
  {
    code: "75",
    name: "物质的除杂专题",
    grade: "初三",
    subject: "化学",
    tcode: "65",
    teacher: "任晓",
    tags: "10年教龄|8年毕业班|中高考提分王",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=75",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/41a2be5e5285890791205889397/v.f30.mp4"
  },
  {
    code: "76",
    name: "二次函数的图像和性质",
    grade: "初三",
    subject: "数学",
    tcode: "77",
    teacher: "占航",
    tags: "黄冈骨干教师|实力派|中考权威代表",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=76",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/418cdf0a5285890791205872700/v.f30.mp4"
  },
  {
    code: "77",
    name: "音标",
    grade: "初一",
    subject: "英语",
    tcode: "55",
    teacher: "刘菲菲",
    tags: "专业八级|语法女王|大招输送",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=77",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/4389aa105285890791205926256/v.f30.mp4"
  },
  {
    code: "78",
    name: "记叙文概论与精讲",
    grade: "初一",
    subject: "语文",
    tcode: "64",
    teacher: "马秀英",
    tags: "北大女神|模考省状元|负责提分",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=78",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/43c11d755285890791205958661/v.f30.mp4"
  },
  {
    code: "79",
    name: "《含泪奔跑的少年》阅读",
    grade: "初一",
    subject: "语文",
    tcode: "66",
    teacher: "滕飞",
    tags: "应试能手|7年教龄|高分制造者",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=79",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/e2fbc4d75285890786742938007/v.f30.mp4"
  },
  {
    code: "80",
    name: "写好开头 先声夺人",
    grade: "初三",
    subject: "语文",
    tcode: "37",
    teacher: "程子豪",
    tags: "人大才子|公考状元|提分担当",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=80",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/1fe94d625285890786743276796/v.f30.mp4"
  },
  {
    code: "81",
    name: "我们周围的空气",
    grade: "初三",
    subject: "化学",
    tcode: "42",
    teacher: "哈旭然",
    tags: "挖坑小能手|中考化学满分|押题王",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=81",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/7dda9d415285890791206126131/v.f30.mp4"
  },
  {
    code: "82",
    name: "我们周围的空气",
    grade: "初三",
    subject: "化学",
    tcode: "42",
    teacher: "哈旭然",
    tags: "挖坑小能手|中考化学满分|押题王",
    version: "沪教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=82",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/7dda9d415285890791206126131/v.f30.mp4"
  },
  {
    code: "83",
    name: "新初一暑假英语满分班 英语试听课",
    grade: "初一",
    subject: "英语",
    tcode: "33",
    teacher: "柴惠美",
    tags: "10年教龄|专业八级|抖包袱达人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=83",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/7d64c9725285890786513710387/v.f30.mp4"
  },
  {
    code: "84",
    name: "有理数的必考概念（一）",
    grade: "初一",
    subject: "数学",
    tcode: "38",
    teacher: "高明东",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    version: "苏科版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=84",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a5c5b3a45285890785826576794/v.f30.mp4"
  },
  {
    code: "85",
    name: "小升初-这样学语文就对了",
    grade: "初一",
    subject: "语文",
    tcode: "41",
    teacher: "高岩",
    tags: "14年教龄|省重点名师|全方位提升",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=85",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a7f50e235285890785826653959/v.f30.mp4"
  },
  {
    code: "86",
    name: "全等三角形的认识",
    grade: "初二",
    subject: "数学",
    tcode: "39",
    teacher: "高明东",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    version: "苏科版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=86",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/648da3775285890786516747433/v.f30.mp4"
  },
  {
    code: "87",
    name: "三角形的认识",
    grade: "初二",
    subject: "数学",
    tcode: "39",
    teacher: "高明东",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=87",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/66f5827f5285890786516858870/v.f30.mp4"
  },
  {
    code: "88",
    name: "声音的产生与传播",
    grade: "初二",
    subject: "物理",
    tcode: "44",
    teacher: "赫梦",
    tags: "7年教龄|高颜值学霸|化繁为简",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=88",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/3181644f5285890785909903021/v.f30.mp4"
  },
  {
    code: "89",
    name: "声音的产生与传播",
    grade: "初二",
    subject: "物理",
    tcode: "44",
    teacher: "赫梦",
    tags: "7年教龄|高颜值学霸|化繁为简",
    version: "沪粤版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=89",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/3181644f5285890785909903021/v.f30.mp4"
  },
  {
    code: "90",
    name: "不定代词2",
    grade: "初二",
    subject: "英语",
    tcode: "46",
    teacher: "胡海燕",
    tags: "保送硕士|10年教龄|学生的活字典",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=90",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/6755cc705285890781174492362/v.f30.mp4"
  },
  {
    code: "91",
    name: "GRAMMAR",
    grade: "初二",
    subject: "英语",
    tcode: "56",
    teacher: "刘菲菲",
    tags: "专业八级|语法女王|大招输送",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=91",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/066604fc5285890786067693833/v.f30.mp4"
  },
  {
    code: "92",
    name: "光的直线传播",
    grade: "初二",
    subject: "物理",
    tcode: "58",
    teacher: "刘京林",
    tags: "满分教练|物理科班出身|",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=92",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a82bd7825285890785826684675/v.f30.mp4"
  },
  {
    code: "93",
    name: "光的直线传播",
    grade: "初二",
    subject: "物理",
    tcode: "58",
    teacher: "刘京林",
    tags: "满分教练|物理科班出身|",
    version: "苏教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=93",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/a82bd7825285890785826684675/v.f30.mp4"
  },
  {
    code: "94",
    name: "三角形的认识",
    grade: "初二",
    subject: "数学",
    tcode: "60",
    teacher: "刘治华",
    tags: "7年教龄|挖坑小能手|福利大礼包",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=94",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/aeb5b4ac5285890786161700932/v.f30.mp4"
  },
  {
    code: "95",
    name: "综合性学习图标题解题技巧",
    grade: "初二",
    subject: "语文",
    tcode: "63",
    teacher: "吕政嘉",
    tags: "名校教师|上分达人|半生少年",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=95",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/80ac48295285890791206292315/v.f30.mp4"
  },
  {
    code: "96",
    name: "Popular science and modern technology Lesson 1",
    grade: "初二",
    subject: "英语",
    tcode: "72",
    teacher: "许源欢",
    tags: "口音模仿王|精分小戏精|行走表情包",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=96",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/5d7338495285890781174017803/v.f30.mp4"
  },
  {
    code: "98",
    name: "完成性时态+完型+词汇",
    grade: "初三",
    subject: "英语",
    tcode: "34",
    teacher: "柴惠美",
    tags: "10年教龄|专业八级|抖包袱达人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=98",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/3ae9e16b5285890781890430045/v.f30.mp4"
  },
  {
    code: "99",
    name: "认识内能",
    grade: "初三",
    subject: "物理",
    tcode: "45",
    teacher: "赫梦",
    tags: "7年教龄|高颜值学霸|化繁为简",
    version: "沪粤版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=99",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/0666ffd45285890786067695121/v.f30.mp4"
  },
  {
    code: "100",
    name: "初三英语暑秋班试题课",
    grade: "初三",
    subject: "英语",
    tcode: "47",
    teacher: "胡海燕",
    tags: "保送硕士|10年教龄|学生的活字典",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=100",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/acd483a05285890785826881674/v.f30.mp4"
  },
  {
    code: "101",
    name: "从电荷走进电学世界",
    grade: "初三",
    subject: "物理",
    tcode: "62",
    teacher: "罗子忡",
    tags: "状元之师|资深教研员|高颜值",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=101",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/06d55be95285890785858677648/v.f30.mp4"
  },
  {
    code: "102",
    name: "同类审题",
    grade: "初三",
    subject: "语文",
    tcode: "67",
    teacher: "滕飞",
    tags: "应试能手|7年教龄|高分制造者",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=102",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/79c7fa3c5285890785870763564/v.f30.mp4"
  },
  {
    code: "103",
    name: "《第一讲习题课》",
    grade: "初三",
    subject: "数学",
    tcode: "71",
    teacher: "徐杰",
    tags: "行业顶级名师|培养多名状元|自称严肃",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=103",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ef7f046f5285890791204618636/v.f30.mp4"
  },
  {
    code: "104",
    name: "Popular science and modern technology Lesson 1 Grammar",
    grade: "初三",
    subject: "英语",
    tcode: "73",
    teacher: "许源欢",
    tags: "口音模仿王|精分小戏精|行走表情包",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=104",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/5d7338495285890781174017803/v.f30.mp4"
  },
  {
    code: "105",
    name: "《生活中常见的电学现象》",
    grade: "初三",
    subject: "物理",
    tcode: "86",
    teacher: "朱中彬",
    tags: "探花之师|物理满分|8年教龄",
    version: "全国版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=105",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/79b89a9b5285890785870758406/v.f30.mp4"
  },
  {
    code: "106",
    name: "议论文写作难点探究",
    grade: "高二",
    subject: "语文",
    tcode: "88",
    teacher: "高岩",
    tags: "14年教龄|省重点名师|全方位提升",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=106",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/aa28c1305285890794339122068/v.f30.mp4"
  },
  {
    code: "107",
    name: "一元二次方程",
    grade: "高一",
    subject: "数学",
    tcode: "89",
    teacher: "王硕",
    tags: "5年教龄|套路王|数学小仙女",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=107",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/aa1a18965285890794339118915/v.f30.mp4"
  },
  {
    code: "108",
    name: "空间中垂直证明",
    grade: "高二",
    subject: "数学",
    tcode: "90",
    teacher: "王硕",
    tags: "5年教龄|套路王|数学小仙女",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=108",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/aa1597ec5285890794339110229/v.f30.mp4"
  },
  {
    code: "109",
    name: "升级打怪攻克氧化还原反应",
    grade: "高一",
    subject: "化学",
    tcode: "91",
    teacher: "赵文彬",
    tags: "名校特约讲师|提分全能王|经验丰富",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=109",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/6cf5beae5285890794077500760/v.f30.mp4"
  },
  {
    code: "110",
    name: "记忆宫殿攻克“有效碰撞”",
    grade: "高二",
    subject: "化学",
    tcode: "92",
    teacher: "赵文彬",
    tags: "名校特约讲师|提分全能王|经验丰富",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=110",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/bdb926f35285890794108765244/v.f30.mp4"
  },
  {
    code: "111",
    name: "四字天书搞定“系统命名”",
    grade: "高二",
    subject: "化学",
    tcode: "92",
    teacher: "赵文彬",
    tags: "名校特约讲师|提分全能王|经验丰富",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=111",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/bd82f77d5285890794108735887/v.f30.mp4"
  },
  {
    code: "112",
    name: "秒杀分段函数两大难点",
    grade: "高一",
    subject: "数学",
    tcode: "93",
    teacher: "刘云鹏",
    tags: "6年教龄|押题小能手|东北段子手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=112",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ba21763d5285890793387872094/v.f30.mp4"
  },
  {
    code: "113",
    name: "解不等式",
    grade: "高一",
    subject: "数学",
    tcode: "94",
    teacher: "代宇",
    tags: "提分小能手|邻家小姐姐|985硕士",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=113",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/8a8255305285890791349154407/v.f30.mp4"
  },
  {
    code: "114",
    name: "函数概念",
    grade: "高一",
    subject: "数学",
    tcode: "95",
    teacher: "王漫谦",
    tags: "北京大学|严厉而慈爱",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=114",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/22fa7f335285890791341197636/v.f30.mp4"
  },
  {
    code: "115",
    name: "十个易混淆手法",
    grade: "高二",
    subject: "语文",
    tcode: "97",
    teacher: "杨红子",
    tags: "北师大本硕|5年教龄|语文解题达人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=115",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/6245ba3c5285890792409847754/v.f30.mp4"
  },
  {
    code: "116",
    name: "描述运动的基本物理量",
    grade: "高一",
    subject: "物理",
    tcode: "99",
    teacher: "徐浪",
    tags: "部属师范|话痨90后|物理逆袭",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=116",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b7daf9325285890790869921401/v.f30.mp4"
  },
  {
    code: "117",
    name: "描述运动的基本物理量",
    grade: "高一",
    subject: "物理",
    tcode: "100",
    teacher: "赵丽华",
    tags: "4年教龄|勤于总结|资深吃货",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=117",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b7b743b55285890790869902018/v.f30.mp4"
  },
  {
    code: "118",
    name: "高中语文学习你需要知道的事",
    grade: "高一",
    subject: "语文",
    tcode: "87",
    teacher: "高岩",
    tags: "14年教龄|省重点名师|全方位提升",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=118",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/97b763c45285890789670374698/v.f30.mp4"
  },
  {
    code: "119",
    name: "从古至今的“相互作用”",
    grade: "高一",
    subject: "物理",
    tcode: "101",
    teacher: "傅磊",
    tags: "邻家大哥哥|物理科代表|高考物理教研",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=119",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/0e67ffba5285890789413469454/v.f30.mp4"
  },
  {
    code: "120",
    name: "电荷间的相互作用",
    grade: "高二",
    subject: "物理",
    tcode: "102",
    teacher: "傅磊",
    tags: "邻家大哥哥|物理科代表|高考物理教研",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=120",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/f2a4dc915285890789416315317/v.f30.mp4"
  },
  {
    code: "121",
    name: "描述运动的基本物理量",
    grade: "高一",
    subject: "物理",
    tcode: "100",
    teacher: "赵丽华",
    tags: "4年教龄|勤于总结|资深吃货",
    version: "必修一（人教版）",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=121",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/fec3ef375285890788590681423/v.f30.mp4"
  },
  {
    code: "122",
    name: "一元二次不等式精讲",
    grade: "高一",
    subject: "数学",
    tcode: "132",
    teacher: "张志君",
    tags: "幽默风趣|模板总结王|5年教学经验",
    version: "必修1+4（课改/非课改）",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=122",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/4b30bb605285890788591607676/v.f30.mp4"
  },
  {
    code: "123",
    name: "描述运动的基本物理量",
    grade: "高一",
    subject: "物理",
    tcode: "103",
    teacher: "李烨",
    tags: "高考物理满分|提分帮主|高考押题王",
    version: "必修一",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=123",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/0534e4245285890788590905788/v.f30.mp4"
  },
  {
    code: "124",
    name: "集合",
    grade: "高一",
    subject: "数学",
    tcode: "105",
    teacher: "吴遇琬",
    tags: "科班出身|竞赛经验|套路杀手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=124",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/2d227fd55285890788095121189/v.f30.mp4"
  },
  {
    code: "125",
    name: "蛋白质的乐谱",
    grade: "高一",
    subject: "生物",
    tcode: "106",
    teacher: "戴炜",
    tags: "13年教龄|名校教师|学生保送北大",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=125",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/56fe07915285890791267267710/v.f30.mp4"
  },
  {
    code: "126",
    name: "英语试听课",
    grade: "高一",
    subject: "英语",
    tcode: "107",
    teacher: "黄令群",
    tags: "全能多面手|行走语法书|奇迹缔造者",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=126",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/01c79e415285890787749920684/v.f30.mp4"
  },
  {
    code: "127",
    name: "试听课（诗歌篇）",
    grade: "高一",
    subject: "语文",
    tcode: "108",
    teacher: "齐霁",
    tags: "9年教龄|提分能手|满分作文名师",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=127",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/0247617f5285890787749992601/v.f30.mp4"
  },
  {
    code: "128",
    name: "陌生方程式的书写",
    grade: "高三",
    subject: "化学",
    tcode: "111",
    teacher: "高兰",
    tags: "11年教龄|高考百事通|学科负责人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=128",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/6b352f225285890787516886376/v.f30.mp4"
  },
  {
    code: "129",
    name: "动量与冲量",
    grade: "高二",
    subject: "物理",
    tcode: "112",
    teacher: "孔力",
    tags: "物理领路人|985院校|偶像实力派",
    version: "非课改",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=129",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/57a714ce5285890786129123472/v.f30.mp4"
  },
  {
    code: "130",
    name: "英语试听课",
    grade: "高一",
    subject: "英语",
    tcode: "113",
    teacher: "孙岩",
    tags: "20年教龄|无敌英语|岩出必胜",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=130",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/6d5519555285890787516958003/v.f30.mp4"
  },
  {
    code: "131",
    name: "英语试听课",
    grade: "高二",
    subject: "英语",
    tcode: "114",
    teacher: "孙岩",
    tags: "20年教龄|无敌英语|岩出必胜",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=131",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/6d5519555285890787516958003/v.f30.mp4"
  },
  {
    code: "132",
    name: "诗歌鉴赏的炼字和炼句",
    grade: "高一",
    subject: "语文",
    tcode: "115",
    teacher: "许俊",
    tags: "30年教龄|寓教于乐|发表小说",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=132",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/abf601725285890787517308613/v.f30.mp4"
  },
  {
    code: "133",
    name: "经济生活",
    grade: "高一",
    subject: "政治",
    tcode: "116",
    teacher: "刘锟",
    tags: "高考阅卷经验|8年教龄|高考提分专家",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=133",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/b590d8945285890787517744701/v.f30.mp4"
  },
  {
    code: "134",
    name: "经济生活",
    grade: "高三",
    subject: "政治",
    tcode: "117",
    teacher: "刘锟",
    tags: "高考阅卷经验|8年教龄|高考提分专家",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=134",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/ba192fc85285890787517928897/v.f30.mp4"
  },
  {
    code: "135",
    name: "植物的向光性",
    grade: "高二",
    subject: "生物",
    tcode: "118",
    teacher: "国石",
    tags: "10年教龄|5届毕业班|提分王",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=135",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/ccae64aa5285890787521406134/v.f30.mp4"
  },
  {
    code: "137",
    name: "细胞的癌变",
    grade: "高三",
    subject: "生物",
    tcode: "119",
    teacher: "国石",
    tags: "10年教龄|5届毕业班|提分王",
    version: "人教版",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=137",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/f4e607515285890787518193510/v.f30.mp4"
  },
  {
    code: "138",
    name: "明朝内阁政治地位演变",
    grade: "高一",
    subject: "历史",
    tcode: "120",
    teacher: "王莹",
    tags: "历史女神|艺考名师|提分小能手",
    version: "不限版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=138",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/f729297e5285890787518283991/v.f30.mp4"
  },
  {
    code: "139",
    name: "老子的思想——道",
    grade: "高二",
    subject: "历史",
    tcode: "121",
    teacher: "王莹",
    tags: "历史女神|艺考名师|提分小能手",
    version: "不限版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=139",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/f96caf915285890787518374401/v.f30.mp4"
  },
  {
    code: "141",
    name: "化学反应速率新思路",
    grade: "高二",
    subject: "化学",
    tcode: "123",
    teacher: "梁旭",
    tags: "高考化学教研|解题思路清奇|奇怪有趣",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=141",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/dc531a645285890791221400259/v.f30.mp4"
  },
  {
    code: "142",
    name: "化学平衡的判定",
    grade: "高二",
    subject: "化学",
    tcode: "125",
    teacher: "向莹",
    tags: "5年教龄|活泼生动|方法独到",
    version: "化学选修四",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=142",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/dc8b16275285890791221433580/v.f30.mp4"
  },
  {
    code: "143",
    name: "原电池原理",
    grade: "高二",
    subject: "化学",
    tcode: "110",
    teacher: "高兰",
    tags: "11年教龄|高考百事通|学科负责人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=143",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/dc8d3aec5285890791221437284/v.f30.mp4"
  },
  {
    code: "144",
    name: "作文素材巧用",
    grade: "高二",
    subject: "语文",
    tcode: "126",
    teacher: "程子豪",
    tags: "人大才子|公考状元|提分担当",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=144",
    url2:
      "https://1251316161.vod2.myqcloud.com/d7645245vodtranscq1251316161/2db442b05285890786210265881/v.f30.mp4"
  },
  {
    code: "145",
    name: "电荷",
    grade: "高二",
    subject: "物理",
    tcode: "127",
    teacher: "郭韬",
    tags: "逻辑清晰|高考刷题王|全能型学霸",
    version: "课改",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=145",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/0f34ae365285890786128306856/v.f30.mp4"
  },
  {
    code: "146",
    name: "动量与冲量",
    grade: "高二",
    subject: "物理",
    tcode: "112",
    teacher: "孔力",
    tags: "物理领路人|985院校|偶像实力派",
    version: "课改",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=146",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/57a714ce5285890786129123472/v.f30.mp4"
  },
  {
    code: "147",
    name: "Vocabulary",
    grade: "高二",
    subject: "英语",
    tcode: "141",
    teacher: "高歌",
    tags: "常青藤名校|高分缔造者|时间规划狂",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=147",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/0d809b515285890786128293081/v.f30.mp4"
  },
  {
    code: "148",
    name: "词汇+语法+阅读",
    grade: "高二",
    subject: "英语",
    tcode: "129",
    teacher: "孙筱媛",
    tags: "语言学硕士|2年教龄|提分小能手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=148",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/dc8e68b55285890791221439768/v.f30.mp4"
  },
  {
    code: "149",
    name: "空间中的位置关系之垂直关系",
    grade: "高二",
    subject: "数学",
    tcode: "96",
    teacher: "王漫谦",
    tags: "北京大学|严厉而慈爱",
    version: "必修2+1-1 文/理科",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=149",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/deab1a4c5285890791221505846/v.f30.mp4"
  },
  {
    code: "150",
    name: "解三角形综合",
    grade: "高二",
    subject: "数学",
    tcode: "96",
    teacher: "王漫谦",
    tags: "北京大学|严厉而慈爱",
    version: "必修5+2-1",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=150",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/dead4b6e5285890791221509817/v.f30.mp4"
  },
  {
    code: "151",
    name: "集合重难点突破",
    grade: "高二",
    subject: "数学",
    tcode: "136",
    teacher: "吴一炯",
    tags: "竞赛一等奖|985院校|4年教龄",
    version: "必修5+2-1 理科",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=151",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/f43a3ae87447398156462511703/v.f30.mp4"
  },
  {
    code: "152",
    name: "简易逻辑初步",
    grade: "高二",
    subject: "数学",
    tcode: "136",
    teacher: "吴一炯",
    tags: "竞赛一等奖|985院校|4年教龄",
    version: "必修5+1-1 文科",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=152",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/ef0697715285890781383414295/v.f30.mp4"
  },
  {
    code: "153",
    name: "高分作文的正确打开方式-如何避开审题立意的“坑”",
    grade: "高三",
    subject: "语文",
    tcode: "109",
    teacher: "齐霁",
    tags: "9年教龄|提分能手|满分作文名师",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=153",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/367eda325285890781455330299/v.f30.mp4"
  },
  {
    code: "154",
    name: "反应热的计算与热化学方程式",
    grade: "高三",
    subject: "化学",
    tcode: "128",
    teacher: "任晓",
    tags: "10年教龄|8年毕业班|中高考提分王",
    version: "不限版本",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=154",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e11252ca5285890791221615635/v.f30.mp4"
  },
  {
    code: "155",
    name: "语法+完形填空",
    grade: "高三",
    subject: "英语",
    tcode: "130",
    teacher: "孙筱媛",
    tags: "语言学硕士|2年教龄|提分小能手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=155",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e121ad445285890791221620624/v.f30.mp4"
  },
  {
    code: "156",
    name: "万有引力定律的应用",
    grade: "高三",
    subject: "物理",
    tcode: "131",
    teacher: "李琳",
    tags: "北京大学|11年教龄|思维女神",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=156",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/06b0a34b5285890785858656788/v.f30.mp4"
  },
  {
    code: "157",
    name: "数列通项",
    grade: "高三",
    subject: "数学",
    tcode: "133",
    teacher: "张志君",
    tags: "幽默风趣|模板总结王|5年教学经验",
    version: "文科/理科",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=157",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e1a292d25285890791221694825/v.f30.mp4"
  },
  {
    code: "158",
    name: "高三英语系统班-状语从句",
    grade: "高三",
    subject: "英语",
    tcode: "135",
    teacher: "郝望月",
    tags: "提分小能手|作文押题王|高冷硬实力",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=158",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e3c1dc0a5285890791221765008/v.f30.mp4"
  },
  {
    code: "159",
    name: "导数恒成立问题之分离参数法",
    grade: "高三",
    subject: "数学",
    tcode: "137",
    teacher: "吴一炯",
    tags: "竞赛一等奖|985院校|4年教龄",
    version: "理科",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=159",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/acf2cf145285890786161683048/v.f30.mp4"
  },
  {
    code: "160",
    name: "函数奇偶性考法大总结",
    grade: "高三",
    subject: "数学",
    tcode: "139",
    teacher: "何超世",
    tags: "高分锻造能手|优雅套路王|6年教龄",
    version: "理科",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=160",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e3e69a125285890791221786058/v.f30.mp4"
  },
  {
    code: "161",
    name: "非谓语动词作状语",
    grade: "高三",
    subject: "英语",
    tcode: "140",
    teacher: "段小寒",
    tags: "翻译硕士|资深教研员|细致入微",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=161",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e3f5798d5285890791221790472/v.f30.mp4"
  },
  {
    code: "162",
    name: "传送带模型",
    grade: "高三",
    subject: "物理",
    tcode: "104",
    teacher: "李烨",
    tags: "高考物理满分|提分帮主|高考押题王",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=162",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/06b1b3a65285890785858658592/v.f30.mp4"
  },
  {
    code: "163",
    name: "Vocabulary",
    grade: "高三",
    subject: "英语",
    tcode: "142",
    teacher: "高歌",
    tags: "常青藤名校|高分缔造者|时间规划狂",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=163",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/0d809b515285890786128293081/v.f30.mp4"
  },
  {
    code: "164",
    name: "如何快速读懂一首诗",
    grade: "高三",
    subject: "语文",
    tcode: "98",
    teacher: "杨红子",
    tags: "北师大本硕|5年教龄|语文解题达人",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=164",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/06d4cf1d5285890785858676610/v.f30.mp4"
  },
  {
    code: "165",
    name: "一元二次不等式及高次不等式的解法",
    grade: "高一",
    subject: "数学",
    tcode: "138",
    teacher: "何超世",
    tags: "高分锻造能手|优雅套路王|6年教龄",
    version: "必修1+2（非课改）/必修1+4（非课改）",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=165",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/e61726ef5285890791221865822/v.f30.mp4"
  },
  {
    code: "166",
    name: "词汇+写作+阅读",
    grade: "高一",
    subject: "英语",
    tcode: "143",
    teacher: "孙雨朦",
    tags: "邻家大姐姐|港大教育学|备考小能手",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=166",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ba36c26f5285890791224042859/v.f30.mp4"
  },
  {
    code: "167",
    name: "高一英语课程体系",
    grade: "高一",
    subject: "英语",
    tcode: "134",
    teacher: "郝望月",
    tags: "提分小能手|作文押题王|高冷硬实力",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=167",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/bc8ace285285890791224140763/v.f30.mp4"
  },
  {
    code: "168",
    name: "物质的量",
    grade: "高一",
    subject: "化学",
    tcode: "122",
    teacher: "梁旭",
    tags: "高考化学教研|解题思路清奇|奇怪有趣",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=168",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/5a2f578f5285890781523922653/v.f30.mp4"
  },
  {
    code: "169",
    name: "电解质与非电解质",
    grade: "高一",
    subject: "化学",
    tcode: "124",
    teacher: "向莹",
    tags: "5年教龄|活泼生动|方法独到",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=169",
    url2:
      "https://1251316161.vod2.myqcloud.com/45af1a62vodtransgzp1251316161/342d94725285890781455237554/v.f30.mp4"
  },
  {
    code: "170",
    name: "不等式的解法",
    grade: "高一",
    subject: "数学",
    tcode: "144",
    teacher: "孙强",
    tags: "高考状元名师|11年教龄|清北制造机",
    version: "必修1+4（课改）",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=170",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/0d81cd795285890786128295672/v.f30.mp4"
  },
  {
    code: "171",
    name: "描述运动的基本物理量",
    grade: "高一",
    subject: "物理",
    tcode: "103",
    teacher: "李烨",
    tags: "高考物理满分|提分帮主|高考押题王",
    version: "必修1",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=171",
    url2:
      "https://1257805666.vod2.myqcloud.com/b0d8fa58vodtranscq1257805666/06b127435285890785858657590/v.f30.mp4"
  },
  {
    code: "172",
    name: "句子主干",
    grade: "高一",
    subject: "英语",
    tcode: "145",
    teacher: "范伟哲",
    tags: "1万课时|剑桥大学培训师|高考押题王",
    version: "",
    url:
      "https://player.bilibili.com/player.html?aid=82854973&cid=141747042&page=172",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/1023fd365285890792164990670/v.f30.mp4"
  },
  {
    code: "176",
    name: "我们都一样——平均数",
    grade: "三年级",
    subject: "数学",
    tcode: "151",
    teacher: "余卓颖",
    tags: "中考数学满分 | 孩子王 | 逻辑超强",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/58be32ed5285890795776797874/v.f30.mp4"
  },
  {
    code: "175",
    name: "农业区位因素",
    grade: "高一",
    subject: "地理",
    tcode: "149",
    teacher: "云杉",
    tags: "高考提分专家 | 13年教龄 | 严谨有实力",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/dc25e6495285890796224609200/v.f30.mp4"
  },
  {
    code: "177",
    name: "Letter Aa 带你揭秘自然拼读",
    grade: "三年级",
    subject: "英语",
    tcode: "30",
    teacher: "Ann",
    tags: "五年教龄 | 故事教学法 | 寓教于乐",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/b11e68615285890796879480247/v.f30.mp4"
  },
  {
    code: "178",
    name: "编程逻辑入门之白细胞大作战",
    grade: "三年级",
    subject: "编程",
    tcode: "152",
    teacher: "王亚茹",
    tags: "竞赛教练 | 创作引导者 | 综艺达人",
    version: "",
    url: "",
    url2:
      "http://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ff2979ad5285890796401375621/v.f30.mp4"
  },
  {
    code: "179",
    name: "让科学成为乐趣",
    grade: "三年级",
    subject: "科学",
    tcode: "153",
    teacher: "祝彩霞",
    tags: "科普发烧友 | 孩子王",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/d768710f5285890796160093183/v.f30.mp4"
  },
  {
    code: "180",
    name: "火星人俱乐部-让科学成为乐趣",
    grade: "三年级",
    subject: "科学",
    tcode: "154",
    teacher: "李萌",
    tags: "实验爱好者 | 学生的朋友 | 自黑幽默",
    version: "",
    url: "",
    url2:
      "http://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/6cc375b35285890796243864125/v.f30.mp4"
  },
  {
    code: "181",
    name: "编程逻辑入门之白细胞大作战",
    grade: "四年级",
    subject: "编程",
    tcode: "152",
    teacher: "王亚茹",
    tags: "竞赛教练 | 创作引导者 | 综艺达人",
    version: "",
    url: "",
    url2:
      "http://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ff2979ad5285890796401375621/v.f30.mp4"
  },
  {
    code: "182",
    name: "让科学成为乐趣",
    grade: "四年级",
    subject: "科学",
    tcode: "153",
    teacher: "祝彩霞",
    tags: "科普发烧友 | 孩子王",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/d768710f5285890796160093183/v.f30.mp4"
  },
  {
    code: "183",
    name: "火星人俱乐部-让科学成为乐趣",
    grade: "四年级",
    subject: "科学",
    tcode: "154",
    teacher: "李萌",
    tags: "实验爱好者 | 学生的朋友 | 自黑幽默",
    version: "",
    url: "",
    url2:
      "http://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/6cc375b35285890796243864125/v.f30.mp4"
  },
  {
    code: "184",
    name: "编程逻辑入门之白细胞大作战",
    grade: "五年级",
    subject: "编程",
    tcode: "152",
    teacher: "王亚茹",
    tags: "竞赛教练 | 创作引导者 | 综艺达人",
    version: "",
    url: "",
    url2:
      "http://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/ff2979ad5285890796401375621/v.f30.mp4"
  },
  {
    code: "185",
    name: "让科学成为乐趣",
    grade: "五年级",
    subject: "科学",
    tcode: "153",
    teacher: "祝彩霞",
    tags: "科普发烧友 | 孩子王",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/d768710f5285890796160093183/v.f30.mp4"
  },
  {
    code: "186",
    name: "火星人俱乐部-让科学成为乐趣",
    grade: "五年级",
    subject: "科学",
    tcode: "154",
    teacher: "李萌",
    tags: "实验爱好者 | 学生的朋友 | 自黑幽默",
    version: "",
    url: "",
    url2:
      "http://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/6cc375b35285890796243864125/v.f30.mp4"
  },
  {
    code: "187",
    name: "六年级语文.寒春试听课",
    grade: "六年级",
    subject: "语文",
    tcode: "155",
    teacher: "余剑勇",
    tags: "武大中文系 | 文综高分 | 古文执念狂",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/3621f0885285890795779367585/v.f30.mp4"
  },
  {
    code: "188",
    name: "颜王秘籍",
    grade: "初一",
    subject: "英语",
    tcode: "156",
    teacher: "颜君",
    tags: "海外硕士 | 10年教龄 | 颜师出高徒",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/8e8d206c5285890795977777854/v.f30.mp4"
  },
  {
    code: "189",
    name: "守恒认知",
    grade: "初三",
    subject: "化学",
    tcode: "148",
    teacher: "肖嵘",
    tags: "九年教龄 | 化学大教主 | 爱吃瓜的猹",
    version: "",
    url: "",
    url2:
      "https://1256304549.vod2.myqcloud.com/c67f29aevodtransgzp1256304549/4b76a7b65285890796436624913/v.f30.mp4"
  },
  {code: '190',name: '高一语文01 羁旅思乡诗',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=542352419&bvid=BV1di4y1E7FF&cid=240460367&page=1',url2:''},
  {code: '191',name: '高一数学02 函数三要素的华丽解法（上）',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=244787848&bvid=BV1xv411y778&cid=240460482&page=1',url2:''},
  {code: '192',name: '高一英语03 topic words单词',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=244829553&bvid=BV1tv411y7pg&cid=240458808&page=1',url2:''},
  {code: '193',name: '高一物理04 处理难搞的运动学问题',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=542273288&bvid=BV1Ji4y1E78R&cid=240461453&page=1',url2:''},
  {code: '194',name: '高一化学05 氧化还原配平',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=584852637&bvid=BV1rz4y1d7gQ&cid=240460999&page=1',url2:''},
  {code: '195',name: '高一语文06 小说中的人物形象',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=754811546&bvid=BV1pk4y1C7eU&cid=240461844&page=1',url2:''},
  {code: '196',name: '高一数学07 函数三要素的华丽解法（下）',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=969856618&bvid=BV13p4y1Y7ge&cid=240462227&page=1',url2:''},
  {code: '197',name: '高一英语08 reading阅读金三角理论',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=414785798&bvid=BV1DV41117qe&cid=240462691&page=1',url2:''},
  {code: '198',name: '高一语文09 古诗基本功--还原画面',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=202257126&bvid=BV1Nh41197QR&cid=240462870&page=1',url2:''},
  {code: '199',name: '高一数学10 分段函数的王者模型（上）',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=842276320&bvid=BV1754y1k7ak&cid=240463160&page=1',url2:''},
  {code: '200',name: '高一英语11 cloze 完形填空',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=927314536&bvid=BV1mT4y1c7rX&cid=240463317&page=1',url2:''},
  {code: '201',name: '高一物理12 速度时间图像的应用',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=329767163&bvid=BV1qA411J7yC&cid=240463614&page=1',url2:''},
  {code: '202',name: '高一化学13 离子方程式正误判断',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=797285394&bvid=BV1dy4y1k7xL&cid=240464043&page=1',url2:''},
  {code: '203',name: '高一语文14 教材经典素材积累--《鸿门宴》',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=669820195&bvid=BV1ma4y157h9&cid=240464809&page=1',url2:''},
  {code: '204',name: '高一数学15 分段函数的王者模型（下）',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=414643293&bvid=BV1qV411m7k1&cid=239610213&page=1',url2:''},
  {code: '205',name: '高三化学31 电解质溶液综合',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=372265627&bvid=BV1VZ4y157bP&cid=240372764&page=1',url2:''},
  {code: '206',name: '高三化学40 课题1. 满分选择题之“迷人的曲线 识K的艺术”',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=329857878&bvid=BV1eA41177rc&cid=240373472&page=1',url2:''},
  {code: '207',name: '高三化学41 阿伏加德罗常数专项突破',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=244872838&bvid=BV1cv411k7eo&cid=240375643&page=1',url2:''},
  {code: '208',name: '高三化学55 课题4. 满分选择题之“结构周期律”',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=457366699&bvid=BV1m5411j7Tw&cid=240376035&page=1',url2:''},
  {code: '209',name: '高三化学56 元素及化合物（1）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=244797333&bvid=BV17v411y714&cid=240376873&page=1',url2:''},
  {code: '210',name: '高三化学60 元素及化合物（2）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=287240942&bvid=BV1Uf4y1D7hR&cid=239508462&page=1',url2:''},
  {code: '211',name: '高三化学63 元素及化合物（3）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=927184393&bvid=BV1UT4y1A77n&cid=239551242&page=1',url2:''},
  {code: '212',name: '高三化学64 课题5：满分选择题之“传统文化素养”',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=457361218&bvid=BV125411j7y6&cid=240377728&page=1',url2:''},
  {code: '213',name: '高三化学67 元素及化合物（4）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=754708589&bvid=BV1pk4y117TZ&cid=239580136&page=1',url2:''},
  {code: '214',name: '高三化学68 课题6：满分选持题之“微粒变化”',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=457196427&bvid=BV1o5411L7J5&cid=239590116&page=1',url2:''},
  {code: '215',name: '高三化学71 元素及化合物（5）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=969696249&bvid=BV1pp4y1a7cZ&cid=239624216&page=1',url2:''},
  {code: '216',name: '高三化学75 元素及化合物（6）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=839706149&bvid=BV1K54y117Vn&cid=239822085&page=1',url2:''},
  {code: '217',name: '高三化学76 课题8：突破工艺流程（1）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=584646063&bvid=BV1Tz4y1Z76v&cid=239844043&page=1',url2:''},
  {code: '218',name: '高三化学79 元素及化合物（7）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=584646063&bvid=BV1Tz4y1Z76v&cid=239844043&page=1',url2:''},
  {code: '219',name: '高三化学82 化学实验专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=329776532&bvid=BV1zA411J7Za&cid=240380085&page=1',url2:''},
  {code: '220',name: '高三化学83 课题9：突破工艺流程（2）',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=712290862&bvid=BV1CD4y1R7k3&cid=240380315&page=1',url2:''},
  {code: '221',name: '高三化学86 元素周期律专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=287267428&bvid=BV1df4y1D7Lk&cid=240380682&page=1',url2:''},
  {code: '222',name: '高三化学87 课题10：氧化还原反应和离子反应',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=457290016&bvid=BV1v5411j7Zi&cid=240381069&page=1',url2:''},
  {code: '223',name: '高三化学90 图像专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=712257143&bvid=BV1hD4y1R7Up&cid=240381830&page=1',url2:''},
  {code: '224',name: '高三化学91 课题11：原理考点规范解答',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=627334702&bvid=BV1Vt4y1v7Ut&cid=240382052&page=1',url2:''},
  {code: '225',name: '高三化学94 工艺流程专题（1）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=372320484&bvid=BV1zZ4y157jo&cid=240383056&page=1',url2:''},
  {code: '226',name: '高三数学61 圆锥曲线中的离心率（一）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=669678289&bvid=BV1ea4y1j7CE&cid=239537803&page=1',url2:''},
  {code: '227',name: '高三数学65 圆锥曲线中的离心率（二）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=969681212&bvid=BV14p4y1a73k&cid=239560887&page=1',url2:''},
  {code: '228',name: '高三数学69 圆锥曲线中的取值范围问题（一）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=287158429&bvid=BV1Yf4y1D71d&cid=239600260&page=1',url2:''},
  {code: '229',name: '高三数学73 圆锥曲线中的取值范围问题（二）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=414674767&bvid=BV11V411m7Qj&cid=239628196&page=1',url2:''},
  {code: '230',name: '高三数学77 圆锥曲线中的最值问题',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=499639253&bvid=BV1XK411K7ob&cid=239834550&page=1',url2:''},
  {code: '231',name: '高三数学80 函数图象与零点问题（一）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=842339631&bvid=BV1B54y1k7rM&cid=240383994&page=1',url2:''},
  {code: '232',name: '高三数学84 函数图象与零点问题（二）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=839804167&bvid=BV1i54y117H5&cid=240384318&page=1',url2:''},
  {code: '233',name: '高三数学88 三角函数与解三角形问题（一）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=414784826&bvid=BV1UV411178A&cid=240384613&page=1',url2:''},
  {code: '234',name: '高三数学92 三角函数与解三角形问题（二）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=287323400&bvid=BV1Zf4y1q7ck&cid=240384778&page=1',url2:''},
  {code: '235',name: '高三英语48 高三英语二轮复习.阅读专题3',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=969829142&bvid=BV1wp4y1Y7xt&cid=240385288&page=1',url2:''},
  {code: '236',name: '高三英语53 高三英语二轮复习.阅读专题',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=884750939&bvid=BV1CK4y187tQ&cid=240385889&page=1',url2:''},
  {code: '237',name: '高三英语66 主旨大意题解题技巧（1）+互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=202161566&bvid=BV1eh411X7z2&cid=239569659&page=1',url2:''},
  {code: '238',name: '高三英语70 主旨大意题解题技巧（2）+互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=414651635&bvid=BV1SV411m7Qn&cid=239616336&page=1',url2:''},
  {code: '239',name: '高三英语74 阅读7选5微技能：快捷解题技法+互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=669680115&bvid=BV12a4y1j7VE&cid=239765223&page=1',url2:''},
  {code: '240',name: '高三英语78 阅读7选5微技能：稳准解题技法+互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=542357173&bvid=BV1oi4y1E7JP&cid=240387214&page=1',url2:''},
  {code: '241',name: '高三英语81 阅读7选5微技能：语篇模式解题技法+互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=499829790&bvid=BV1uK411N7ca&cid=240388242&page=1',url2:''},
  {code: '242',name: '高三英语85 阅读方法复习总结＋互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=627297814&bvid=BV1Ct4y1q7rB&cid=240388575&page=1',url2:''},
  {code: '243',name: '高三英语89 完型微技能：句内层次题+互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=499821486&bvid=BV1jK411N7S2&cid=240444235&page=1',url2:''},
  {code: '244',name: '高三英语93 完型微技能：句组层次题+互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=329816587&bvid=BV1HA411774Y&cid=240389825&page=1',url2:''},
  {code: '245',name: '高三化学07 原电池核心考点突破 第1讲',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=584778168&bvid=BV1Fz4y1f78k&cid=240390360&page=1',url2:''},
  {code: '246',name: '高三化学15 电解池核心考点突破',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=499833403&bvid=BV1gK411N7kK&cid=240390560&page=1',url2:''},
  {code: '247',name: '高三化学21 电化学综合',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=754857969&bvid=BV1ik4y1C7yF&cid=240390765&page=1',url2:''},
  {code: '248',name: '高三化学45 来电的化学——电化学基础',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=969844254&bvid=BV17p4y1Y7jc&cid=240391018&page=1',url2:''},
  {code: '249',name: '高三化学46 氧化还原反应',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=669855915&bvid=BV1fa4y1576p&cid=240391429&page=1',url2:''},
  {code: '250',name: '高三化学50 有机化合物之必修必得',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=927254687&bvid=BV17T4y1c79Y&cid=240391947&page=1',url2:''},
  {code: '251',name: '高三化学51 离子反应专项突破',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=584802340&bvid=BV1Zz4y1Z7wy&cid=240444845&page=1',url2:''},
  {code: '252',name: '高三化学72 课题7：满分选择题之“基础实验”',grade: '高三',subject: '化学',tcode: '',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=244873283&bvid=BV1cv411k7Mb&cid=240395346&page=1',url2:''},
  {code: '253',name: '高三数学04 函数的奇偶性',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=712126620&bvid=BV1eD4y1o7Bf&cid=239189866&page=1',url2:''},
  {code: '254',name: '高三数学05 函数的单调性',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=202160306&bvid=BV1eh411X79B&cid=239161427&page=1',url2:''},
  {code: '255',name: '高三数学12 函数的周期性和对称性',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=202172710&bvid=BV1th411X7d8&cid=238753507&page=1',url2:''},
  {code: '256',name: '高三数学13 非常规数列通项公式求法',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=754780416&bvid=BV1Gk4y1C732&cid=240396114&page=1',url2:''},
  {code: '257',name: '高三数学18 数列求和常见的方法',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=927267633&bvid=BV1HT4y1c7Sh&cid=240397193&page=1',url2:''},
  {code: '258',name: '高三数学23 均值不等式精讲',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=372333373&bvid=BV1YZ4y157tZ&cid=240397335&page=1',url2:''},
  {code: '259',name: '高三数学28 空间几何体的外接球与内切球',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=712296936&bvid=BV1eD4y1R7x2&cid=240397529&page=1',url2:''},
  {code: '260',name: '高三数学29 导数中的隐零点问题',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=754778473&bvid=BV1Gk4y1C7mp&cid=240397803&page=1',url2:''},
  {code: '261',name: '高三数学34 导数中的极值点偏移问题',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=754795473&bvid=BV1Mk4y1C7cS&cid=240398007&page=1',url2:''},
  {code: '262',name: '高三数学37 函数值域经典求法（一）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=797353264&bvid=BV17y4y1C7ST&cid=240398215&page=1',url2:''},
  {code: '263',name: '高三数学42 函数值域经典求法（二）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=329768865&bvid=BV1qA411J7rQ&cid=240401908&page=1',url2:''},
  {code: '264',name: '高三数学47 函数值域经典求法（三）',grade: '高三',subject: '数学',tcode: '',teacher: '',tags: '',version: '',url:'https:',url2:''},
  {code: '265',name: '高三数学52 指数函数',grade: '高三',subject: '数学',tcode: '',teacher: '',tags: '',version: '',url:'https://player.bilibili.com/player.html?aid=372258161&bvid=BV1nZ4y157xY&cid=240475237&page=1',url2:''},
  {code: '266',name: '高三数学57 对数函数精讲',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=927304004&bvid=BV1CT4y1c7no&cid=240402639&page=1',url2:''},
  {code: '267',name: '高三物理02 点与运动',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=244728101&bvid=BV1fv411C7Nr&cid=238777457&page=1',url2:''},
  {code: '268',name: '高三物理10 连接体',grade: '高三',subject: '物理',tcode: '',teacher: '',tags: '',version: '',url:'https:',url2:''},
  {code: '269',name: '高三物理20 点睛：板块问题',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=542330640&bvid=BV1qi4y1E7Yt&cid=240475505&page=1',url2:''},
  {code: '270',name: '高三物理26 传送带问题',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=969822731&bvid=BV1cp4y1Y7ym&cid=240403409&page=1',url2:''},
  {code: '271',name: '高三物理36 曲线运动',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=584871489&bvid=BV1vz4y1d7Xn&cid=240413519&page=1',url2:''},
  {code: '272',name: '高三物理39 牛顿运动定律应用1',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=584796819&bvid=BV1Rz4y1Z7NQ&cid=240413800&page=1',url2:''},
  {code: '273',name: '高三物理44 牛顿运动定律应用2',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=797311605&bvid=BV1Ky4y1C7Fd&cid=240414002&page=1',url2:''},
  {code: '274',name: '高三物理49 圆周运动1',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=927289298&bvid=BV1tT4y1c7YN&cid=240414651&page=1',url2:''},
  {code: '275',name: '高三物理54 圆周运动2',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=712357634&bvid=BV1AD4y1d7oW&cid=240414857&page=1',url2:''},
  {code: '276',name: '高三物理59 万有引力定律中的常见问题1',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=712296945&bvid=BV1eD4y1R7xq&cid=240415476&page=1',url2:''},
  {code: '277',name: '高三英语62 推理判断题解题技巧＋互动练习',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=287266603&bvid=BV1df4y1D7zq&cid=240415678&page=1',url2:''},
  {code: '278',name: '高三英语01 阅读完形技巧提分-Part1 七选五',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=927131080&bvid=BV1HT4y1A7vi&cid=238760032&page=1',url2:''},
  {code: '279',name: '高三英语06 阅读完形技巧提分-Part2 传统阅读之细节题',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=329744214&bvid=BV18A411J7Wt&cid=239479226&page=1',url2:''},
  {code: '280',name: '高三英语09 阅读完形技巧提分-传统阅读之细节题实战演练',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=329867191&bvid=BV14A41177PP&cid=240420167&page=1',url2:''},
  {code: '281',name: '高三英语14 阅读完形技巧提分-Part3 完形填空',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=457265931&bvid=BV1E5411j7PF&cid=240420379&page=1',url2:''},
  {code: '282',name: '高三英语19 语法填空点睛突破',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=712337456&bvid=BV12D4y1R7vy&cid=240420574&page=1',url2:''},
  {code: '283',name: '高三英语24 语法填空点睛突破2',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=202352090&bvid=BV1eh41197bN&cid=240420844&page=1',url2:''},
  {code: '284',name: '高三英语25 阅读完形技巧提分-完形填空',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=927332595&bvid=BV1kT4y1c7cQ&cid=240420999&page=1',url2:''},
  {code: '285',name: '高三英语30 语法填空点睛突破3',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=202266275&bvid=BV1Zh411X7jY&cid=240457502&page=1',url2:''},
  {code: '286',name: '高三英语35 语法填空点睛突破4',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=287271480&bvid=BV1of4y1D7bo&cid=240457623&page=1',url2:''},
  {code: '287',name: '高三英语38 高三英语二轮复习.阅读专题',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=627251099&bvid=BV16t4y1q7rP&cid=240425526&page=1',url2:''},
  {code: '288',name: '高三英语43 高三英语二轮复习.阅读专题2',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=669800730&bvid=BV1ha4y157pV&cid=240448714&page=1',url2:''},
  {code: '289',name: '高三英语58 记叙类文本的常见语篇模式及阅读策略',grade: '高三',subject: '英语',tcode: '',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=927349419&bvid=BV1oT4y1c7Up&cid=240448927&page=1',url2:''},
  {code: '290',name: '高三语文03 诗歌鉴赏 客观题',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=329790856&bvid=BV15A41177JR&cid=240449009&page=1',url2:''},
  {code: '291',name: '高三语文08 文学类理解题答题技巧——词语理解类题型',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=542281246&bvid=BV1ai4y1E7it&cid=240449093&page=1',url2:''},
  {code: '292',name: '高三语文11 文言文阅读：翻译三字诀',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=712327816&bvid=BV1yD4y1R7Xc&cid=240450075&page=1',url2:''},
  {code: '293',name: '高三语文16 文学类鉴赏题（一）',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=969848659&bvid=BV1Ep4y1Y7YF&cid=240451000&page=1',url2:''},
  {code: '294',name: '高三语文17 文学类鉴赏题（二）',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=927353934&bvid=BV1mT4y1c7D3&cid=240451118&page=1',url2:''},
  {code: '295',name: '高三语文22 语言运用主观题',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=842363588&bvid=BV1i54y1k7e7&cid=240451212&page=1',url2:''},
  {code: '296',name: '高三语文27 文化常识精讲之称谓',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=457271541&bvid=BV1E5411j7Wj&cid=240452701&page=1',url2:''},
  {code: '297',name: '高三语文32 论述类文本综合训练',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=754845055&bvid=BV1ak4y1C7Zs&cid=240452824&page=1',url2:''},
  {code: '298',name: '高三语文33节 语言运用主观题 压缩语段',grade: '高三',subject: '语文',tcode: '108',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https://player.bilibili.com/player.html?aid=669762523&bvid=BV1ca4y177Z9&cid=240452949&page=1',url2:''},
  {code: '299',name: '高二语文01如何快速读懂一首诗',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1cV411U7di&page=1',url2:''},
  {code: '300',name: '高二物理02带点粒子在电场中的运动',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?bvid=BV18h411X7qs&page=1',url2:''},
  {code: '301',name: '高二数学03空间立体几何的体积拆解',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1o54y1y7K7&page=1',url2:''},
  {code: '302',name: '高二英语04无敌口诀突破定语从句（上）',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Z5411L7AK&page=1',url2:''},
  {code: '303',name: '高二英语05无敌口诀突破定语从句（下）',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1w54y117cF&page=1',url2:''},
  {code: '304',name: '高二化学06电极方程式',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1bp4y1a7Vd&page=1',url2:''},
  {code: '305',name: '高二语文07文言文精读',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1qZ4y1N72B&page=1',url2:''},
  {code: '306',name: '高二数学08空间中平行证明技巧',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1at4y1q73b&page=1',url2:''},
  {code: '307',name: '高二物理09带点粒子在电场中的综合运动',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1tD4y1o7sk&page=1',url2:''},
  {code: '308',name: '高二语文10文言文精读',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV17h411X7Bo&page=1',url2:''},
  {code: '309',name: '高二数学11空间中垂直证明',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Ai4y1E7sa&page=1',url2:''},
  {code: '310',name: '高二英语12搞定名词性从句（上）',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1n541187xs&page=1',url2:''},
  {code: '311',name: '高二英语13搞定名词性从句（下）',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1xf4y1D7iQ&page=1',url2:''},
  {code: '312',name: '高二化学14电极方程式',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1uk4y11784&page=1',url2:''},
  {code: '313',name: '高二语文15诗歌鉴赏',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Xk4y1k7gj&page=1',url2:''},
  {code: '314',name: '高二数学16圆锥曲线之焦点三角形',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1q54y1y7XF&page=1',url2:''},
  {code: '315',name: '高二数学17圆锥曲线之焦点三角形',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1xz4y1Z7tc&page=1',url2:''},
  {code: '316',name: '高二英语18搞定名词性从句大总结',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1nk4y117H3&page=1',url2:''},
  {code: '317',name: '高二物理19带点粒子在电场中的运动',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1qa4y1j7qS&page=1',url2:''},
  {code: '318',name: '高二语文20诗歌鉴赏刷题课',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1JA411J77W&page=1',url2:''},
  {code: '319',name: '高二语文21诗歌鉴赏',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Ha4y1j7Aj&page=1',url2:''},
  {code: '320',name: '高二数学22韦达定理1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV18T4y1A7LA&page=1',url2:''},
  {code: '321',name: '高二英语23小词大用法',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Xy4y1y7u8&page=1',url2:''},
  {code: '322',name: '高二化学24选择题方法',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Lf4y1D7T9&page=1',url2:''},
  {code: '323',name: '高二物理25带点粒子在电场中的综合运动',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1m54y1y7zP&page=1',url2:''},
  {code: '324',name: '高二语文26真题精讲',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV18K411P7Sq&page=1',url2:''},
  {code: '325',name: '高二数学27韦达定理2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1za4y1j7Pv&page=1',url2:''},
  {code: '326',name: '高二英语28突破状语从句',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1cZ4y1K7ZM&page=1',url2:''},
  {code: '327',name: '高二英语29句型与词汇的升级（上）',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1zi4y177WL&page=1',url2:''},
  {code: '328',name: '高二化学30金属腐蚀',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV11K4y1a7EA&page=1',url2:''},
  {code: '329',name: '高二语文31诗歌鉴赏',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1M54y117jY&page=1',url2:''},
  {code: '330',name: '高二数学32韦达定理3',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1ZA411E71Z&page=1',url2:''},
  {code: '331',name: '高二数学33韦达定理4',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1gA411J7qJ&page=1',url2:''},
  {code: '332',name: '高二英语34句型与词汇的升级（下）',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV11i4y177Zk&page=1',url2:''},
  {code: '333',name: '高二物理35物理仪器中的电磁运动',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1AV411U7J1&page=1',url2:''},
  {code: '334',name: '高二语文36高考真题精讲',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1hK411P7aZ&page=1',url2:''},
  {code: '335',name: '高二生物37果酒和果醋的制作',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1xh411X7HR&page=1',url2:''},
  {code: '336',name: '高二语文38真题精讲',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV12v411C7wq&page=1',url2:''},
  {code: '337',name: '高二化学39原电池',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1tV41117Vg&page=1',url2:''},
  {code: '338',name: '高二数学40韦达定理5',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1eT4y1A7i5&page=1',url2:''},
  {code: '339',name: '高二物理41电磁感应中的能量转化与守恒1',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1G5411j76x&page=1',url2:''},
  {code: '340',name: '高二数学42焦点三角形',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1pi4y1E7qw&page=1',url2:''},
  {code: '341',name: '高二生物43腐乳的制作',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1ch41197qV&page=1',url2:''},
  {code: '342',name: '高二语文44名校冲刺精讲',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Nk4y117xq&page=1',url2:''},
  {code: '343',name: '高二数学45韦达定理6',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1V5411j7S8&page=1',url2:''},
  {code: '344',name: '高二物理46电磁感应中的能量转化与守恒2',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Qv411C78o&page=1',url2:''},
  {code: '345',name: '高二英语47公益课1',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1yh411X7Bw&page=1',url2:''},
  {code: '346',name: '高二物理48电磁感应常见概念问题',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1N54y1173A&page=1',url2:''},
  {code: '347',name: '高二生物49制作泡菜并检测亚硝酸盐的含量',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Z54y1y773&page=1',url2:''},
  {code: '348',name: '高二英语50公益课2',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Nv411y7U7&page=1',url2:''},
  {code: '349',name: '高二数学51直线与曲线的交集1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1gA411J7Do&page=1',url2:''},
  {code: '350',name: '高二语文52小说概括与鉴赏',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1VK4y1Y7Kn&page=1',url2:''},
  {code: '351',name: '高二物理53电磁感应中的能量转化与守恒3',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1AK4y1Y7H9&page=1',url2:''},
  {code: '352',name: '高二化学54三大守恒',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1XV411m7Rm&page=1',url2:''},
  {code: '353',name: '高二生物55微生物的实验室培养（一）',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV13541187z9&page=1',url2:''},
  {code: '354',name: '高二语文56小说阅读',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1jz4y1Z7xn&page=1',url2:''},
  {code: '355',name: '高二化学57原电池的发展',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Uk4y1k76R&page=1',url2:''},
  {code: '356',name: '高二英语58公益课3',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Sv411C7Ky&page=1',url2:''},
  {code: '357',name: '高二物理59电磁感应中的应用',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1S54y1y7Jv&page=1',url2:''},
  {code: '358',name: '高二数学60直线与曲线的交集2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1tA411J7WV&page=1',url2:''},
  {code: '359',name: '高二英语61公益课4',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Hp4y1a7Vp&page=1',url2:''},
  {code: '360',name: '高二数学62导数的几何意义',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1np4y1a7NV&page=1',url2:''},
  {code: '361',name: '高二语文63真题精讲',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1tv411C7S8&page=1',url2:''},
  {code: '362',name: '高二英语64公益课5',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Qa4y1j71x&page=1',url2:''},
  {code: '363',name: '高二物理65电磁感应复习',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1rV411m7Z2&page=1',url2:''},
  {code: '364',name: '高二语文66先秦诗歌',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1bD4y1R7qU&page=1',url2:''},
  {code: '365',name: '高二生物67微生物的实验室培养（二）',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1BK4y1a7Ku&page=1',url2:''},
  {code: '366',name: '高二数学68导数与单调性1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Df4y1D7BH&page=1',url2:''},
  {code: '367',name: '高二语文69如何快速把握散文主旨',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1EA411J7wR&page=1',url2:''},
  {code: '368',name: '高二化学70化学电源1',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1tt4y1q7jk&page=1',url2:''},
  {code: '369',name: '高二物理71磁场的能量',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1wK4y1Y7Fc&page=1',url2:''},
  {code: '370',name: '高二数学72导数与单调性2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1f5411L7cF&page=1',url2:''},
  {code: '371',name: '高二生物73土壤中分解尿素的细菌的分离和计数（一）',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1qf4y1D7QS&page=1',url2:''},
  {code: '372',name: '高二数学74导数与单调性3',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Nt4y1q7i6&page=1',url2:''},
  {code: '373',name: '高二语文75词语理解答题技巧',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1yh411X76p&page=1',url2:''},
  {code: '374',name: '高二化学76化学电源2',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?bvid=BV19h411X7gG&page=1',url2:''},
  {code: '375',name: '高二物理77电磁感应总结1',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1fD4y1o7Dc&page=1',url2:''},
  {code: '376',name: '高二英语78公益课6',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Cz4y1Z72p&page=1',url2:''},
  {code: '377',name: '高二物理79交变电流的产生',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1cZ4y1K7dx&page=1',url2:''},
  {code: '378',name: '高二生物80土壤中分解尿素的细菌的分离和计数（二）',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Dv411C7gw&page=1',url2:''},
  {code: '379',name: '高二数学81极值与最值1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1ND4y1Z7TS&page=1',url2:''},
  {code: '380',name: '高二语文82句子理解答题技巧',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1kv411C7BG&page=1',url2:''},
  {code: '381',name: '高二英语83公益课7',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Wt4y1q7ww&page=1',url2:''},
  {code: '382',name: '高二物理84电磁感应总结2',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1X54y1y7Aw&page=1',url2:''},
  {code: '383',name: '高二化学85电荷守恒',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1jA411J7XJ&page=1',url2:''},
  {code: '384',name: '高二生物86分解纤维素的微生物的分离（一）',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Ja4y1j7d5&page=1',url2:''},
  {code: '385',name: '高二数学87极值与最值2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1kT4y1A71Z&page=1',url2:''},
  {code: '386',name: '高二语文88赏析题答题技巧',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV17z4y1Z7Dn&page=1',url2:''},
  {code: '387',name: '高二化学89电解池',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Di4y177Df&page=1',url2:''},
  {code: '388',name: '高二物理90交流电产生的表述',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1QZ4y1N7Fx&page=1',url2:''},
  {code: '389',name: '高二英语91公益课8',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Ep4y1a74U&page=1',url2:''},
  {code: '390',name: '高二英语92公益课9',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1X54y1y73r&page=1',url2:''},
  {code: '391',name: '高二数学93导数的几何意义1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1ji4y1E7ga&page=1',url2:''},
  {code: '392',name: '高二语文94散文刷题课',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1eh411X774&page=1',url2:''},
  {code: '393',name: '高二英语95公益课10',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1rf4y1D7wh&page=1',url2:''},
  {code: '394',name: '高二物理96交变电流2',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Sf4y1D7Ww&page=1',url2:''},
  {code: '395',name: '高二语文97西汉诗歌',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Bp4y1a7Tq&page=1',url2:''},
  {code: '396',name: '高二生物98分解纤维素的微生物的分离（二）',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV17Z4y157d6&page=1',url2:''},
  {code: '397',name: '高二数学99导数的几何意义2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1RK4y1a7qC&page=1',url2:''},
  {code: '398',name: '高二语文100如何积累优质论据',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?bvid=BV12K4y1a7P8&page=1',url2:''},
  {code: '399',name: '高二化学101电解池',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?aid=839730848&bvid=BV1V54y117bU&cid=239151048&page=1',url2:''},
  {code: '400',name: '高二物理102描述交流电的物理量1',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=969662290&bvid=BV1Qp4y1e7wB&cid=238866663&page=1',url2:''},
  {code: '401',name: '高二数学103导数的几何意义3',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=797144009&bvid=BV11y4y1y7Vr&cid=239103096&page=1',url2:''},
  {code: '402',name: '高二生物104果胶酶在果汁生产中的作用',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=202224553&bvid=BV1dh411X7Vj&cid=239089107&page=1',url2:''},
  {code: '403',name: '高二数学105导数与极值最值1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=927158513&bvid=BV1hT4y1A7nv&cid=239088535&page=1',url2:''},
  {code: '404',name: '高二语文106时事热点积累1',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=627132518&bvid=BV19t4y1i7MH&cid=238839191&page=1',url2:''},
  {code: '405',name: '高二化学107电解池应用',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?aid=414693427&bvid=BV1wV411U7mG&cid=239151062&page=1',url2:''},
  {code: '406',name: '高二物理108描述交流电的物理量2',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=627161941&bvid=BV1Gt4y1q7qK&cid=238866687&page=1',url2:''},
  {code: '407',name: '高二英语109公益课11',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=244636973&bvid=BV1bv411C7gE&cid=238844363&page=1',url2:''},
  {code: '408',name: '高二物理110交变电流的有效值',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?aid=542129312&bvid=BV11i4y177pW&cid=239103113&page=1',url2:''},
  {code: '409',name: '高二生物111探究加酶洗衣粉的洗涤效果',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=329678089&bvid=BV1uA411J729&cid=239103141&page=1',url2:''},
  {code: '410',name: '高二数学112导数与极值最值2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=839686872&bvid=BV1u54y1178V&cid=239103166&page=1',url2:''},
  {code: '411',name: '高二语文113时事热点积累2',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=584643293&bvid=BV1Mz4y1Z7BP&cid=239187468&page=1',url2:''},
  {code: '412',name: '高二英语114公益课12',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=329712654&bvid=BV1aA411J7cW&cid=239187495&page=1',url2:''},
  {code: '413',name: '高二物理115交变电流规律的应用',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=329702909&bvid=BV17A411J7wz&cid=239187539&page=1',url2:''},
  {code: '414',name: '高二化学116离子浓度比大小',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=287246651&bvid=BV1ff4y1D7DC&cid=239187559&page=1',url2:''},
  {code: '415',name: '高二生物117酵母细胞的固定化',grade: '高二',subject: '生物',tcode: '',teacher: '张蕾',tags: '29年教龄 | 成都市学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=584638955&bvid=BV1Tz4y1Z7n1&cid=239187589&page=1',url2:''},
  {code: '416',name: '高二数学118导数与极值最值3',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=499748134&bvid=BV19K411P78t&cid=239187610&page=1',url2:''},
  {code: '417',name: '高二语文119时事热点积累3',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=584658311&bvid=BV1Hz4y1Z7PF&cid=239187629&page=1',url2:''},
  {code: '418',name: '高二化学120原电池和电解池的复习',grade: '高二',subject: '化学',tcode: '',teacher: '刘楠',tags: '中学一级教师 | 竞赛教练',version: '',url:'https://player.bilibili.com/player.html?aid=712209429&bvid=BV1SD4y1o7FK&cid=239187643&page=1',url2:''},
  {code: '419',name: '高二物理121示波器的使用',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=457216078&bvid=BV1G5411j7oL&cid=239187661&page=1',url2:''},
  {code: '420',name: '高二英语122公益课13',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=244633041&bvid=BV14v411C7Xq&cid=239187687&page=1',url2:''},
  {code: '421',name: '高二英语123公益课14',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=927178009&bvid=BV11T4y1A7gK&cid=239187715&page=1',url2:''},
  {code: '422',name: '高二数学124导数与极值最值4',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=927156478&bvid=BV1bT4y1A7he&cid=239187749&page=1',url2:''},
  {code: '423',name: '高二语文125时事热点积累4',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=884711747&bvid=BV1VK4y1Y7Rw&cid=239187777&page=1',url2:''},
  {code: '424',name: '高二英语126公益课15',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=457131775&bvid=BV1w541187kC&cid=239187799&page=1',url2:''},
  {code: '425',name: '高二物理127电容器在交流电路中的应用',grade: '高二',subject: '物理',tcode: '',teacher: '周军',tags: '全国赛课一等奖 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=797176805&bvid=BV1Ry4y1y7fs&cid=239187812&page=1',url2:''},
  {code: '426',name: '高二语文128时事热点积累5',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=414673640&bvid=BV12V411m7AD&cid=239187863&page=1',url2:''},
  {code: '427',name: '高二物理129电磁感应精讲1',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?aid=499626372&bvid=BV1fK411K7Ru&cid=239431968&page=1',url2:''},
  {code: '428',name: '高二英语130时态语态1',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=842166305&bvid=BV1j54y1y7X9&cid=239431978&page=1',url2:''},
  {code: '429',name: '高二语文131语言基础知识精讲（一）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=839626664&bvid=BV1h54y1m79A&cid=239431993&page=1',url2:''},
  {code: '430',name: '高二化学132电离平衡图滴定曲线',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=927197564&bvid=BV1rT4y1A7Ux&cid=239432005&page=1',url2:''},
  {code: '431',name: '高二数学133等差等比性质相关问题1',grade: '高二',subject: '数学',tcode: '',teacher: '王威',tags: '竞赛出身 | 培优专家 | 11年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=287242351&bvid=BV1mf4y1D7mZ&cid=239432029&page=1',url2:''},
  {code: '432',name: '高二数学134导数与极值最值5',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=669732373&bvid=BV1Da4y1j7EK&cid=239432044&page=1',url2:''},
  {code: '433',name: '高二物理135电磁感应精讲2',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?aid=884643613&bvid=BV1XK4y1a7P4&cid=239432057&page=1',url2:''},
  {code: '434',name: '高二英语136时态语态2',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=839667056&bvid=BV1X54y1y7Jf&cid=239455591&page=1',url2:''},
  {code: '435',name: '高二化学138滴定曲线',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=839638598&bvid=BV1s54y1m7yL&cid=239455630&page=1',url2:''},
  {code: '436',name: '高二数学139数列求和（一）',grade: '高二',subject: '数学',tcode: '',teacher: '王威',tags: '竞赛出身 | 培优专家 | 11年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=797164912&bvid=BV1Dy4y1y79o&cid=239455650&page=1',url2:''},
  {code: '437',name: '高二物理140电磁感应精讲3',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?aid=414649348&bvid=BV1UV411m7Ne&cid=239436922&page=1',url2:''},
  {code: '438',name: '高二物理141电磁感应精讲4',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?aid=754678815&bvid=BV13k4y117bj&cid=239436938&page=1',url2:''},
  {code: '439',name: '高二英语142时态语态3',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=414735190&bvid=BV1WV41117e6&cid=239455733&page=1',url2:''},
  {code: '440',name: '高二语文143语言基础知识精讲（三）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=669685181&bvid=BV1ma4y1j7un&cid=239455749&page=1',url2:''},
  {code: '441',name: '高二化学144反比例曲线',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=414667508&bvid=BV11V411m74t&cid=239436953&page=1',url2:''},
  {code: '442',name: '高二数学145数列求和（二）',grade: '高二',subject: '数学',tcode: '',teacher: '王威',tags: '竞赛出身 | 培优专家 | 11年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=372238803&bvid=BV1FZ4y1K7rr&cid=239455771&page=1',url2:''},
  {code: '443',name: '高二化学146离子浓度比大小',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=287232125&bvid=BV11f4y1D7Zm&cid=239436980&page=1',url2:''},
  {code: '444',name: '高二物理147交变电流精讲1',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?aid=202177509&bvid=BV18h411X75z&cid=239436998&page=1',url2:''},
  {code: '445',name: '高二英语148时态语态4',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=884702443&bvid=BV1fK4y1a78w&cid=239437016&page=1',url2:''},
  {code: '446',name: '高二语文149语言基础知识精讲（四）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=372248173&bvid=BV1jZ4y157LF&cid=239437053&page=1',url2:''},
  {code: '447',name: '高二化学150分布曲线',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=627161303&bvid=BV1Gt4y1q7nq&cid=239460638&page=1',url2:''},
  {code: '448',name: '高二数学151数列通项的求解',grade: '高二',subject: '数学',tcode: '',teacher: '王威',tags: '竞赛出身 | 培优专家 | 11年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=287149296&bvid=BV1bf4y1D73B&cid=239460673&page=1',url2:''},
  {code: '449',name: '高二英语152时态语态5',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=457188025&bvid=BV1P5411j7YQ&cid=239460691&page=1',url2:''},
  {code: '450',name: '高二物理153变压器与远距离输电',grade: '高二',subject: '物理',tcode: '112',teacher: '孔力',tags: '物理领路人|985院校|偶像实力派',version: '',url:'https://player.bilibili.com/player.html?aid=244648893&bvid=BV1kv411C7fM&cid=239460712&page=1',url2:''},
  {code: '451',name: '高二英语154总复习',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=287161051&bvid=BV1Yf4y1D775&cid=239460729&page=1',url2:''},
  {code: '452',name: '高二语文155语言基础知识精讲（五）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=329687497&bvid=BV1sA411J7wp&cid=239460741&page=1',url2:''},
  {code: '453',name: '高二化学156水电离程度曲线',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=244685794&bvid=BV19v411C7Ro&cid=239460757&page=1',url2:''},
  {code: '454',name: '高二数学157数列综合问题训练',grade: '高二',subject: '数学',tcode: '',teacher: '王威',tags: '竞赛出身 | 培优专家 | 11年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=969630380&bvid=BV1Cp4y1e7na&cid=239460776&page=1',url2:''},
  {code: '455',name: '高二语文158唐代诗歌（上）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=457237210&bvid=BV1u5411j7W6&cid=239460787&page=1',url2:''},
  {code: '456',name: '高二数学159等差数列的函数本质1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=372248856&bvid=BV1EZ4y157EW&cid=239460807&page=1',url2:''},
  {code: '457',name: '高二物理160电磁场中的规律与题型总结1',grade: '高二',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=287219230&bvid=BV1Df4y1D7N6&cid=239460824&page=1',url2:''},
  {code: '458',name: '高二化学161同分异构体1',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=842125873&bvid=BV1P54y1y7Q5&cid=239460840&page=1',url2:''},
  {code: '459',name: '高二英语162答疑课1',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=584630721&bvid=BV1Pz4y1Z7RM&cid=239466817&page=1',url2:''},
  {code: '460',name: '高二语文163唐代诗歌（下）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=754743325&bvid=BV1Dk4y1k7s4&cid=239466836&page=1',url2:''},
  {code: '461',name: '高二数学164等差数列的函数本质2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=584655925&bvid=BV1Hz4y1Z7Bs&cid=239466853&page=1',url2:''},
  {code: '462',name: '高二物理165电磁场中的规律与题型总结2',grade: '高二',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=414660257&bvid=BV1XV411m7tS&cid=239466868&page=1',url2:''},
  {code: '463',name: '高二化学166同分异构体2',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=884635569&bvid=BV1zK4y1a7Qz&cid=239466884&page=1',url2:''},
  {code: '464',name: '高二英语167答疑课2',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=797143502&bvid=BV11y4y1y7PR&cid=239466903&page=1',url2:''},
  {code: '465',name: '高二语文168宋代诗词（上）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=842238710&bvid=BV1m54y1y7UW&cid=239466916&page=1',url2:''},
  {code: '466',name: '高二数学169等差数列的函数本质3',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=457177918&bvid=BV1L541187dB&cid=239466930&page=1',url2:''},
  {code: '467',name: '高二物理170电磁场中的规律与题型总结3',grade: '高二',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=287196000&bvid=BV1vf4y1D75U&cid=239466945&page=1',url2:''},
  {code: '468',name: '高二英语171答疑课3',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=839684628&bvid=BV1g54y117gA&cid=239466969&page=1',url2:''},
  {code: '469',name: '高二化学172同分异构体3',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=202227421&bvid=BV1Rh411X7Gw&cid=239466984&page=1',url2:''},
  {code: '470',name: '高二语文173宋代诗词（下）',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=287158518&bvid=BV1Yf4y1D718&cid=239467000&page=1',url2:''},
  {code: '471',name: '高二数学174利用递推公式求通项公式1',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=884689347&bvid=BV1dK4y1a7GS&cid=239516882&page=1',url2:''},
  {code: '472',name: '高二物理175带电粒子在电磁场中运动的重点模型1',grade: '高二',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=839697606&bvid=BV1A54y117eW&cid=239516897&page=1',url2:''},
  {code: '473',name: '高二化学176有机化学性质1',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=839719762&bvid=BV1J54y117nR&cid=239516925&page=1',url2:''},
  {code: '474',name: '高二英语177答疑课4',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=499641633&bvid=BV1QK411K7o1&cid=239516938&page=1',url2:''},
  {code: '475',name: '高二语文178南宋词坛',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=884648271&bvid=BV1XK4y1a7UC&cid=239516950&page=1',url2:''},
  {code: '476',name: '高二数学179利用递推公式求通项公式2',grade: '高二',subject: '数学',tcode: '89',teacher: '王硕',tags: '5年教龄|套路王|数学小仙女',version: '',url:'https://player.bilibili.com/player.html?aid=584703352&bvid=BV1sz4y1Z7yN&cid=239516963&page=1',url2:''},
  {code: '477',name: '高二物理180带电粒子在电磁场中运动的重点模型2',grade: '高二',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=669689558&bvid=BV1Ua4y1j7sD&cid=239516973&page=1',url2:''},
  {code: '478',name: '高二化学181有机化学性质2',grade: '高二',subject: '化学',tcode: '',teacher: '侯宇',tags: '保送清华 | 化学学霸 | 十年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=372216636&bvid=BV1NZ4y1K7ga&cid=239516993&page=1',url2:''},
  {code: '479',name: '高二英语182答疑课5',grade: '高二',subject: '英语',tcode: '113',teacher: '孙岩',tags: '20年教龄|无敌英语|岩出必胜',version: '',url:'https://player.bilibili.com/player.html?aid=457203943&bvid=BV1f5411L7h9&cid=239517007&page=1',url2:''},
  {code: '480',name: '高二语文183元曲之美',grade: '高二',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https://player.bilibili.com/player.html?aid=499657314&bvid=BV14K411P7Pk&cid=239517021&page=1',url2:''},



  {code: '481',name: '初一数学03 有理数混合运算',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=839896422&bvid=BV1A54y127aA&cid=246142888&page=1',url2:''},
  {code: '482',name: '初一数学06 重难点梳理-数轴必考题',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=329931559&bvid=BV12A411779M&cid=246143780&page=1',url2:''},
  {code: '483',name: '初一数学09 上学期重难点梳理-绝对值化简必杀技',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=754969859&bvid=BV1Fk4y1y7uz&cid=246145072&page=1',url2:''},
  {code: '484',name: '初一数学103 实数的计算习题课',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=669875703&bvid=BV1Xa4y157og&cid=246172241&page=1',url2:''},
  {code: '485',name: '初一数学107 实数复习',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=927375383&bvid=BV1KT4y1w7Um&cid=246173090&page=1',url2:''},
  {code: '486',name: '初一数学10　整式化简中整体思想的妙用',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=797495288&bvid=BV1uy4y1r7KX&cid=246145787&page=1',url2:''},
  {code: '487',name: '初一数学110 实数（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=797474968&bvid=BV15y4y1r76B&cid=246173778&page=1',url2:''},
  {code: '488',name: '初一数学111 实数（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=202454533&bvid=BV1ua411A7qg&cid=246174406&page=1',url2:''},
  {code: '489',name: '初一数学115 平面直角坐标系初步（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=499941927&bvid=BV15K411A7Ng&cid=246175977&page=1',url2:''},
  {code: '490',name: '初一数学116 平面直角坐标系初步（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=927449746&bvid=BV1JT4y1w7Ke&cid=246177314&page=1',url2:''},
  {code: '491',name: '初一数学120 平面直角坐标系中的特殊直线和距离（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=287442867&bvid=BV1ef4y1B74r&cid=246178091&page=1',url2:''},
  {code: '492',name: '初一数学121 平面直角坐标系中的特殊直线和距离（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=927412452&bvid=BV17T4y1w7Co&cid=246178987&page=1',url2:''},
  {code: '493',name: '初一数学125 平面直角坐标系中的变换（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=329912898&bvid=BV1XA41177LU&cid=246179387&page=1',url2:''},
  {code: '494',name: '初一数学126 平面直角坐标系中的变换（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=584893603&bvid=BV1Cz4y1d7qZ&cid=246179836&page=1',url2:''},
  {code: '495',name: '初一数学130 平面直角坐标系中求面积和规律（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=754958274&bvid=BV1Kk4y1y7n7&cid=246180674&page=1',url2:''},
  {code: '496',name: '初一数学131 平面直角坐标系中求面积和规律（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=839900959&bvid=BV1P54y1279q&cid=246181116&page=1',url2:''},
  {code: '497',name: '初一数学13　一元一次方程你必须要会的解法',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=457489769&bvid=BV19541157qC&cid=246146473&page=1',url2:''},
  {code: '498',name: '初一数学17 线的分类讨论',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=414910676&bvid=BV1tV41127WR&cid=246147265&page=1',url2:''},
  {code: '499',name: '初一数学21 角的分类讨论',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=542404493&bvid=BV1Ei4y1j7vg&cid=246147764&page=1',url2:''},
  {code: '500',name: '初一数学24 上学期重难点梳理-线与角的计数',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=969955093&bvid=BV11p4y1r7wC&cid=246148767&page=1',url2:''},
  {code: '501',name: '初一数学28 同底数幂的乘法',grade: '初一',subject: '数学',tcode: '97',teacher: '杨慧园',tags: '10年教龄 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=669913003&bvid=BV15a4y1L7UC&cid=246151137&page=1',url2:''},
  {code: '502',name: '初一数学29 相交线和平行线（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=754921053&bvid=BV1Rk4y1C7ng&cid=246151715&page=1',url2:''},
  {code: '503',name: '初一数学33 幂的乘方与积的乘方（1）',grade: '初一',subject: '数学',tcode: '97',teacher: '杨慧园',tags: '10年教龄 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=584884252&bvid=BV1Qz4y1d7Lk&cid=246152281&page=1',url2:''},
  {code: '504',name: '初一数学34 相交线和平行线（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=329984889&bvid=BV1VA411E7xq&cid=246152894&page=1',url2:''},
  {code: '505',name: '初一数学38 幂的乘方与积的乘方（2）',grade: '初一',subject: '数学',tcode: '97',teacher: '杨慧园',tags: '10年教龄 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=244936315&bvid=BV1Jv411k7LK&cid=246153654&page=1',url2:''},
  {code: '506',name: '初一数学42 习题课：幂的有关运算',grade: '初一',subject: '数学',tcode: '97',teacher: '杨慧园',tags: '10年教龄 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=927457511&bvid=BV1HT4y1w7p1&cid=246154209&page=1',url2:''},
  {code: '507',name: '初一数学46 同底数幂的除法（1）',grade: '初一',subject: '数学',tcode: '97',teacher: '杨慧园',tags: '10年教龄 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=797416644&bvid=BV1iy4y1C7n3&cid=246154771&page=1',url2:''},
  {code: '508',name: '初一数学49 相交线（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=712384071&bvid=BV1gD4y1d7Yn&cid=246155258&page=1',url2:''},
  {code: '509',name: '初一数学51 平行线的判定和性质（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=627396573&bvid=BV1Yt4y1v7NP&cid=246155976&page=1',url2:''},
  {code: '510',name: '初一数学53 三线八角',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=969896987&bvid=BV1Wp4y1Y7GG&cid=246157121&page=1',url2:''},
  {code: '511',name: '初一数学55 平行线的判定和性质（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=969924273&bvid=BV1hp4y1Y7cZ&cid=246158184&page=1',url2:''},
  {code: '512',name: '初一数学57 咋地能平行',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=842413137&bvid=BV1c54y1C78P&cid=246159273&page=1',url2:''},
  {code: '513',name: '初一数学61 平行线的性质',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=499980339&bvid=BV1sK411A7jj&cid=246160356&page=1',url2:''},
  {code: '514',name: '初一数学65 习题课：相交与平行',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=797409438&bvid=BV1iy4y1C7A3&cid=246161428&page=1',url2:''},
  {code: '515',name: '初一数学69 平行线构造（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=244930713&bvid=BV1Ev411k7ur&cid=246162057&page=1',url2:''},
  {code: '516',name: '初一数学71 平移、平行线构造（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=329932203&bvid=BV12A41177W5&cid=246162477&page=1',url2:''},
  {code: '517',name: '初一数学73 平行线的构造',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=969985737&bvid=BV1Xp4y1r7SK&cid=246163025&page=1',url2:''},
  {code: '518',name: '初一数学76 平移、平行线构造（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=927495877&bvid=BV1QK4y1f7JY&cid=246163960&page=1',url2:''},
  {code: '519',name: '初一数学78 实数（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=712467906&bvid=BV14D4y1d7XA&cid=246164656&page=1',url2:''},
  {code: '520',name: '初一数学83 实数（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=842489058&bvid=BV1V54y1C7we&cid=246165759&page=1',url2:''},
  {code: '521',name: '初一数学87 实数（三）',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=244886942&bvid=BV15v411k7jB&cid=246166831&page=1',url2:''},
  {code: '522',name: '初一数学91 实数的估算',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=842440470&bvid=BV1M54y1C7xX&cid=246167433&page=1',url2:''},
  {code: '523',name: '初一数学94 有理数混合运算',grade: '初一',subject: '数学',tcode: '97',teacher: '王菂',tags: '数学基地班|数学全能王|15年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=584990282&bvid=BV1Hz4y1o7du&cid=246168985&page=1',url2:''},
  {code: '524',name: '初一数学95 实数的估算习题课',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=842423344&bvid=BV1X54y1k7ik&cid=246169938&page=1',url2:''},
  {code: '525',name: '初一数学97 平方根、立方根（二）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=329959908&bvid=BV1dA41177GW&cid=246170615&page=1',url2:''},
  {code: '526',name: '初一数学99 实数的计算',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=754949019&bvid=BV1Pk4y1y7Vp&cid=246171419&page=1',url2:''},
  {code: '527',name: '初一生物31 生物圈种的人：《预防传染病》＋课堂练习',grade: '初一',subject: '政治',tcode: '97',teacher: '周琴',tags: '市骨干教师 | 20年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=457391102&bvid=BV1N5411776J&cid=246128757&page=1',url2:''},
  {code: '528',name: '初一生物40 生物圈中的人：《人体免疫》＋课堂练习',grade: '初一',subject: '生物',tcode: '97',teacher: '周琴',tags: '市骨干教师 | 20年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=842448775&bvid=BV1g54y1C7Dg&cid=246129767&page=1',url2:''},
  {code: '529',name: '初一生物52 人体免疫2',grade: '初一',subject: '生物',tcode: '97',teacher: '周琴',tags: '市骨干教师 | 20年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=499987687&bvid=BV14K411A7ZG&cid=246130424&page=1',url2:''},
  {code: '530',name: '初一生物60 健康及其条件',grade: '初一',subject: '生物',tcode: '97',teacher: '周琴',tags: '市骨干教师 | 20年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=244949635&bvid=BV1vv411k71j&cid=246133495&page=1',url2:''},
  {code: '531',name: '初一生物72 人类的食物',grade: '初一',subject: '生物',tcode: '97',teacher: '周琴',tags: '市骨干教师 | 20年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=669890280&bvid=BV1ua4y1L75t&cid=246134489&page=1',url2:''},
  {code: '532',name: '初一政治75 性别差异和性别优势',grade: '初一',subject: '政治',tcode: '97',teacher: '徐颖',tags: '政治学科带头人 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=287451809&bvid=BV1if4y1B7hg&cid=246136693&page=1',url2:''},
  {code: '533',name: '初一生物82 食物的消化',grade: '初一',subject: '生物',tcode: '97',teacher: '周琴',tags: '市骨干教师 | 20年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=669948039&bvid=BV1xa4y1L7Dp&cid=246140204&page=1',url2:''},
  {code: '534',name: '初一英语05 重点难点复习之特殊疑问句',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=797484512&bvid=BV1jy4y1r7X8&cid=246182188&page=1',url2:''},
  {code: '535',name: '初一英语08 综合复习之单项选择题',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=414993782&bvid=BV1cV411y7fW&cid=246182658&page=1',url2:''},
  {code: '536',name: '初一英语100 趣味英语+Unit3 section B peri',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=414964391&bvid=BV1eV411276C&cid=246206001&page=1',url2:''},
  {code: '537',name: '初一英语101 词汇过关+完型+现在进行时（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=542378476&bvid=BV1Hi4y1j7uk&cid=246206792&page=1',url2:''},
  {code: '538',name: '初一英语104 趣味英语+Unit3 section B peri',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=927445386&bvid=BV1tT4y1w7YB&cid=246208645&page=1',url2:''},
  {code: '539',name: '初一英语108 趣味英语+Unit3 综合复习',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=669947046&bvid=BV14a4y1L7ui&cid=246209433&page=1',url2:''},
  {code: '540',name: '初一英语109 词汇过关+完型+现在进行时（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=669919322&bvid=BV17a4y1L7J6&cid=246210265&page=1',url2:''},
  {code: '541',name: '初一英语114 词汇过关+完型+介词（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=797467820&bvid=BV1wy4y1r7G6&cid=246211786&page=1',url2:''},
  {code: '542',name: '初一英语117 词汇过关+完型+不定代词（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=669934548&bvid=BV1Va4y1L7L2&cid=246212649&page=1',url2:''},
  {code: '543',name: '初一英语119 词汇过关+完型+不定代词（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=842401668&bvid=BV1Z54y1k7Ak&cid=246214319&page=1',url2:''},
  {code: '544',name: '初一英语122 词汇过关+写作+形容词（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=839889115&bvid=BV1G54y127Sr&cid=246215656&page=1',url2:''},
  {code: '545',name: '初一英语124 词汇过关+写作+形容词（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=884957031&bvid=BV1iK4y1h7WC&cid=246217101&page=1',url2:''},
  {code: '546',name: '初一英语127 词汇过关+写作+ 副词（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=839955568&bvid=BV1i54y1R7qL&cid=246218309&page=1',url2:''},
  {code: '547',name: '初一英语129 词汇过关+写作+ 副词（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=839908222&bvid=BV1T54y127qf&cid=246219965&page=1',url2:''},
  {code: '548',name: '初一英语132 词汇过关+写作+一般过去时（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=244933800&bvid=BV1Jv411k7rU&cid=246221443&page=1',url2:''},
  {code: '549',name: '初一英语134 词汇过关+写作+一般过去时（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=712452102&bvid=BV1aD4y1d7sD&cid=246222541&page=1',url2:''},
  {code: '550',name: '初一英语16　完形填空',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=414914150&bvid=BV18V41127Mc&cid=246183462&page=1',url2:''},
  {code: '551',name: '初一英语18 上学期重点复习综合篇（完型2）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=414964879&bvid=BV1eV41127GY&cid=246184017&page=1',url2:''},
  {code: '552',name: '初一英语20 词汇讲解',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=797376475&bvid=BV1Vy4y1C7BC&cid=246184615&page=1',url2:''},
  {code: '553',name: '初一英语23 上学期重点复习综合篇（阅读1）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=499938830&bvid=BV1wK411A7UL&cid=246185212&page=1',url2:''},
  {code: '554',name: '初一英语27 趣味单词与语法大演练（上）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=414967352&bvid=BV1iV41127V2&cid=246185759&page=1',url2:''},
  {code: '555',name: '初一英语32 趣味单词与语法大演练（中）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=839954678&bvid=BV1i54y1R7Xy&cid=246186729&page=1',url2:''},
  {code: '556',name: '初一英语37 趣味单词与语法大演练（下）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=797459524&bvid=BV1fy4y167mT&cid=246187340&page=1',url2:''},
  {code: '557',name: '初一英语41 趣味短语与阅读（上）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=244928320&bvid=BV1jv411k793&cid=246188150&page=1',url2:''},
  {code: '558',name: '初一英语45 趣味短语与阅读（下）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=627422721&bvid=BV1Qt4y1v7dd&cid=246188650&page=1',url2:''},
  {code: '559',name: '初一英语47 词汇过关+精读+情态动词（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=927486055&bvid=BV1SK4y1f7NQ&cid=246189575&page=1',url2:''},
  {code: '560',name: '初一英语50　Unit 1 Section A（1a-2d）',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=754895383&bvid=BV1qk4y1C7qn&cid=246190195&page=1',url2:''},
  {code: '561',name: '初一英语54 Unit 1 Section A(Grammar）',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=884880504&bvid=BV1WK4y1h7iu&cid=246191575&page=1',url2:''},
  {code: '562',name: '初一英语58 Unit 1 Section B(1a-1f)',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=669981232&bvid=BV1ia4y1L72B&cid=246192533&page=1',url2:''},
  {code: '563',name: '初一英语59 词汇过关+精读+时间表达法（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=244933234&bvid=BV1nv411k7gV&cid=246193515&page=1',url2:''},
  {code: '564',name: '初一英语62 Unit 1 Section B(2a-2c)',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=244926699&bvid=BV1jv411k7d1&cid=246194680&page=1',url2:''},
  {code: '565',name: '初一英语66 Unit 1 Section B(3a-self）',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=372495336&bvid=BV1WZ4y1L7yc&cid=246195248&page=1',url2:''},
  {code: '566',name: '初一英语67 词汇过关+精读+时间表达法（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=669892729&bvid=BV1Fa4y1L79Q&cid=246196450&page=1',url2:''},
  {code: '567',name: '初一英语70 Unit 2 Section A（1a-2d）',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=712430204&bvid=BV1jD4y1d7Jf&cid=246197099&page=1',url2:''},
  {code: '568',name: '初一英语74 Unit 1A(Grammar Focus-3c)',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=797467883&bvid=BV1wy4y1r734&cid=246198340&page=1',url2:''},
  {code: '569',name: '初一英语79 Unit 2 Section B(1a-1e)',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=839905390&bvid=BV1M54y127cJ&cid=246199256&page=1',url2:''},
  {code: '570',name: '初一英语81 词汇过关+精读+祈使句（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=969992298&bvid=BV1dp4y1r74R&cid=246200706&page=1',url2:''},
  {code: '571',name: '初一英语84 Unit 2 Section B(2a-2c)',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=842480282&bvid=BV1n54y1C7mR&cid=246201728&page=1',url2:''},
  {code: '572',name: '初一英语89 词汇过关+精读+祈使句（二）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=927458592&bvid=BV1HT4y1w7GU&cid=246202654&page=1',url2:''},
  {code: '573',name: '初一英语92 趣味英语+Unit3 section A peri',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=499880810&bvid=BV1iK411N7Cx&cid=246203850&page=1',url2:''},
  {code: '574',name: '初一英语96 趣味英语+Unit3 section A peri',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=499921101&bvid=BV1TK411A72j&cid=246204716&page=1',url2:''},
  {code: '575',name: '初一语文01 写作必备之正侧面描写相结合',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=927445693&bvid=BV1tT4y1w7Bs&cid=246223692&page=1',url2:''},
  {code: '576',name: '初一英语02 上学期重点复习（冠词）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=499984346&bvid=BV1xK411A7oU&cid=246226002&page=1',url2:''},
  {code: '577',name: '初一语文04 写作必备之如何构思一篇作文',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=372375919&bvid=BV1ZZ4y157Ap&cid=246227171&page=1',url2:''},
  {code: '578',name: '初一语文07 基础必备之古诗鉴赏',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=842377810&bvid=BV1S54y1k7pB&cid=246228292&page=1',url2:''},
  {code: '579',name: '初一语文105 七下重点古诗词练习二',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=754924716&bvid=BV1dk4y1C7Wk&cid=246251952&page=1',url2:''},
  {code: '580',name: '初一语文106 【写作素材】亘古男儿一放翁',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=969954234&bvid=BV11p4y1r7E8&cid=246252848&page=1',url2:''},
  {code: '581',name: '初一语文118 七下重点基础复习二',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=712390095&bvid=BV1VD4y1d7bM&cid=246253870&page=1',url2:''},
  {code: '582',name: '初一语文123 七下重点文言文练习三',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=839953424&bvid=BV1e54y1R7mX&cid=246254679&page=1',url2:''},
  {code: '583',name: '初一语文128 七下名著练习',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=754913790&bvid=BV19k4y1C7dx&cid=246255604&page=1',url2:''},
  {code: '584',name: '初一语文133 七下期中重点阅读练习',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=627488522&bvid=BV1Gt4y1i78T&cid=246256876&page=1',url2:''},
  {code: '585',name: '初一语文15 阅读必备之记叙文作用题（下）',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=712433826&bvid=BV17D4y1d7pf&cid=246229487&page=1',url2:''},
  {code: '586',name: '初一语文19 基础必备之病句辨析',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=329881260&bvid=BV1kA41177Gi&cid=246230952&page=1',url2:''},
  {code: '587',name: '初一语文22 基础必备之课外文言文讲练',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=969917316&bvid=BV18p4y1Y7ma&cid=246233029&page=1',url2:''},
  {code: '588',name: '初一语文26 作文课：想象与联想',grade: '初一',subject: '语文',tcode: '97',teacher: '张军',tags: '25年教龄 | 区优秀教师',version: '',url:'https:////player.bilibili.com/player.html?aid=669883327&bvid=BV1Ka4y1L7vS&cid=246235138&page=1',url2:''},
  {code: '589',name: '初一语文30 老山界',grade: '初一',subject: '语文',tcode: '97',teacher: '何建华',tags: '20年教龄 | 初中语文优秀教师',version: '',url:'https:////player.bilibili.com/player.html?aid=627497473&bvid=BV1Pt4y1i7Ub&cid=246236081&page=1',url2:''},
  {code: '590',name: '初一语文35 【知人论世】唐代诗歌风格变化（上）',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=927470201&bvid=BV1RK4y1f7KC&cid=246237384&page=1',url2:''},
  {code: '591',name: '初一语文43 七下重点古诗词练习一',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=542446206&bvid=BV1Ci4y1j7eX&cid=246239201&page=1',url2:''},
  {code: '592',name: '初一语文44 【知人论世】唐代诗歌风格变化（下）',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=244880633&bvid=BV1Vv411k7vE&cid=246239990&page=1',url2:''},
  {code: '593',name: '初一语文48 【课内古诗】《木兰诗》',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=839894653&bvid=BV1P54y127Gp&cid=246241208&page=1',url2:''},
  {code: '594',name: '初一语文56 【文学常识】汉字演变',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=202488838&bvid=BV1Ea411A7vf&cid=246242709&page=1',url2:''},
  {code: '595',name: '初一语文63 七下重点文言文练习一',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=584927893&bvid=BV19z4y1d7Gp&cid=246244348&page=1',url2:''},
  {code: '596',name: '初一语文64 【写作素材】爱国人物故事会',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=457428550&bvid=BV1K541177ao&cid=246245033&page=1',url2:''},
  {code: '597',name: '初一语文68 【名著阅读】《骆驼祥子》练习',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=244944776&bvid=BV1av411k7bW&cid=246245963&page=1',url2:''},
  {code: '598',name: '初一语文77 【文学常识】对联知识',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=927420755&bvid=BV1gT4y1w7h9&cid=246246526&page=1',url2:''},
  {code: '599',name: '初一政治80 行己有耻和止于至善',grade: '初一',subject: '政治',tcode: '97',teacher: '徐颖',tags: '政治学科带头人 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=884913526&bvid=BV1eK4y1h7sk&cid=246247592&page=1',url2:''},
  {code: '600',name: '初一语文85 七下重点基础复习一',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=372468283&bvid=BV15Z4y1L7ed&cid=246248505&page=1',url2:''},
  {code: '601',name: '初一语文86 【写作素材】最美的逆行者',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=627377360&bvid=BV1Bt4y1v7Jk&cid=246249818&page=1',url2:''},
  {code: '602',name: '初一语文90 【课内古诗】《登飞来峰》《游山西村》讲练',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=329894795&bvid=BV1vA41177Xv&cid=246250993&page=1',url2:''},
  {code: '603',name: '初一数学36 初中数学提分神器——错题本',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=884945169&bvid=BV1yK4y1h7tS&cid=246257598&page=1',url2:''},
  {code: '604',name: '初一数学93 平方根、立方根（一）',grade: '初一',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=457388485&bvid=BV1K541177Tr&cid=246259067&page=1',url2:''},
  {code: '605',name: '初一数学102 初一必备运算技巧：有理数综合',grade: '初一',subject: '数学',tcode: '97',teacher: '王菂',tags: '数学基地班|数学全能王|15年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=329919517&bvid=BV1XA41177xs&cid=246260049&page=1',url2:''},
  {code: '606',name: '初一英语25 上学期重点复习综合篇（阅读2）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=499964535&bvid=BV1uK411A7mq&cid=246260697&page=1',url2:''},
  {code: '607',name: '初一英语88 Unit 2B(3a-self check)',grade: '初一',subject: '英语',tcode: '97',teacher: '李传雨',tags: '英语教研员 | 市级优秀人才 | 教龄18年',version: '',url:'https:////player.bilibili.com/player.html?aid=627389466&bvid=BV1kt4y1v7wk&cid=246261377&page=1',url2:''},
  {code: '608',name: '初一英语112 词汇过关+完型+介词（一）',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=499975713&bvid=BV1WK411A7h4&cid=246262081&page=1',url2:''},
  {code: '609',name: '初一语文98 【课内文言文】《卖油翁》',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=202466806&bvid=BV1Aa411A7Wi&cid=246262844&page=1',url2:''},
  {code: '610',name: '初一语文113 七下重点文言文练习二',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=287482335&bvid=BV12f4y1B71F&cid=246263860&page=1',url2:''},
  {code: '611',name: '初一语文11 记叙文阅读必备之作用题（上）',grade: '初一',subject: '语文',tcode: '97',teacher: '许蓁',tags: '考点雷达|提升成绩|国学达人',version: '',url:'https:////player.bilibili.com/player.html?aid=584942345&bvid=BV1uz4y1o7aS&cid=246269708&page=1',url2:''},
  {code: '612',name: '初一英语12 上学期综合复习之单选2',grade: '初一',subject: '英语',tcode: '97',teacher: '颜君',tags: '海外硕士 | 10年教龄 | 颜师出高徒',version: '',url:'https:////player.bilibili.com/player.html?aid=542450248&bvid=BV1yi4y1j7m3&cid=246269678&page=1',url2:''},
  {code: '613',name: '初一数学14 带你揭开规律探究题的面纱',grade: '初一',subject: '数学',tcode: '97',teacher: '高明东',tags: '提分大神|兼具才华颜值|最具亲和力',version: '',url:'https:////player.bilibili.com/player.html?aid=712460991&bvid=BV1sD4y1d7VQ&cid=246269635&page=1',url2:''},
  {code: '614',name: '初二数学43 二次根式的概念和运算（一）',grade: '初二',subject: '数学',tcode: '97',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https:////player.bilibili.com/player.html?aid=884956646&bvid=BV1iK4y1h7Gk&cid=246373320&page=1',url2:''},
  {code: '615',name: '初二数学46 提公因式法（二） ',grade: '初二',subject: '数学',tcode: '97',teacher: '高俊',tags: '26年教龄 | 省骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=884942857&bvid=BV1kK4y1h7eq&cid=246294073&page=1',url2:''},
  {code: '616',name: '初二数学51 公式法（一） ',grade: '初二',subject: '数学',tcode: '97',teacher: '高俊',tags: '26年教龄 | 省骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=797493927&bvid=BV1uy4y1r7Hz&cid=246294433&page=1',url2:''},
  {code: '617',name: '初二数学54 二次根式的概念和运算（二）',grade: '初二',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=372458164&bvid=BV1GZ4y1L7CA&cid=246294855&page=1',url2:''},
  {code: '618',name: '初二数学57 公式法（2）',grade: '初二',subject: '数学',tcode: '97',teacher: '高俊',tags: '26年教龄 | 省骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=842481887&bvid=BV1G54y1C7CF&cid=246295265&page=1',url2:''},
  {code: '619',name: '初二数学62 《因式分解》小结与复习',grade: '初二',subject: '数学',tcode: '97',teacher: '高俊',tags: '26年教龄 | 省骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=627381324&bvid=BV1zt4y1v7vy&cid=246295311&page=1',url2:''},
  {code: '620',name: '初二数学66 二次根式的运算习题课',grade: '初二',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=754980910&bvid=BV1Ur4y1c75B&cid=246296599&page=1',url2:''},
  {code: '621',name: '初二数学68 二次根式的化简、勾股定理的证明（一）',grade: '初二',subject: '数学',tcode: '97',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https:////player.bilibili.com/player.html?aid=244904079&bvid=BV13v411k7tv&cid=246296869&page=1',url2:''},
  {code: '622',name: '初二数学71 认识分式（一） ',grade: '初二',subject: '数学',tcode: '97',teacher: '邱勇',tags: '初三把关 | 深入浅出 | 校明星教师',version: '',url:'https:////player.bilibili.com/player.html?aid=797405684&bvid=BV1sy4y1C7uB&cid=246296910&page=1',url2:''},
  {code: '623',name: '初二数学76 认识分式（二） ',grade: '初二',subject: '数学',tcode: '97',teacher: '邱勇',tags: '初三把关 | 深入浅出 | 校明星教师',version: '',url:'https:////player.bilibili.com/player.html?aid=584954737&bvid=BV1Vz4y1o73F&cid=246297802&page=1',url2:''},
  {code: '624',name: '初二数学79 二次根式的化简、勾股定理的证明（二）',grade: '初二',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=884875908&bvid=BV1pK4y1h7UD&cid=246298039&page=1',url2:''},
  {code: '625',name: '初二数学82 内容分式乘除',grade: '初二',subject: '数学',tcode: '97',teacher: '高俊',tags: '26年教龄 | 省骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=202444340&bvid=BV1Na411A7H7&cid=246298401&page=1',url2:''},
  {code: '626',name: '初二数学87 分式的加减（1）',grade: '初二',subject: '数学',tcode: '97',teacher: '高俊',tags: '26年教龄 | 省骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=457429931&bvid=BV1M541177yg&cid=246298683&page=1',url2:''},
  {code: '627',name: '初二数学91 二次根式的化简习题课',grade: '初二',subject: '数学',tcode: '97',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https:////player.bilibili.com/player.html?aid=927384848&bvid=BV1fT4y1c7jU&cid=246299151&page=1',url2:''},
  {code: '628',name: '初二数学93 勾股定理和勾股逆定理（一）',grade: '初二',subject: '数学',tcode: '97',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https:////player.bilibili.com/player.html?aid=842448236&bvid=BV1g54y1C7kR&cid=246299444&page=1',url2:''},
  {code: '629',name: '初二数学96 分式的加减（二）',grade: '初二',subject: '数学',tcode: '97',teacher: '邱勇',tags: '初三把关 | 深入浅出 | 校明星教师',version: '',url:'https:////player.bilibili.com/player.html?aid=329984028&bvid=BV1VA411E7Vc&cid=246299920&page=1',url2:''},
  {code: '630',name: '初二物理03 八上期末复习—机械运动',grade: '初二',subject: '物理',tcode: '97',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https:////player.bilibili.com/player.html?aid=584970588&bvid=BV1Mz4y1o7uN&cid=246300680&page=1',url2:''},
  {code: '631',name: '初二物理07 八上期末复习—汽化液化',grade: '初二',subject: '物理',tcode: '97',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https:////player.bilibili.com/player.html?aid=584980384&bvid=BV1nz4y1o7gL&cid=246300922&page=1',url2:''},
  {code: '632',name: '初二物理100 《连通器和液压技术》',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=457416467&bvid=BV1G541177CG&cid=246311058&page=1',url2:''},
  {code: '633',name: '初二物理105 压力与压强',grade: '初二',subject: '物理',tcode: '97',teacher: '于斐',tags: '命题克星|奖学金收割机|亲和力UP',version: '',url:'https:////player.bilibili.com/player.html?aid=927446172&bvid=BV1tT4y1w7gW&cid=246311282&page=1',url2:''},
  {code: '634',name: '初二物理11 八上期末复习—平面镜成像',grade: '初二',subject: '物理',tcode: '97',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https:////player.bilibili.com/player.html?aid=287416802&bvid=BV14f4y1B7jf&cid=246301275&page=1',url2:''},
  {code: '635',name: '初二物理14 八上期末复习—光现象1',grade: '初二',subject: '物理',tcode: '97',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https:////player.bilibili.com/player.html?aid=842415356&bvid=BV1F54y1C7QA&cid=246301530&page=1',url2:''},
  {code: '636',name: '初二物理18 八上期末复习—光现象2',grade: '初二',subject: '物理',tcode: '97',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https:////player.bilibili.com/player.html?aid=839933380&bvid=BV1E54y1R7FL&cid=246301781&page=1',url2:''},
  {code: '637',name: '初二物理23 八上期末复习—密度计算1',grade: '初二',subject: '物理',tcode: '97',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https:////player.bilibili.com/player.html?aid=329943240&bvid=BV1FA411E7fk&cid=246302100&page=1',url2:''},
  {code: '638',name: '初二物理25 八上期末复习－声音的特性',grade: '初二',subject: '物理',tcode: '97',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https:////player.bilibili.com/player.html?aid=969935104&bvid=BV1Up4y1r75J&cid=246302143&page=1',url2:''},
  {code: '639',name: '初二物理28 八上期末复习—密度计算2',grade: '初二',subject: '物理',tcode: '97',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https:////player.bilibili.com/player.html?aid=244970698&bvid=BV1hv411k7qk&cid=246302495&page=1',url2:''},
  {code: '640',name: '初二物理31 力',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=754998464&bvid=BV1Cr4y1c7Fy&cid=246302908&page=1',url2:''},
  {code: '641',name: '初二物理36 力的描述',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=627406079&bvid=BV1qt4y1v7Th&cid=246303422&page=1',url2:''},
  {code: '642',name: '初二物理40 弹力 力的测量',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=842435416&bvid=BV1T54y1C78B&cid=246303783&page=1',url2:''},
  {code: '643',name: '初二物理45 重力',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=969958191&bvid=BV12p4y1r7ez&cid=246304123&page=1',url2:''},
  {code: '644',name: '初二物理48 力的认识、重力、弹力',grade: '初二',subject: '物理',tcode: '97',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https:////player.bilibili.com/player.html?aid=499941906&bvid=BV15K411A7P7&cid=246304312&page=1',url2:''},
  {code: '645',name: '初二物理50 摩擦力',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=927393294&bvid=BV1cT4y1w7mB&cid=246304415&page=1',url2:''},
  {code: '646',name: '初二物理56 弹力专题',grade: '初二',subject: '物理',tcode: '97',teacher: '牟泽川',tags: '7年教龄 | 课堂生动 | 深入浅出',version: '',url:'https:////player.bilibili.com/player.html?aid=754892762&bvid=BV11k4y1C7Do&cid=246304842&page=1',url2:''},
  {code: '647',name: '初二物理61 《摩擦力专题》',grade: '初二',subject: '物理',tcode: '97',teacher: '牟泽川',tags: '7年教龄 | 课堂生动 | 深入浅出',version: '',url:'https:////player.bilibili.com/player.html?aid=754978190&bvid=BV12r4y1c71c&cid=246305169&page=1',url2:''},
  {code: '648',name: '初二物理65 《力的合成》',grade: '初二',subject: '物理',tcode: '97',teacher: '牟泽川',tags: '7年教龄 | 课堂生动 | 深入浅出',version: '',url:'https:////player.bilibili.com/player.html?aid=542403941&bvid=BV1Ei4y1j7tM&cid=246306855&page=1',url2:''},
  {code: '649',name: '初二物理70 《牛顿第一定律和惯性》',grade: '初二',subject: '物理',tcode: '97',teacher: '牟泽川',tags: '7年教龄 | 课堂生动 | 深入浅出',version: '',url:'https:////player.bilibili.com/player.html?aid=414925608&bvid=BV1WV41127xR&cid=246307355&page=1',url2:''},
  {code: '650',name: '初二物理73 力与运动',grade: '初二',subject: '物理',tcode: '97',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https:////player.bilibili.com/player.html?aid=969911096&bvid=BV1qp4y1Y7aV&cid=246307649&page=1',url2:''},
  {code: '651',name: '初二物理81 《力的平衡专题》',grade: '初二',subject: '物理',tcode: '97',teacher: '牟泽川',tags: '7年教龄 | 课堂生动 | 深入浅出',version: '',url:'https:////player.bilibili.com/player.html?aid=414953420&bvid=BV16V411278D&cid=246307906&page=1',url2:''},
  {code: '652',name: '初二物理86 《力与运动》',grade: '初二',subject: '物理',tcode: '97',teacher: '牟泽川',tags: '7年教龄 | 课堂生动 | 深入浅出',version: '',url:'https:////player.bilibili.com/player.html?aid=584986729&bvid=BV1pz4y1o7rQ&cid=246308972&page=1',url2:''},
  {code: '653',name: '初二物理90 《压强》',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=202477015&bvid=BV15a411A7od&cid=246309281&page=1',url2:''},
  {code: '654',name: '初二物理95 《液体的压强》',grade: '初二',subject: '物理',tcode: '97',teacher: '王金容',tags: '物理教研组长 | 骨干教师',version: '',url:'https:////player.bilibili.com/player.html?aid=712445319&bvid=BV1bD4y1d7CM&cid=246309621&page=1',url2:''},
  {code: '655',name: '初二物理98 摩擦力',grade: '初二',subject: '物理',tcode: '97',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https:////player.bilibili.com/player.html?aid=499921093&bvid=BV1TK411A72s&cid=246310781&page=1',url2:''},
  {code: '656',name: '初二生物102 原生生物的主要类群',grade: '初二',subject: '生物',tcode: '97',teacher: '杨严',tags: '6年教龄 | 课堂生动有趣',version: '',url:'https:////player.bilibili.com/player.html?aid=842491475&bvid=BV1L54y1C7wr&cid=246279344&page=1',url2:''},
  {code: '657',name: '初二生物47 生命的起源',grade: '初二',subject: '生物',tcode: '97',teacher: '宋孝丽',tags: '国家一级教师',version: '',url:'https:////player.bilibili.com/player.html?aid=372408993&bvid=BV1TZ4y1L7D1&cid=246278977&page=1',url2:''},
  {code: '658',name: '初二生物52 生物的进化',grade: '初二',subject: '生物',tcode: '97',teacher: '宋孝丽',tags: '国家一级教师',version: '',url:'https:////player.bilibili.com/player.html?aid=499933981&bvid=BV1cK411A7Z4&cid=246279026&page=1',url2:''},
  {code: '659',name: '初二生物72 生物的进化',grade: '初二',subject: '生物',tcode: '97',teacher: '杨严',tags: '6年教龄 | 课堂生动有趣',version: '',url:'https:////player.bilibili.com/player.html?aid=969901702&bvid=BV1vp4y1Y7jR&cid=246279070&page=1',url2:''},
  {code: '660',name: '初二生物77 人类的起源与进化',grade: '初二',subject: '生物',tcode: '97',teacher: '杨严',tags: '6年教龄 | 课堂生动有趣',version: '',url:'https:////player.bilibili.com/player.html?aid=202495931&bvid=BV1Ga411A7Nz&cid=246279218&page=1',url2:''},
  {code: '661',name: '初二生物97 生物的分类',grade: '初二',subject: '生物',tcode: '97',teacher: '杨严',tags: '6年教龄 | 课堂生动有趣',version: '',url:'https:////player.bilibili.com/player.html?aid=627493015&bvid=BV1At4y1i7Wv&cid=246279283&page=1',url2:''},
  {code: '662',name: '初二英语02 八年级英语（上）语法复习1',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=542445555&bvid=BV1ri4y1j7bY&cid=246311494&page=1',url2:''},
  {code: '663',name: '初二英语06 八年级英语（上）语法复习2',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=842493642&bvid=BV1554y1C7WJ&cid=246311729&page=1',url2:''},
  {code: '664',name: '初二英语10 八年级英语（上）词汇复习1及运用',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=839923286&bvid=BV1454y1R7ci&cid=246311906&page=1',url2:''},
  {code: '665',name: '初二英语106 语法与操练',grade: '初二',subject: '英语',tcode: '97',teacher: '许源欢',tags: '口音模仿王|精分小戏精|行走表情包',version: '',url:'https:////player.bilibili.com/player.html?aid=627399766&bvid=BV1et4y1v7K2&cid=246373537&page=1',url2:''},
  {code: '666',name: '初二英语110 词汇与操练',grade: '初二',subject: '英语',tcode: '97',teacher: '许源欢',tags: '口音模仿王|精分小戏精|行走表情包',version: '',url:'https:////player.bilibili.com/player.html?aid=457451860&bvid=BV1k541157Z3&cid=246373720&page=1',url2:''},
  {code: '667',name: '初二英语13 八年级英语（上）词汇复习2及运用',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=627415662&bvid=BV1St4y1v73W&cid=246312136&page=1',url2:''},
  {code: '668',name: '初二英语15 八年级英语（上）语法和词汇综合填空特训',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=884900630&bvid=BV1hK4y1h7VX&cid=246312332&page=1',url2:''},
  {code: '669',name: '初二英语17 八年级英语（上）句型复习及运用',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=712430159&bvid=BV1jD4y1d7Jz&cid=246312547&page=1',url2:''},
  {code: '670',name: '初二英语22 八年级英语（上）阅读综合练',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=842462786&bvid=BV1K54y1C7hB&cid=246312797&page=1',url2:''},
  {code: '671',name: '初二英语27 八年级英语（上）完形综合练',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=712388334&bvid=BV13D4y1d7y3&cid=246313118&page=1',url2:''},
  {code: '672',name: '初二英语30 新老师和新冠病毒',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=627396470&bvid=BV1Yt4y1v7To&cid=246313423&page=1',url2:''},
  {code: '673',name: '初二英语35 Molly需要你帮助',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=969950916&bvid=BV1Cp4y1r7r6&cid=246374075&page=1',url2:''},
  {code: '674',name: '初二英语38 词汇句型过关+阅读+语法',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=414913208&bvid=BV18V41127sT&cid=246313958&page=1',url2:''},
  {code: '676',name: '初二英语44 从病毒瘟疫到信息瘟疫2',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=287430660&bvid=BV1Jf4y1B7ec&cid=246315538&page=1',url2:''},
  {code: '677',name: '初二英语49 Let’s have breakfast！',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=414991820&bvid=BV1wV411y7YT&cid=246369281&page=1',url2:''},
  {code: '678',name: '初二英语55 词汇达人公开赛1 （英语词汇拓展策略学习） ',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=884879853&bvid=BV1WK4y1h7on&cid=246315983&page=1',url2:''},
  {code: '679',name: '初二英语60 诗歌和远方 （英美文化背景知识拓展）',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=669899614&bvid=BV1ca4y1L7CR&cid=246316390&page=1',url2:''},
  {code: '680',name: '初二英语63 词汇句型过关+完形+语法',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=842417378&bvid=BV1Q54y1k7oJ&cid=246316606&page=1',url2:''},
  {code: '681',name: '初二英语64 当柯蓝遇上元芳1 （英语阅读推理策略训练1）',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=669920066&bvid=BV17a4y1L7eJ&cid=246317700&page=1',url2:''},
  {code: '682',name: '初二英语69 当柯蓝遇上元芳2 （英语阅读推理策略训练2）',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=797386230&bvid=BV1ty4y1C78U&cid=246318254&page=1',url2:''},
  {code: '683',name: '初二英语74 那些川菜背后的故事 （怎样利用story map进',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=329875834&bvid=BV1rA41177Vo&cid=246318529&page=1',url2:''},
  {code: '684',name: '初二英语80 善良需要传递-Story of Eyam',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=499987957&bvid=BV1tK411A7wp&cid=246368835&page=1',url2:''},
  {code: '685',name: '初二英语85 阅读策略训练-Sequence',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=839936369&bvid=BV1J54y1R7Yd&cid=246318980&page=1',url2:''},
  {code: '686',name: '初二英语88 词汇句型过关+阅读+语法',grade: '初二',subject: '英语',tcode: '97',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https:////player.bilibili.com/player.html?aid=754884083&bvid=BV1Ck4y1C7jY&cid=246368559&page=1',url2:''},
  {code: '687',name: '初二英语89 绘本阅读',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=712431166&bvid=BV1jD4y1d7AW&cid=246368290&page=1',url2:''},
  {code: '688',name: '初二英语94 入其俗,从其令-英美文化习俗阅读',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=839920862&bvid=BV1s54y1R7F8&cid=246319614&page=1',url2:''},
  {code: '689',name: '初二英语99 那些人，那些事儿(图片新闻写作指导)',grade: '初二',subject: '英语',tcode: '97',teacher: '程莉',tags: '英语学科督学 | 19年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=542481386&bvid=BV1Xi4y1j7yo&cid=246367720&page=1',url2:''},
  {code: '690',name: '初二语文04 初二科幻文写作上',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=754957533&bvid=BV1Kk4y1y7KC&cid=246367540&page=1',url2:''},
  {code: '691',name: '初二语文08 初二科幻文写作下',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=329911058&bvid=BV1DA41177aT&cid=246367326&page=1',url2:''},
  {code: '692',name: '初二语文103 《庄子》二则《北冥有鱼》',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=542470670&bvid=BV1ri4y1j7ut&cid=246328555&page=1',url2:''},
  {code: '693',name: '初二语文108 八下重点古诗词练习',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=542418670&bvid=BV1ei4y1j7ko&cid=246328906&page=1',url2:''},
  {code: '694',name: '初二语文19 初二阅读小说通关',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=839948693&bvid=BV1Y54y1R7dg&cid=246367174&page=1',url2:''},
  {code: '695',name: '初二语文24 初二基础病句通关',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=584912462&bvid=BV1Zz4y1d7mx&cid=246366984&page=1',url2:''},
  {code: '696',name: '初二语文33 八下课外古诗词《诗经》',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=839994324&bvid=BV1q54y1R7k2&cid=246326487&page=1',url2:''},
  {code: '697',name: '初二语文34 八下重点现代诗练习',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=797376909&bvid=BV1xy4y1C7pd&cid=246326595&page=1',url2:''},
  {code: '698',name: '初二语文42 《送杜少府之任蜀州》《望洞庭湖赠张丞相》',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=754933981&bvid=BV1Dk4y1C73q&cid=246326621&page=1',url2:''},
  {code: '699',name: '初二语文53 山水田园市派代表（一）：错失机会的孟浩然',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=842488705&bvid=BV1V54y1C7vw&cid=246366734&page=1',url2:''},
  {code: '700',name: '初二语文58 杜甫 茅屋为秋风所破歌',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=669885626&bvid=BV1Ta4y1L7XU&cid=246327522&page=1',url2:''},
  {code: '701',name: '初二语文59 八下重点文言文练习一',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=499960265&bvid=BV1MK411A74d&cid=246327638&page=1',url2:''},
  {code: '702',name: '初二语文67 白居易 《卖炭翁》',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=244970278&bvid=BV1av411k7V6&cid=246328008&page=1',url2:''},
  {code: '703',name: '初二语文78 卖炭翁',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=884981104&bvid=BV19K4y1h777&cid=246328173&page=1',url2:''},
  {code: '704',name: '初二语文83 题破山寺后禅院 送友人',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=884877129&bvid=BV1pK4y1h7ib&cid=246328217&page=1',url2:''},
  {code: '705',name: '初二语文84 八下重点基础复习一',grade: '初二',subject: '语文',tcode: '97',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https:////player.bilibili.com/player.html?aid=287428761&bvid=BV1nf4y1B7Tq&cid=246328307&page=1',url2:''},
  {code: '706',name: '初二语文92 卜算子.黄州定慧寓居作 卜算子.咏梅',grade: '初二',subject: '语文',tcode: '97',teacher: '李佳佳',tags: '语文基本功大赛一等奖 | 8年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=372392435&bvid=BV1XZ4y157Mb&cid=246328424&page=1',url2:''},
  {code: '707',name: '初三化学03 期末查漏补缺—质量守恒',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=287395201&bvid=BV1Mf4y1B7J9&cid=245853034&page=1',url2:''},
  {code: '708',name: '初三化学08 实验原理-气密性检查',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=669994496&bvid=BV18a4y1L7pi&cid=245855197&page=1',url2:''},
  {code: '709',name: '初三化学13 推断题 解题题眼',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=754934233&bvid=BV1Dk4y1C7LZ&cid=245856701&page=1',url2:''},
  {code: '710',name: '初三化学19 金属活动性',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=584906379&bvid=BV1mz4y1d7sZ&cid=245859723&page=1',url2:''},
  {code: '711',name: '初三化学25 期末查漏补缺—金属滤液滤渣',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=839890412&bvid=BV1G54y127qW&cid=245868513&page=1',url2:''},
  {code: '712',name: '初三化学28 流程图题',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=839910879&bvid=BV1p54y1R75Z&cid=245870768&page=1',url2:''},
  {code: '713',name: '初三化学31 溶液',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=627406445&bvid=BV1qt4y1v7EQ&cid=245872483&page=1',url2:''},
  {code: '714',name: '初三化学37 中考复习—溶解度',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=712385593&bvid=BV1GD4y1d75z&cid=245874290&page=1',url2:''},
  {code: '715',name: '初三化学43 金属与金属材料',grade: '初三',subject: '化学',tcode: '97',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https:////player.bilibili.com/player.html?aid=627432123&bvid=BV1yt4y1v774&cid=245875672&page=1',url2:''},
  {code: '716',name: '初三化学49 溶解度',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=754885255&bvid=BV11k4y1C784&cid=245880124&page=1',url2:''},
  {code: '717',name: '初三化学56 金属化学性质',grade: '初三',subject: '化学',tcode: '97',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https:////player.bilibili.com/player.html?aid=627403642&bvid=BV1vt4y1v7QB&cid=245881752&page=1',url2:''},
  {code: '718',name: '初三化学60 溶质的质量分数',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=797403509&bvid=BV1py4y1C7H9&cid=245882881&page=1',url2:''},
  {code: '719',name: '初三化学62 溶液稀释',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=414938113&bvid=BV14V41127Y4&cid=245885817&page=1',url2:''},
  {code: '720',name: '初三化学69 金属活动性',grade: '初三',subject: '化学',tcode: '97',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https:////player.bilibili.com/player.html?aid=244969049&bvid=BV1bv411k7fY&cid=245901002&page=1',url2:''},
  {code: '721',name: '初三化学75 金属化学性质中考基础练习',grade: '初三',subject: '化学',tcode: '97',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https:////player.bilibili.com/player.html?aid=842399995&bvid=BV1Z54y1k7Tw&cid=245902366&page=1',url2:''},
  {code: '722',name: '初三化学82 溶质质量分数',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=202422745&bvid=BV1fa411w7xn&cid=245904602&page=1',url2:''},
  {code: '723',name: '初三化学89 金属资源的利用和保护',grade: '初三',subject: '化学',tcode: '97',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https:////player.bilibili.com/player.html?aid=542420392&bvid=BV1ei4y1j7A7&cid=245905800&page=1',url2:''},
  {code: '724',name: '初三化学93 固体的溶解度 习题课',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=372477431&bvid=BV14Z4y1L7EZ&cid=245906907&page=1',url2:''},
  {code: '725',name: '初三化学96 溶解度曲线',grade: '初三',subject: '化学',tcode: '97',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https:////player.bilibili.com/player.html?aid=754903742&bvid=BV16k4y1C7cU&cid=245908947&page=1',url2:''},
  {code: '726',name: '初三数学04 数与式',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=842486034&bvid=BV1554y1C7Px&cid=245910858&page=1',url2:''},
  {code: '727',name: '初三数学09 数与式习题课1',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=457483398&bvid=BV1X541157Ra&cid=246130638&page=1',url2:''},
  {code: '728',name: '初三数学14 数与式习题课2',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=287426526&bvid=BV1Ef4y1B7Ua&cid=245914660&page=1',url2:''},
  {code: '729',name: '初三数学16 方程、不等式',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=884957705&bvid=BV1BK4y1h7tj&cid=246132157&page=1',url2:''},
  {code: '730',name: '初三数学20 方程、不等式（习题课1）',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=542382347&bvid=BV1pi4y1j7sZ&cid=246143180&page=1',url2:''},
  {code: '731',name: '初三数学26 方程、不等式（习题课2）',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=202401960&bvid=BV1ka411w7YU&cid=246146541&page=1',url2:''},
  {code: '732',name: '初三数学32 概率&统计',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=499875585&bvid=BV1pK411N7BZ&cid=246147922&page=1',url2:''},
  {code: '733',name: '初三数学38 概率&统计（习题课）',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=202383769&bvid=BV1Ua411w7Kg&cid=246156435&page=1',url2:''},
  {code: '734',name: '初三数学44 中考复习：函数及其图像（1）',grade: '初三',subject: '数学',tcode: '97',teacher: '周海东',tags: '高级教师 | 区学科带头人',version: '',url:'https:////player.bilibili.com/player.html?aid=927463333&bvid=BV1pT4y1w7YK&cid=246158609&page=1',url2:''},
  {code: '735',name: '初三数学46 二次函数概念',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=287434422&bvid=BV1Hf4y1B7Gu&cid=246164800&page=1',url2:''},
  {code: '736',name: '初三数学47 中考专项复习——三角形',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=839974023&bvid=BV1h54y1R7TK&cid=246166058&page=1',url2:''},
  {code: '737',name: '初三数学50 中考复习：函数及其图像（2）',grade: '初三',subject: '数学',tcode: '97',teacher: '周海东',tags: '高级教师 | 区学科带头人',version: '',url:'https:////player.bilibili.com/player.html?aid=884929898&bvid=BV1bK4y1h7Y7&cid=246168647&page=1',url2:''},
  {code: '738',name: '初三数学52 二次函数的图像与性质（1）',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=372386545&bvid=BV1fZ4y157Rn&cid=246169258&page=1',url2:''},
  {code: '739',name: '初三数学57 中考复习：函数及其图像（3） ',grade: '初三',subject: '数学',tcode: '97',teacher: '周海东',tags: '高级教师 | 区学科带头人',version: '',url:'https:////player.bilibili.com/player.html?aid=329958844&bvid=BV1dA41177hy&cid=246172085&page=1',url2:''},
  {code: '740',name: '初三数学59 二次函数的图像与性质（2） ',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=414970831&bvid=BV1qV4112719&cid=246350171&page=1',url2:''},
  {code: '741',name: '初三数学63 中考复习：函数及其图像（4） ',grade: '初三',subject: '数学',tcode: '97',teacher: '周海东',tags: '高级教师 | 区学科带头人',version: '',url:'https:////player.bilibili.com/player.html?aid=329900729&bvid=BV1BA41177Qw&cid=246174860&page=1',url2:''},
  {code: '742',name: '初三数学65 二次函数的关系式',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=927480096&bvid=BV1dK4y1f7X2&cid=246176169&page=1',url2:''},
  {code: '743',name: '初三数学70 中考复习：函数及其图像（5） ',grade: '初三',subject: '数学',tcode: '97',teacher: '周海东',tags: '高级教师 | 区学科带头人',version: '',url:'https:////player.bilibili.com/player.html?aid=329882291&bvid=BV1rA411779r&cid=246179858&page=1',url2:''},
  {code: '744',name: '初三数学72 二次函数的实践与探索（1）',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=584952050&bvid=BV13z4y1o7Ni&cid=246181284&page=1',url2:''},
  {code: '745',name: '初三数学77 三角形全等（一）',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=627439890&bvid=BV12t4y1v7rN&cid=246182883&page=1',url2:''},
  {code: '746',name: '初三数学78 二次函数的实践与探索（2）',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=499887671&bvid=BV1iK411N7Zr&cid=246184173&page=1',url2:''},
  {code: '747',name: '初三数学79 中考专项复习——四边形',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=457489507&bvid=BV19541157Ys&cid=246185643&page=1',url2:''},
  {code: '748',name: '初三数学84 三角形全等（一）习题课',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=414887460&bvid=BV1nV41127c8&cid=246187407&page=1',url2:''},
  {code: '749',name: '初三数学85 二次函数中的a,b,c',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=542483370&bvid=BV1Ri4y1j7vf&cid=246188809&page=1',url2:''},
  {code: '750',name: '初三数学91 三角形全等（二）',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=457445406&bvid=BV1k5411577W&cid=246189866&page=1',url2:''},
  {code: '751',name: '初三数学92 圆的基本元素',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=884996139&bvid=BV1UK4y1h765&cid=246190496&page=1',url2:''},
  {code: '752',name: '初三数学98 三角形全等（二）习题课',grade: '初三',subject: '数学',tcode: '97',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https:////player.bilibili.com/player.html?aid=372419131&bvid=BV1uZ4y1L7k4&cid=246192090&page=1',url2:''},
  {code: '753',name: '初三数学99 圆的对称性（1）',grade: '初三',subject: '数学',tcode: '97',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https:////player.bilibili.com/player.html?aid=839882315&bvid=BV1g54y1277K&cid=246193489&page=1',url2:''},
  {code: '754',name: '初三物理01 中考复习——声、热',grade: '初三',subject: '物理',tcode: '97',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https:////player.bilibili.com/player.html?aid=754936576&bvid=BV1Sk4y1C7XV&cid=246196767&page=1',url2:''},
  {code: '755',name: '初三物理06 光的直线传播与反射',grade: '初三',subject: '物理',tcode: '97',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https:////player.bilibili.com/player.html?aid=202492078&bvid=BV1ga411A7n8&cid=246198108&page=1',url2:''},
  {code: '756',name: '初三物理11 光的折射与色散',grade: '初三',subject: '物理',tcode: '97',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https:////player.bilibili.com/player.html?aid=202416871&bvid=BV1Za411w7R4&cid=246199449&page=1',url2:''},
  {code: '757',name: '初三物理17 质量与密度',grade: '初三',subject: '物理',tcode: '97',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https:////player.bilibili.com/player.html?aid=372375246&bvid=BV11Z4y157G8&cid=246200530&page=1',url2:''},
  {code: '758',name: '初三物理22 中考复习——力学基础',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=457437047&bvid=BV1u541177AQ&cid=246204700&page=1',url2:''},
  {code: '759',name: '初三物理23 中考复习——压强1',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=669883638&bvid=BV1Ka4y1L7wf&cid=246206911&page=1',url2:''},
  {code: '760',name: '初三物理29 压强2',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=202493283&bvid=BV1ga411A7Ms&cid=246214931&page=1',url2:''},
  {code: '761',name: '初三物理35 中考复习——浮力1',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=797377662&bvid=BV1xy4y1C7wV&cid=246215224&page=1',url2:''},
  {code: '762',name: '初三物理45 磁体与磁场',grade: '初三',subject: '物理',tcode: '97',teacher: '徐建宝',tags: '骨干教师 | 中国科学院博士',version: '',url:'https:////player.bilibili.com/player.html?aid=244936806&bvid=BV1Hv411k75H&cid=246215298&page=1',url2:''},
  {code: '763',name: '初三物理51 电流的磁场',grade: '初三',subject: '物理',tcode: '97',teacher: '徐建宝',tags: '骨干教师 | 中国科学院博士',version: '',url:'https:////player.bilibili.com/player.html?aid=627464782&bvid=BV1Rt4y1v7AJ&cid=246215396&page=1',url2:''},
  {code: '764',name: '初三物理53 中考复习——浮力2',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=842440328&bvid=BV1M54y1C7JH&cid=246215498&page=1',url2:''},
  {code: '765',name: '初三物理64 磁场对电流的作用 电动机',grade: '初三',subject: '物理',tcode: '97',teacher: '徐建宝',tags: '骨干教师 | 中国科学院博士',version: '',url:'https:////player.bilibili.com/player.html?aid=414886848&bvid=BV1nV41127JB&cid=246215609&page=1',url2:''},
  {code: '766',name: '初三物理71 电磁感应 发电机',grade: '初三',subject: '物理',tcode: '97',teacher: '徐建宝',tags: '骨干教师 | 中国科学院博士',version: '',url:'https:////player.bilibili.com/player.html?aid=884944646&bvid=BV1kK4y1h78W&cid=246215766&page=1',url2:''},
  {code: '767',name: '初三物理76 中考复习——重力',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=669988611&bvid=BV1za4y1L7vq&cid=246215802&page=1',url2:''},
  {code: '768',name: '初三物理83 中考复习——弹力',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=627401887&bvid=BV1vt4y1v7R4&cid=246218262&page=1',url2:''},
  {code: '769',name: '初三物理86 中考复习——摩擦力',grade: '初三',subject: '物理',tcode: '97',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https:////player.bilibili.com/player.html?aid=669932112&bvid=BV13a4y1L7We&cid=246218689&page=1',url2:''},
  {code: '770',name: '初三物理97 中考复习——气体压强',grade: '初三',subject: '物理',tcode: '97',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https:////player.bilibili.com/player.html?aid=457439691&bvid=BV1g541177pq&cid=246220741&page=1',url2:''},
  {code: '771',name: '初三英语02 中考真题语法1',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=287408764&bvid=BV1Wf4y1B7ZA&cid=246221774&page=1',url2:''},
  {code: '772',name: '初三英语07 中考真题词汇1',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=669897590&bvid=BV1wa4y1L7nR&cid=246222112&page=1',url2:''},
  {code: '773',name: '初三英语100 中考真题写作2 范哥核心句子论',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=329915166&bvid=BV1QA41177y6&cid=246232495&page=1',url2:''},
  {code: '774',name: '初三英语12 阅读理解六大神能',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=584958403&bvid=BV1Pz4y1o7tE&cid=246222422&page=1',url2:''},
  {code: '775',name: '初三英语18 完形 如何造句',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=287408243&bvid=BV1Wf4y1B7U5&cid=246223977&page=1',url2:''},
  {code: '776',name: '初三英语24 中考真题写作1 如何造句升级',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=969967862&bvid=BV1Zp4y1r7DX&cid=246224224&page=1',url2:''},
  {code: '777',name: '初三英语30 中考真题语法2',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=499898564&bvid=BV18K411N7ZX&cid=246224736&page=1',url2:''},
  {code: '778',name: '初三英语34 五大基本句型 词汇2',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=287442487&bvid=BV1ef4y1B7sY&cid=246225563&page=1',url2:''},
  {code: '779',name: '初三英语36 语法-五大基本句型',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=839887176&bvid=BV1354y127Tk&cid=246225887&page=1',url2:''},
  {code: '780',name: '初三英语42 中考冲刺巩固复习1 时态',grade: '初三',subject: '英语',tcode: '97',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https:////player.bilibili.com/player.html?aid=542419774&bvid=BV1ei4y1j7ay&cid=246226648&page=1',url2:''},
  {code: '781',name: '初三英语48 中考冲刺巩固复习2 情态动词',grade: '初三',subject: '英语',tcode: '97',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https:////player.bilibili.com/player.html?aid=542473029&bvid=BV16i4y1j7iq&cid=246226724&page=1',url2:''},
  {code: '782',name: '初三英语55 中考冲刺巩固复习3 情态动词',grade: '初三',subject: '英语',tcode: '97',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https:////player.bilibili.com/player.html?aid=372388478&bvid=BV1cZ4y1L72W&cid=246227118&page=1',url2:''},
  {code: '783',name: '初三英语61 英语巩固复习4 专项练习',grade: '初三',subject: '英语',tcode: '97',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https:////player.bilibili.com/player.html?aid=839899903&bvid=BV1N54y127NK&cid=246229798&page=1',url2:''},
  {code: '784',name: '初三英语66 中考真题完形2',grade: '初三',subject: '英语',tcode: '97',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https:////player.bilibili.com/player.html?aid=202401707&bvid=BV1Ca411w7Nz&cid=246230302&page=1',url2:''},
  {code: '785',name: '初三英语68 英语巩固复习5 专项练习',grade: '初三',subject: '英语',tcode: '97',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https:////player.bilibili.com/player.html?aid=969949565&bvid=BV1Cp4y1r7Z5&cid=246230383&page=1',url2:''},
  {code: '786',name: '初三英语74 中考英语——词汇&语法',grade: '初三',subject: '英语',tcode: '97',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https:////player.bilibili.com/player.html?aid=797438797&bvid=BV1vy4y1C7NG&cid=246230607&page=1',url2:''},
  {code: '787',name: '初三英语81 中考英语——词汇&语法 词性、句法',grade: '初三',subject: '英语',tcode: '97',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https:////player.bilibili.com/player.html?aid=754970035&bvid=BV1Fk4y1y7TC&cid=246230811&page=1',url2:''},
  {code: '788',name: '初三英语88 中考英语——词汇&语法 谓语',grade: '初三',subject: '英语',tcode: '97',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https:////player.bilibili.com/player.html?aid=797434878&bvid=BV1Yy4y1C7SB&cid=246232030&page=1',url2:''},
  {code: '789',name: '初三英语95 中考英语——词汇&语法 词性 成分',grade: '初三',subject: '英语',tcode: '97',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https:////player.bilibili.com/player.html?aid=839928152&bvid=BV1754y1R7Tc&cid=246232303&page=1',url2:''},
  {code: '790',name: '初三语文05 中考必备阅读技巧之标题作用',grade: '初三',subject: '语文',tcode: '97',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https:////player.bilibili.com/player.html?aid=202481072&bvid=BV1ja411A7G3&cid=246234171&page=1',url2:''},
  {code: '791',name: '初三语文10 中考必备阅读技巧之修辞赏析',grade: '初三',subject: '语文',tcode: '97',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https:////player.bilibili.com/player.html?aid=839886910&bvid=BV1354y127Pk&cid=246234570&page=1',url2:''},
  {code: '792',name: '初三语文15 中考必备阅读技巧之赏析类题型',grade: '初三',subject: '语文',tcode: '97',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https:////player.bilibili.com/player.html?aid=669905502&bvid=BV1Pa4y1L7kA&cid=246234948&page=1',url2:''},
  {code: '793',name: '初三语文21 中考必备作文之成长类写作',grade: '初三',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https:////player.bilibili.com/player.html?aid=842471035&bvid=BV1E54y1C7rZ&cid=246235127&page=1',url2:''},
  {code: '794',name: '初三语文27 中考必备作文之亲情类写作',grade: '初三',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https:////player.bilibili.com/player.html?aid=969987528&bvid=BV1Rp4y1r7eB&cid=246235414&page=1',url2:''},
  {code: '795',name: '初三语文33 中考基础之病句刷题',grade: '初三',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https:////player.bilibili.com/player.html?aid=499897583&bvid=BV1hK411N7j9&cid=246235999&page=1',url2:''},
  {code: '796',name: '初三语文39 中考名著之水浒刷题',grade: '初三',subject: '语文',tcode: '97',teacher: '杨红子',tags: '北师大本硕|5年教龄|语文解题达人',version: '',url:'https:////player.bilibili.com/player.html?aid=499971570&bvid=BV1GK411A7sD&cid=246236068&page=1',url2:''},
  {code: '797',name: '初三语文40 中考必考文言文复习（一）',grade: '初三',subject: '语文',tcode: '97',teacher: '齐霁',tags: '9年教龄|提分能手|满分作文名师',version: '',url:'https:////player.bilibili.com/player.html?aid=329990766&bvid=BV1KA411E76T&cid=246350324&page=1',url2:''},
  {code: '798',name: '初三语文41 风雅中国，吟唱《诗经》之美',grade: '初三',subject: '语文',tcode: '97',teacher: '吕晓艳',tags: '中学高级教师 | 省级教学名师',version: '',url:'https:////player.bilibili.com/player.html?aid=244949745&bvid=BV1vv411k7yb&cid=246241371&page=1',url2:''},
  {code: '799',name: '初三语文54 文化自信，传承《诗经》',grade: '初三',subject: '语文',tcode: '97',teacher: '吕晓艳',tags: '中学高级教师 | 省级教学名师',version: '',url:'https:////player.bilibili.com/player.html?aid=202493008&bvid=BV1ga411A7AV&cid=246241683&page=1',url2:''},
  {code: '800',name: '初三语文58 解密中考阅读（一）',grade: '初三',subject: '语文',tcode: '97',teacher: '沈黎江',tags: '二十年教龄 | 硬核提分',version: '',url:'https:////player.bilibili.com/player.html?aid=372493113&bvid=BV1HZ4y1L7ZK&cid=246241943&page=1',url2:''},
  {code: '801',name: '初三语文67 音乐之美，唱响《诗经》',grade: '初三',subject: '语文',tcode: '97',teacher: '吕晓艳',tags: '中学高级教师 | 省级教学名师',version: '',url:'https:////player.bilibili.com/player.html?aid=712378647&bvid=BV1uD4y1d7em&cid=246266299&page=1',url2:''},
  {code: '802',name: '初三语文73 乱世中的美神——李清照（一）',grade: '初三',subject: '语文',tcode: '97',teacher: '杨智慧',tags: '一线语文教师 | 寓教于乐',version: '',url:'https:////player.bilibili.com/player.html?aid=927460600&bvid=BV1nT4y1w7tH&cid=246266560&page=1',url2:''},
  {code: '803',name: '初三语文80 乱世中的美神——李清照（二）',grade: '初三',subject: '语文',tcode: '97',teacher: '杨智慧',tags: '一线语文教师 | 寓教于乐',version: '',url:'https:////player.bilibili.com/player.html?aid=457454569&bvid=BV1y541157Rn&cid=246267039&page=1',url2:''},
  {code: '804',name: '初三语文87 把栏杆拍遍——辛弃疾',grade: '初三',subject: '语文',tcode: '97',teacher: '杨智慧',tags: '一线语文教师 | 寓教于乐',version: '',url:'https:////player.bilibili.com/player.html?aid=329897264&bvid=BV1qA411777k&cid=246267244&page=1',url2:''},
  {code: '805',name: '初三语文90 解密中考阅读（一）',grade: '初三',subject: '语文',tcode: '97',teacher: '沈黎江',tags: '二十年教龄 | 硬核提分',version: '',url:'https:////player.bilibili.com/player.html?aid=839889842&bvid=BV1V54y127Ny&cid=246267302&page=1',url2:''},
  {code: '806',name: '初三语文94 把栏杆拍遍--辛弃疾2',grade: '初三',subject: '语文',tcode: '97',teacher: '杨智慧',tags: '一线语文教师 | 寓教于乐',version: '',url:'https:////player.bilibili.com/player.html?aid=754953394&bvid=BV1Pk4y1y7RU&cid=246267555&page=1',url2:''},


  {code: '807',name: '高一英语16 grammar 第4讲',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=585237125&bvid=BV1Vz4y1y7SQ&cid=251156287&page=1',url2:''},
  {code: '808',name: '高一英语17 完形填空技巧提分',grade: '高一',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=287683750&bvid=BV1Tf4y1q7Gf&cid=251157058&page=1',url2:''},
  {code: '809',name: '高一物理18 位移时间图像的应用',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=839743894&bvid=BV1j54y117yU&cid=239611133&page=1',url2:''},
  {code: '810',name: '高一语文19 文言文句法初探',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=414709878&bvid=BV1oV411m79k&cid=239613776&page=1',url2:''},
  {code: '811',name: '高一数学20 函数图像问题的上帝视角',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=415180424&bvid=BV1gV41117WN&cid=251131379&page=1',url2:''},
  {code: '812',name: '高一数学21 抽象函数求值问题',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=627229494&bvid=BV1st4y1q7GB&cid=239828757&page=1',url2:''},
  {code: '813',name: '高一英语22 完型填空技巧提分',grade: '高一',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=669653575&bvid=BV1qa4y1j7GP&cid=239829665&page=1',url2:''},
  {code: '814',name: '高一语文23 《明史》文本精读（1）',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=842706152&bvid=BV1U54y1r74X&cid=251176162&page=1',url2:''},
  {code: '815',name: '高一化学24 阿伏伽德罗定律',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=287698513&bvid=BV1Ff4y1q76q&cid=251125552&page=1',url2:''},
  {code: '816',name: '高一语文25 诗歌解读关键一招——意象',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=415152357&bvid=BV1cV41117W9&cid=251176518&page=1',url2:''},
  {code: '817',name: '高一数学26 函数奇偶性的天选技巧（上）',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=842668104&bvid=BV1q54y1r7Si&cid=251132193&page=1',url2:''},
  {code: '818',name: '高一英语27 grammar',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=927719360&bvid=BV1fT4y1F7YT&cid=251158301&page=1',url2:''},
  {code: '819',name: '高一物理28 等时圆模型',grade: '高一',subject: '数学',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=797628165&bvid=BV1Dy4y1r7o9&cid=251144078&page=1',url2:''},
  {code: '820',name: '高一化学29 铝及其化合物的性质',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=500167241&bvid=BV1VK411P7jh&cid=251125838&page=1',url2:''},
  {code: '821',name: '高一语文30 论述类文本初探',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=500247454&bvid=BV1DK411G7uW&cid=251186894&page=1',url2:''},
  {code: '822',name: '高一数学31 函数奇偶性的天选技巧（下）',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=669689287&bvid=BV1Ua4y1j7nr&cid=239454359&page=1',url2:''},
  {code: '823',name: '高一英语32 School Life 单词',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=712203940&bvid=BV12D4y1o7Nc&cid=239460587&page=1',url2:''},
  {code: '824',name: '高一英语33 阅读金三角理论',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=884697316&bvid=BV1ZK4y1a7vJ&cid=239467477&page=1',url2:''},
  {code: '825',name: '高一物理34 连接体问题',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=627155434&bvid=BV13t4y1q7SH&cid=239471784&page=1',url2:''},
  {code: '826',name: '高一语文35 素材的积累',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=839652001&bvid=BV1F54y117Wq&cid=239477711&page=1',url2:''},
  {code: '827',name: '高一数学36 平面向量&三角函数秒杀技',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=287185647&bvid=BV16f4y1D7iQ&cid=239505526&page=1',url2:''},
  {code: '828',name: '高一语文37 抗疫期间学生心理防护',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=839744274&bvid=BV1j54y117d2&cid=239519597&page=1',url2:''},
  {code: '829',name: '高一数学38 三角函数的恒等变换',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=457184473&bvid=BV1w5411j7QK&cid=239520440&page=1',url2:''},
  {code: '830',name: '高一英语39 Cloze 完形',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=287676439&bvid=BV1Pf4y1q784&cid=251159658&page=1',url2:''},
  {code: '831',name: '高一物理40 连接体问题进阶',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=244697401&bvid=BV1mv411C7Cd&cid=239521488&page=1',url2:''},
  {code: '832',name: '高一生物41 《细胞的增殖》细胞不能无限长大的原因',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=670166700&bvid=BV14a4y1s7A7&cid=251129647&page=1',url2:''},
  {code: '833',name: '高一物理42 相对运动法',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=800144802&bvid=BV12y4y1B7WW&cid=251147118&page=1',url2:''},
  {code: '834',name: '高一语文43 疫情当前，社会就是一本打开的语文书',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=627186980&bvid=BV1Jt4y1q787&cid=239595472&page=1',url2:''},
  {code: '835',name: '高一物理45 超重和失重',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=372700848&bvid=BV11Z4y1V7W8&cid=251146751&page=1',url2:''},
  {code: '836',name: '高一英语46 grammar',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=499739519&bvid=BV1rK411P71G&cid=239603350&page=1',url2:''},
  {code: '837',name: '高一生物47 《细胞的增殖》有丝分裂的过程',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=797710450&bvid=BV1yy4y1z7zc&cid=252772303&page=1',url2:''},
  {code: '838',name: '高一化学48 元素周期表结构',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=585236138&bvid=BV1cz4y1y7ZB&cid=252751493&page=1',url2:''},
  {code: '839',name: '高一数学49 巧算高次函数',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=584628226&bvid=BV1Gz4y1Z7UA&cid=239609336&page=1',url2:''},
  {code: '840',name: '高一语文50 疫情当前，社会就是一本打开的语文书',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=970158817&bvid=BV1Up4y1k7K4&cid=251187478&page=1',url2:''},
  {code: '841',name: '高一数学51 两角和与差的正弦、余弦、正切公式2',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=330231389&bvid=BV1qA411j789&cid=252786970&page=1',url2:''},
  {code: '842',name: '高一英语52 英语课程巩固复习3',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=202652390&bvid=BV1ta411c7QN&cid=252798989&page=1',url2:''},
  {code: '843',name: '高一物理53 瞬时性问题',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=457670415&bvid=BV1z5411L7qb&cid=252452363&page=1',url2:''},
  {code: '844',name: '高一生物54 有丝分裂的曲线和图像',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=842722250&bvid=BV1y54y1r7Kk&cid=252773897&page=1',url2:''},
  {code: '845',name: '高一化学55 元素的性质与原子结构(一）',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=800137083&bvid=BV1yy4y1B7Tz&cid=252753683&page=1',url2:''},
  {code: '846',name: '高一化学56 原子结构',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=500185180&bvid=BV1hK411G76f&cid=251127919&page=1',url2:''},
  {code: '847',name: '高一语文57 荷塘月色',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=797655466&bvid=BV1Fy4y1k7i3&cid=251187631&page=1',url2:''},
  {code: '848',name: '高一数学58 二倍角的正弦、余弦、正切公式1',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=542723568&bvid=BV1Li4y1L7ae&cid=252788699&page=1',url2:''},
  {code: '849',name: '高一物理59 传送带问题1',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=287701010&bvid=BV1wf4y1q7Pu&cid=252792542&page=1',url2:''},
  {code: '850',name: '高一英语60 Part1 Reading',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=330236124&bvid=BV1DA411j7sA&cid=251173077&page=1',url2:''},
  {code: '851',name: '高一生物61 实验：观察根尖分生组织的有丝分裂、',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=670153986&bvid=BV1Ya4y1s7N6&cid=252776066&page=1',url2:''},
  {code: '852',name: '高一英语62 reading',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=670164625&bvid=BV14a4y1s7BS&cid=251173383&page=1',url2:''},
  {code: '853',name: '高一语文63 荷塘月色',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=755231054&bvid=BV1Rr4y1w7S7&cid=251187962&page=1',url2:''},
  {code: '854',name: '高一数学64 二倍角的正弦、余弦、正切公式2',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=287740039&bvid=BV1sf4y1q7Y1&cid=251137787&page=1',url2:''},
  {code: '855',name: '高一英语65 完形填空',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=415194332&bvid=BV1AV41117ha&cid=251173704&page=1',url2:''},
  {code: '856',name: '高一物理66 传送带问题2',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=245234363&bvid=BV1gv411r7eh&cid=252452683&page=1',url2:''},
  {code: '857',name: '高一化学67 元素的性质与原子结构(二）',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=797651791&bvid=BV1uy4y1k7jZ&cid=252757452&page=1',url2:''},
  {code: '858',name: '高一语文68 先秦诗歌',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=797731109&bvid=BV1ry4y1z7Kw&cid=251188288&page=1',url2:''},
  {code: '859',name: '高一语文69 荷塘月色',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=585227616&bvid=BV1fz4y1C7bL&cid=252457937&page=1',url2:''},
  {code: '860',name: '高一数学70 三角恒等式习题课',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=970190166&bvid=BV1dp4y1k7zD&cid=251138343&page=1',url2:''},
  {code: '861',name: '高一英语71 英语课程巩固复习6',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=800194871&bvid=BV1Py4y1z7gs&cid=252801082&page=1',url2:''},
  {code: '862',name: '高一物理72 传送带问题3',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=457664620&bvid=BV1B5411L7t2&cid=251151861&page=1',url2:''},
  {code: '863',name: '高一生物73 细胞的生命历程',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=797645908&bvid=BV1Ny4y1k7kx&cid=251129741&page=1',url2:''},
  {code: '864',name: '高一物理74 摩擦角与自锁',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=500130090&bvid=BV1wK411P7ju&cid=251152662&page=1',url2:''},
  {code: '865',name: '高一语文75 故都的秋',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=800139959&bvid=BV11y4y1B7Yq&cid=251191376&page=1',url2:''},
  {code: '866',name: '高一数学76 正弦定理1',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=797737644&bvid=BV19y4y1z7RB&cid=251138977&page=1',url2:''},
  {code: '867',name: '高一物理77 传送带问题4',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=245248173&bvid=BV1xv411r7BS&cid=252794323&page=1',url2:''},
  {code: '868',name: '高一英语78 grammar',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=842704459&bvid=BV1S54y1r75q&cid=251174529&page=1',url2:''},
  {code: '869',name: '高一生物79 《细胞的分化》',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=542745100&bvid=BV1ei4y1L7qi&cid=252778543&page=1',url2:''},
  {code: '870',name: '高一化学80 核素',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=755156659&bvid=BV1Yr4y1w7js&cid=252760257&page=1',url2:''},
  {code: '871',name: '高一数学81 巧算高次函数',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=670143505&bvid=BV1ha4y1s73P&cid=251139033&page=1',url2:''},
  {code: '872',name: '高一语文82 故都的秋',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=372711370&bvid=BV1ZZ4y1V7cL&cid=251191885&page=1',url2:''},
  {code: '873',name: '高一数学83 正弦定理2',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=457710946&bvid=BV1n5411V7hR&cid=252790467&page=1',url2:''},
  {code: '874',name: '高一英语84 英语课程巩固复习8',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=585182626&bvid=BV1Rz4y1C7UL&cid=252804241&page=1',url2:''},
  {code: '875',name: '高一物理85 板块问题1',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=712696027&bvid=BV1oD4y197xg&cid=251152690&page=1',url2:''},
  {code: '876',name: '高一生物86 《细胞的衰老和凋亡》',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=372742326&bvid=BV1TZ4y157QV&cid=252780824&page=1',url2:''},
  {code: '877',name: '高一化学87 人教版必修二第一章综合练习',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=500213541&bvid=BV16K411G72j&cid=252761961&page=1',url2:''},
  {code: '878',name: '高一化学88 元素周期表',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=755213149&bvid=BV1cr4y1A74z&cid=251128068&page=1',url2:''},
  {code: '879',name: '高一语文89 故都的秋',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=755228348&bvid=BV19r4y1w7HB&cid=252458593&page=1',url2:''},
  {code: '880',name: '高一数学90 正弦定理',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=287625576&bvid=BV1zf4y1i7SJ&cid=251139304&page=1',url2:''},
  {code: '881',name: '高一物理91 板块问题2',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=202710015&bvid=BV11a411c7Z1&cid=252796652&page=1',url2:''},
  {code: '882',name: '高一英语92 完形',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=542691233&bvid=BV1Ni4y1L7Zm&cid=251174735&page=1',url2:''},
  {code: '883',name: '高一生物93 《细胞的癌变》',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=330171843&bvid=BV18A411j7kg&cid=252782893&page=1',url2:''},
  {code: '884',name: '高一英语94 兴趣爱好-完形',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=457625397&bvid=BV1x5411L75K&cid=252456905&page=1',url2:''},
  {code: '885',name: '高一语文95 故都的秋',grade: '高一',subject: '语文',tcode: '182',teacher: '戢雁',tags: '14年教龄 | 市优秀青年教师、骨干教师',version: '',url:'https://player.bilibili.com/player.html?aid=927734363&bvid=BV1YK4y1Z7eK&cid=251192736&page=1',url2:''},
  {code: '886',name: '高一数学96 余弦定理',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=755202193&bvid=BV12r4y1w7G5&cid=251141016&page=1',url2:''},
  {code: '887',name: '高一英语97 英语课程巩固复习10',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=970222810&bvid=BV1sp4y167xa&cid=252806336&page=1',url2:''},
  {code: '888',name: '高一物理98 板块问题3',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=542645353&bvid=BV1wi4y1L7Kz&cid=251155180&page=1',url2:''},
  {code: '889',name: '高一化学99 原子核外电子的排布',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=885212484&bvid=BV18K4y1E77e&cid=252764467&page=1',url2:''},
  {code: '890',name: '高一语文100 两汉诗歌',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=287633308&bvid=BV16f4y1i75o&cid=251193204&page=1',url2:''},
  {code: '891',name: '高一语文101 诗歌鉴赏精练1',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=627716935&bvid=BV1kt4y1e7Tg&cid=251194166&page=1',url2:''},
  {code: '892',name: '高一数学102 余弦定理应用',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=627680802&bvid=BV18t4y1e7UT&cid=251141254&page=1',url2:''},
  {code: '893',name: '高一英语103 英语课程巩固-语法',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=712724076&bvid=BV1PD4y1R7cR&cid=252807987&page=1',url2:''},
  {code: '894',name: '高一物理104 板块问题4',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=755133123&bvid=BV1sr4y1w7Bz&cid=251155218&page=1',url2:''},
  {code: '895',name: '高一生物105 孟德尔的豌豆杂交实验（一）',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=372663497&bvid=BV1eZ4y1V7LY&cid=251130417&page=1',url2:''},
  {code: '896',name: '高一物理106 惯性力与非惯性参考系',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=542706848&bvid=BV1ni4y1L7Hc&cid=251155709&page=1',url2:''},
  {code: '897',name: '高一语文107 诗歌鉴赏精练2',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=287724261&bvid=BV1gf4y1q7Nq&cid=251194556&page=1',url2:''},
  {code: '898',name: '高一数学108 正余弦定理应用举例1',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=797744313&bvid=BV1Ry4y1z7PK&cid=251143362&page=1',url2:''},
  {code: '899',name: '高一物理109 平衡问题分析方法1',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=797698641&bvid=BV1Gy4y1k75d&cid=251156247&page=1',url2:''},
  {code: '900',name: '高一英语110 英语课程巩固-词汇',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=627699443&bvid=BV1st4y1e7LC&cid=252455989&page=1',url2:''},
  {code: '901',name: '高一生物111 孟德尔的豌豆杂交实验（一）第二课时',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=797709584&bvid=BV11y4y1z7w6&cid=252785149&page=1',url2:''},
  {code: '902',name: '高一化学112 元素周期律1',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=457241009&bvid=BV1g5411j7er&cid=239768989&page=1',url2:''},
  {code: '903',name: '高一数学113 平面向量及运算1',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=712226633&bvid=BV1PD4y1Z7U1&cid=239769018&page=1',url2:''},
  {code: '904',name: '高一语文114 古诗鉴赏精讲演练（三）',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=627225215&bvid=BV1Yt4y1q7BE&cid=239839481&page=1',url2:''},
  {code: '905',name: '高一数学115 利用正弦余弦定理解三角形1',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=669691174&bvid=BV1ma4y1j7UL&cid=239769081&page=1',url2:''},
  {code: '906',name: '高一英语116 课程巩固阅读',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=712188255&bvid=BV19D4y1o7F1&cid=239769111&page=1',url2:''},
  {code: '907',name: '高一物理117 平衡问题分析方法2',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=287129926&bvid=BV15f4y1D7ia&cid=239769160&page=1',url2:''},
  {code: '908',name: '高一生物118 孟德尔的豌豆杂交实验（二）第一课时',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=712207648&bvid=BV1mD4y1o7LH&cid=239769190&page=1',url2:''},
  {code: '909',name: '高一化学119 元素周期律2',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=797146721&bvid=BV1yy4y1y77G&cid=239769231&page=1',url2:''},
  {code: '910',name: '高一化学120 元素周期律总结',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=414647346&bvid=BV1UV411m7kA&cid=239769264&page=1',url2:''},
  {code: '911',name: '高一语文121 古诗鉴赏精讲演练（四）',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=839643895&bvid=BV1b54y1m7Ah&cid=239769292&page=1',url2:''},
  {code: '912',name: '高一数学122 利用正弦余弦定理解三角形2',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=584631163&bvid=BV1Nz4y1Z7Kj&cid=239769324&page=1',url2:''},
  {code: '913',name: '高一物理123 平衡问题分析方法3',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=927171127&bvid=BV1yT4y1A7ov&cid=239769358&page=1',url2:''},
  {code: '914',name: '高一英语124 课程巩固完形',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=754668334&bvid=BV1gk4y117GN&cid=239769395&page=1',url2:''},
  {code: '915',name: '高一生物125 孟德尔的豌豆杂交实验（二）第二课时',grade: '高一',subject: '生物',tcode: '180',teacher: '陈平香',tags: '中学一级教师 | 优秀班主任 | 9年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=884729806&bvid=BV1MK4y1Y7Dt&cid=239769422&page=1',url2:''},
  {code: '916',name: '高一英语126 答疑课',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=669716243&bvid=BV1da4y1j759&cid=239769474&page=1',url2:''},
  {code: '917',name: '高一语文127 古诗鉴赏精讲演练（五）',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=244645614&bvid=BV1hv411C7qB&cid=239769517&page=1',url2:''},
  {code: '918',name: '高一数学128 利用正弦余弦定理解三角形3',grade: '高一',subject: '数学',tcode: '181',teacher: '李小林',tags: '8年教龄 | 市优秀教师',version: '',url:'https://player.bilibili.com/player.html?aid=669700123&bvid=BV1ka4y1j7az&cid=239769543&page=1',url2:''},
  {code: '919',name: '高一英语129 课程巩固语法1',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=754631676&bvid=BV1fk4y1y7go&cid=239769577&page=1',url2:''},
  {code: '920',name: '高一物理130 平衡问题分析方法4',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=842150379&bvid=BV1H54y1y72E&cid=239842451&page=1',url2:''},
  {code: '921',name: '高一化学131 元素周期律3',grade: '高一',subject: '化学',tcode: '185',teacher: '彭诗媛',tags: '骨干教师 | 编写理科综合图书',version: '',url:'https://player.bilibili.com/player.html?aid=414730751&bvid=BV1pV41117gs&cid=239842466&page=1',url2:''},
  {code: '922',name: '高一语文132 魏晋诗歌',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=927636972&bvid=BV1CT4y1F7mJ&cid=251195411&page=1',url2:''},
  {code: '923',name: '高一语文133 《史记》选文精讲1',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=927749927&bvid=BV1bK4y1Z7KS&cid=251198880&page=1',url2:''},
  {code: '924',name: '高一数学134 平面向量及运算2',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?aid=627221764&bvid=BV1at4y1q7AB&cid=239847021&page=1',url2:''},
  {code: '925',name: '高一英语135 课程巩固语法2',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=244738616&bvid=BV1Fv411y7fe&cid=239842512&page=1',url2:''},
  {code: '926',name: '高一物理136 平衡问题分析方法5',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=754703207&bvid=BV1Jk4y117E1&cid=239842524&page=1',url2:''},
  {code: '927',name: '高一化学137 胶体物质',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=244634326&bvid=BV18v411C7N6&cid=239842597&page=1',url2:''},
  {code: '928',name: '高一物理138 运动学和力学分析的重要模型',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=927248155&bvid=BV1xT4y1c7gF&cid=239842611&page=1',url2:''},
  {code: '929',name: '高一语文139 《史记》选文精讲2',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=627247935&bvid=BV1zt4y1q7Gq&cid=239854464&page=1',url2:''},
  {code: '930',name: '高一数学140 向量拆分技巧1',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1QK411K7of&page=1',url2:''},
  {code: '931',name: '高一物理141 平衡问题分析方法6',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1p5411j7Ux&page=1',url2:''},
  {code: '932',name: '高一英语142 课程巩固语法3',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1dA411E7Qg&page=1',url2:''},
  {code: '933',name: '高一化学143 溶液配置',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?aid=712724491&bvid=BV1KD4y1R7cK&cid=251128293&page=1',url2:''},
  {code: '934',name: '高一数学144 向量拆分技巧2',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1t54y1y7d2&page=1',url2:''},
  {code: '935',name: '高一语文145 《史记》选文精讲3',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1jk4y117nQ&page=1',url2:''},
  {code: '936',name: '高一数学146 向量拆分技巧3',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1tz4y1Z75g&page=1',url2:''},
  {code: '937',name: '高一英语147 课程巩固词汇',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1QZ4y1N7xH&page=1',url2:''},
  {code: '938',name: '高一物理148 追及相遇问题1',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV19h411X7SJ&page=1',url2:''},
  {code: '939',name: '高一化学149 电离与电解质',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1mv411C74Z&page=1',url2:''},
  {code: '940',name: '高一化学150 化学键',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1rA411J72Y&page=1',url2:''},
  {code: '941',name: '高一语文151 《宋史》选文精讲1',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV16y4y1y7eK&page=1',url2:''},
  {code: '942',name: '高一数学152 向量拆分技巧4',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV16y4y1y72p&page=1',url2:''},
  {code: '943',name: '高一物理153 追及相遇问题2',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1oZ4y1N7LU&page=1',url2:''},
  {code: '944',name: '高一英语154 课程巩固完形',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV11p4y1a7GS&page=1',url2:''},
  {code: '945',name: '高一化学155 钠及其化合物',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV17t4y1q7iZ&page=1',url2:''},
  {code: '946',name: '高一英语156 答疑课1',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1qK4y1a7tQ&page=1',url2:''},
  {code: '947',name: '高一语文157 《宋史》选文精讲2',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1hZ4y1N73E&page=1',url2:''},
  {code: '948',name: '高一数学158 三角形面积分割比',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Jh411X7q4&page=1',url2:''},
  {code: '949',name: '高一英语159 课程巩固阅读',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Wi4y1E7Q7&page=1',url2:''},
  {code: '950',name: '高一物理160 追及相遇问题3',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1XD4y1o7Cm&page=1',url2:''},
  {code: '951',name: '高一化学161 氯及其化合物',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1iK411P7me&page=1',url2:''},
  {code: '952',name: '高一语文162 唐代诗歌1',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1n54y1y7my&page=1',url2:''},
  {code: '953',name: '高一物理163 追及相遇问题4',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Xi4y177xW&page=1',url2:''},
  {code: '954',name: '高一数学164 向量的数量积运算',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1iZ4y1N7CB&page=1',url2:''},
  {code: '955',name: '高一化学165 热能',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Rh411X7Ce&page=1" scrolling="no" border="0" frameborder="no" framespacing="1" allowfullscreen="true"> </iframe>',url2:''},
  {code: '956',name: '高一英语166 答疑课2',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1ka4y1j7mV&page=1',url2:''},
  {code: '957',name: '高一语文167 唐代诗歌2',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1KZ4y1K77P&page=1',url2:''},
  {code: '958',name: '高一物理168 曲线运动的规律总结与应用1',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1TA411J7X8&page=1',url2:''},
  {code: '959',name: '高一数学169 定角问题',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Z54y1y7M8&page=1',url2:''},
  {code: '960',name: '高一化学170 电化学',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1x54y1m7n5&page=1',url2:''},
  {code: '961',name: '高一英语171 答疑课3',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1XD4y1o7Bt&page=1',url2:''},
  {code: '962',name: '高一语文172 宋代诗词1',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1oi4y177KM&page=1',url2:''},
  {code: '963',name: '高一物理173 曲线运动的规律总结与应用2',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1LA411J7iF&page=1',url2:''},
  {code: '964',name: '高一数学174 积化平方差',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1rT4y1A7YQ&page=1',url2:''},
  {code: '965',name: '高一化学175 化学反应速率',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV11D4y1o7ZV&page=1',url2:''},
  {code: '966',name: '高一英语176 答疑课4',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1yK4y187wc&page=1',url2:''},
  {code: '967',name: '高一语文177 宋代诗词2',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Zv411C7Su&page=1',url2:''},
  {code: '968',name: '高一物理178 平抛运动拔高',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Cy4y1y73L&page=1',url2:''},
  {code: '969',name: '高一数学179 向量坐标化思路',grade: '高一',subject: '数学',tcode: '93',teacher: '刘云鹏',tags: '6年教龄|押题小能手|东北段子手',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1RD4y1R7R1&page=1',url2:''},
  {code: '970',name: '高一化学180 有机化合物',grade: '高一',subject: '化学',tcode: '122',teacher: '梁旭',tags: '高考化学教研|解题思路清奇|奇怪有趣',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1ph41197y3&page=1',url2:''},
  {code: '971',name: '高一英语181 答疑课5',grade: '高一',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1wz4y1f7Dk&page=1',url2:''},
  {code: '972',name: '高一语文182 南宋词坛',grade: '高一',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1n54y1k7ZF&page=1',url2:''},
  {code: '973',name: '高一物理183 圆周运动综合',grade: '高一',subject: '物理',tcode: '103',teacher: '李烨',tags: '高考物理满分|提分帮主|高考押题王',version: '',url:'https://player.bilibili.com/player.html?bvid=BV1Eh4119777&page=1',url2:''},
  {code: '974',name: '初二物理109 固体的压力和压强2',grade: '初二',subject: '物理',tcode: '76',teacher: '于斐',tags: '命题克星|奖学金收割机|亲和力UP',version: '',url:'https://player.bilibili.com/player.html?aid=970159440&bvid=BV1mp4y1k7y2&cid=251206121&page=1',url2:''},
  {code: '975',name: '初二英语110 高频易混淆词精讲精练',grade: '初二',subject: '英语',tcode: '72',teacher: '许源欢',tags: '口音模仿王|精分小戏精|行走表情包',version: '',url:'https://player.bilibili.com/player.html?aid=457451860&bvid=BV1k541157Z3&cid=246373720&page=1',url2:''},
  {code: '976',name: '初二数学111 勾股定理的证明',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=457544104&bvid=BV1G5411L7e7&cid=250925726&page=1',url2:''},
  {code: '977',name: '初二语文112 基础病句通关(续篇)',grade: '初二',subject: '语文',tcode: '84',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https://player.bilibili.com/player.html?aid=627736691&bvid=BV1mt4y1e7f5&cid=251278029&page=1',url2:''},
  {code: '978',name: '初二英语113 词汇句型过关+写作+语法',grade: '初二',subject: '英语',tcode: '46',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https://player.bilibili.com/player.html?aid=542671262&bvid=BV13i4y1L7v8&cid=252713348&page=1',url2:''},
  {code: '979',name: '初二物理114 液体压强',grade: '初二',subject: '物理',tcode: '82',teacher: '张雪峰',tags: '4年教龄|江湖派教师|提分能手',version: '',url:'https://player.bilibili.com/player.html?aid=885223765&bvid=BV1eK4y1E75m&cid=251206610&page=1',url2:''},
  {code: '980',name: '初二英语115 完形填空篇章演练',grade: '初二',subject: '英语',tcode: '72',teacher: '许源欢',tags: '口音模仿王|精分小戏精|行走表情包',version: '',url:'https://player.bilibili.com/player.html?aid=670177105&bvid=BV1ra4y1s7Mg&cid=251212627&page=1',url2:''},
  {code: '981',name: '初二数学116 勾股定理的证明习题课',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=287608162&bvid=BV1kf4y1i7eJ&cid=250935217&page=1',url2:''},
  {code: '982',name: '初二数学117 直角三角形、平行四边形（一）',grade: '初二',subject: '数学',tcode: '78',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https://player.bilibili.com/player.html?aid=202598867&bvid=BV1Ca411A7Ag&cid=250922640&page=1',url2:''},
  {code: '983',name: '初二物理118 液体压力压强强化',grade: '初二',subject: '物理',tcode: '82',teacher: '张雪峰',tags: '4年教龄|江湖派教师|提分能手',version: '',url:'https://player.bilibili.com/player.html?aid=202690752&bvid=BV1ha411c7yV&cid=251206940&page=1',url2:''},
  {code: '984',name: '初二英语119 阅读理解篇章演练',grade: '初二',subject: '英语',tcode: '72',teacher: '许源欢',tags: '口音模仿王|精分小戏精|行走表情包',version: '',url:'https://player.bilibili.com/player.html?aid=330244693&bvid=BV19A411j7w4&cid=251213061&page=1',url2:''},
  {code: '985',name: '初二数学120 勾股定理',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=372567028&bvid=BV1AZ4y1V7Zy&cid=250939486&page=1',url2:''},
  {code: '986',name: '初二语文121 《桃花源记》通关实练',grade: '初二',subject: '语文',tcode: '84',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https://player.bilibili.com/player.html?aid=927728502&bvid=BV1YK4y1Z7wf&cid=251794698&page=1',url2:''},
  {code: '987',name: '初二物理122 受力分析综合强化',grade: '初二',subject: '物理',tcode: '53',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https://player.bilibili.com/player.html?aid=585188527&bvid=BV1Uz4y1C7wn&cid=251207596&page=1',url2:''},
  {code: '988',name: '初二物理123 连通器的原理与应用',grade: '初二',subject: '物理',tcode: '76',teacher: '于斐',tags: '命题克星|奖学金收割机|亲和力UP',version: '',url:'https://player.bilibili.com/player.html?aid=202673041&bvid=BV1va411c7cS&cid=251207923&page=1',url2:''},
  {code: '989',name: '初二英语124 语法填空 小题型',grade: '初二',subject: '英语',tcode: '72',teacher: '许源欢',tags: '口音模仿王|精分小戏精|行走表情包',version: '',url:'https://player.bilibili.com/player.html?aid=885205413&bvid=BV1qK4y1E77P&cid=251256427&page=1',url2:''},
  {code: '990',name: '初二数学125 勾股定理习题课',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=927591758&bvid=BV1JT4y1F7ru&cid=250941958&page=1',url2:''},
  {code: '991',name: '初二数学126 直角三角形、平行四边形（二）',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=457642002&bvid=BV1k5411L7yL&cid=251197269&page=1',url2:''},
  {code: '992',name: '初二语文127 《小石潭记》文言文重点精讲（二）',grade: '初二',subject: '语文',tcode: '84',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https://player.bilibili.com/player.html?aid=585235891&bvid=BV1cz4y1y79P&cid=251794837&page=1',url2:''},
  {code: '993',name: '初二英语128 词汇句型过关+写作+语法',grade: '初二',subject: '英语',tcode: '46',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https://player.bilibili.com/player.html?aid=885199950&bvid=BV1iK4y1E7EN&cid=251256981&page=1',url2:''},
  {code: '994',name: '初二数学129 矩形、菱形（一）',grade: '初二',subject: '数学',tcode: '78',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https://player.bilibili.com/player.html?aid=585180735&bvid=BV1dz4y1C7hS&cid=251197412&page=1',url2:''},
  {code: '995',name: '初二物理130 压力压强',grade: '初二',subject: '物理',tcode: '54',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https://player.bilibili.com/player.html?aid=670225779&bvid=BV11a4y1s7Qn&cid=251208282&page=1',url2:''},
  {code: '996',name: '初二数学131 矩形、菱形（二）',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=712673456&bvid=BV1fD4y197jo&cid=251197531&page=1',url2:''},
  {code: '997',name: '初二语文132 八下重点基础复习二',grade: '初二',subject: '语文',tcode: '84',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https://player.bilibili.com/player.html?aid=542725399&bvid=BV17i4y1L7sj&cid=251810456&page=1',url2:''},
  {code: '998',name: '初二英语133 词汇句型过关+阅读+语法',grade: '初二',subject: '英语',tcode: '46',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https://player.bilibili.com/player.html?aid=712628201&bvid=BV1vD4y1976P&cid=252718813&page=1',url2:''},
  {code: '999',name: '初二数学134 正方形、四边形综合（一）',grade: '初二',subject: '数学',tcode: '78',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https://player.bilibili.com/player.html?aid=330133067&bvid=BV1TA411j77g&cid=251202164&page=1',url2:''},
  {code: '1000',name: '初二物理135 液体压强',grade: '初二',subject: '物理',tcode: '53',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https://player.bilibili.com/player.html?aid=330212515&bvid=BV1kA411j7Sq&cid=251209170&page=1',url2:''},
  {code: '1001',name: '初二数学136 正方形、四边形综合（二）',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=585146512&bvid=BV11z4y1C79A&cid=251202483&page=1',url2:''},
  {code: '1002',name: '初二语文137 《核舟记》文言文重点精讲（三）',grade: '初二',subject: '语文',tcode: '84',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https://player.bilibili.com/player.html?aid=415162583&bvid=BV1RV411y7R5&cid=251810605&page=1',url2:''},
  {code: '1003',name: '初二英语138 词汇句型过关+完形+语法',grade: '初二',subject: '英语',tcode: '46',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https://player.bilibili.com/player.html?aid=800196555&bvid=BV1Ay4y1z7om&cid=251257445&page=1',url2:''},
  {code: '1004',name: '初二数学139 函数、一次函数初步（一）',grade: '初二',subject: '数学',tcode: '78',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https://player.bilibili.com/player.html?aid=797738853&bvid=BV19y4y1z7kq&cid=252479922&page=1',url2:''},
  {code: '1005',name: '初二物理140 气体压强',grade: '初二',subject: '物理',tcode: '54',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https://player.bilibili.com/player.html?aid=970247630&bvid=BV1ap4y167Sc&cid=251209767&page=1',url2:''},
  {code: '1006',name: '初二数学141 函数、一次函数初步（二）',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=712711768&bvid=BV1gD4y1R7KT&cid=252549980&page=1',url2:''},
  {code: '1007',name: '初二语文142 名著重点精讲《傅雷家书》',grade: '初二',subject: '语文',tcode: '84',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https://player.bilibili.com/player.html?aid=970153224&bvid=BV1yp4y1k7Ct&cid=251810662&page=1',url2:''},
  {code: '1008',name: '初二英语143 词汇句型过关+阅读+语法',grade: '初二',subject: '英语',tcode: '46',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https://player.bilibili.com/player.html?aid=330192774&bvid=BV14A411j7VJ&cid=251257818&page=1',url2:''},
  {code: '1009',name: '初二数学144 一次函数的图象性质、求解析式（一）',grade: '初二',subject: '数学',tcode: '78',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https://player.bilibili.com/player.html?aid=415130656&bvid=BV1yV411y7dy&cid=251202888&page=1',url2:''},
  {code: '1010',name: '初二物理145 浮力基础',grade: '初二',subject: '物理',tcode: '53',teacher: '李路宁',tags: '化繁为简|举例小能手|温柔小姐姐',version: '',url:'https://player.bilibili.com/player.html?aid=970205393&bvid=BV18p4y167iS&cid=251210157&page=1',url2:''},
  {code: '1011',name: '初二数学146 一次函数的图象性质、求解析式（二）',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=542740352&bvid=BV1hi4y1L7E6&cid=251203198&page=1',url2:''},
  {code: '1012',name: '初二语文147 阅读重点精讲',grade: '初二',subject: '语文',tcode: '84',teacher: '张殷然',tags: '作文状元|高分输送|解题实力派',version: '',url:'https://player.bilibili.com/player.html?aid=330166249&bvid=BV17A411j7Pd&cid=251810750&page=1',url2:''},
  {code: '1013',name: '初二英语148 词汇句型过关+完形+语法',grade: '初二',subject: '英语',tcode: '46',teacher: '胡海燕',tags: '保送硕士|10年教龄|学生的活字典',version: '',url:'https://player.bilibili.com/player.html?aid=415193550&bvid=BV1AV411179D&cid=251257987&page=1',url2:''},
  {code: '1014',name: '初二数学149 一次函数的图像变换、与方程综合（一）',grade: '初二',subject: '数学',tcode: '78',teacher: '张佳镁',tags: '北大学神|中考状元名师|懂学生爱学生',version: '',url:'https://player.bilibili.com/player.html?aid=970214960&bvid=BV1pp4y167Vu&cid=251204680&page=1',url2:''},
  {code: '1015',name: '初二物理150 浮力综合',grade: '初二',subject: '物理',tcode: '54',teacher: '李宁',tags: '提分达人|985硕士|套路大咖',version: '',url:'https://player.bilibili.com/player.html?aid=330219028&bvid=BV1CA411j7qL&cid=252554667&page=1',url2:''},
  {code: '1016',name: '初二数学151 一次函数的图像变换、与方程综合（二）',grade: '初二',subject: '数学',tcode: '48',teacher: '黄其若',tags: '数学名师|高分制造者|萌贱大哥哥',version: '',url:'https://player.bilibili.com/player.html?aid=970180437&bvid=BV19p4y1k7f1&cid=251205758&page=1',url2:''},
  {code: '1017',name: '高三化学95 氧化还原和离子反应',grade: '高三',subject: '化学',tcode: '183',teacher: '杨国东',tags: '骨干教师 | 市高中化学核心研究团队组长',version: '',url:'https://player.bilibili.com/player.html?aid=797720730&bvid=BV1zy4y1z7Mx&cid=252545075&page=1',url2:''},
  {code: '1018',name: '高三数学96 巧解选填难题',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=245219080&bvid=BV1Lv411r75y&cid=252547765&page=1',url2:''},
  {code: '1019',name: '高三英语97 完型微技能：语篇层次题+互动练习',grade: '高三',subject: '英语',tcode: '184',teacher: '邱文丽',tags: '15年教龄 | 骨干教师 | 学科带头人',version: '',url:'https://player.bilibili.com/player.html?aid=372701106&bvid=BV11Z4y1V7tX&cid=252560712&page=1',url2:''},
  {code: '1020',name: '高三化学98 工艺流程专题（2）',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=797734275&bvid=BV1ky4y1z7e4&cid=252487271&page=1',url2:''},
  {code: '1021',name: '高三数学99 利用导数研究函数的单调性',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=627669387&bvid=BV1Lt4y1e7fE&cid=252547933&page=1',url2:''},
  {code: '1022',name: '高三英语100 完形填空点睛突破',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=797652446&bvid=BV1My4y1k7mc&cid=252561096&page=1',url2:''},
  {code: '1023',name: '高三化学101 化学用语专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=415158084&bvid=BV1QV411y7SU&cid=252488461&page=1',url2:''},
  {code: '1024',name: '高三数学102 利用导数研究方程根的分布问题',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=797739914&bvid=BV19y4y1z7pN&cid=252548672&page=1',url2:''},
  {code: '1025',name: '高三英语103 完形填空点睛突破',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=797734212&bvid=BV1ky4y1z7v6&cid=252561359&page=1',url2:''},
  {code: '1026',name: '高三化学104 元素化合物综合专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=627711739&bvid=BV1Bt4y1e7zs&cid=252545665&page=1',url2:''},
  {code: '1027',name: '高三数学105 利用导数研究函数中的不等式问题（一）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=842735289&bvid=BV1Z54y1r7MQ&cid=252551845&page=1',url2:''},
  {code: '1028',name: '高三英语106 完形填空点睛突破',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=927662426&bvid=BV19T4y1F75R&cid=252561966&page=1',url2:''},
  {code: '1029',name: '高三化学107 速率平衡专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=372701956&bvid=BV11Z4y1V7GL&cid=252546151&page=1',url2:''},
  {code: '1030',name: '高三数学108 利用导数研究函数中的不等式问题（二）',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=970179915&bvid=BV19p4y1k7SZ&cid=252551989&page=1',url2:''},
  {code: '1031',name: '高三英语109 完形填空点睛突破',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=245218500&bvid=BV15v411r7ZW&cid=252715759&page=1',url2:''},
  {code: '1032',name: '高三化学110 电化学专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=415127108&bvid=BV1CV411y7DH&cid=252495318&page=1',url2:''},
  {code: '1033',name: '高三数学111 利用导数研究函数中的含参问题',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=627636005&bvid=BV1Kt4y1e7yS&cid=252552273&page=1',url2:''},
  {code: '1034',name: '高三英语112 完形填空点睛突破',grade: '高三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=970217659&bvid=BV1Wp4y167YG&cid=252721033&page=1',url2:''},
  {code: '1035',name: '高三化学113 有机化学专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=500139629&bvid=BV15K411P7GK&cid=252495574&page=1',url2:''},
  {code: '1036',name: '高三数学114 平面向量经典技巧讲解',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=330225297&bvid=BV1iA411j7XY&cid=252552651&page=1',url2:''},
  {code: '1037',name: '高三语文115 诗歌鉴赏 形象类题目精讲',grade: '高三',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=927650899&bvid=BV1zT4y1F7bM&cid=252714702&page=1',url2:''},
  {code: '1038',name: '高三英语116 阅读完形技巧提分 七选五',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=415158961&bvid=BV19V411y7XP&cid=252720755&page=1',url2:''},
  {code: '1039',name: '高三物理117 万有引力定律中的常见问题2',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=927743871&bvid=BV1vK4y1Z72C&cid=252555418&page=1',url2:''},
  {code: '1040',name: '高三化学118 高考真题训练专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=415183620&bvid=BV1GV41117w3&cid=252495619&page=1',url2:''},
  {code: '1041',name: '高三数学119 平面向量经典技巧讲解 向量模长不等式的应用',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=800231397&bvid=BV1Vy4y1z7K5&cid=252552774&page=1',url2:''},
  {code: '1042',name: '高三语文120 诗歌鉴赏 形象类题目精讲',grade: '高三',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=927712501&bvid=BV1ZT4y1F7k9&cid=252707406&page=1',url2:''},
  {code: '1043',name: '高三英语121 传统阅读之细节题',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=415172238&bvid=BV1TV41117oX&cid=252720242&page=1',url2:''},
  {code: '1044',name: '高三物理122 万有引力定律中的常见问题3',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=457649222&bvid=BV1C5411L7wu&cid=252555656&page=1',url2:''},
  {code: '1045',name: '高三化学123 高考真题训练专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=970213608&bvid=BV1pp4y167EU&cid=252499735&page=1',url2:''},
  {code: '1046',name: '高三数学124 数学答疑',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=457630084&bvid=BV1b5411L7Wc&cid=252472651&page=1',url2:''},
  {code: '1047',name: '高三语文125 文言文断句',grade: '高三',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=670244399&bvid=BV1Fa4y1x7ZG&cid=252707184&page=1',url2:''},
  {code: '1048',name: '高三英语126 推断题阅读技巧',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=372684866&bvid=BV1SZ4y1V7S7&cid=252566278&page=1',url2:''},
  {code: '1049',name: '高三物理127 带电粒子在磁场中的运动1',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=202676783&bvid=BV1ia411c7GZ&cid=252556385&page=1',url2:''},
  {code: '1050',name: '高三化学128 高考真题训练专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=800178471&bvid=BV1Uy4y1B7e5&cid=252518074&page=1',url2:''},
  {code: '1051',name: '高三数学129 答疑',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=970190615&bvid=BV1dp4y1k7S1&cid=252474131&page=1',url2:''},
  {code: '1052',name: '高三语文130 文意理解题 解题技巧',grade: '高三',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=842736717&bvid=BV1f54y1r7SQ&cid=252692416&page=1',url2:''},
  {code: '1053',name: '高三英语131 完形填空技巧突破',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=712728606&bvid=BV1TD4y1R7Va&cid=252690544&page=1',url2:''},
  {code: '1054',name: '高三物理132 带电粒子在磁场中的运动2',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=245158120&bvid=BV1Uv41167KA&cid=252557888&page=1',url2:''},
  {code: '1055',name: '高三化学133 元素化合物综合专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=970133878&bvid=BV1Dp4y1k78L&cid=252546708&page=1',url2:''},
  {code: '1056',name: '高三数学134 巧解选填难题3',grade: '高三',subject: '数学',tcode: '144',teacher: '孙强',tags: '高考状元名师|11年教龄|清北制造机',version: '',url:'https://player.bilibili.com/player.html?aid=202748459&bvid=BV1fa411c7yp&cid=252555350&page=1',url2:''},
  {code: '1057',name: '高三语文135 任务驱动型作文 审题立意',grade: '高三',subject: '语文',tcode: '146',teacher: '杨小晴',tags: '5年教龄 | 省示范名校 | 可盐可甜',version: '',url:'https://player.bilibili.com/player.html?aid=372721247&bvid=BV1QZ4y1V78w&cid=252692563&page=1',url2:''},
  {code: '1058',name: '高三英语136 完形填空技巧突破',grade: '高三',subject: '英语',tcode: '107',teacher: '黄令群',tags: '全能多面手|行走语法书|奇迹缔造者',version: '',url:'https://player.bilibili.com/player.html?aid=800188632&bvid=BV1Dy4y1B75t&cid=252714977&page=1',url2:''},
  {code: '1059',name: '高三物理137 感生电动势和感生电场',grade: '高三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=842667677&bvid=BV1B54y1r7L1&cid=252560029&page=1',url2:''},
  {code: '1060',name: '高三化学138 化学计算专题',grade: '高三',subject: '化学',tcode: '65',teacher: '任晓',tags: '10年教龄|8年毕业班|中高考提分王',version: '',url:'https://player.bilibili.com/player.html?aid=927709396&bvid=BV1KT4y1c7dA&cid=252547612&page=1',url2:''},
  {code: '1061',name: '初三语文101 四时之诗——春（二）',grade: '初三',subject: '语文',tcode: '165',teacher: '杨智慧',tags: '一线语文教师 | 寓教于乐',version: '',url:'https://player.bilibili.com/player.html?aid=202687089&bvid=BV18a411c7k9&cid=252403596&page=1',url2:''},
  {code: '1062',name: '初三英语102 中考英语-词汇&语法',grade: '初三',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=585208360&bvid=BV1Nz4y1y7HN&cid=252390416&page=1',url2:''},
  {code: '1063',name: '初三化学103 含杂质的计算',grade: '初三',subject: '化学',tcode: '159',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https://player.bilibili.com/player.html?aid=970188463&bvid=BV1op4y1k7nM&cid=251839875&page=1',url2:''},
  {code: '1064',name: '初三物理104 中考复习——简单机械1',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=202692257&bvid=BV1ha411c7qw&cid=252125456&page=1',url2:''},
  {code: '1065',name: '初三数学105 三角形相似（一）',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=415241546&bvid=BV1AV411a7JU&cid=251878839&page=1',url2:''},
  {code: '1066',name: '初三数学106 圆的对称性（2）',grade: '初三',subject: '数学',tcode: '161',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https://player.bilibili.com/player.html?aid=245176719&bvid=BV1Av411r73g&cid=251865355&page=1',url2:''},
  {code: '1067',name: '初三语文107 说明文专题复习',grade: '初三',subject: '语文',tcode: '186',teacher: '钟菊',tags: '10年教龄 | 教坛新秀 | 师德标兵',version: '',url:'https://player.bilibili.com/player.html?aid=202700646&bvid=BV1ea411c7MD&cid=252403634&page=1',url2:''},
  {code: '1068',name: '初三英语108 Grammar 形容词副词',grade: '初三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=415171391&bvid=BV1MV41117ps&cid=252390693&page=1',url2:''},
  {code: '1069',name: '初三化学109 金属资源保护',grade: '初三',subject: '化学',tcode: '159',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https://player.bilibili.com/player.html?aid=627727132&bvid=BV1et4y1e7GX&cid=251839959&page=1',url2:''},
  {code: '1070',name: '初三物理110 中考复习--简单机械2',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=885159183&bvid=BV1VK4y1E7bs&cid=252709451&page=1',url2:''},
  {code: '1071',name: '初三数学111 三角形相似（一）习题课',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=800150012&bvid=BV1zy4y1B7fV&cid=251879339&page=1',url2:''},
  {code: '1072',name: '初三数学112 圆周角和直径的关系',grade: '初三',subject: '数学',tcode: '161',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https://player.bilibili.com/player.html?aid=287683971&bvid=BV1Tf4y1q7j1&cid=251879589&page=1',url2:''},
  {code: '1073',name: '初三数学113 中考专项复习——圆',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=800174566&bvid=BV1Zy4y1B7w7&cid=251880121&page=1',url2:''},
  {code: '1074',name: '初三语文114 议论文专题复习（一）',grade: '初三',subject: '语文',tcode: '186',teacher: '钟菊',tags: '10年教龄 | 教坛新秀 | 师德标兵',version: '',url:'https://player.bilibili.com/player.html?aid=970135500&bvid=BV1Dp4y1k77D&cid=252415555&page=1',url2:''},
  {code: '1075',name: '初三英语115 Grammar 形容词副词',grade: '初三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=457650604&bvid=BV115411L7V8&cid=252392497&page=1',url2:''},
  {code: '1076',name: '初三化学116 酸碱盐的定义',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=500167469&bvid=BV1VK411P7pz&cid=251840217&page=1',url2:''},
  {code: '1077',name: '初三物理117 中考复习--功与能',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=885143936&bvid=BV1EK4y1E7cu&cid=252126139&page=1',url2:''},
  {code: '1078',name: '初三数学118 三角形相似（二）',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=330178139&bvid=BV1hA411j7sr&cid=252480494&page=1',url2:''},
  {code: '1079',name: '初三数学119 圆周角和圆心角、弧的关系',grade: '初三',subject: '数学',tcode: '161',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https://player.bilibili.com/player.html?aid=712734405&bvid=BV1MD4y1R754&cid=251881835&page=1',url2:''},
  {code: '1080',name: '初三物理120 中考复习——电路分析1',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=842663858&bvid=BV1q54y1r7Mu&cid=252472162&page=1',url2:''},
  {code: '1081',name: '初三语文121 记叙文阅读专题复习（一）',grade: '初三',subject: '语文',tcode: '186',teacher: '钟菊',tags: '10年教龄 | 教坛新秀 | 师德标兵',version: '',url:'https://player.bilibili.com/player.html?aid=927704597&bvid=BV1KT4y1c7VG&cid=252415764&page=1',url2:''},
  {code: '1082',name: '初三英语122 形容词副词',grade: '初三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=415234940&bvid=BV1jV41117jW&cid=252394097&page=1',url2:''},
  {code: '1083',name: '初三化学123 金属和金属材料',grade: '初三',subject: '化学',tcode: '159',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https://player.bilibili.com/player.html?aid=670167887&bvid=BV1ba4y1s7Lm&cid=251840297&page=1',url2:''},
  {code: '1084',name: '初三语文124 语文知识点讲座 文学素养',grade: '初三',subject: '语文',tcode: '164',teacher: '沈黎江',tags: '二十年教龄 | 硬核提分',version: '',url:'https://player.bilibili.com/player.html?aid=245183775&bvid=BV1Nv411r7ZF&cid=252418899&page=1',url2:''},
  {code: '1085',name: '初三数学125 三角形相似（二）习题课',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=712687728&bvid=BV1RD4y197wX&cid=252118720&page=1',url2:''},
  {code: '1086',name: '初三数学126 圆内接四边形',grade: '初三',subject: '数学',tcode: '161',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https://player.bilibili.com/player.html?aid=500222670&bvid=BV1YK411G7ct&cid=252118847&page=1',url2:''},
  {code: '1087',name: '初三化学127 中考复习-酸',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=670176954&bvid=BV1ra4y1s7AA&cid=251840434&page=1',url2:''},
  {code: '1088',name: '初三语文128 议论文专题复习（二）',grade: '初三',subject: '语文',tcode: '186',teacher: '钟菊',tags: '10年教龄 | 教坛新秀 | 师德标兵',version: '',url:'https://player.bilibili.com/player.html?aid=970205841&bvid=BV18p4y16721&cid=252424815&page=1',url2:''},
  {code: '1089',name: '初三英语129 英语巩固复习9',grade: '初三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=670182414&bvid=BV1ra4y1s7aa&cid=252530439&page=1',url2:''},
  {code: '1090',name: '初三化学130 酸的化学性质 硫酸',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=202656657&bvid=BV1Ja411c7sp&cid=251840611&page=1',url2:''},
  {code: '1091',name: '初三物理131 中考复习--电路分析2',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=457711429&bvid=BV1n5411V76j&cid=252176990&page=1',url2:''},
  {code: '1092',name: '初三数学132 三角形全等与相似',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=755146912&bvid=BV16r4y1w7y7&cid=252708028&page=1',url2:''},
  {code: '1093',name: '初三数学133 直线与圆的位置关系',grade: '初三',subject: '数学',tcode: '161',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https://player.bilibili.com/player.html?aid=970147097&bvid=BV1yp4y1k7KQ&cid=252118973&page=1',url2:''},
  {code: '1094',name: '初三英语134 中考真题语法3 范哥核心句子论',grade: '初三',subject: '英语',tcode: '145',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=245152087&bvid=BV1Rv411679s&cid=252396031&page=1',url2:''},
  {code: '1095',name: '初三语文135 议论文专题复习（三）',grade: '初三',subject: '语文',tcode: '186',teacher: '钟菊',tags: '10年教龄 | 教坛新秀 | 师德标兵',version: '',url:'https://player.bilibili.com/player.html?aid=800239792&bvid=BV17y4y1z74i&cid=252426338&page=1',url2:''},
  {code: '1096',name: '初三英语136 关系代词',grade: '初三',subject: '英语',tcode: '141',teacher: '高歌',tags: '常青藤名校|高分缔造者|时间规划狂',version: '',url:'https://player.bilibili.com/player.html?aid=797679634&bvid=BV17y4y1k7vf&cid=252398161&page=1',url2:''},
  {code: '1097',name: '初三化学137 溶液',grade: '初三',subject: '化学',tcode: '159',teacher: '齐梦霓',tags: '一师一优课 | 部级优课',version: '',url:'https://player.bilibili.com/player.html?aid=585214832&bvid=BV1Kz4y1y7ce&cid=252464506&page=1',url2:''},
  {code: '1098',name: '初三物理138 中考复习--欧姆定律1',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=755208502&bvid=BV1Fr4y1A7Kf&cid=252485153&page=1',url2:''},
  {code: '1099',name: '初三数学139 三角形全等与相似习题课',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=372748620&bvid=BV1gZ4y157fR&cid=252119198&page=1',url2:''},
  {code: '1100',name: '初三数学140 切线',grade: '初三',subject: '数学',tcode: '161',teacher: '范冬娥',tags: '23年教龄 | 任教研组长至今10年',version: '',url:'https://player.bilibili.com/player.html?aid=585192822&bvid=BV1Sz4y1C7nH&cid=252480654&page=1',url2:''},
  {code: '1101',name: '初三英语141 中考冲刺——语法填空',grade: '初三',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=670212139&bvid=BV1Xa4y1s73d&cid=252398513&page=1',url2:''},
  {code: '1102',name: '初三化学142 氢氧化钙',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=542666095&bvid=BV1Zi4y157a5&cid=251860388&page=1',url2:''},
  {code: '1103',name: '初三物理143 中考复习——欧姆定律2',grade: '初三',subject: '物理',tcode: '147',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https://player.bilibili.com/player.html?aid=797688665&bvid=BV1gy4y1k78j&cid=252514286&page=1',url2:''},
  {code: '1104',name: '初三数学144 中考复习——四边形（一）',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=885145542&bvid=BV17K4y1E7DL&cid=252488192&page=1',url2:''},
  {code: '1105',name: '初三数学145 中考专项复习——函数',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=457657883&bvid=BV1v5411L7XQ&cid=252490736&page=1',url2:''},
  {code: '1106',name: '初三英语146 中考冲刺——语法填空',grade: '初三',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=885125047&bvid=BV1wK4y1E7wY&cid=252532051&page=1',url2:''},
  {code: '1107',name: '初三化学147 氢氧化钠1',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=800178657&bvid=BV1Uy4y1B789&cid=252475909&page=1',url2:''},
  {code: '1108',name: '初三物理148 中考复习——电能与电功',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=712740214&bvid=BV1ED4y1R7Y2&cid=252516269&page=1',url2:''},
  {code: '1109',name: '初三数学149 中考复习——四边形（一）习题课',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=712668379&bvid=BV1mD4y197ig&cid=252492585&page=1',url2:''},
  {code: '1110',name: '初三物理150 中考复习——欧姆定律2',grade: '初三',subject: '物理',tcode: '147',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https://player.bilibili.com/player.html?aid=202692786&bvid=BV1ha411c7uL&cid=252520082&page=1',url2:''},
  {code: '1111',name: '初三英语151 中考冲刺——完形填空',grade: '初三',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=797736352&bvid=BV1ry4y1z7Zy&cid=252533398&page=1',url2:''},
  {code: '1112',name: '初三化学152 氢氧化钠2',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=500153550&bvid=BV17K411P7AA&cid=252477432&page=1',url2:''},
  {code: '1113',name: '初三物理153 中考复习——电功率2',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=842681361&bvid=BV1h54y1r74m&cid=252521356&page=1',url2:''},
  {code: '1114',name: '初三数学154 中考复习——四边形（二）',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=287664188&bvid=BV1Df4y1i7TN&cid=252493991&page=1',url2:''},
  {code: '1115',name: '初三化学155 中考复习-复分解',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=415204204&bvid=BV1EV41117Ki&cid=252478871&page=1',url2:''},
  {code: '1116',name: '初三英语156 中考冲刺——完形填空',grade: '初三',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=927674666&bvid=BV1oT4y1F7dk&cid=252535190&page=1',url2:''},
  {code: '1117',name: '初三化学157 碳酸钠',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=245232378&bvid=BV13v411r7uy&cid=252480093&page=1',url2:''},
  {code: '1118',name: '初三物理158 中考复习——焦耳定律',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=287720065&bvid=BV1Mf4y1q7Xb&cid=252522845&page=1',url2:''},
  {code: '1119',name: '初三数学159 中考复习——四边形（二）习题课1',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=330238481&bvid=BV1DA411j7Fd&cid=252495650&page=1',url2:''},
  {code: '1120',name: '初三英语160 中考真题词汇3',grade: '初三',subject: '英语',tcode: '145',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=542661084&bvid=BV1oi4y157e7&cid=252536743&page=1',url2:''},
  {code: '1121',name: '初三英语161 中考冲刺——完形填空',grade: '初三',subject: '英语',tcode: '134',teacher: '郝望月',tags: '提分小能手|作文押题王|高冷硬实力',version: '',url:'https://player.bilibili.com/player.html?aid=755202202&bvid=BV12r4y1w7GN&cid=252538394&page=1',url2:''},
  {code: '1122',name: '初三化学162 碳酸氢钠',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=885189676&bvid=BV1HK4y1E7JB&cid=252481571&page=1',url2:''},
  {code: '1123',name: '初三物理163 中考复习——家庭电路',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=970207170&bvid=BV18p4y167a6&cid=252525164&page=1',url2:''},
  {code: '1124',name: '初三数学164 中考复习——四边形（二）习题课2',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=927651757&bvid=BV1zT4y1F7kP&cid=252497215&page=1',url2:''},
  {code: '1125',name: '初三数学165 中考专项复习——几何变换、最值',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=970196014&bvid=BV1tp4y167Y7&cid=252499210&page=1',url2:''},
  {code: '1126',name: '初三物理166 中考复习——电能与电工',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=585249877&bvid=BV17z4y1y7AP&cid=252526635&page=1',url2:''},
  {code: '1127',name: '初三化学167 中考复习-离子共存',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=842746437&bvid=BV1Q54y1r7p4&cid=252484191&page=1',url2:''},
  {code: '1128',name: '初三数学168 几何变换、最值',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=372632792&bvid=BV1pZ4y1V7Rc&cid=252502304&page=1',url2:''},
  {code: '1129',name: '初三英语169 答疑',grade: '初三',subject: '英语',tcode: '145',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=245147275&bvid=BV1Rv41167wS&cid=252539752&page=1',url2:''},
  {code: '1130',name: '初三数学170 中考专项复习——动点问题',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=202647071&bvid=BV14a411c7f4&cid=252119801&page=1',url2:''},
  {code: '1131',name: '初三物理171 中考复习——电功率1',grade: '初三',subject: '物理',tcode: '147',teacher: '赵星义',tags: '授课1万小时 | 教师培训师 | 金牌教师',version: '',url:'https://player.bilibili.com/player.html?aid=415216178&bvid=BV1HV41117rR&cid=252709957&page=1',url2:''},
  {code: '1132',name: '初三化学172 中考复习-实验',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=627651988&bvid=BV1Ht4y1e7ux&cid=251863844&page=1',url2:''},
  {code: '1133',name: '初三数学173 答疑',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=627744508&bvid=BV1Ut4y1e7W8&cid=252509298&page=1',url2:''},
  {code: '1134',name: '初三英语174 答疑',grade: '初三',subject: '英语',tcode: '145',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=415151605&bvid=BV1cV411172r&cid=252993879&page=1',url2:''},
  {code: '1135',name: '初三数学175 中考专项复习——存在性问题（一）',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=245137429&bvid=BV1Qv41167mv&cid=252993844&page=1',url2:''},
  {code: '1136',name: '初三物理176　中考复习——电功率',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=800234084&bvid=BV15y4y1z7vJ&cid=252528560&page=1',url2:''},
  {code: '1137',name: '初三化学177 中考复习-推断',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=330127498&bvid=BV1KA411j7G7&cid=252486350&page=1',url2:''},
  {code: '1138',name: '初三数学178 答疑',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=202678167&bvid=BV1va411c7dS&cid=252512208&page=1',url2:''},
  {code: '1139',name: '初三英语179 答疑',grade: '初三',subject: '英语',tcode: '145',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=842685943&bvid=BV1a54y1r7kK&cid=252541148&page=1',url2:''},
  {code: '1140',name: '初三数学180 中考专项复习——存在性问题（二）',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=287731086&bvid=BV1gf4y1q7JL&cid=252122754&page=1',url2:''},
  {code: '1141',name: '初三物理181 中考复习——焦耳定律',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=415243193&bvid=BV1AV411a7gg&cid=252710522&page=1',url2:''},
  {code: '1142',name: '初三化学182 中考复习-探究',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=287669456&bvid=BV1Df4y1i7ZL&cid=251863945&page=1',url2:''},
  {code: '1143',name: '初三数学183 中考专项复习——存在性问题（二）习题课',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=670146371&bvid=BV18a4y1s7mM&cid=252480881&page=1',url2:''},
  {code: '1144',name: '初三英语184 范哥教你读单词',grade: '初三',subject: '英语',tcode: '145',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=800173753&bvid=BV1Ry4y1B7f1&cid=252401213&page=1',url2:''},
  {code: '1145',name: '初三数学185 中考专项复习——选填压轴题、新题型',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=500139539&bvid=BV15K411P7Gs&cid=252481096&page=1',url2:''},
  {code: '1146',name: '初三物理186 中考复习——家庭电路',grade: '初三',subject: '物理',tcode: '131',teacher: '李琳',tags: '北京大学|11年教龄|思维女神',version: '',url:'https://player.bilibili.com/player.html?aid=457727118&bvid=BV1L5411V7Y7&cid=252178512&page=1',url2:''},
  {code: '1147',name: '初三化学187 中考复习-计算',grade: '初三',subject: '化学',tcode: '148',teacher: '肖嵘',tags: '九年教龄 | 化学大教主 | 爱吃瓜的猹',version: '',url:'https://player.bilibili.com/player.html?aid=415144206&bvid=BV1fV411y7N6&cid=251864894&page=1',url2:''},
  {code: '1148',name: '初三数学188 中考专项复习——选填压轴题、新题型（2）',grade: '初三',subject: '数学',tcode: '138',teacher: '何超世',tags: '高分锻造能手|优雅套路王|6年教龄',version: '',url:'https://player.bilibili.com/player.html?aid=755199709&bvid=BV1yr4y1w7Uq&cid=252123623&page=1',url2:''},
  {code: '1149',name: '初三英语189节 范哥带你说人名记单词',grade: '初三',subject: '英语',tcode: '145',teacher: '范伟哲',tags: '1万课时|剑桥大学培训师|高考押题王',version: '',url:'https://player.bilibili.com/player.html?aid=372712404&bvid=BV1FZ4y157MU&cid=252401568&page=1',url2:''},

];

var _teachers = [
  {
    code: "1",
    name: "卜哲媛",
    grade: "三年级",
    sf: "语文",
    tags: "科班出身|阅读理解控|有亲和力",
    num: "10562",
    percent: "95%",
    info:
      "文学硕士-七年中文专业学习<br/>四年一等奖学金、征文比赛一等奖<br/>兴趣激励，两年小学语文面授<br/>“爱好超多”“积木之王”",
    mj:
      "阅读总丢分？多读，精读，开启趣味阅读之旅。课文背不会？逻辑思维需训练，理清脉络是关键。作文写不出？始于模仿，终于创造，从观察生活与体会情感出发，让表达更流畅。",
    cj: "",
    ry: "2012年-2016年连续四年获得校级一等奖学金",
    ts:
      "爱看书、写作、篮球、电竞。过去的几年和孩子相处很多，因为自身童心未泯，所以和他们在一起觉得无拘无束。希望我能用专业知识和对中文专业的热爱去激励孩子们学习语文的兴趣，让学习语文成为一件美好的事情。做一个引导者，带孩子去游历神奇瑰丽的文学世界。",
    tstag: "四年校级奖学金夺冠者",
    video:
      "https://player.bilibili.com/player.html?aid=82886930&cid=141806451&page=1",
    grade2: "三年级"
  },
  {
    code: "2",
    name: "戴朋",
    grade: "四年级",
    sf: "数学",
    tags: "8年教龄 | 逻辑清晰 | 善于引导",
    num: "2845",
    percent: "96.3%",
    info:
      "近9年教龄<br/>三百余人考入南开翔宇、执信、广雅等知名中<br/>华杯赛、希望杯、迎春杯优秀教练员<br/>在思维引导和拓展方面堪称专家<br/>深刻了解孩子易错或难懂的环节",
    mj:
      "善于引导学生由浅及深学习知识，让孩子不知不觉中已经学会了应学知识，知识点把握精准，逻辑缜密，清晰，善于举一反三，让孩子们快速提高学习成绩的同时对数学产生成就感和兴趣。",
    cj:
      "8年教龄，累计所授学员已过千人，有6年毕业班代课经验，熟悉小升初考试，代课期间，90%以上孩子考上全市前五的学校，同时，所带班级学生成绩均有所提高，学习优秀的学生考入理想中学，学习有困难的同学提升了做题效率和正确率，成绩也提升不少，其次所带竞赛班的孩子获奖无数。",
    ry:
      "2015年学而思教研卓越创新奖，2016年学而思骨干教师称号，2014年-2016年分别获得华罗庚杯优秀教练称号",
    ts:
      "戴老师喜欢把生活与数学结合，由浅及深的剖析知识点，让学生不自觉的喜欢上数学，同时成绩也有明显的提高。我想对学生说的是，只要你想学就一定能学好，相信自己！",
    tstag: "8年的卓越、优秀骨干教师",
    video:
      "https://player.bilibili.com/player.html?aid=82887085&cid=141806662&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "3",
    name: "戴朋",
    grade: "五年级",
    sf: "数学",
    tags: "8年教龄 | 逻辑清晰 | 善于引导",
    num: "2845",
    percent: "96.3%",
    info:
      "近9年教龄<br/>三百余人考入南开翔宇、执信、广雅等知名中<br/>华杯赛、希望杯、迎春杯优秀教练员<br/>在思维引导和拓展方面堪称专家<br/>深刻了解孩子易错或难懂的环节",
    mj:
      "善于引导学生由浅及深学习知识，让孩子不知不觉中已经学会了应学知识，知识点把握精准，逻辑缜密，清晰，善于举一反三，让孩子们快速提高学习成绩的同时对数学产生成就感和兴趣。",
    cj:
      "8年教龄，累计所授学员已过千人，有6年毕业班代课经验，熟悉小升初考试，代课期间，90%以上孩子考上全市前五的学校，同时，所带班级学生成绩均有所提高，学习优秀的学生考入理想中学，学习有困难的同学提升了做题效率和正确率，成绩也提升不少，其次所带竞赛班的孩子获奖无数。",
    ry:
      "2015年学而思教研卓越创新奖，2016年学而思骨干教师称号，2014年-2016年分别获得华罗庚杯优秀教练称号",
    ts:
      "戴老师喜欢把生活与数学结合，由浅及深的剖析知识点，让学生不自觉的喜欢上数学，同时成绩也有明显的提高。我想对学生说的是，只要你想学就一定能学好，相信自己！",
    tstag: "8年的卓越、优秀骨干教师",
    video:
      "https://player.bilibili.com/player.html?aid=82887085&cid=141806662&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "4",
    name: "Olivia",
    grade: "六年级",
    sf: "英语",
    tags: "小学霸主 | 授之以渔 | 英文歌能手",
    num: " 44830",
    percent: "97.6%",
    info:
      "新概念王者，XDF金牌名师<br/>知名机构英语教师<br/>XDF小升初名师<br/>累计学员上千，平均提分10分+，重点中学升入率名列前茅<br/>英语专八，教师资格，剑桥TKT资格证书",
    mj:
      "提高词汇量？我有音标背词的方法。梳理语法知识？我有简洁的思维导图。提升口语发音?我有专业的唱歌技巧。动笔阅读写作？我有典型的答题模板。只要你肯来，我们就可以擦出新火花！",
    cj:
      "熟悉校内以及各类知名教材，在机构内参与教材汇编以及课程研发。了解小升初咨询，多数学生考入重点中学。",
    ry:
      "2016吉林省职业院校技能大赛英语口语金奖2015年全国大学生英语竞赛二等奖2015年知名机构金牌名师",
    ts:
      "悦心悦意,悦神悦智，悦耳悦目。我喜欢与艺术，美丽有关的事物。因为热爱生活，所以领略世界的精彩，挑战新鲜的事物，并将这种格局印刻在学生的心中，伴他们同行。",
    tstag: "课程研发霸王、机构名牌教师",
    video:
      "https://player.bilibili.com/player.html?aid=82886659&cid=141805855&page=1",
    grade2: "六年级"
  },
  {
    code: "5",
    name: "崔明杰",
    grade: "五年级",
    sf: "语文",
    tags: "6年教龄|4年教研|解题达人",
    num: "44742",
    percent: "96%",
    info: "北京师范大学中文系，教育界“水泥崔”<br/>传道受业解惑，卖萌花痴钻研",
    mj: "沉浸式教育，让语文更有趣；知之者不如好之者，好之者不如乐之者。",
    cj:
      "鼓励学生爱上语文，多人考上当地名校。所带私立学校多人考入清华、人大、北师大。",
    ry: "2017年2月优秀教研员",
    ts:
      "喜欢跑步，因为今天不想跑步，所以今天更要跑步；喜欢看书，因为今天不想看书，所以今天更要看书。挑战自己，坚持去做那些自己不喜欢却正确的事情。",
    tstag: "所带学生考入清华北大不在话下",
    video:
      "https://player.bilibili.com/player.html?aid=82888881&cid=141809511&page=1",
    grade2: "五年级"
  },
  {
    code: "6",
    name: "王奕奕",
    grade: "四年级",
    sf: "英语",
    tags: "8年教学|英式发音|趣味教学",
    num: "67038",
    percent: "95.6%",
    info:
      "英国本科和硕士教育学，专修小学教育<br/>2011-2016：在英国当地4所学校教学5门科目<br/>2017-2019：在深圳知名K12教育机构担任师训主管<br/>8年教龄<br/>语言证书：雅思口语，听力8分（满分9分）<br/>2014年获得TEFLUK国际教师资格证<br/>2016年获得英国小学教师资格证QTS<br/>2017年获得AmericanTESOL培训师资格证<br/>了解小升初咨询，所带优秀学会说呢过进入深圳排名第一中学",
    mj:
      "词汇量扩充，我的信息量足够大。单词记忆，不怕不怕，教你英国小学生的单词记忆法。阅读写作，不知如何下笔？情景分析和结合生活老师包你满意。",
    cj:
      "雅思听力口语8分，5年教学经验，教授过不同层次不同年龄，不同国籍的学生。熟悉校内以及各类知名教材，在机构内参与教材汇编以及课程研发。了解小升初咨询，多数学生考入重点中学，国际班学生考取优秀的雅思成绩。",
    ry:
      "2014年获得TEFLUK国际教师资格证2016年获得英国小学教师资格证QTS2017年获得AmericanTESOL培训师资格证",
    ts:
      "我的行李箱去过三大洲，跨国三大洋，体验过各国文化，见识过各类人群。在教学过程中结合内容拓展各国文化。喜欢静下心来做手工，拼LEGO画油画还有DIY教具，自己制作的教具都是满满的爱心噢。",
    tstag: "雅思口语8分，神奇教学",
    video:
      "https://player.bilibili.com/player.html?aid=82888779&cid=141809178&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "7",
    name: "王奕奕",
    grade: "五年级",
    sf: "英语",
    tags: "8年教学|英式发音|趣味教学",
    num: "67038",
    percent: "95.6%",
    info:
      "英国本科和硕士教育学，专修小学教育<br/>2011-2016：在英国当地4所学校教学5门科目<br/>2017-2019：在深圳知名K12教育机构担任师训主管<br/>8年教龄<br/>语言证书：雅思口语，听力8分（满分9分）<br/>2014年获得TEFLUK国际教师资格证<br/>2016年获得英国小学教师资格证QTS<br/>2017年获得AmericanTESOL培训师资格证<br/>了解小升初咨询，所带优秀学会说呢过进入深圳排名第一中学",
    mj:
      "词汇量扩充，我的信息量足够大。单词记忆，不怕不怕，教你英国小学生的单词记忆法。阅读写作，不知如何下笔？情景分析和结合生活老师包你满意。",
    cj:
      "雅思听力口语8分，5年教学经验，教授过不同层次不同年龄，不同国籍的学生。熟悉校内以及各类知名教材，在机构内参与教材汇编以及课程研发。了解小升初咨询，多数学生考入重点中学，国际班学生考取优秀的雅思成绩。",
    ry:
      "2014年获得TEFLUK国际教师资格证2016年获得英国小学教师资格证QTS2017年获得AmericanTESOL培训师资格证",
    ts:
      "我的行李箱去过三大洲，跨国三大洋，体验过各国文化，见识过各类人群。在教学过程中结合内容拓展各国文化。喜欢静下心来做手工，拼LEGO画油画还有DIY教具，自己制作的教具都是满满的爱心噢。",
    tstag: "雅思口语8分，神奇教学",
    video:
      "https://player.bilibili.com/player.html?aid=82888779&cid=141809178&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "8",
    name: "李燕军",
    grade: "五年级",
    sf: "语文",
    tags: "中文专业硕士|五年辅导经验|御姐老师",
    num: "323",
    percent: "99%",
    info:
      "中文类专业硕士<br/>五年小学语文兼职辅导经验<br/>连续两年二等奖学金获得者<br/>某著名在线辅导机构辅导老师",
    mj:
      "对于小学语文，我们需要通过情境创设，走入语文学习的情景中，发散学生的思维，让学生在体验中学习，激发学生兴趣，创造快乐课堂。",
    cj:
      "五年线下辅导经历，所带班级每位学生语文成绩均有大幅度提升，让学生爱上语文。",
    ry: "2017年-2019年连续获得学业奖二等奖学金",
    ts: "",
    tstag: "情景教学，让学生爱上语文",
    video:
      "https://player.bilibili.com/player.html?aid=82889628&cid=141810630&page=1",
    grade2: "五年级"
  },
  {
    code: "9",
    name: "史逸华",
    grade: "五年级",
    sf: "语文",
    tags: "985中哲硕士|国学达人|汉字爱好者",
    num: "3955",
    percent: "98%",
    info: "山东大学中国哲学硕士<br/>高校国学大讲堂青少年国学讲师",
    mj:
      "着重探索语言文字背后的文化内涵与思想价值，让语文变得生动有趣。让我们一起用我们的生活来理解语文，用语文来丰富我们的生活，在不知不觉中学好语文！",
    cj: "多次进校园举办国学讲座受到学生、老师、家长的好评。",
    ry: "2016年-2019年连续三年奖学金获得者",
    ts:
      "热爱生活，兴趣爱好广泛，喜欢旅游、读书、打乒乓、看电影，不过最开心的是看到同学们的成绩不断进步。语文的学习不能一蹴而就，要一步一个脚印往前走，愿在你们前进的路上有我陪伴。",
    tstag: "山大哲学硕士，国学讲师",
    video: "",
    grade2: "五年级"
  },
  {
    code: "10",
    name: "耿云喆",
    grade: "五年级",
    sf: "数学",
    tags: "小学升学专家|全能学霸|学习规划师",
    num: "90005",
    percent: "98.4%",
    info:
      "江湖人称导弹老师<br/>北京理工大学导弹设计专业，工学硕士<br/>企鹅辅导六年级负责人小升初精讲名师",
    mj:
      "擅长提高学生自己的数学思维和学习习惯，善于引导孩子学习心理，为孩子中高考的学习铺平道路。教学思路严谨，逻辑性强，使学生感觉数学不再枯燥并爱上数学。",
    cj:
      "7年教龄，所带班级全部为毕业班。负责全国小升初指导和学习规划工作，巡回讲座近百场。奥数金牌教练，所带学员斩获各大杯赛金牌。所辅导的学生结业考试的成绩均在98分以上，90%顺利升入省重点私立学校，整班升入全国排名前十名中学。",
    ry:
      "2014年某知名教育机构双S级教师2014年-2017年华罗庚杯金牌教练2016年杯赛命题人、升学考试阅卷人2017-2018年企鹅辅导“家长和学生最喜爱的老师”称号",
    ts:
      "阿喆老师上知天文，下知地理，前通历史，后懂科技，语文作文满分，英语口语流利。跟着阿喆老师当学霸，学习不再无聊，数学不再可怕，让我们在快乐中达到学习的巅峰！",
    tstag: "7年教龄，前通历史，后懂科技",
    video:
      "https://player.bilibili.com/player.html?aid=82889274&cid=141809862&page=1",
    grade2: "五年级、六年级"
  },
  {
    code: "11",
    name: "耿云喆",
    grade: "六年级",
    sf: "数学",
    tags: "小学升学专家|全能学霸|学习规划师",
    num: "90005",
    percent: "98.4%",
    info:
      "江湖人称导弹老师<br/>北京理工大学导弹设计专业，工学硕士<br/>企鹅辅导六年级负责人小升初精讲名师",
    mj:
      "擅长提高学生自己的数学思维和学习习惯，善于引导孩子学习心理，为孩子中高考的学习铺平道路。教学思路严谨，逻辑性强，使学生感觉数学不再枯燥并爱上数学。",
    cj:
      "7年教龄，所带班级全部为毕业班。负责全国小升初指导和学习规划工作，巡回讲座近百场。奥数金牌教练，所带学员斩获各大杯赛金牌。所辅导的学生结业考试的成绩均在98分以上，90%顺利升入省重点私立学校，整班升入全国排名前十名中学。",
    ry:
      "2014年某知名教育机构双S级教师2014年-2017年华罗庚杯金牌教练2016年杯赛命题人、升学考试阅卷人2017-2018年企鹅辅导“家长和学生最喜爱的老师”称号",
    ts:
      "阿喆老师上知天文，下知地理，前通历史，后懂科技，语文作文满分，英语口语流利。跟着阿喆老师当学霸，学习不再无聊，数学不再可怕，让我们在快乐中达到学习的巅峰！",
    tstag: "7年教龄，前通历史，后懂科技",
    video:
      "https://player.bilibili.com/player.html?aid=82889274&cid=141809862&page=1",
    grade2: "五年级、六年级"
  },
  {
    code: "12",
    name: "王春玮",
    grade: "四年级",
    sf: "数学",
    tags: "高效教学|兴趣培养|移动表情包",
    num: "5839",
    percent: "99%",
    info:
      "衡水中学，985本硕，支教经验<br/>知名教育机构名师<br/>小学数学4年教龄<br/>三、四、五年级自身主讲教师",
    mj:
      "都说数学比较难，其实数学很好玩；先要有个好兴趣，再加上个好习惯；题海战术要不得，举一反三最关键；算术图形和应用，在题目中找答案；再加上个小诀窍，数学满分赞赞赞。",
    cj:
      "注重孩子们学习习惯与学习兴趣的培养，提高孩子们对数学的热情，所教的孩子成绩都有很大的提高，满分多名，顺利升入著名学校。",
    ry:
      "2014年5月校数模竞赛二等奖，智能车竞赛三等奖2016年1月“挑战杯”省特等奖，国家三等奖2017年7月校优秀学生共产党员2019年4月本科、研究生均为校优秀毕业生",
    ts:
      "春春老师上得了舞台也上得了讲台，喜欢数学更喜欢带着你们一起学数学。最喜欢把数学讲到故事里，让你们爱上数学，搞定数学。",
    tstag: "985本硕优秀生，教育机构名师，",
    video:
      "https://player.bilibili.com/player.html?aid=82956947&cid=141922366&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "13",
    name: "王春玮",
    grade: "五年级",
    sf: "数学",
    tags: "高效教学|兴趣培养|移动表情包",
    num: "5839",
    percent: "98%",
    info:
      "衡水中学，985本硕，支教经验<br/>知名教育机构名师<br/>小学数学4年教龄<br/>三、四、五年级自身主讲教师",
    mj:
      "都说数学比较难，其实数学很好玩；先要有个好兴趣，再加上个好习惯；题海战术要不得，举一反三最关键；算术图形和应用，在题目中找答案；再加上个小诀窍，数学满分赞赞赞。",
    cj:
      "注重孩子们学习习惯与学习兴趣的培养，提高孩子们对数学的热情，所教的孩子成绩都有很大的提高，满分多名，顺利升入著名学校。",
    ry:
      "2014年5月校数模竞赛二等奖，智能车竞赛三等奖2016年1月“挑战杯”省特等奖，国家三等奖2017年7月校优秀学生共产党员2019年4月本科、研究生均为校优秀毕业生",
    ts:
      "春春老师上得了舞台也上得了讲台，喜欢数学更喜欢带着你们一起学数学。最喜欢把数学讲到故事里，让你们爱上数学，搞定数学。",
    tstag: "985本硕优秀生，教育机构名师，",
    video:
      "https://player.bilibili.com/player.html?aid=82956947&cid=141922366&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "14",
    name: "任小叶",
    grade: "三年级",
    sf: "语文",
    tags: "教育世家|作文满分|文娱小达人",
    num: "34273",
    percent: "94.6%",
    info:
      "山东大学优秀研究生<br/>省级优秀毕业生、优秀毕业论文<br/>师范类教学技能创新比赛一等奖<br/>省级经典诵读比赛一等奖<br/>省部级科研课题组",
    mj:
      "语文就是死记硬背？就是看着别人轻松斩获高分？NO!语文成绩的钥匙，就在你自己的手中！让叶子老师为你指路，找到属于你的学习节奏和学习方法，每节课都有新收获，每节课都会发现原来自己这么棒！",
    cj:
      "教育实习期间，在某公立学校尝试一对一精批作文，虽然工作量很大，但之后的期中期末考，两个班学生的作文成绩都有了明显提升，连带阅读也有小幅提分。那一刻的欣慰与幸福更坚定了自己心中对教师职业的认同。辅导学生参加写作、诵读比赛，多次获得个人及团体一等奖，并且在与同学老师们共同努力的过程中，自己也学到了很多。",
    ry:
      "2013年12月省级经典诵读比赛一等奖2015年6月师范类教学技能创新比赛一等奖2016年省级优秀毕业生、优秀毕业论文2017年山东大学优秀研究生",
    ts:
      "始终觉得自己是个幸运的人：温馨的家庭，真诚的师友，他们给了我足够的爱与支持，让我无畏前路。我有一个自己的小天地：有J.K.罗琳也有刘慈欣；有莫泊桑、简·奥斯汀，也有蒲松龄、汪曾祺；有莎士比亚也有王实甫、曹禺......尤其喜欢乐器和动画片，也喜欢十字绣和乐高积木，还喜欢刷剧闲逛打游戏。偶尔自己玩儿配音、弹尤克里里，或者练练硬笔、听听越剧。我会把自己的学习、生活心得尽数分享给你，毕竟，一朝相识，此生便是兄弟！",
    tstag: "山大优秀研究生，学习方法小能手",
    video: "",
    grade2: "三年级"
  },
  {
    code: "15",
    name: "于双",
    grade: "四年级",
    sf: "语文",
    tags: "破题小能手|思维风暴|兴趣激发师",
    num: "34256",
    percent: "96.3%",
    info:
      "武汉理工大学硕士研究生<br/>破题小能手、鱼渔双授<br/>窝训:每天进步一点点，前进不止一小点",
    mj:
      "古语云：授人以鱼不如授人以渔。而我说，既要授以渔也要授以鱼。语文教育重在与生活相联系，不仅让学生习得书本知识，也要明白人生道理，做到渔鱼双授。",
    cj: "",
    ry: "2016年-2019年连续三年获校级奖学金",
    ts:
      "每一个文字都有自己的灵魂，每一首诗词都有自己的世界。希望孩子们和我一起，爱上知识，爱上学习，爱上语文。",
    tstag: "鱼渔双授，思维跟我走",
    video: "",
    grade2: "四年级"
  },
  {
    code: "16",
    name: "郭昊晨",
    grade: "四年级",
    sf: "语文",
    tags: "高考作文满分|酷爱读书",
    num: "15240",
    percent: "95.3%",
    info:
      "前学而思S级教师，前新东方总部明星教师<br/>毕业于南京大学新闻系<br/>英国女王大学教育学硕士<br/>七年授课经验，雷击授课十万+人次，好读书，废寝忘食",
    mj:
      "语文就是“背多分”？带你理解语文知识背后丰富的文化含义，让你在学习的过程中潜移默化的爱上语文，腹有诗书气自华。",
    cj:
      "七年教龄，所教学生人次累计超过10万人，辅导各地学生获得各大作文竞赛一等奖，从不喜欢语文到彻底爱上语文。",
    ry: "",
    ts: "",
    tstag: "七年授课经验，机构骨干名师",
    video:
      "https://player.bilibili.com/player.html?aid=82889497&cid=141810260&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "17",
    name: "郭昊晨",
    grade: "五年级",
    sf: "语文",
    tags: "高考作文满分|酷爱读书",
    num: "15240",
    percent: "95.3%",
    info:
      "前学而思S级教师，前新东方总部明星教师<br/>毕业于南京大学新闻系<br/>英国女王大学教育学硕士<br/>七年授课经验，雷击授课十万+人次，好读书，废寝忘食",
    mj:
      "语文就是“背多分”？带你理解语文知识背后丰富的文化含义，让你在学习的过程中潜移默化的爱上语文，腹有诗书气自华。",
    cj:
      "七年教龄，所教学生人次累计超过10万人，辅导各地学生获得各大作文竞赛一等奖，从不喜欢语文到彻底爱上语文。",
    ry: "",
    ts: "",
    tstag: "七年授课经验，机构骨干名师",
    video:
      "https://player.bilibili.com/player.html?aid=82889497&cid=141810260&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "18",
    name: "车英琦",
    grade: "六年级",
    sf: "语文",
    tags: "高考131分|双学位在手|文学发烧友",
    num: "3966",
    percent: "96.1%",
    info: "教育学汉语言文学双学位<br/>家教学生中最高提三十二分<br/>文学发烧友",
    mj:
      "语文学习方法委员会提醒您：道路千万条，学好第一条。方法不规范，亲人两行泪。学语文也有方法，做阅读也有捷径，写作文更能轻松，跟着车司机这辆“语文号”，抄近路冲上语文高分学霸的快车道，孩儿们冲鸭！",
    cj:
      "家教学生中最低提七分，最高提三十二分。学生在学习后对语文的学习兴趣有明显提升，做题更有方法，能够自主探索合适的学习方法，逐渐构建起成熟的语文学习思维方式。",
    ry: "",
    ts:
      "文字的力量是单薄的，文字的力量也是奇妙的，一句“我喜欢你”，可以用千万种方式表达；文字是轻如鸿毛的，文字也是重如泰山的，文字可以毫无意义，也可以写尽山河壮美，世间百味。嗨，同学，只要你愿意相信我，只要你愿意跟着我，我就带上你，我们一起去品风花雪月，去看山岳星宿，去走过仲夏与凛冬，去感受江湖之远与庙堂之高。来吧，来吧，风儿温柔，月色美好，语文的世界已经敞开大门，只等着你。",
    tstag: "提分小能手，32分经常有",
    video: "",
    grade2: "六年级"
  },
  {
    code: "19",
    name: "徐佳超",
    grade: "六年级",
    sf: "数学",
    tags: "提分小能手|循循善诱|温暖阳光",
    num: "20151",
    percent: "97.6%",
    info:
      "五、六年级自身主讲教师<br/>一线教学五年教龄<br/>一直执教毕业班，原某机构名师、杯赛教练员精准急迫学生弱点，小学教学体系S级教师，学员遍布全国",
    mj:
      "换位思考，理解学生难点；用心琢磨，找到教学切入点；精准出击，攻克学生痛点；坚持不懈，教会每位学生。",
    cj:
      "所辅导的学生数学成绩均获得很大提升，出现多个满分，并建立起对数学的信心。很多学生从抵触数学到喜欢数学，并和老师成为朋友，从70分左右提升到98分以上。",
    ry:
      "2016年省级优秀毕业生2012年-2015年连续三年度校级甲等奖学金2014年省征文比赛三等奖",
    ts:
      "爱写小文章的数学老师也有浪漫情怀；做过卧底记者的数学老师才懂世间百态；演过小短剧的数学老师也曾是唯一男主角；一个有故事的数学老师才最有魅力。",
    tstag: "一线教学，五年教龄，获奖无数",
    video:
      "https://player.bilibili.com/player.html?aid=82865274&cid=141771829&page=1",
    grade2: "六年级"
  },
  {
    code: "20",
    name: "Jane",
    grade: "四年级",
    sf: "英语",
    tags: "4年教龄|兴趣教学|课堂活泼",
    num: "32568",
    percent: "92.8%",
    info:
      "语言专业科班出身<br/>雅思7分<br/>丰富的英语教育工作经验<br/>线下某英语培训机构指导老师<br/>线上、线下指导过的学生过千",
    mj:
      "Jane姐姐的课堂活泼，氛围轻松，语言就是要快乐学习，分数就是手到擒来的事情啦~重视兴趣教学，让孩子爱上语言，爱上课堂，自信说一口漂亮的英语最重要！",
    cj:
      "教学成就鼓励孩子开口说，帮助数百名因英语不好而自卑的孩子，突破自己语言短板，取得中考佳绩。",
    ry: "2011年英语专业八级2016年线下机构优秀老师",
    ts:
      "上课风格轻松幽默，深谙小学生学习心理，多年英语教学经验，对知识点把握精准。提倡引导式教学，培养学生学习兴趣，提高学习动力。",
    tstag: "英语专业八级，提高学习动力",
    video:
      "https://player.bilibili.com/player.html?aid=82888470&cid=141808850&page=1",
    grade2: "四年级"
  },
  {
    code: "21",
    name: "Lisa",
    grade: "四年级",
    sf: "英语",
    tags: "十年教龄|人气孩子王|语法剪刀手",
    num: "57071",
    percent: "95.6%",
    info:
      "2013-2018年学而思s级A级名师<br/>太原分校英语创始人<br/>语言证书：英语专八、雅思7.5<br/>教师证书：中国教师资格证、英国剑桥大学出版社访问学者<br/>80%高分率（130分以上），国际班剑桥考试优秀率年级第一",
    mj:
      "孩子不张口？自然拼读+国际音标双管齐下孩子发音不用愁！孩子不爱学？趣味动画+互动教学从此让孩子沉迷英语学习！孩子不会考？听说读写全覆盖，高效输入+定期输出，一学一练让孩子不知不觉成为小考霸！爸爸妈妈再也不用担心娃的英语学习，我们一路伴随~",
    cj:
      "英语专业八级，教学10年以来，线下所教小学/初中/高中学员2000+，熟悉各阶段英语学习规划以及学生特点，所带中考班平均提分15+，130分以上占比80%以上；所带国际班剑桥考试fce,ket优秀率年级第一；目前往届多数学生已进入国外名牌大学学习或被保送国内知名学府如上海外国语大学等。",
    ry:
      "2013年英语专八、托业优秀证书2014年-2016年多次获得在线教育平台S级A级优秀教师奖2016年剑桥大学TKT教学能力测试证书",
    ts:
      "授人以鱼不如授人以渔，我相信：最好的老师就是一本活字典-不仅能把晦涩难懂的知识转化成简洁有趣的小学问，还能对孩子的学习习惯和学习方法的教与学游刃有余。爱英语，爱世界，让孩子有一门语言特技，从此自信面对人生每一天。",
    tstag: "十年教学，爱英语，更爱学生",
    video:
      "https://player.bilibili.com/player.html?aid=82888583&cid=141809010&page=1",
    grade2: "四年级"
  },
  {
    code: "22",
    name: "赵一一",
    grade: "二年级",
    sf: "数学",
    tags: "课堂生动|寓教于乐|偶像实力派",
    num: "144150",
    percent: "97%",
    info:
      "企鹅辅导小学三、四、五年级资深主讲老师<br/>5年小学数学教学经验<br/>家庭教育讲师<br/>独创思维训练体系",
    mj:
      "做孩子最亲密的伙伴，聊他们最感兴趣的话题；做学生最喜欢的老师，给他们最高效的学习方法；做爸妈最信赖的朋友，帮父母创造全能牛娃。撒娇、卖萌、说段子，让你看到最意想不到的数学课堂。",
    cj:
      "6年教龄，累计学员数千人次，学员的校内成绩均有明显提升，数百学生竞赛获奖。深度了解小学数学体系及各年级特点。",
    ry: "",
    ts: "小小数学不用怕，跟着一姐变学霸！",
    tstag: "6年教龄，5年经验，学员数千",
    video: "",
    grade2: "二年级、三年级、四年级"
  },
  {
    code: "23",
    name: "赵一一",
    grade: "三年级",
    sf: "数学",
    tags: "课堂生动|寓教于乐|偶像实力派",
    num: "144150",
    percent: "97%",
    info:
      "企鹅辅导小学三、四、五年级资深主讲老师<br/>5年小学数学教学经验<br/>家庭教育讲师<br/>独创思维训练体系",
    mj:
      "做孩子最亲密的伙伴，聊他们最感兴趣的话题；做学生最喜欢的老师，给他们最高效的学习方法；做爸妈最信赖的朋友，帮父母创造全能牛娃。撒娇、卖萌、说段子，让你看到最意想不到的数学课堂。",
    cj:
      "6年教龄，累计学员数千人次，学员的校内成绩均有明显提升，数百学生竞赛获奖。深度了解小学数学体系及各年级特点。",
    ry: "",
    ts: "小小数学不用怕，跟着一姐变学霸！",
    tstag: "6年教龄，5年经验，学员数千",
    video:
      "https://player.bilibili.com/player.html?aid=82886796&cid=141806243&page=1",
    grade2: "二年级、三年级、四年级"
  },
  {
    code: "24",
    name: "赵一一",
    grade: "四年级",
    sf: "数学",
    tags: "课堂生动|寓教于乐|偶像实力派",
    num: "144150",
    percent: "97%",
    info:
      "企鹅辅导小学三、四、五年级资深主讲老师<br/>5年小学数学教学经验<br/>家庭教育讲师<br/>独创思维训练体系",
    mj:
      "做孩子最亲密的伙伴，聊他们最感兴趣的话题；做学生最喜欢的老师，给他们最高效的学习方法；做爸妈最信赖的朋友，帮父母创造全能牛娃。撒娇、卖萌、说段子，让你看到最意想不到的数学课堂。",
    cj:
      "6年教龄，累计学员数千人次，学员的校内成绩均有明显提升，数百学生竞赛获奖。深度了解小学数学体系及各年级特点。",
    ry: "",
    ts: "小小数学不用怕，跟着一姐变学霸！",
    tstag: "6年教龄，5年经验，学员数千",
    video:
      "https://player.bilibili.com/player.html?aid=82886796&cid=141806243&page=1",
    grade2: "二年级、三年级、四年级"
  },
  {
    code: "25",
    name: "申奇",
    grade: "三年级",
    sf: "数学",
    tags: "9年教龄|形象生动|清晰易懂",
    num: "24141",
    percent: "96.3%",
    info:
      "小学数学8年教龄<br/>知名教育机构优秀教师，雷击授课学院几千人次<br/>杯赛优秀教练员，趣味课程设计师<br/>逻辑清晰、幽默风趣、生动易懂<br/>经验丰富、深刻了解孩子易错或难懂的环节",
    mj:
      "善于引导学生思考，举一反三。授课逻辑层层递进，会用特别好懂的例子帮助孩子们理解抽象的知识，孩子们学完之后普遍印象深刻，并且觉得好玩有趣。",
    cj:
      "8年教龄，累计授课学员几千人次。学员在校内成绩均有明显提高，部分优秀学员在华杯赛、希望杯、迎春杯中有突出表现，斩获奖项学员数以百计。",
    ry:
      "2014年知名在线教育平台“优秀教师奖”2016年希望杯数学竞赛优秀教练员2016年全国华罗庚金杯优秀教练员",
    ts: "“神奇”老师帮你忙，数学世界任飞翔！",
    tstag: "机构优秀教师，趣味课程设计师",
    video:
      "https://player.bilibili.com/player.html?aid=82887214&cid=141806896&page=1",
    grade2: "三年级、四年级"
  },
  {
    code: "26",
    name: "申奇",
    grade: "四年级",
    sf: "数学",
    tags: "9年教龄|形象生动|清晰易懂",
    num: "24141",
    percent: "96.3%",
    info:
      "小学数学8年教龄<br/>知名教育机构优秀教师，雷击授课学院几千人次<br/>杯赛优秀教练员，趣味课程设计师<br/>逻辑清晰、幽默风趣、生动易懂<br/>经验丰富、深刻了解孩子易错或难懂的环节",
    mj:
      "善于引导学生思考，举一反三。授课逻辑层层递进，会用特别好懂的例子帮助孩子们理解抽象的知识，孩子们学完之后普遍印象深刻，并且觉得好玩有趣。",
    cj:
      "8年教龄，累计授课学员几千人次。学员在校内成绩均有明显提高，部分优秀学员在华杯赛、希望杯、迎春杯中有突出表现，斩获奖项学员数以百计。",
    ry:
      "2014年知名在线教育平台“优秀教师奖”2016年希望杯数学竞赛优秀教练员2016年全国华罗庚金杯优秀教练员",
    ts: "“神奇”老师帮你忙，数学世界任飞翔！",
    tstag: "机构优秀教师，趣味课程设计师",
    video:
      "https://player.bilibili.com/player.html?aid=82887214&cid=141806896&page=1",
    grade2: "三年级、四年级"
  },
  {
    code: "27",
    name: "谢小紫",
    grade: "四年级",
    sf: "数学",
    tags: "逻辑超强|小学顶级名师|兴趣激发师",
    num: "98516",
    percent: "98.5%",
    info:
      "多个年级的教课经验<br/>接触数干名学生和家长<br/>儿童心理研究<br/>小学数学教研师<br/>华杯赛、希望杯、启智杯教练",
    mj:
      "熟悉小学知识体系，能抓准校内考点、杯赛热点，押题准。抓习惯、抓兴趣，用独有的教育方法，全方面培养学生，让学生成绩提升，决胜小学。",
    cj:
      "中山大学理科学霸知名小学高级教师全国优秀家庭教育讲师6年教龄，累计学员已数万人；学员遍布全国，90%学生竞赛获奖、年级前十",
    ry:
      "2015年-2017年启智杯优秀教练员2016年-2018年深圳优秀教育讲师2018年-2019年小学独创体系核心成员2018年至今教材教研组、命题组成员",
    ts: "跟着小紫走，数学冲上游！摆脱题海，吃透方法带你来“开窍”！",
    tstag: "中大理学霸，全国优秀教育讲师",
    video:
      "https://player.bilibili.com/player.html?aid=82888376&cid=141808544&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "28",
    name: "谢小紫",
    grade: "五年级",
    sf: "数学",
    tags: "逻辑超强|小学顶级名师|兴趣激发师",
    num: "98516",
    percent: "98.5%",
    info:
      "多个年级的教课经验<br/>接触数干名学生和家长<br/>儿童心理研究<br/>小学数学教研师<br/>华杯赛、希望杯、启智杯教练",
    mj:
      "熟悉小学知识体系，能抓准校内考点、杯赛热点，押题准。抓习惯、抓兴趣，用独有的教育方法，全方面培养学生，让学生成绩提升，决胜小学。",
    cj:
      "中山大学理科学霸知名小学高级教师全国优秀家庭教育讲师6年教龄，累计学员已数万人；学员遍布全国，90%学生竞赛获奖、年级前十",
    ry:
      "2015年-2017年启智杯优秀教练员2016年-2018年深圳优秀教育讲师2018年-2019年小学独创体系核心成员2018年至今教材教研组、命题组成员",
    ts: "跟着小紫走，数学冲上游！摆脱题海，吃透方法带你来“开窍”！",
    tstag: "中大理学霸，全国优秀教育讲师",
    video:
      "https://player.bilibili.com/player.html?aid=82888376&cid=141808544&page=1",
    grade2: "四年级、五年级"
  },
  {
    code: "29",
    name: "冯毅辰",
    grade: "六年级",
    sf: "数学",
    tags: "小升初精讲名师|幽默风趣|押题准",
    num: "101680",
    percent: "98.4%",
    info:
      "小升初全国精讲名师、小学K12体系金牌规划师<br/>华杯、希望杯全国优秀教练员，全国教材教研研讨会成员<br/>曾在天津所带学生获奖人数占总全市获奖人数35%<br/>北京师范大学出版集团签约作者<br/>一线教学八年,6年执教毕业班<br/>整班小升初数学100分奇迹创造者，人送外号押题王",
    mj:
      "通晓小学六年数学体系，针对不同的学生丢分点制定提分方案，因材施教，题虽难，讲易懂。小升初考点压中100%，成功压中近三年小升初压轴题。",
    cj:
      "8年教龄，累计学员7000人。毕业班学员95%数学单科成绩满分，所有学员均考入重点初中，在各项数学能力比赛中有90%的学员获奖.",
    ry:
      "2013年-2017年华杯赛优秀教练员2015年-2017年高端班金牌教练，口碑教师2017年至今北京师范大学出版集团签约作者2017年至今《小学数学奥林匹克训练题库》视频讲解作者2018年至今教材编写组，命题组成员",
    ts: "始于颜值，忠于段子，陷于才华。原来数学如此简单，老师如此帅气！",
    tstag: "毕业班学员95%数学成绩满分",
    video:
      "https://player.bilibili.com/player.html?aid=82885721&cid=141773355&page=1",
    grade2: "六年级"
  },
  {
    code: "30",
    name: "Ann",
    grade: "一年级",
    sf: "英语",
    tags: "五年教龄|故事教学法|寓教于乐",
    num: "71414",
    percent: "95.7%",
    info:
      "山东师范大学-英语和学期教育学双学位<br/>香港中文大学研修学习<br/>曾任职某知名英语培训学校",
    mj:
      "擅长将枯燥的英语知识趣味化，使用一个个生动有趣的故事，营造浸入式的学习氛围，激发孩子主动学习的诉求。即使隔着屏幕也能抓住孩子们的心，让孩子全神贯注地投入英语学习中去。",
    cj:
      "依托丰富的线上线下教学经验，累计接触各个年龄段的学生10万+，对于不同年龄段孩子的身心发展及学习特点有深入的了解。帮助许多孩子寻找到了学习英语的乐趣及正确的学习方法，使英语成为孩子的优势学科。",
    ry: "",
    ts:
      "我的小可爱们都喜欢叫我是他们的Dramaqueen，是个戏精，能编又能演。喜欢撸猫，最爱的就是周末在家抱着猫咪看一部英文电影。喜爱旅行，世界这么大，想把全世界的风土人情都带到我的学生眼前。",
    tstag: "教育学双学位，学员过万",
    video: "",
    grade2: "一年级、二年级"
  },
  {
    code: "31",
    name: "Ann",
    grade: "二年级",
    sf: "英语",
    tags: "五年教龄|故事教学法|寓教于乐",
    num: "71414",
    percent: "95.7%",
    info:
      "山东师范大学-英语和学期教育学双学位<br/>香港中文大学研修学习<br/>曾任职某知名英语培训学校",
    mj:
      "擅长将枯燥的英语知识趣味化，使用一个个生动有趣的故事，营造浸入式的学习氛围，激发孩子主动学习的诉求。即使隔着屏幕也能抓住孩子们的心，让孩子全神贯注地投入英语学习中去。",
    cj:
      "依托丰富的线上线下教学经验，累计接触各个年龄段的学生10万+，对于不同年龄段孩子的身心发展及学习特点有深入的了解。帮助许多孩子寻找到了学习英语的乐趣及正确的学习方法，使英语成为孩子的优势学科。",
    ry: "",
    ts:
      "我的小可爱们都喜欢叫我是他们的Dramaqueen，是个戏精，能编又能演。喜欢撸猫，最爱的就是周末在家抱着猫咪看一部英文电影。喜爱旅行，世界这么大，想把全世界的风土人情都带到我的学生眼前。",
    tstag: "教育学双学位，学员过万",
    video: "",
    grade2: "一年级、二年级"
  },
  {
    code: "32",
    name: "魏漫漫",
    grade: "一年级",
    sf: "数学",
    tags: "逻辑超强|生动课堂|最受欢迎",
    num: "73147",
    percent: "99.7%",
    info: "10年教龄<br/>学而思超常班教练、迎春杯命题人、阅卷人",
    mj:
      "最爱讲“为什么”，最爱缕逻辑，最爱把复杂的知识比喻拟人化，最爱搞笑，最了解孩子心理，最受孩子欢迎。",
    cj:
      "10年教龄，培养获奖学员无数，考入各类重点初中的孩子不计其数。带过的所有基础班学员90%以上升入更高班次。迎春杯、希望杯、走美杯获奖学员100+",
    ry:
      "2014年年度“学而思十佳教师”2017年年度“学而思十佳教师”2018年年度“双师全国十佳主讲”",
    ts:
      "课堂生动，有活力，能抓住每一个孩子的注意力。能知道孩子的薄弱环节，针对薄弱环节重点讲授。喜欢给孩子把知识讲透而不是应试，让孩子真正掌握数学的学习方法。",
    tstag: "10年教龄，最受孩子欢迎。",
    video: "",
    grade2: "一年级"
  },
  {
    code: "33",
    name: "柴惠美",
    grade: "初一",
    sf: "英语",
    tags: "10年教龄|专业八级|抖包袱达人",
    num: "117014",
    percent: "98.8%",
    info:
      "企鹅辅导初中英语负责人，10年教龄，英语专业八级<br/>国家级演讲大赛北京分赛区评委、国际体系项目负责人<br/>国家级英语演讲大赛全国总冠军导师、剑桥五级体系总设计师<br/>独创天柴标记阅读法天柴锦囊学习法<br/>累计培养158名中考英语满分状元，中考提分高达20分",
    mj:
      "有效结合‘learntoread’&amp;amp;amp;amp;amp;’readtolearn’从此爱上英语原版阅读；用数学解析法遇见语法学通透的自己。",
    cj:
      "亲授学生王之栋获中国日报社21世纪杯英语演讲大赛小高组全国总冠军，亲授学生黄楚玉获全国中学生英语演讲与辩论五项大赛全国亚军；带出全年级雅思模考排名TOP1和TOP2的学生。成绩分别是TOP1初思齐阅读8分，听力7.5分，TOP2董心知阅读7.5分，听力8分；累计培养出133名中考满分状元。所带学生均有提显著提分，其中多名同学从期末考试103，104提分至中考一模118、119分。讲授剑桥五级课程期间，本班通过率遥遥领先，高于北京市平均通过率30%。",
    ry:
      "2011年-2013年凭借剑桥五级乐考项目设计者的成就获得学而思教育集团优秀项目主管2011-2013年获得剑桥大学TKT（教学能力测试）Band4（最高级4级）2014-2015年获GlobalSummerSchool“最受学生欢迎的国际教师“之一2017年连获学而思S级A级老师",
    ts:
      "被誉为用数学思维教英语的怪才老师，用大学外语学院女篮队主力的体能，玩狼人杀过人的思辨能力，业余rocker的爆发力，带你成为以英语满分为起点，听说读写全能的英语达人。",
    tstag: "培养出158名中考英语满分状元",
    video: "",
    grade2: "初一、初三"
  },
  {
    code: "34",
    name: "柴惠美",
    grade: "初三",
    sf: "英语",
    tags: "10年教龄|专业八级|抖包袱达人",
    num: "117014",
    percent: "98.8%",
    info:
      "企鹅辅导初中英语负责人，10年教龄，英语专业八级<br/>国家级演讲大赛北京分赛区评委、国际体系项目负责人<br/>国家级英语演讲大赛全国总冠军导师、剑桥五级体系总设计师<br/>独创天柴标记阅读法天柴锦囊学习法<br/>累计培养158名中考英语满分状元，中考提分高达20分",
    mj:
      "有效结合‘learntoread’&amp;amp;amp;amp;amp;’readtolearn’从此爱上英语原版阅读；用数学解析法遇见语法学通透的自己。",
    cj:
      "亲授学生王之栋获中国日报社21世纪杯英语演讲大赛小高组全国总冠军，亲授学生黄楚玉获全国中学生英语演讲与辩论五项大赛全国亚军；带出全年级雅思模考排名TOP1和TOP2的学生。成绩分别是TOP1初思齐阅读8分，听力7.5分，TOP2董心知阅读7.5分，听力8分；累计培养出133名中考满分状元。所带学生均有提显著提分，其中多名同学从期末考试103，104提分至中考一模118、119分。讲授剑桥五级课程期间，本班通过率遥遥领先，高于北京市平均通过率30%。",
    ry:
      "2011年-2013年凭借剑桥五级乐考项目设计者的成就获得学而思教育集团优秀项目主管2011-2013年获得剑桥大学TKT（教学能力测试）Band4（最高级4级）2014-2015年获GlobalSummerSchool“最受学生欢迎的国际教师“之一2017年连获学而思S级A级老师",
    ts:
      "被誉为用数学思维教英语的怪才老师，用大学外语学院女篮队主力的体能，玩狼人杀过人的思辨能力，业余rocker的爆发力，带你成为以英语满分为起点，听说读写全能的英语达人。",
    tstag: "培养出158名中考英语满分状元",
    video: "",
    grade2: "初一、初三"
  },
  {
    code: "35",
    name: "陈超",
    grade: "初一",
    sf: "数学",
    tags: "中考提分能手|总结型名师|风趣幽默",
    num: "20271",
    percent: "96.9%",
    info:
      "毕业于北京科技大学，中高考成绩优异<br/>3年教龄<br/>90%以上的学生进入人大附中,清华附中,常青籐等名校",
    mj:
      "单选填空不折手段滴满分，很多小妙招需要掌握；抓住数学学习的根，以不变应万变；超超独有学习方法，愿意和你们一起分享我的高分秘诀，实验者就是我本人，表示实验非常成功！",
    cj:
      "2015年任教，教授的学生以很高的比例进入清华高中部，国际部，人大附高中部，常青藤学校等高中名校，学生高中依旧保持着良好的学习习惯。90%以上的学生在成绩上有了很大的进步，取得了非常明显的排名的突飞猛进，进入90分以上（满分100）分数区域。除了学习课程，在不知不觉中培养学生学习习惯，使之在未来走的更加长远。",
    ry: "2017年9月知名教育机构优秀教师",
    ts:
      "喜欢内容：游乐场，蹦极，滑雪，旅游（偏爱南方，暖和）看动漫，逛吃逛吃，读包括课本以内的书籍（哈哈），个人觉得除了学习学的非常好，我们的生活也应该丰富多彩，做一个效率高而专注的大宝宝，学的开心，玩的欢乐，做独立而又美丽的自己，让才华与美貌兼得。PS：可以一起约看动漫哈，永远的18岁!!!",
    tstag: "北科大出身，优秀教师",
    video:
      "https://player.bilibili.com/player.html?aid=82891615&cid=141813754&page=1",
    grade2: "初一、初三"
  },
  {
    code: "36",
    name: "陈超",
    grade: "初三",
    sf: "数学",
    tags: "中考提分能手|总结型名师|风趣幽默",
    num: "20271",
    percent: "96.9%",
    info:
      "毕业于北京科技大学，中高考成绩优异<br/>3年教龄<br/>90%以上的学生进入人大附中,清华附中,常青籐等名校",
    mj:
      "单选填空不折手段滴满分，很多小妙招需要掌握；抓住数学学习的根，以不变应万变；超超独有学习方法，愿意和你们一起分享我的高分秘诀，实验者就是我本人，表示实验非常成功！",
    cj:
      "2015年任教，教授的学生以很高的比例进入清华高中部，国际部，人大附高中部，常青藤学校等高中名校，学生高中依旧保持着良好的学习习惯。90%以上的学生在成绩上有了很大的进步，取得了非常明显的排名的突飞猛进，进入90分以上（满分100）分数区域。除了学习课程，在不知不觉中培养学生学习习惯，使之在未来走的更加长远。",
    ry: "2017年9月知名教育机构优秀教师",
    ts:
      "喜欢内容：游乐场，蹦极，滑雪，旅游（偏爱南方，暖和）看动漫，逛吃逛吃，读包括课本以内的书籍（哈哈），个人觉得除了学习学的非常好，我们的生活也应该丰富多彩，做一个效率高而专注的大宝宝，学的开心，玩的欢乐，做独立而又美丽的自己，让才华与美貌兼得。PS：可以一起约看动漫哈，永远的18岁!!!",
    tstag: "北科大出身，优秀教师",
    video:
      "https://player.bilibili.com/player.html?aid=82891615&cid=141813754&page=1",
    grade2: "初一、初三"
  },
  {
    code: "37",
    name: "程子豪",
    grade: "初三",
    sf: "语文",
    tags: "人大才子|公考状元|提分担当",
    num: "15371",
    percent: "99.6%",
    info:
      "中国人民大学-文学院硕士<br/>北京市海淀区先进教育工作者<br/>提分担当<br/>所教尖子班数百人考入北大、清华、人大等顶级名校<br/>所教逆袭班和高考特训班学生语文成绩平均提升20分",
    mj:
      "采用“三通”教学法，通方法，通规律，通思维，从根本上解决因为学习方法不当、知识储备贫乏和思维能力不够导致的语文成绩提升难问题。如果你最恨背、背、背，我来教你轻松高效的记忆方法；如果你最怕读、读、读，我来带你探寻文章的微言大义，体验读懂后豁然开朗的快意；如果你最惧写、写、写，跟我一起做一场思维的游戏，无压力的写作让你下笔如有神，笑傲考场。连续多年切中高考全国卷和地方卷作文题，靠的不是侥幸，而是能把握时代主题，洞察命题规律。",
    cj:
      "所教尖子班学生数百人考入北大、清华、人大、浙大、复旦、交大等“双一流”顶级名校，所教逆袭班和高考特训班学生语文成绩平均提升20分。近年来，尤其是转入线上教育后，致力于初高中语文一体化的研究和实践，重点做好初高中的衔接和贯通，夯实基础，形成体系，帮助数千名学生考入当地重点中学，并且在进入高中后语文成绩持续提升，保持领先。",
    ry:
      "2011年5月北京市海淀区优秀青年教师2012年5月北京市海淀区先进教育工作者2013年6月北京市海淀区优秀共产党员",
    ts:
      "指点江山，激扬文字，以语言为翅膀自由飞翔！从小学起参加各类演讲比赛从未出过三甲；在唇枪舌剑的辩论赛上常常一剑封喉斩获“最佳辩手”；主持晚会、对话名人、掌控论坛，于千万人之前游刃有余、从容不迫。细思量却发现语言的力量不是为了获胜，而是为了传递情感，启迪思想，于是我选择做一名老师。身经百战，精通考试法则，从竞争比高考还要惨烈的公务员考试中突出重围，夺得笔试面试双第一。蓦然回首才领悟到真正的风光不是别人羡慕的眼神，而是自己内心的安宁，于是我选择弃政从教，坚守初心！愿我能用自己对母语发自灵魂的热爱点燃你对语文的热情，点亮你的诗意青春！",
    tstag: "民大硕士，通方法，通规律，通思维",
    video: "",
    grade2: "初三、高二"
  },
  {
    code: "38",
    name: "高明东",
    grade: "初一",
    sf: "数学",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    num: "75246",
    percent: "98.4%",
    info: "5年教龄<br/>提分大神<br/>90%升入市重点",
    mj:
      "课上激情四射，课堂氛围活跃；亲和力极强，学生愿意听课；责任心强，课后及时关注学生情况，与学生亦师亦友；注重因材施教，懂得换位思考，更容易走进学生的世界。",
    cj:
      "5年教龄，专注提升学生数学成绩，曾经辅导三年的学生85%升入市重点中学，5%升入省重点中学",
    ry: "2014年-2018年校一等奖学金、校励学金2018年优秀毕业生",
    ts:
      "高老师生性可爱，耍的了二，卖得了萌，在数学界那可是文能提笔安天下，武能立马定乾坤，少年我看你骨骼清奇，是万中无一的数学奇才，维护世界和平就靠你啦，爱数学的人运气都不会太差啦！",
    tstag: "5年教龄，专注提升学生成绩",
    video: "",
    grade2: "初一、初二、初三"
  },
  {
    code: "39",
    name: "高明东",
    grade: "初二",
    sf: "数学",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    num: "75246",
    percent: "98.4%",
    info: "5年教龄<br/>提分大神<br/>90%升入市重点",
    mj:
      "课上激情四射，课堂氛围活跃；亲和力极强，学生愿意听课；责任心强，课后及时关注学生情况，与学生亦师亦友；注重因材施教，懂得换位思考，更容易走进学生的世界。",
    cj:
      "5年教龄，专注提升学生数学成绩，曾经辅导三年的学生85%升入市重点中学，5%升入省重点中学",
    ry: "2014年-2018年校一等奖学金、校励学金2018年优秀毕业生",
    ts:
      "高老师生性可爱，耍的了二，卖得了萌，在数学界那可是文能提笔安天下，武能立马定乾坤，少年我看你骨骼清奇，是万中无一的数学奇才，维护世界和平就靠你啦，爱数学的人运气都不会太差啦！",
    tstag: "5年教龄，专注提升学生成绩",
    video: "",
    grade2: "初一、初二、初三"
  },
  {
    code: "40",
    name: "高明东",
    grade: "初三",
    sf: "数学",
    tags: "提分大神|兼具才华颜值|最具亲和力",
    num: "75246",
    percent: "98.4%",
    info: "5年教龄<br/>提分大神<br/>90%升入市重点",
    mj:
      "课上激情四射，课堂氛围活跃；亲和力极强，学生愿意听课；责任心强，课后及时关注学生情况，与学生亦师亦友；注重因材施教，懂得换位思考，更容易走进学生的世界。",
    cj:
      "5年教龄，专注提升学生数学成绩，曾经辅导三年的学生85%升入市重点中学，5%升入省重点中学",
    ry: "2014年-2018年校一等奖学金、校励学金2018年优秀毕业生",
    ts:
      "高老师生性可爱，耍的了二，卖得了萌，在数学界那可是文能提笔安天下，武能立马定乾坤，少年我看你骨骼清奇，是万中无一的数学奇才，维护世界和平就靠你啦，爱数学的人运气都不会太差啦！",
    tstag: "5年教龄，专注提升学生成绩",
    video: "",
    grade2: "初一、初二、初三"
  },
  {
    code: "41",
    name: "高岩",
    grade: "初一",
    sf: "语文",
    tags: "14年教龄|省重点名师|全方位提升",
    num: "34022",
    percent: "99.5%",
    info:
      "十四年教龄,前人大附中系列学校语文组长<br/>多次参与市区中考模拟命制,中考专家<br/>受到国家级新闻周刊《北京周报》采访<br/>中考阅卷组阅读部分大组组长、中考评分标准制定小组成员<br/>人教版教材配套练习册编写者、北京市师德征文一等奖",
    mj:
      "透彻命中知识点，准确抓住典型题，熟悉命题思路，经验造就高效。在提分的过程中同步提升思维的深度和广度，让你站得高，望得远！",
    cj:
      "任教十四年来，桃李遍天下。从清华北大人大等国内顶级高校，到美国加拿大等世界排名前100的大学，都有高老师孩子们的踪迹。离开公立校的最后一届孩子，已有多人拿到清华北大的加分和保送资格，跟着高老师，圆自己的名校之梦想！",
    ry:
      "2008年-2013年市区中心备课组成员2014年-2016年人教版配套练习册编写组成员2018年语文报杯作文大赛特等奖辅导教师2018年改革开放四十周年教师代表",
    ts:
      "懂你的悲喜，才能在你展翅时欢呼，在你沮丧时鼓舞。我是你的老师，是你的教练，是你的长辈，更是你的朋友。愿我的用心，成就你的梦想，那便是作为老师最好的幸福。",
    tstag: "透彻命中知识点，经验造就高效",
    video:
      "https://player.bilibili.com/player.html?aid=82941681&cid=141896979&page=1",
    grade2: "初一、高一、高二"
  },
  {
    code: "42",
    name: "哈旭然",
    grade: "初三",
    sf: "化学",
    tags: "挖坑小能手|中考化学满分|押题王",
    num: "124472",
    percent: "99.5%",
    info:
      "授课时长2500+、累计教授学员人数超过13W<br/>初升高化学专家一线执教6年毕业班经验<br/>自建中考化学特色体系初中化学讲义主编<br/>曾任线下辅导机构教研组长<br/>指导上万名考生考入重点名校，有“满分制造机”之称",
    mj:
      "初中化学还在死记硬背？你OUT啦！这里有全面的知识梳理归纳，让你轻松掌握知识脉络，告别死记硬背，不用题海战术轻松拿高分。妈妈再也不用担心你的化学啦~！",
    cj:
      "自我2013年从教以来，所教学生人数累计超过3万人，接触的各类学生中，有基础欠缺型，经过30多次的辅导课程基本达到班上中上游水平。在我的众多学生中，每年有多人考上当地重点高中。其中还不乏有一些学生被直接保送至重点校。并且每年都会有部分同学取得满分的好成绩。老师期待你成为下一个他们！",
    ry: "",
    ts:
      "本人是一名性格开朗，幽默风趣的老师，我的性格就像我的名字，因此大家都叫我哈哈老师。我的课堂就像坐火箭一般飞快的过去啦，在这其中你一定颇有收获又会觉得超级有趣哦，所以希望同学们不要错过每一次的直播课，我是你们的良师更是你们的益友。",
    tstag: "满分制造机，数十万学员的老师",
    video:
      "https://player.bilibili.com/player.html?aid=82891326&cid=141813332&page=1",
    grade2: "初三"
  },
  {
    code: "43",
    name: "韩欢欢",
    grade: "初一",
    sf: "数学",
    tags: "资深教研|13年教龄|提分诸葛",
    num: "5484",
    percent: "100%",
    info:
      "985大学硕士<br/>资深教研：13年教龄<br/>企鹅辅导数学教研负责人<br/>编20+教辅书、讲义",
    mj:
      "选择题中遇到字母的题你还在正面迎敌吗？特殊值法就可以秒杀答案；几何压轴题还在苦于没有思路吗？几何模型能助你一臂之力；动点问题令你眼花缭乱了吗？动中求静是突破之法！",
    cj: "传承薪火、教书育人区状元数枚、校状元n+、所带学生提分15~25分不等",
    ry:
      "2003年-2005年连续三年获得山西师范大学一等奖学金2008年某教育平台教师风采大赛二等奖2015年-2016年某教育平台出版中心优秀个人",
    ts: "我的爱好广泛：唱歌、跳舞（健美操）、动手（插拼积木）",
    tstag: "状元导师",
    video: "",
    grade2: "初一"
  },
  {
    code: "44",
    name: "赫梦",
    grade: "初二",
    sf: "物理",
    tags: "7年教龄|高颜值学霸|化繁为简",
    num: "40692",
    percent: "99.1%",
    info:
      "原西安新东方初中部物理教师<br/>物理教研组组长<br/>全国物理教师技能大赛获奖<br/>在线物理直播名师好评过万",
    mj:
      "如果你为物理学习困扰，木木夕经过多年的沉淀和积累，对物理有一套自己的教学方法，善于从你们的角度出发分析，用最通俗易懂的讲法和实例帮你们秒杀各种物理重难点。如果你为物理总考不到高分而发愁，木木夕变身挖坑小能手，帮你在跳坑的过程中寻找考试出题规律，做到知己知彼，百战不殆。",
    cj:
      "自从教以来，所教学生人数累计超过3万人。线下中考物理满分学员累计30+，大量学员被五大名校录取。",
    ry:
      '2009年-2011年连续三年获得校级二等奖学金及三好学生2011年8月全国"人教社杯“物理教学技能大赛获奖',
    ts:
      "木木夕是一名超爱跳舞，爱电影，爱旅游的物理老师。亦师亦友，每一名学生都是木木夕很重要的朋友。也许物理教学只有短短两年时间，但是和同学们一起成长和进步是无期限的。",
    tstag: "在线物理直播名师好评过万",
    video:
      "https://player.bilibili.com/player.html?aid=82890107&cid=141811316&page=1",
    grade2: "初二、初三"
  },
  {
    code: "45",
    name: "赫梦",
    grade: "初三",
    sf: "物理",
    tags: "7年教龄|高颜值学霸|化繁为简",
    num: "40692",
    percent: "99.1%",
    info:
      "原西安新东方初中部物理教师<br/>物理教研组组长<br/>全国物理教师技能大赛获奖<br/>在线物理直播名师好评过万",
    mj:
      "如果你为物理学习困扰，木木夕经过多年的沉淀和积累，对物理有一套自己的教学方法，善于从你们的角度出发分析，用最通俗易懂的讲法和实例帮你们秒杀各种物理重难点。如果你为物理总考不到高分而发愁，木木夕变身挖坑小能手，帮你在跳坑的过程中寻找考试出题规律，做到知己知彼，百战不殆。",
    cj:
      "自从教以来，所教学生人数累计超过3万人。线下中考物理满分学员累计30+，大量学员被五大名校录取。",
    ry:
      '2009年-2011年连续三年获得校级二等奖学金及三好学生2011年8月全国"人教社杯“物理教学技能大赛获奖',
    ts:
      "木木夕是一名超爱跳舞，爱电影，爱旅游的物理老师。亦师亦友，每一名学生都是木木夕很重要的朋友。也许物理教学只有短短两年时间，但是和同学们一起成长和进步是无期限的。",
    tstag: "在线物理直播名师好评过万",
    video:
      "https://player.bilibili.com/player.html?aid=82890107&cid=141811316&page=1",
    grade2: "初二、初三"
  },
  {
    code: "46",
    name: "胡海燕",
    grade: "初二",
    sf: "英语",
    tags: "保送硕士|10年教龄|学生的活字典",
    num: "54656",
    percent: "99.1%",
    info:
      "英语专业八级<br/>英美文学硕士<br/>中学一级教师<br/>十年教龄<br/>提分能手",
    mj:
      "英语语法一团糟？思维导图学语法，你肯定没见过；阅读理解怎么破？跟我四步走；单词短语难记忆？顺口溜带你无死角全方位通过；考试怎么考？题海刷刷刷！",
    cj:
      "自2007年读研期间，教学实践涉及少儿英语，初高中英语，大学四六级英语。毕业后从事热爱的教学工作，所教学生累计数百人进入重点高中实验班。尤其擅长以个性化的教学方法快速快乐提分，累计十几位学生从不及格到八十分以上。",
    ry: "2012年9月优质课区级一等奖2014年2月市级教坛新星2015年9月威海市教学能手",
    ts:
      "我始终坚信，一个用心的教师不仅可以改变学生成绩，更应该能够培养学生良好的学习习惯。没有教不好的孩子，只有蒙着眼教学的教师。会学习，找方法，用思考教学，就能给每个孩子翅膀。希望每个孩子都能站在老师的肩膀上成为巨人。",
    tstag: "英语专业八级，英美文学硕士",
    video:
      "https://player.bilibili.com/player.html?aid=82890877&cid=141812650&page=1",
    grade2: "初二、初三"
  },
  {
    code: "47",
    name: "胡海燕",
    grade: "初三",
    sf: "英语",
    tags: "保送硕士|10年教龄|学生的活字典",
    num: "54656",
    percent: "99.1%",
    info:
      "英语专业八级<br/>英美文学硕士<br/>中学一级教师<br/>十年教龄<br/>提分能手",
    mj:
      "英语语法一团糟？思维导图学语法，你肯定没见过；阅读理解怎么破？跟我四步走；单词短语难记忆？顺口溜带你无死角全方位通过；考试怎么考？题海刷刷刷！",
    cj:
      "自2007年读研期间，教学实践涉及少儿英语，初高中英语，大学四六级英语。毕业后从事热爱的教学工作，所教学生累计数百人进入重点高中实验班。尤其擅长以个性化的教学方法快速快乐提分，累计十几位学生从不及格到八十分以上。",
    ry: "2012年9月优质课区级一等奖2014年2月市级教坛新星2015年9月威海市教学能手",
    ts:
      "我始终坚信，一个用心的教师不仅可以改变学生成绩，更应该能够培养学生良好的学习习惯。没有教不好的孩子，只有蒙着眼教学的教师。会学习，找方法，用思考教学，就能给每个孩子翅膀。希望每个孩子都能站在老师的肩膀上成为巨人。",
    tstag: "英语专业八级，英美文学硕士",
    video:
      "https://player.bilibili.com/player.html?aid=82890877&cid=141812650&page=1",
    grade2: "初二、初三"
  },
  {
    code: "48",
    name: "黄其若",
    grade: "初一",
    sf: "数学",
    tags: "数学名师|高分制造者|萌贱大哥哥",
    num: "71221",
    percent: "98.8%",
    info:
      "北京科技电学毕业<br/>前学而思网校优秀主讲教师、教育理念研究组成员<br/>江湖人称:“数学套路王”、“提分小能手”<br/>卖萌耍贱无所不能，带你玩转数学",
    mj:
      '"注重思维引导，拒绝填鸭式教学，让你从会一道题变成会一类题！用各种陷阱题目“套路”学生，让学生牢记考点',
    cj: "所带班级20%学员处于年级前列，30%学员短期内取得10-17分的进步",
    ry: "2016年学而思网校优秀辅导教师",
    ts:
      "不是数学老师，而是会唱歌的数学老师，是集“萌”、“贱”与一体的知心大哥哥。课上传授知识，课下谈笑风生，想带学生们称为数学学科上的“小霸王”！",
    tstag: "注重思维引导，拒绝填鸭式教学",
    video: "",
    grade2: "初一、初二、初三"
  },
  {
    code: "49",
    name: "黄其若",
    grade: "初二",
    sf: "数学",
    tags: "数学名师|高分制造者|萌贱大哥哥",
    num: "71221",
    percent: "98.8%",
    info:
      "北京科技电学毕业<br/>前学而思网校优秀主讲教师、教育理念研究组成员<br/>江湖人称:“数学套路王”、“提分小能手”<br/>卖萌耍贱无所不能，带你玩转数学",
    mj:
      '"注重思维引导，拒绝填鸭式教学，让你从会一道题变成会一类题！用各种陷阱题目“套路”学生，让学生牢记考点',
    cj: "所带班级20%学员处于年级前列，30%学员短期内取得10-17分的进步",
    ry: "2016年学而思网校优秀辅导教师",
    ts:
      "不是数学老师，而是会唱歌的数学老师，是集“萌”、“贱”与一体的知心大哥哥。课上传授知识，课下谈笑风生，想带学生们称为数学学科上的“小霸王”！",
    tstag: "注重思维引导，拒绝填鸭式教学",
    video: "",
    grade2: "初一、初二、初三"
  },
  {
    code: "50",
    name: "黄其若",
    grade: "初三",
    sf: "数学",
    tags: "数学名师|高分制造者|萌贱大哥哥",
    num: "71221",
    percent: "98.8%",
    info:
      "北京科技电学毕业<br/>前学而思网校优秀主讲教师、教育理念研究组成员<br/>江湖人称:“数学套路王”、“提分小能手”<br/>卖萌耍贱无所不能，带你玩转数学",
    mj:
      '"注重思维引导，拒绝填鸭式教学，让你从会一道题变成会一类题！用各种陷阱题目“套路”学生，让学生牢记考点',
    cj: "所带班级20%学员处于年级前列，30%学员短期内取得10-17分的进步",
    ry: "2016年学而思网校优秀辅导教师",
    ts:
      "不是数学老师，而是会唱歌的数学老师，是集“萌”、“贱”与一体的知心大哥哥。课上传授知识，课下谈笑风生，想带学生们称为数学学科上的“小霸王”！",
    tstag: "注重思维引导，拒绝填鸭式教学",
    video: "",
    grade2: "初一、初二、初三"
  },
  {
    code: "51",
    name: "纪晓斐",
    grade: "初一",
    sf: "数学",
    tags: "统计学硕士|教研员|逻辑超强",
    num: "26558",
    percent: "95.6%",
    info:
      "取谐音小肥老师<br/>统计学硕士<br/>ago教研员<br/>逻辑超强自认为没有解不出来的几何<br/>细节剖析达人，对盲目做笔记说NO!!!",
    mj:
      "都说方法很重要，小肥也是这样想；你说做题不能少，小肥想要辩一辩；机械做题不能干，举一反三最关键；把握考情抓重点，事半功倍最有效。",
    cj:
      "专注提高学生学习数学的兴趣，激发学生努力探索的潜能，深受学生、家长信任",
    ry:
      "2013年-2016年校优秀学生、校优秀奖学金2017年优秀应届本科生2017年-2018年硕士研究生学业奖学金、一等学业奖学金",
    ts:
      "虽是小肥老师，却能举重若轻。把握知识点的同时还卖得了萌，耍得了帅，土味情话也略通一二。想带你走进数学，爱上数学，但也想让你从心底觉得自己是最棒的人。",
    tstag: "“数学套路王”带你玩转数学",
    video:
      "https://player.bilibili.com/player.html?aid=82892055&cid=141814483&page=1",
    grade2: "初一、初二"
  },
  {
    code: "52",
    name: "纪晓斐",
    grade: "初二",
    sf: "数学",
    tags: "统计学硕士|教研员|逻辑超强",
    num: "26558",
    percent: "95.6%",
    info:
      "取谐音小肥老师<br/>统计学硕士<br/>ago教研员<br/>逻辑超强自认为没有解不出来的几何<br/>细节剖析达人，对盲目做笔记说NO!!!",
    mj:
      "都说方法很重要，小肥也是这样想；你说做题不能少，小肥想要辩一辩；机械做题不能干，举一反三最关键；把握考情抓重点，事半功倍最有效。",
    cj:
      "专注提高学生学习数学的兴趣，激发学生努力探索的潜能，深受学生、家长信任",
    ry:
      "2013年-2016年校优秀学生、校优秀奖学金2017年优秀应届本科生2017年-2018年硕士研究生学业奖学金、一等学业奖学金",
    ts:
      "虽是小肥老师，却能举重若轻。把握知识点的同时还卖得了萌，耍得了帅，土味情话也略通一二。想带你走进数学，爱上数学，但也想让你从心底觉得自己是最棒的人。",
    tstag: "“数学套路王”带你玩转数学",
    video:
      "https://player.bilibili.com/player.html?aid=82892055&cid=141814483&page=1",
    grade2: "初一、初二"
  },
  {
    code: "53",
    name: "李路宁",
    grade: "初二",
    sf: "物理",
    tags: "化繁为简|举例小能手|温柔小姐姐",
    num: "13144",
    percent: "98.7%",
    info:
      "研究院硕士研究生<br/>线下物理老师<br/>家长100%满意<br/>学习物理的好帮手",
    mj:
      "带你发现生活中的物理，脱离枯燥的概念记忆，从生活实例中学习。化繁为简，用图片和故事带你在物理的世界飞。",
    cj: "所教授学生提分明显，有学生考前提分20分（百分制），100%家长满意度。",
    ry: "2012年-2016年连续四年获校级奖学金",
    ts:
      "喜欢唱歌、游泳和电影。初中物理两年学习，时间虽短，却想陪你一起度过。想要和你一起感受有趣的物理世界。",
    tstag: "学习物理的好帮手，100%包满意",
    video:
      "https://player.bilibili.com/player.html?aid=82890245&cid=141811544&page=1",
    grade2: "初二"
  },
  {
    code: "54",
    name: "李宁",
    grade: "初二",
    sf: "物理",
    tags: "提分达人|985硕士|套路大咖",
    num: "15881",
    percent: "97.5%",
    info:
      "东南大学物理学硕士<br/>公立学校教学经验<br/>各种参加支教活动,支教时间所带班级获全县第二",
    mj:
      "物理知识枯燥乏味？来，我让你看看它多有趣。物理题目难懂不会做？来，看我如何分分钟解决。跟着我让你爱上这门学科，从生活中理解物理，学会物理，战胜难题。",
    cj: "支教时间所带班级获全县第二，所带学生300余人成绩均有提升",
    ry: "2015年9月获优秀支教生荣誉",
    ts:
      "个人爱好：读书、旅游、唱歌。我喜欢读心理学方面的书籍这样可以帮助我更好的理解别人；我喜欢看不一样的风景感受不一样的人文，旅游之间探索宇宙的奇妙；我还喜欢唱歌，不是很好但也不错。我还喜欢和学生交朋友，以朋友的身份带学生感受物理世界的美妙。",
    tstag: "生活中的物理，创新的思维记忆",
    video:
      "https://player.bilibili.com/player.html?aid=82890485&cid=141811933&page=1",
    grade2: "初二"
  },
  {
    code: "55",
    name: "刘菲菲",
    grade: "初一",
    sf: "英语",
    tags: "专业八级|语法女王|大招输送",
    num: "96128",
    percent: "98.9%",
    info:
      "大连外国语大学，曾任新华社编辑，10年教龄，专业八级<br/>原学而思培优初三年级教研负责人原作业帮初中英语负责人<br/>创建学而思“系统三轮复习”方案和语法的“菲菲大法”<br/>作业帮初中英语“三班型〃体系，教学“五步教学法”<br/>70000多粉丝,学生提分迅速，广受好评",
    mj:
      "1.想提分，语法要学的透彻。独创“菲菲大法”，帮助同学理解、快速记忆语法知识，不仅会做题，而且能自己讲题。2.想得高分，完形阅读要有足够的方法技巧支撑。独创“完形6大阅读4大解题大招”，快速突破完型阅读。3.想要听课不枯燥，学习必须有套路。独创“五步教学法”（导入---讲解---操练---总结---综合练习），当堂消化吸收所学知识。",
    cj:
      "1.线下班成绩：所带学生平均提分15分以上；成绩优异的学生保证满分，进入北大附、人大附、清华附等北京重点初高中；更是带着一帮基础不大好的同学，由原先的不及格到中考的113+。2.线上班成绩：期期满班，好评超高，受到学生的高度认可。2017年中考，所带学生众多实现了115+/120的成绩；激发基础较差者的英语学习兴趣，更有一名同学实现了提分56分的奇迹。",
    ry: "",
    ts:
      "想对大家说：找对一个好老师，跟定一个好体系，加上自己的努力，任何时候你都可以实现成功或逆袭！",
    tstag: "10年教龄，独创“菲菲大法”",
    video:
      "https://player.bilibili.com/player.html?aid=82890984&cid=141812802&page=1",
    grade2: "初一、初二"
  },
  {
    code: "56",
    name: "刘菲菲",
    grade: "初二",
    sf: "英语",
    tags: "专业八级|语法女王|大招输送",
    num: "96128",
    percent: "98.9%",
    info:
      "大连外国语大学，曾任新华社编辑，10年教龄，专业八级<br/>原学而思培优初三年级教研负责人原作业帮初中英语负责人<br/>创建学而思“系统三轮复习”方案和语法的“菲菲大法”<br/>作业帮初中英语“三班型〃体系，教学“五步教学法”<br/>70000多粉丝,学生提分迅速，广受好评",
    mj:
      "1.想提分，语法要学的透彻。独创“菲菲大法”，帮助同学理解、快速记忆语法知识，不仅会做题，而且能自己讲题。2.想得高分，完形阅读要有足够的方法技巧支撑。独创“完形6大阅读4大解题大招”，快速突破完型阅读。3.想要听课不枯燥，学习必须有套路。独创“五步教学法”（导入---讲解---操练---总结---综合练习），当堂消化吸收所学知识。",
    cj:
      "1.线下班成绩：所带学生平均提分15分以上；成绩优异的学生保证满分，进入北大附、人大附、清华附等北京重点初高中；更是带着一帮基础不大好的同学，由原先的不及格到中考的113+。2.线上班成绩：期期满班，好评超高，受到学生的高度认可。2017年中考，所带学生众多实现了115+/120的成绩；激发基础较差者的英语学习兴趣，更有一名同学实现了提分56分的奇迹。",
    ry: "",
    ts:
      "想对大家说：找对一个好老师，跟定一个好体系，加上自己的努力，任何时候你都可以实现成功或逆袭！",
    tstag: "10年教龄，独创“菲菲大法”",
    video:
      "https://player.bilibili.com/player.html?aid=82890984&cid=141812802&page=1",
    grade2: "初一、初二"
  },
  {
    code: "57",
    name: "刘浩哲",
    grade: "初一",
    sf: "英语",
    tags: "高考英语142|可严可甜|英语心理学",
    num: "24753",
    percent: "95%",
    info:
      "高考英语142<br/>美国加州大学圣地亚哥分校交流生(世界排名T0P30),课程成绩全A<br/>心理学&英语双学位<br/>全国心理学大会外宾组翻译(二级心理咨询师,不会算命)<br/>研究生期间在大型教育机构海外留学部",
    mj:
      "独特的音标语音教学，助你掌握纯正的美音！有趣的单词记忆法，让你知道记单词有多么简单！语法觉得太难？别怕！兔子老师的秘诀帮你牢记语法点！什么！阅读还在读全文？你out啦！瞬间定位找答案！",
    cj:
      "所教学生托福成绩60+提升100+，雅思4+提升到7+，80%被世界top30学校录取；所教初高中学生中95%成绩提升到90+或120+；帮助小学5年级学生掌握3000+单词",
    ry:
      "2012年-2016年连续四年校级奖学金一等奖2014年全国大学生英语竞赛二等奖2017年二级心理咨询师",
    ts:
      "其实英语真的没有想象中的那么难，大多时候都是我们自己在制造英语很难的这个假象。二级心理咨询师的兔子老师能做到的是更懂你的心，更能理解你，当然啦还能用独特的记忆方法帮你记住看似复杂的各种知识点！怎么样，想试试吗？那就跟着兔子老师，我们一起打败英语这个假想敌！",
    tstag: "二级心理咨询师，双学位学子",
    video:
      "https://player.bilibili.com/player.html?aid=82892239&cid=141814764&page=1",
    grade2: "初一"
  },
  {
    code: "58",
    name: "刘京林",
    grade: "初二",
    sf: "物理",
    tags: "满分教练|物理科班出身|",
    num: "83127",
    percent: "97.2%",
    info:
      "8年教龄、人称精灵老师<br/>擅长夯基础,耍大招，精灵大法好,难题chuanhua秒<br/>所教学生60%进入人大附中，清华附中，北大附中等京城名校<br/>中考物理95分以上学生比例超95%<br/>每年都有4到5名物理单科满分学员",
    mj: "物理不怕不下功夫，就怕听不明白，跟着我让你找到顿悟的感觉。",
    cj:
      "7年初中物理教龄，所教学生60%进入人大附中，清华附中，北大附中等京城名校，中考物理95分以上学生比例超95%，每年都有4到5名物理单科满分学员。",
    ry: "2015年高思“优秀教师”2016年高思“专家级讲师”",
    ts: "",
    tstag: "8年教龄，擅长夯基础,耍大招",
    video:
      "https://player.bilibili.com/player.html?aid=82890589&cid=141812146&page=1",
    grade2: "初二、初三"
  },
  {
    code: "59",
    name: "刘京林",
    grade: "初三",
    sf: "物理",
    tags: "满分教练|物理科班出身|",
    num: "83127",
    percent: "97.2%",
    info:
      "8年教龄、人称精灵老师<br/>擅长夯基础,耍大招，精灵大法好,难题chuanhua秒<br/>所教学生60%进入人大附中，清华附中，北大附中等京城名校<br/>中考物理95分以上学生比例超95%<br/>每年都有4到5名物理单科满分学员",
    mj: "物理不怕不下功夫，就怕听不明白，跟着我让你找到顿悟的感觉。",
    cj:
      "7年初中物理教龄，所教学生60%进入人大附中，清华附中，北大附中等京城名校，中考物理95分以上学生比例超95%，每年都有4到5名物理单科满分学员。",
    ry: "2015年高思“优秀教师”2016年高思“专家级讲师”",
    ts: "",
    tstag: "8年教龄，擅长夯基础,耍大招",
    video:
      "https://player.bilibili.com/player.html?aid=82890589&cid=141812146&page=1",
    grade2: "初二、初三"
  },
  {
    code: "60",
    name: "刘治华",
    grade: "初二",
    sf: "数学",
    tags: "7年教龄|挖坑小能手|福利大礼包",
    num: "83826",
    percent: "99.2%",
    info:
      "原学而思集团骨干教师<br/>清北传送机<br/>中老学员平均提分20+<br/>擅长:挖坑",
    mj:
      "学习不轻松，数学不简单。只凭努力刷题，终究与学霸一步之遥。老刘带你串联知识，拓展思维，解构套路，熟悉“坑题”。万能系、秒杀系、超能汇总系、实用超纲系，助力学霸之路！",
    cj:
      "学而思教育集团智康北京大区核心教师，数学学科教研员，7年一线教学经验，学员遍布人大附中、北京四中、北京十一学校等名校。中考学员数学满分教师，所带学生平均提分20+",
    ry:
      "2012年学而思集团北京智康年度优秀教师2014年学而思集团北京智康年度优秀教研员",
    ts:
      "爱运动身为一名AIDA自由潜水员，怀着敬畏之心，去亲近海洋了解自我爱阅读从《乡土中国》到《浮生六记》，停不下求知思索的脚步",
    tstag: "清北传送机，助力学霸之路！",
    video:
      "https://player.bilibili.com/player.html?aid=82889887&cid=141810994&page=1",
    grade2: "初二"
  },
  {
    code: "61",
    name: "路露",
    grade: "初一",
    sf: "英语",
    tags: "中考状元名师|功底大咖|雅思8.5",
    num: "25592",
    percent: "99.5%",
    info:
      "状元之师<br/>企鹅辅导19年初一英语教研负责人<br/>英语专业八级优秀、雅思8.5<br/>英国贵族学校访问学者、新加坡对外汉语教师<br/>醉心教学的匠人<br/>功底强、逻辑强、浸入式教字、爱学生",
    mj:
      "中国学生英语学习四大根本问题：1.单词怎么背2.语法怎么学3.发音怎么练4.听力如何提高中国学生太善于用翻译的方法记单词，这种记单词的方法一是不准确，二是孩子们很快就会忘记，导致英语学习中单词一直是拦路虎。小太阳九阴白骨爪记单词秘籍，每一个单词背后都是一个原汁原味生动爆笑的幽默短剧，更会把外刊新闻中的用词带进课堂，让孩子们通过活灵活现的语境，不仅秒懂单词，而且会用单词。上知天文，下知英文，睁眼看世界。英语语法很多孩子觉得枯燥，条条框框太多，这其实是教法上多年故弄玄虚的结果。其实类比中文，孩子们从小也没学语法，中文还是沟通无障碍，用来说话的语言能难到哪里去呢？小太阳语法新解，我们只需要把老外的脑子打开，探秘老外开口用这个语法的时候，脑子里究竟在想什么。理解了这一点，无需记条条框框就能学懂语法。英语听力问题归根结底是发音问题。英语不是”说“出来的，而是“弹”出来的。在我多年教授语音的过程中，我发现一个非常可怕的现象-中国学生错误的发音说得多了，听到正确的发音时充耳不闻，导致听力失分。中国有句老话“不破不立”，小太阳语法新教程就是要打破人云亦云，打破中式发音，把真正正确的语音范本带给孩子们。",
    cj:
      "三年亲授2018年深圳市中考状元周治韬（南海中学），在中考中英语满分。培养出了黄思成（深圳中学初二年级学生）雅思首战总分7.5，卿欣如（深圳中学初一年级学生）雅思首战总分7.5，王子轩（深圳中学初一年级学生）雅思首战总分7.5，甘乾文（深圳罗湖小学六年级）雅思首战总分7.5，李盈盈（深圳外国语初一学生）雅思首战总分7，二战8。中国首套FCE写作书FCEwritingmodels主编。",
    ry: "",
    ts:
      "多年的教学实践和海外经历让我看到了中国孩子学习英语的希望和路径。我会用文本细读法带你去读中考考纲下的每一个话题文章，每一篇外刊阅读，与其说是我教你读书，不如说是我伴你读书。从头到尾一字一句带你把书读厚，再读薄，直到你烂熟于心。这是语言学习唯一的方法。我们有太多求速的方法，求速的结果是浮躁，是不扎实。文本细读法带你体验厚积薄发的力量。记住，英语不是你攻克的对象，而是你终生去拓展思维和眼界的伙伴。",
    tstag: "状元之师，英语专业八级",
    video:
      "https://player.bilibili.com/player.html?aid=82892330&cid=141814899&page=1",
    grade2: "初一"
  },
  {
    code: "62",
    name: "罗子忡",
    grade: "初三",
    sf: "物理",
    tags: "状元之师|资深教研员|高颜值",
    num: "59125",
    percent: "99.7%",
    info:
      "中考考入全市前十,毕业于985名校大学<br/>已有多年任教初中物理的经验<br/>擅长以简单生活化的语言,将物理解释地浅显易懂<br/>套路贼多!<br/>企鹅辅导好评率99.9%!",
    mj:
      "没有秘籍。学物理，跟老罗，走进生活，用最简单的语言诠释物理，用最简洁的方法学好物理。老罗大长腿，物理带你飞。",
    cj:
      "线下任教过程中，所教学生均成绩大幅提升，大量考生考入深圳四大名校，十大高中，更有不少学生中考物理满分。线上任教以来，学员数已超2万，好评率高达99.8%，不少学生的物理成绩提分显著。",
    ry: "2015年学而思s级教师2016年学而思教学之星",
    ts:
      "三高老师，高颜值，高智商，高个子（185cm）。喜欢发现生活中体现物理之美的东西。喜欢运动，NBA，旅行，桌游。#一个有猫有狗的长腿学霸#老罗有一猫一狗，猫的名字叫皮蛋，狗的名字叫laughing（会念吗），课堂直播会有猫咪和狗狗互动环节哦~",
    tstag: "985名校出身，企鹅辅导好评率999%!",
    video:
      "https://player.bilibili.com/player.html?aid=82891902&cid=141814173&page=1",
    grade2: "初三"
  },
  {
    code: "63",
    name: "吕政嘉",
    grade: "初二",
    sf: "语文",
    tags: "名校教师|上分达人|半生少年",
    num: "67119",
    percent: "98.4%",
    info:
      "9年教龄、前人大附中教师、8年一线在职教师<br/>剧作社指导教师、辩论队教练<br/>垒球队教练、学生领导力社团顾问<br/>模拟联合国社团指导教师",
    mj: "原创作文教学法多种原创中考语文阅读答题技巧",
    cj:
      "8年人大附中联合总校教学经历，5年实验班班主任经验，初中、国际高中语文教师。所教初中学生半数考入人大附中、北大附中、清华附中、101中学、十一学校、四中等全国知名学校。高中毕业生多考入纽约大学、滑铁卢大学、UCLA等国际知名大学",
    ry:
      "2013年海淀区教师基本功大赛二等奖2014年“春蕾杯”全国作文大赛优秀指导教师2015年6月海淀区辩论赛16强“优秀指导教师”",
    ts:
      "校足球队、篮球队成员，自幼学习武术。写过小说，出过单曲，能说相声，演过话剧，上过电视，参加过全国数学竞赛、编程大赛的语文老师就是区区在下。所以，嘉嘉老师教的不光是知识，而是纷繁复杂的世界。我们学的不光是语文，而是文字背后的人生逻辑。",
    tstag: "9年教龄 ，8年一线在职教师 ",
    video:
      "https://player.bilibili.com/player.html?aid=82891223&cid=141813129&page=1",
    grade2: "初二"
  },
  {
    code: "64",
    name: "马秀英",
    grade: "初一",
    sf: "语文",
    tags: "北大女神|模考省状元|负责提分",
    num: "70721",
    percent: "99.4%",
    info:
      "北大女神<br/>模考省状元<br/>负责提分<br/>学生平均提升7-13分，最高提升24分，有学生中考取得117分",
    mj:
      "语文是个慢功夫？你要茫茫书海多阅读？你要漫无头绪多积累？NO！老师每节必讲清一个知识点，每一节课都能提分！",
    cj:
      "自从教以来，所教学生平均提升7-13分，有学生从88分提升到112分，有学生中考取得117分成绩！",
    ry: "",
    ts:
      "初中三年，月考期中考期末考，从来只考第一；高二时期，数学一度只考86分；高三模考，冲到省排名第一。无论你是学神学霸还是学渣，我可能都是曾经的你。除了执著的信念，我最想传授你好用的方法！",
    tstag: "提分小能手，逆袭路上不可少",
    video: "",
    grade2: "初一"
  },
  {
    code: "65",
    name: "任晓",
    grade: "初三",
    sf: "化学",
    tags: "10年教龄|8年毕业班|中高考提分王",
    num: "136583",
    percent: "99.6%",
    info:
      "北京航空航天大学<br/>9年教龄、7年毕业班经验<br/>中学化学教师<br/>企鹅辅导累计1lW+学员<br/>主持编写《中考核心必考点》等多部教辅",
    mj:
      "学习固然需要记忆，但是如果只记忆而忽视了对知识背后规律的探究和总结，只会让你事倍功半；考试检验的不仅仅是知识的掌握，更是我们思维灵活性和逻辑能力的考察。老师相信，万事皆有方法，掌握了正确方法就可以让你更快成功，学习、考试也是如此。在8年的教学过程中，老师总结了不同阶段的学生在学习化学过程中常见的知识障碍和思维方法误区，希望能通过课堂传授给你，帮助到你的学习和考试。",
    cj:
      "从教8年来，累计有20余名学生升入北大清华；上百人升入211院校，更有多名学生出国到欧洲或北美留学。更重要的是帮助更多的学生找到了适合自己的学习方法，让大家对化学不在畏惧，让学习成为轻松快乐的事。",
    ry: "2012年9月好学乐知奖优秀教师2014年9月百佳教师",
    ts:
      "化学是一门有趣的学科，化学知识的学习绝不仅仅是为了应对考试，它给了我们另一种看待世界的方式，可以让我们在探究周围世界时不囿于表象，通过纷纭的线下探究内在的规律。我们一起：让化学回归化学。",
    tstag: "企鹅辅导累计1lW+学员",
    video:
      "https://player.bilibili.com/player.html?aid=82891424&cid=141813462&page=1",
    grade2: "初三、高三"
  },
  {
    code: "66",
    name: "滕飞",
    grade: "初一",
    sf: "语文",
    tags: "应试能手|7年教龄|高分制造者",
    num: "84766",
    percent: "99.2%",
    info:
      "八年教龄、五年中考授课<br/>应试作文达人、学霸之师<br/>嗓音有内涵<br/>上课干货满满,让考题闻风丧胆,<br/>长得健谈，宇宙无敌超级大美飞",
    mj:
      "得基础者得语文，你还不知道吗？轻松快乐掌握中考语基必备知识点；阅读还不能拿满分吗？7大题型必杀技你值得拥有；课外文言文快速积累，中考满分必备。",
    cj: "帮助2000余位学生进入人大附、北大附、清华附、北师大附中等理想高中。",
    ry: "",
    ts:
      "读书、思考是生活的常态，我愿把我的知识技巧和思考分享给有缘的同学，带领你们发现生活的小细节，感受文字的魅力。我会收获到同学们思考后的感悟，学业进步的喜悦以及这份萍水相逢带来的美好。",
    tstag: "五年中考授课，应试作文达人",
    video:
      "https://player.bilibili.com/player.html?aid=82892613&cid=141815289&page=1",
    grade2: "初一、初三"
  },
  {
    code: "67",
    name: "滕飞",
    grade: "初三",
    sf: "语文",
    tags: "应试能手|7年教龄|高分制造者",
    num: "84766",
    percent: "99.2%",
    info:
      "八年教龄、五年中考授课<br/>应试作文达人、学霸之师<br/>嗓音有内涵<br/>上课干货满满,让考题闻风丧胆,<br/>长得健谈，宇宙无敌超级大美飞",
    mj:
      "得基础者得语文，你还不知道吗？轻松快乐掌握中考语基必备知识点；阅读还不能拿满分吗？7大题型必杀技你值得拥有；课外文言文快速积累，中考满分必备。",
    cj: "帮助2000余位学生进入人大附、北大附、清华附、北师大附中等理想高中。",
    ry: "",
    ts:
      "读书、思考是生活的常态，我愿把我的知识技巧和思考分享给有缘的同学，带领你们发现生活的小细节，感受文字的魅力。我会收获到同学们思考后的感悟，学业进步的喜悦以及这份萍水相逢带来的美好。",
    tstag: "五年中考授课，应试作文达人",
    video:
      "https://player.bilibili.com/player.html?aid=82892613&cid=141815289&page=1",
    grade2: "初一、初三"
  },
  {
    code: "68",
    name: "王迪",
    grade: "初一",
    sf: "语文",
    tags: "试题终结者|专克命题人|逗比王",
    num: "494",
    percent: "98%",
    info:
      "古文达人:可以把《道德经》《周易》当小说讲<br/>解题能手、试题终结者:发现和总结试题解题规律与方法<br/>授课幽默:善于引导学生在学习中发现语文之美",
    mj: "文言文读不懂？不怕，直接做题，轻轻松松虐爆TA",
    cj: "让一男同学从厌恶恐惧语文到爱上语文，从79/120到语文成绩全年级第三。",
    ry:
      "2018年3月-2018年7月潍坊奎文支教优秀讲课先进个人2018年10月山东师范大学第六届师范生从业技能大赛二等奖",
    ts: "读书睡觉看电影，最正宗的吃货。",
    tstag: "解题能手，授课幽默",
    video:
      "https://player.bilibili.com/player.html?aid=82892720&cid=141815388&page=1",
    grade2: "初一"
  },
  {
    code: "69",
    name: "王菂",
    grade: "初一",
    sf: "数学",
    tags: "数学基地班|数学全能王|15年教龄",
    num: "41930",
    percent: "92.5%",
    info:
      "四川大学硕士<br/>数学全能王<br/>15年教龄<br/>让学生一个月数学快速提升70分",
    mj:
      "马虎从不是错误的原因，只是错误的借口。扎实的知识习得、丰富的解题技巧、良好的做题习惯、灵活的数学思维，让135分成为数学的保底分。高分的目标必须脚踏实地一步步实现。务实的目标拆解，专业的进度规划、详尽的内容讲解、轻松的课堂氛围，让你每次考试稳步提高，遥远的目标最终唾手可得。",
    cj:
      "最全面的数学老师，从小学数学到考研数学，从国内中高考到国外AP、Alevel、GMAT、GRE，都有丰富的教学经验。从教十多年，学生遍布国内知名高校，欧美众多名校。既能让学生一个月数学快速提升70分；也能陪伴学生从小学成长为剑桥哥伦比亚硕士；还能让嘻哈歌手从顽劣少年到数学满分。",
    ry: "",
    ts:
      "足球：经常和曾经的中学同学相约踢球，也喜欢看球侃球，还曾前往巴西看世界杯，和荷兰队住在了同一家酒店。骑行：从成都骑车沿着318国道前往西藏，沿途翻越雪山的成就感和完成数学题的满足感很类似。跑步：曾经的国家田径二级运动员，跑步的时候可以帮助自己更深入地思考问题",
    tstag: "985、211名校硕士，快速提分王者",
    video: "",
    grade2: "初一、初二"
  },
  {
    code: "70",
    name: "王菂",
    grade: "初二",
    sf: "数学",
    tags: "数学基地班|数学全能王|15年教龄",
    num: "41930",
    percent: "92.5%",
    info:
      "四川大学硕士<br/>数学全能王<br/>15年教龄<br/>让学生一个月数学快速提升70分",
    mj:
      "马虎从不是错误的原因，只是错误的借口。扎实的知识习得、丰富的解题技巧、良好的做题习惯、灵活的数学思维，让135分成为数学的保底分。高分的目标必须脚踏实地一步步实现。务实的目标拆解，专业的进度规划、详尽的内容讲解、轻松的课堂氛围，让你每次考试稳步提高，遥远的目标最终唾手可得。",
    cj:
      "最全面的数学老师，从小学数学到考研数学，从国内中高考到国外AP、Alevel、GMAT、GRE，都有丰富的教学经验。从教十多年，学生遍布国内知名高校，欧美众多名校。既能让学生一个月数学快速提升70分；也能陪伴学生从小学成长为剑桥哥伦比亚硕士；还能让嘻哈歌手从顽劣少年到数学满分。",
    ry: "",
    ts:
      "足球：经常和曾经的中学同学相约踢球，也喜欢看球侃球，还曾前往巴西看世界杯，和荷兰队住在了同一家酒店。骑行：从成都骑车沿着318国道前往西藏，沿途翻越雪山的成就感和完成数学题的满足感很类似。跑步：曾经的国家田径二级运动员，跑步的时候可以帮助自己更深入地思考问题",
    tstag: "985、211名校硕士，快速提分王者",
    video: "",
    grade2: "初一、初二"
  },
  {
    code: "71",
    name: "徐杰",
    grade: "初三",
    sf: "数学",
    tags: "行业顶级名师|培养多名状元|自称严肃",
    num: "35498",
    percent: "99.6%",
    info:
      "曾是学而思网校年薪百万级年度优秀教师<br/>现任企鹅辅导初数团队leader<br/>8年教龄,其中5年是初、高中连带<br/>曾培养出三名市级中考状元<br/>大量线上学员考入北京四中、深圳中学、成都外国语、西安高新一中、青岛二中、上海七宝中学等各地名校。",
    mj:
      "独家题型方法总结，让孩子做一道题，会一类题！数次压中中考压轴题型，帮助数以万计学员中考满分或接近满分课程趣味性极强，很多学员表示上完徐大帅的课，就完全不想上其它数学老师的课了",
    cj:
      "线上累计学员16万人，培养了3名市级中考总分状元，中考数学满分学员或接近满分学员数以万计",
    ry:
      "2009年学而思培优新星教师2012年学而思网校年度优秀教师2014年学而思网校S级名师2016年学而思网校年薪百万级名师",
    ts:
      "谁说上数学课不能哈哈大笑？徐大帅带你爱上数学！坚持数学梦想，徐杰老师一路挺你！",
    tstag: "8年教龄，初数团队领导者",
    video:
      "https://player.bilibili.com/player.html?aid=82891703&cid=141813890&page=1",
    grade2: "初三"
  },
  {
    code: "72",
    name: "许源欢",
    grade: "初二",
    sf: "英语",
    tags: "口音模仿王|精分小戏精|行走表情包",
    num: "86122",
    percent: "99.4%",
    info:
      "毕业于广东外语外贸大学<br/>专业英语八级,雅思8分<br/>平均词汇量1.8W+<br/>日阅读量1W词,目前雅思考试阅读模块9分满分<br/>全能词汇王：未在单词PK中失手过<br/>美食小达人：为了吃把所有食物的名字都背了一遍",
    mj:
      "单词背不下来？发音规律+构词法+情景故事帮你记！完形填空一脸懵逼？上下文的伏笔逐一挖给你看！语法还在靠语感？用数学逻辑思维带你看公式！你走过最长的路就是老师的套路，走出套路，进步神速！",
    cj:
      "所教学生累计2000+，所培老师超过200+！不仅是学生心目中的名师还是老师的培训师~所带提高班80%学生提分20+，所带高端班学生覆盖深圳四大名校top10，深圳中考前10名2人次，四大重点高中上线率80%",
    ry:
      "2012年广州“优秀志愿者”2013年广交会“优秀实习生”/英语专业八级/英语专业八级口译证书2015年学而思优秀教师2016年剑桥大学TKT教学能力测试全模块证书/剑桥大学FCE英语能力测试GradeA",
    ts:
      "人称多分老师，据说可以帮你拿很多分，曾被家长评价是最不像老师的老师，从不按套路出牌，行走表情包，精分重症患者，装得了酷，卖得了萌，撒得了娇，希望通过演绎带大家一起感受英语，掌握套路，了解外国文化，走向人生巅峰。",
    tstag: "英语八级,雅思8分",
    video:
      "https://player.bilibili.com/player.html?aid=82891095&cid=141812997&page=1",
    grade2: "初二、初三"
  },
  {
    code: "73",
    name: "许源欢",
    grade: "初三",
    sf: "英语",
    tags: "口音模仿王|精分小戏精|行走表情包",
    num: "86122",
    percent: "99.4%",
    info:
      "毕业于广东外语外贸大学<br/>专业英语八级,雅思8分<br/>平均词汇量1.8W+<br/>日阅读量1W词,目前雅思考试阅读模块9分满分<br/>全能词汇王：未在单词PK中失手过<br/>美食小达人：为了吃把所有食物的名字都背了一遍",
    mj:
      "单词背不下来？发音规律+构词法+情景故事帮你记！完形填空一脸懵逼？上下文的伏笔逐一挖给你看！语法还在靠语感？用数学逻辑思维带你看公式！你走过最长的路就是老师的套路，走出套路，进步神速！",
    cj:
      "所教学生累计2000+，所培老师超过200+！不仅是学生心目中的名师还是老师的培训师~所带提高班80%学生提分20+，所带高端班学生覆盖深圳四大名校top10，深圳中考前10名2人次，四大重点高中上线率80%",
    ry:
      "2012年广州“优秀志愿者”2013年广交会“优秀实习生”/英语专业八级/英语专业八级口译证书2015年学而思优秀教师2016年剑桥大学TKT教学能力测试全模块证书/剑桥大学FCE英语能力测试GradeA",
    ts:
      "人称多分老师，据说可以帮你拿很多分，曾被家长评价是最不像老师的老师，从不按套路出牌，行走表情包，精分重症患者，装得了酷，卖得了萌，撒得了娇，希望通过演绎带大家一起感受英语，掌握套路，了解外国文化，走向人生巅峰。",
    tstag: "英语八级,雅思8分",
    video:
      "https://player.bilibili.com/player.html?aid=82891095&cid=141812997&page=1",
    grade2: "初二、初三"
  },
  {
    code: "74",
    name: "许蓁",
    grade: "初一",
    sf: "语文",
    tags: "考点雷达|提升成绩|国学达人",
    num: "20396",
    percent: "96.7%",
    info:
      "初中语文主讲老师<br/>考点雷达/提升成绩/国学达人<br/>四年一线教学经验",
    mj:
      "语文学习摸不着头绪？语文成绩提升无从下手？老师带你架起一道平日积累与成绩提升的桥梁！归纳方法夯实基础，大招技巧搞定阅读，素材拓展提升写作，让每份付出更有回报！",
    cj:
      "四年多的任教期间，带过全国各地不同省市的学生超过五千人，多名学员考入北京四中、人大附中、北京二中、衡水中学等重点高中。",
    ry: "",
    ts:
      "静可读书作画，动能射箭攀岩。热爱生活，热爱教学，注重培养学生文学素养和语文学习思维，让学生在轻松愉快的氛围中爱上语文学习，提升成绩。",
    tstag: "四年一线教学经验",
    video:
      "https://player.bilibili.com/player.html?aid=82892929&cid=141815680&page=1",
    grade2: "初一"
  },
  {
    code: "75",
    name: "轩冉",
    grade: "初一",
    sf: "数学",
    tags: "南开学霸|精算背景|宁夏支教",
    num: "22336",
    percent: "95.3%",
    info:
      "南开大学金融学院硕士<br/>自考北美精算师(SOA)科目<br/>第一作者在《经济》发表文章——《大数据时代经济学的应用研究》",
    mj:
      "在欢声笑语中让孩子掌握数学知识，在书山题海中为孩子建立数学思维，用饱满的激情感染孩子热爱数学，用纯纯的耐心引导孩子在青春时期健康成长！",
    cj:
      "1.2015年7月-9月，前往宁夏回族自治区石嘴山市进行义务支教，帮助当地孩子学习数学，陪伴他们学习成长。2.2016年11月-2017年4月，在某教育机构进行一对一专业辅导，专注提升学生数学成绩，曾辅导学生提分最高达53分。3.2018年11月-2019年1月，在某教育机构带班课，所带学生期中期末考试均有明显提分，其中最高提分42分，深受学生家长信赖。",
    ry:
      "2016年6月以第一作者身份在《经济》发表论文《大数据时代经济学的应用研究》2016年6月国家励志奖学金，综合校一等奖学金2017年4月数学建模大赛二等奖",
    ts:
      "爱动漫、爱Cosplay、爱笑、爱闹、爱唱歌、爱养狗害怕猫、爱和学生打成一片，常爱说的一句话就是：小可爱们，你们让我想死了！",
    tstag: "南开硕士，精算自考",
    video:
      "https://player.bilibili.com/player.html?aid=82892142&cid=141814625&page=1",
    grade2: "初一"
  },
  {
    code: "76",
    name: "于斐",
    grade: "初二",
    sf: "物理",
    tags: "命题克星|奖学金收割机|亲和力UP",
    num: "12374",
    percent: "96.5%",
    info:
      "物理学硕士，公立学校多年教授经验<br/>奖学金收割机：国家奖学金、国家励志奖学金、校级一等奖学金若干…<br/>爱好：阅读,辩论,看科幻大片",
    mj:
      "从零开始，从基础开始，小于老师让你该拿的分一分不丢，简单题基础分打定你的分数基线。高端进阶，举一反三，小于老师从不讲一道题，只讲一类题，让你脱离题海，在区分度较高的难题中脱颖而出。只要跟对老师，找对方法，学民可以超越学霸，学渣照样可以逆袭为学霸。",
    cj:
      "自从教以来，学生平均提分15分。曾经带过一个学生，在2个月的时间里，从30分提高到中考80+。",
    ry:
      "2009-2013年国家奖学金，国家励志奖学金，一等奖学金7次2013年省级优秀毕业生2017年北京工业大学优秀研究生",
    ts:
      "虽说是根正苗红的物理专业出身，但是喜欢阅读，辩论，知识面涉及甚广。跨界当辩论老师，带出个北京市亚军，朝阳区冠军。哈哈！太喜欢和孩子们在一起了，讨论物理，讨论人生，最重要的是玩转“初中物理”。还在等什么？快到小于老师的碗里来吧，让小于老师带你一起翻转“物理世界”！",
    tstag: "物理学硕士，不是青铜，是王者",
    video:
      "https://player.bilibili.com/player.html?aid=82890694&cid=141812302&page=1",
    grade2: "初二"
  },
  {
    code: "77",
    name: "占航",
    grade: "初三",
    sf: "数学",
    tags: "黄冈骨干教师|实力派|中考权威代表",
    num: "112780",
    percent: "99.7%",
    info:
      "*年教龄<br/>黄冈市骨干教师<br/>集教学教研于一身，中考权威代表<br/>一线教师，更懂你",
    mj: "数学，因“有型”而“有型”，航仔哥，因“有你”而“美丽”。",
    cj:
      "2006年、2008年累计3名学生获奥数一等奖2010年、2013年毕业班重点升学率达57%和65%2015年辅导14名广州初三毕业生，其中5人考入广州华师附中",
    ry:
      "2006年奥数金牌教练2009年黄冈市学科骨干教师2015年广州卓越教育金牌培训师",
    ts:
      "黄冈市骨干教师在广州。执着沉稳而不拘一格，专注中考13年，集教学教研于一身，对各类学生的辅导堪称“妙手回春”，教学成绩斐然。",
    tstag: "一线教师，更懂你。",
    video:
      "https://player.bilibili.com/player.html?aid=82891797&cid=141814008&page=1",
    grade2: "初三"
  },
  {
    code: "78",
    name: "张佳镁",
    grade: "初一",
    sf: "数学",
    tags: "北大学神|中考状元名师|懂学生爱学生",
    num: "138897",
    percent: "99%",
    info:
      "文理全才：北京大学文理双学位<br/>无敌考神：初中全部数学考试只有2次不是满分<br/>全能学霸：数理化生四门竟赛获奖经历,北京大学自主招生30分加分<br/>状元名师：半以上毕业班学员中考得分率95%+",
    mj:
      "初中三年数学只有2次不是满分获得北京大学30分自主招生加分成功押中十余道上海中考试题",
    cj:
      "累计学员6604人，毕业班有1/10学员提前签约，一半以上学员中考得分率超过95%",
    ry:
      "2015年作为共同作者在NatureCommunication杂志发表文章2017年学而思网校季度盟主",
    ts:
      "功底深厚却不相信“蛮干”，人称“学神”却不放弃努力，知道如何学，更不愿意放弃玩。想要带着学生们一起玩转数学，发现学习的乐趣！",
    tstag: "文理全才，无敌考神",
    video:
      "https://player.bilibili.com/player.html?aid=82889986&cid=141811182&page=1",
    grade2: "初一、初二、初三"
  },
  {
    code: "79",
    name: "张佳镁",
    grade: "初二",
    sf: "数学",
    tags: "北大学神|中考状元名师|懂学生爱学生",
    num: "138897",
    percent: "99%",
    info:
      "文理全才：北京大学文理双学位<br/>无敌考神：初中全部数学考试只有2次不是满分<br/>全能学霸：数理化生四门竟赛获奖经历,北京大学自主招生30分加分<br/>状元名师：半以上毕业班学员中考得分率95%+",
    mj:
      "初中三年数学只有2次不是满分获得北京大学30分自主招生加分成功押中十余道上海中考试题",
    cj:
      "累计学员6604人，毕业班有1/10学员提前签约，一半以上学员中考得分率超过95%",
    ry:
      "2015年作为共同作者在NatureCommunication杂志发表文章2017年学而思网校季度盟主",
    ts:
      "功底深厚却不相信“蛮干”，人称“学神”却不放弃努力，知道如何学，更不愿意放弃玩。想要带着学生们一起玩转数学，发现学习的乐趣！",
    tstag: "文理全才，无敌考神",
    video:
      "https://player.bilibili.com/player.html?aid=82889986&cid=141811182&page=1",
    grade2: "初一、初二、初三"
  },
  {
    code: "80",
    name: "张佳镁",
    grade: "初三",
    sf: "数学",
    tags: "北大学神|中考状元名师|懂学生爱学生",
    num: "138897",
    percent: "99%",
    info:
      "文理全才：北京大学文理双学位<br/>无敌考神：初中全部数学考试只有2次不是满分<br/>全能学霸：数理化生四门竟赛获奖经历,北京大学自主招生30分加分<br/>状元名师：半以上毕业班学员中考得分率95%+",
    mj:
      "初中三年数学只有2次不是满分获得北京大学30分自主招生加分成功押中十余道上海中考试题",
    cj:
      "累计学员6604人，毕业班有1/10学员提前签约，一半以上学员中考得分率超过95%",
    ry:
      "2015年作为共同作者在NatureCommunication杂志发表文章2017年学而思网校季度盟主",
    ts:
      "功底深厚却不相信“蛮干”，人称“学神”却不放弃努力，知道如何学，更不愿意放弃玩。想要带着学生们一起玩转数学，发现学习的乐趣！",
    tstag: "文理全才，无敌考神",
    video:
      "https://player.bilibili.com/player.html?aid=82889986&cid=141811182&page=1",
    grade2: "初一、初二、初三"
  },
  {
    code: "81",
    name: "张宁杰",
    grade: "初三",
    sf: "化学",
    tags: "交心好朋友|填坑小能手|中考化学满分",
    num: "17769",
    percent: "98.4%",
    info:
      "爱称:小张老师(老张也okk)<br/>毕业院校:中国地质大学应用化学专业<br/>两年教龄,热爱与学生打成一片<br/>多名学生考入重点高中",
    mj:
      "让你从日常生活中感受到化学的奇妙之处，绝对接地气的讲法带你脱离死记硬背知识点的苦恼。海量图片、小故事……让我们一起走进绚丽多彩的化学世界！因为爱上我，你会更加爱化学！",
    cj: "一对一授课的学生们100%成绩进步，30%学生中考化学满分，100%家长满意度",
    ry: "2016年10月校级优秀干部2017年5月院级奖学金",
    ts:
      "嘿！女孩，想成为万众瞩目的理科小能手吗？小张老师将带你学会超强的化学思维能力。嘿！男孩，想成为同学问题的首选对象吗？小张老师将教你掌握牢固的化学记忆方法。学习之路，道阻且长，让小张老师陪你们一起，将其变成青春路上最明媚的风景吧！",
    tstag: "100%学生的选择，100%家长的满意",
    video:
      "https://player.bilibili.com/player.html?aid=82891510&cid=141813584&page=1",
    grade2: "初三"
  },
  {
    code: "82",
    name: "张雪峰",
    grade: "初二",
    sf: "物理",
    tags: "4年教龄|江湖派教师|提分能手",
    num: "48224",
    percent: "98.4%",
    info:
      "中考物理满分、高考物理接近满分<br/>数学、物理竞赛获奖自招进入厦门大学<br/>理学与经济学双学位<br/>4年教龄,江湖派教师,提分能手<br/>某知名机构师资培训负责人、原学而思初中物理名师",
    mj: "以简单清晰的思路，看纷繁复杂的题目",
    cj:
      "授课学生过千人，帮助多人考入深中，深外等理想高中；授课从基础班型到尖端班型，包括提高班、尖子班、精英班；学生成绩提高明显，尖端班多名学生考入全校前十，提高班学员高比例考入当地重点高中；编写制作某知名机构全国初中物理讲义、课件；主导负责某知名机构教师的培训选拔工作；",
    ry:
      "2017年3月某知名机构第一届全国教师技能大赛决赛评委2017年9月某知名机构分公司外聘集团导师2017年11月某知名机构第二届全国教师技能大赛指导导师、评委",
    ts:
      "我喜欢好多事情的：踢足球，fifa，培训老师，做物理教学，帮助学生帮助老师，是一件很有成就感的事情，自己成功或不成功的经验，都希望成为帮助孩子们成长的助力。",
    tstag: "双学位学霸，高提分王者",
    video:
      "https://player.bilibili.com/player.html?aid=82890786&cid=141812487&page=1",
    grade2: "初二、初三"
  },
  {
    code: "83",
    name: "张雪峰",
    grade: "初三",
    sf: "物理",
    tags: "4年教龄|江湖派教师|提分能手",
    num: "48224",
    percent: "98.4%",
    info:
      "中考物理满分、高考物理接近满分<br/>数学、物理竞赛获奖自招进入厦门大学<br/>理学与经济学双学位<br/>4年教龄,江湖派教师,提分能手<br/>某知名机构师资培训负责人、原学而思初中物理名师",
    mj: "以简单清晰的思路，看纷繁复杂的题目",
    cj:
      "授课学生过千人，帮助多人考入深中，深外等理想高中；授课从基础班型到尖端班型，包括提高班、尖子班、精英班；学生成绩提高明显，尖端班多名学生考入全校前十，提高班学员高比例考入当地重点高中；编写制作某知名机构全国初中物理讲义、课件；主导负责某知名机构教师的培训选拔工作；",
    ry:
      "2017年3月某知名机构第一届全国教师技能大赛决赛评委2017年9月某知名机构分公司外聘集团导师2017年11月某知名机构第二届全国教师技能大赛指导导师、评委",
    ts:
      "我喜欢好多事情的：踢足球，fifa，培训老师，做物理教学，帮助学生帮助老师，是一件很有成就感的事情，自己成功或不成功的经验，都希望成为帮助孩子们成长的助力。",
    tstag: "双学位学霸，高提分王者",
    video:
      "https://player.bilibili.com/player.html?aid=82890786&cid=141812487&page=1",
    grade2: "初二、初三"
  },
  {
    code: "84",
    name: "张殷然",
    grade: "初一",
    sf: "语文",
    tags: "作文状元|高分输送|解题实力派",
    num: "39970",
    percent: "96.3%",
    info:
      "211工程/985平台大学本硕、连续三年奖学金获得者<br/>第一作者发表核心论文1篇,参与发表核心论文7篇<br/>某教育机构初中语文组教师<br/>曾获作文类奖项第九届全国青少年“春蕾杯”征文三等奖<br/>第三届“语文周报杯”全国中小学创新作文三等奖",
    mj:
      "做阅读还在抓耳挠腮，殷然“妙招”助你答全要点；写作文还在绞尽脑汁，殷然“导图”助你下笔成章；文言文还在死记硬背，殷然“对译”助你深解文意；语基题还在反复丢分，殷然“专题”助你夯实基础！",
    cj: "帮助学生培养语文学习习惯，掌握语文答题技巧，收获语文读写乐趣。",
    ry:
      "2016年-2019年连续三年学业奖学金获得者2008年4月获第九届全国青少年“春蕾杯”作文奖2008年9月获第三届“语文周报杯”全国中小学创新作文奖",
    ts:
      "风华正茂惜年少，天道酬勤列前茅。博观约取莫浮躁，厚积薄发冲云霄。胸怀文墨常问道，腹有诗书胜不骄。殷然课堂学诀窍，才子佳人乐逍遥。",
    tstag: "“语文高分”解题钥匙",
    video:
      "https://player.bilibili.com/player.html?aid=82893034&cid=141815871&page=1",
    grade2: "初一"
  },
  {
    code: "85",
    name: "赵静",
    grade: "初一",
    sf: "英语",
    tags: "口语达人|功底女侠|电动小马达",
    num: "27894",
    percent: "98.2%",
    info:
      "英语语言学硕士<br/>专业八级证书、高级口译证书<br/>中钱友好青年代表+省政府陪同翻译<br/>全国英语竞赛一等奖+国家奖学金",
    mj:
      "单词记不住？“一目十行”静教你拼读、构词法，中考单词轻松背！完形填不出？“独家侦探”静带你找出上下文伏笔！阅读不想做？“身怀绝技”静传你线索词定位法，阅读满分不是梦！你可能猜不透出卷老师的心，但你可以摸清他们的套路。走出套路，拿到高分！",
    cj:
      "所教学生人数累计超过2000+，涵盖小学、初中、高中和大学各个阶段，好评率为99%以上，提分明显，并有多位学生考上省、市重点中学。",
    ry:
      "2015年国家奖学金、国家励志奖学金2016年专业八级证书、高级口译证书2017年中俄优秀青年称号、国际夏令营优秀志愿者2018年全国大学生英语竞赛一等奖、优秀青年教师",
    ts:
      "人称静静老师，据说每天想静静，英语一直在前进，被学生评价为“最爱笑且最容易让他们吃醋”的别人家的老师。功底深厚也不忘记努力，喜欢读英文原版书，喜欢看电影，更喜欢看到每天都在进步的你们。“千变万化”静想要带你们横扫出题套路、感受异国风情、走上人生巅峰。",
    tstag: "语言硕士，英语八级",
    video:
      "https://player.bilibili.com/player.html?aid=82892442&cid=141815022&page=1",
    grade2: "初一"
  },
  {
    code: "86",
    name: "朱中彬",
    grade: "初三",
    sf: "物理",
    tags: "探花之师|物理满分|8年教龄",
    num: "41626",
    percent: "98.4%",
    info:
      "10年教龄,带出数十位中考状元和黑马<br/>学生送封号“学神”、“活题库”<br/>善于将复杂问题简单化,通俗易懂<br/>注重理科思维的培养和训练,技巧、方法、套路的总结",
    mj:
      "N多学生称我为“学神”，称我讲的方法、技巧为“学神绝技”。在物理学神的课堂上，可以口算浮力压轴题，可以一招搞定所有电学范围值计算。在物理学神的课堂上，一个个的模型、方法在参考书上都是找不到的。",
    cj: "",
    ry: "2011年及2012年哈工大学子教育“金牌教师”2015年学而思“S级教师”",
    ts:
      "除了研究物理，也喜欢健身，更喜欢游泳。个人浑身每个细胞都充满了正能量，希望能在潜移默化中帮助到你。我是学神，认准学神，准错不了！",
    tstag: "数十位中考状元黑马的选择",
    video:
      "https://player.bilibili.com/player.html?aid=82891977&cid=141814347&page=1",
    grade2: "初三"
  },
  {
    code: "87",
    name: "高岩",
    grade: "高一",
    sf: "语文",
    tags: "14年教龄|省重点名师|全方位提升",
    num: "34022",
    percent: "99.5%",
    info:
      "十五年教龄、前人大附中系列学校语文组长<br/>人教版教材配套练习册编写者、市级骨干教师研修班成员<br/>多次承担北京市级公开课任务<br/>改革开放四十周年教师代表接受媒体访问<br/>语文报杯,新概念作文大赛等奖辅导老师<br/>培养学子遍布海内外知名大学",
    mj:
      "透彻命中知识点，准确抓住典型题，熟悉命题思路，经验造就高效。在提分的过程中同步提升思维的深度和广度，让你站得高，望得远！",
    cj:
      "任教十四年来，桃李遍天下。从清华北大人大等国内顶级高校，到美国加拿大等世界排名前100的大学，都有高老师孩子们的踪迹。离开公立校的最后一届孩子，已有多人拿到清华北大的加分和保送资格，跟着高老师，圆自己的名校之梦想！",
    ry:
      "2008年-2013年市区中心备课组成员2014年-2016年人教版配套练习册编写组成员2018年语文报杯作文大赛特等奖辅导教师2018年改革开放四十周年教师代表",
    ts:
      "懂你的悲喜，才能在你展翅时欢呼，在你沮丧时鼓舞。我是你的老师，是你的教练，是你的长辈，更是你的朋友。愿我的用心，成就你的梦想，那便是作为老师最好的幸福。",
    tstag: "透彻命中知识点，经验造就高效",
    video:
      "https://player.bilibili.com/player.html?aid=82941681&cid=141896979&page=1",
    grade2: "初一、高一、高二"
  },
  {
    code: "88",
    name: "高岩",
    grade: "高二",
    sf: "语文",
    tags: "14年教龄|省重点名师|全方位提升",
    num: "34022",
    percent: "99.5%",
    info:
      "十五年教龄、前人大附中系列学校语文组长<br/>人教版教材配套练习册编写者、市级骨干教师研修班成员<br/>多次承担北京市级公开课任务<br/>改革开放四十周年教师代表接受媒体访问<br/>语文报杯,新概念作文大赛等奖辅导老师<br/>培养学子遍布海内外知名大学",
    mj:
      "透彻命中知识点，准确抓住典型题，熟悉命题思路，经验造就高效。在提分的过程中同步提升思维的深度和广度，让你站得高，望得远！",
    cj:
      "任教十四年来，桃李遍天下。从清华北大人大等国内顶级高校，到美国加拿大等世界排名前100的大学，都有高老师孩子们的踪迹。离开公立校的最后一届孩子，已有多人拿到清华北大的加分和保送资格，跟着高老师，圆自己的名校之梦想！",
    ry:
      "2008年-2013年市区中心备课组成员2014年-2016年人教版配套练习册编写组成员2018年语文报杯作文大赛特等奖辅导教师2018年改革开放四十周年教师代表",
    ts:
      "懂你的悲喜，才能在你展翅时欢呼，在你沮丧时鼓舞。我是你的老师，是你的教练，是你的长辈，更是你的朋友。愿我的用心，成就你的梦想，那便是作为老师最好的幸福。",
    tstag: "透彻命中知识点，经验造就高效",
    video:
      "https://player.bilibili.com/player.html?aid=82941681&cid=141896979&page=1",
    grade2: "初一、高一、高二"
  },
  {
    code: "89",
    name: "王硕",
    grade: "高一",
    sf: "数学",
    tags: "5年教龄|套路王|数学小仙女",
    num: "17255",
    percent: "97.5%",
    info:
      "线下授课时长超过1800小时<br/>所带学生平均分提升在20分以上,高考生最高提升40分<br/>所带学员大都考入211及以上大学",
    mj: "数学公式记不住？别急，硕姐来帮助！数学做题没思路？莫怕，硕姐有套路",
    cj:
      "自2015年从教以来，从一对一到线下大班再到在线课，对每种教学模式都有探索，与学生的近距离接触也让我能快速了解学生的痛点在哪里目前累计上课时超过长1800小时，帮助学生在高三一年快速提高分数，最高达40分，所教学生数十人进入重点大学，上百人进入一本院校",
    ry:
      "2012年第七届“挑战杯”首都大学生创业计划竞赛银奖2012年GMC国际挑战赛三等奖2013年美国大学生数学建模大赛三等奖",
    ts:
      "我喜欢和学生打成一片，喜欢和男生组队打游戏也喜欢和女生讨论电视剧，当然更喜欢给学生答疑解惑，学生成绩提升甚至于明白一个题或知识点都让我感受到成就，在我的心中，与其说我是传授知识的老师，我更愿意做能聆听和帮助孩子们的大姐姐。",
    tstag: "学生一年快速提高分数最高达40分",
    video:
      "https://player.bilibili.com/player.html?aid=82941444&cid=141896530&page=1",
    grade2: "高一、高二"
  },
  {
    code: "90",
    name: "王硕",
    grade: "高二",
    sf: "数学",
    tags: "5年教龄|套路王|数学小仙女",
    num: "17255",
    percent: "97.5%",
    info:
      "线下授课时长超过1800小时<br/>所带学生平均分提升在20分以上,高考生最高提升40分<br/>所带学员大都考入211及以上大学",
    mj: "数学公式记不住？别急，硕姐来帮助！数学做题没思路？莫怕，硕姐有套路",
    cj:
      "自2015年从教以来，从一对一到线下大班再到在线课，对每种教学模式都有探索，与学生的近距离接触也让我能快速了解学生的痛点在哪里目前累计上课时超过长1800小时，帮助学生在高三一年快速提高分数，最高达40分，所教学生数十人进入重点大学，上百人进入一本院校",
    ry:
      "2012年第七届“挑战杯”首都大学生创业计划竞赛银奖2012年GMC国际挑战赛三等奖2013年美国大学生数学建模大赛三等奖",
    ts:
      "我喜欢和学生打成一片，喜欢和男生组队打游戏也喜欢和女生讨论电视剧，当然更喜欢给学生答疑解惑，学生成绩提升甚至于明白一个题或知识点都让我感受到成就，在我的心中，与其说我是传授知识的老师，我更愿意做能聆听和帮助孩子们的大姐姐。",
    tstag: "学生一年快速提高分数最高达40分",
    video:
      "https://player.bilibili.com/player.html?aid=82941444&cid=141896530&page=1",
    grade2: "高一、高二"
  },
  {
    code: "91",
    name: "赵文彬",
    grade: "高一",
    sf: "化学",
    tags: "名校特约讲师|提分全能王|经验丰富",
    num: "54121",
    percent: "99.4%",
    info:
      "华南理工大学化学工程（全球前15）<br/>某顶尖K12教育机构、名校特约讲师、高考工作室、备考体系负责人<br/>授课时长:3000+小时<br/>领导力课程满分学员、市级化学竞赛二等奖、市级作文竞赛一等奖<br/>高中化学教学负责人、S级骨干教师、资深培训师",
    mj:
      "记忆宫殿学习法、奇幻故事家、灵魂画手、口诀大师、平坑之王……我流传于江湖上的这些名号并非浪得虚名。想学好化学？跟我来，让我带你进入化学中的“造化钟神秀”……",
    cj:
      "国家级示范性重点高中特约讲师，授课时长3000+小时。擅于因材施教，所带学员遍布广州前4所高中，成绩长期稳定年级前列；基础不扎实的学生稳定提分20+。",
    ry:
      "2016年某顶尖K12教育机构“最具激情奖”2017年某顶尖K12教育机构“最佳团队”2018年某顶尖K12教育机构“S级教师”",
    ts:
      "长得一般，但足以让你望眼欲穿；智商平凡，但博古通今侃侃而谈；略显古板，但引经据典笑点不断；兴趣广泛，但专注教学从不怠慢；神秘玄幻，欢迎诸位来我班上看看～",
    tstag: "S级骨干教师，国家级特约讲师",
    video:
      "https://player.bilibili.com/player.html?aid=82946052&cid=141904383&page=1",
    grade2: "高一、高二"
  },
  {
    code: "92",
    name: "赵文彬",
    grade: "高二",
    sf: "化学",
    tags: "名校特约讲师|提分全能王|经验丰富",
    num: "54121",
    percent: "99.4%",
    info:
      "华南理工大学化学工程（全球前15）、佛山市第一中学、某顶尖K12教育机构、名校特约讲师、高考工作室、备考体系负责人、授课时长:3000+小时、学生会主席、文娱部部长、艺术团团长、优秀主持人、校友会学生代表、领导力课程满分学员、市级化学竞赛二等奖、市级作文竞赛一等奖、高中化学教学负责人、S级骨干教师、资深培训师、提高班尖子班尖端班、广州前四特色班、高级中学教师资格证、普通话二级甲等",
    mj:
      "记忆宫殿学习法、奇幻故事家、灵魂画手、口诀大师、平坑之王……我流传于江湖上的这些名号并非浪得虚名。想学好化学？跟我来，让我带你进入化学中的“造化钟神秀”……",
    cj:
      "国家级示范性重点高中特约讲师，授课时长3000+小时。擅于因材施教，所带学员遍布广州前4所高中，成绩长期稳定年级前列；基础不扎实的学生稳定提分20+。",
    ry:
      "2016年某顶尖K12教育机构“最具激情奖”2017年某顶尖K12教育机构“最佳团队”2018年某顶尖K12教育机构“S级教师”",
    ts:
      "长得一般，但足以让你望眼欲穿；智商平凡，但博古通今侃侃而谈；略显古板，但引经据典笑点不断；兴趣广泛，但专注教学从不怠慢；神秘玄幻，欢迎诸位来我班上看看～",
    tstag: "S级骨干教师，国家级特约讲师",
    video:
      "https://player.bilibili.com/player.html?aid=82946052&cid=141904383&page=1",
    grade2: "高一、高二"
  },
  {
    code: "93",
    name: "刘云鹏",
    grade: "高一",
    sf: "数学",
    tags: "6年教龄|押题小能手|东北段子手",
    num: "120730",
    percent: "99.1%",
    info:
      "高考数学148分;在某知名网校平合荣获“十佳讲师称号;入选超级老师计划；某平台担任初高中数学主讲培训师；蔚蓝教育文化学校创始人:累计授课4000+h;辅导学生高考数学平均分125分；重本录取率约83%",
    mj:
      "重基础、重套路、重总结，三者缺一不可；解析大题不用愁，轻轻松松满分有；归纳题型，秒杀解法，做一个快乐的数学霸主！鹏哥课堂走一走，高考数学149！",
    cj:
      "自我2013年从教以来，辅导学生高考数学平均分125分+，重本录取率在83%以上。曾有学生数学考试成绩从49分提升至高考数学121分。",
    ry: "2015年-2018年某知名网校平台高中数学“十佳主讲”入选超级老师计划",
    ts:
      "喜欢打篮球，在生活中，喜欢和学生们做朋友，有心事找鹏哥，小嗑一唠都好说！只要我们共同努力，高考数学必定取得理想的成绩。",
    tstag: "十佳讲师，数学霸主",
    video:
      "https://player.bilibili.com/player.html?aid=82946022&cid=141904058&page=1",
    grade2: "高一"
  },
  {
    code: "94",
    name: "代宇",
    grade: "高一",
    sf: "数学",
    tags: "提分小能手|邻家小姐姐|985硕士",
    num: "30465",
    percent: "99.3%",
    info: "辅导学生平均提升20+分;所带学生大多考入985/211院校;",
    mj:
      "学习知识，更要掌握方法。学习技巧，同时培养思维。在我的数学课堂里，带你快乐学习，轻松提分！",
    cj: "所教高三学生一年内从64到120分",
    ry:
      "2014年11月一等学业奖学金+TPI奖学金+翰克斯奖学金2016年11月优秀学生奖学金一等奖+专项奖学金2019年06月优秀毕业生",
    ts:
      "小代知道如何学，更知道如何玩。兴趣爱好那叫一个广泛，健身、跑步、乒乓球(悄悄告诉你，我以前是校队的哦~)、游泳、跳舞样样都来。跟着小代老师一起课上玩转数学，课下玩转生活！",
    tstag: "速度快，提分高，学生必备",
    video:
      "https://player.bilibili.com/player.html?aid=82940478&cid=141894705&page=1",
    grade2: "高一"
  },
  {
    code: "95",
    name: "王漫谦",
    grade: "高一",
    sf: "数学",
    tags: "北京大学|严厉而慈爱",
    num: "105027",
    percent: "98.6%",
    info:
      "毕业于北京大学<br/>医学、经济学双学位<br/>高中数学老师，教龄7年<br/>公立学校3年、学而思3年(常年S级老师)",
    mj:
      "1.讲课逻辑性强，由易到难，最后总结概括；2.严厉而“慈爱”，上课认真听讲，作业按时完成，积极踊跃提问就能看到“慈爱”的一面，听课开小差，那肯定就时时挨“怼”",
    cj: "7年教龄；累计学员近10万；多名学生保送清北",
    ry: "",
    ts: "",
    tstag: "北大才子，S级优秀老师",
    video:
      "https://player.bilibili.com/player.html?aid=82941499&cid=141896661&page=1",
    grade2: "高一、高二"
  },
  {
    code: "96",
    name: "王漫谦",
    grade: "高二",
    sf: "数学",
    tags: "北京大学|严厉而慈爱",
    num: "105027",
    percent: "98.6%",
    info:
      "毕业于北京大学<br/>医学、经济学双学位<br/>高中数学老师，教龄7年<br/>公立学校3年、学而思3年(常年S级老师)",
    mj:
      "1.讲课逻辑性强，由易到难，最后总结概括；2.严厉而“慈爱”，上课认真听讲，作业按时完成，积极踊跃提问就能看到“慈爱”的一面，听课开小差，那肯定就时时挨“怼”",
    cj: "7年教龄；累计学员近10万；多名学生保送清北",
    ry: "",
    ts: "",
    tstag: "北大才子，S级优秀老师",
    video:
      "https://player.bilibili.com/player.html?aid=82941499&cid=141896661&page=1",
    grade2: "高一、高二"
  },
  {
    code: "97",
    name: "杨红子",
    grade: "高二",
    sf: "语文",
    tags: "北师大本硕|5年教龄|语文解题达人",
    num: "77667",
    percent: "99.4%",
    info:
      "北京师范大学中文系本科教育学硕士<br/>10000+省级示范校大班授课经验<br/>6年教学经验,连续4年高三毕业班经验<br/>200多学员高考语文125+,古诗文满分学员300+<br/>多次获得省市教学大赛、教学论文比赛一等奖",
    mj:
      "语文学习有两条路，一条是阅读，一条是表达。有五种阅读方法，和三种表达技巧，帮助你高效阅读，精准表达。",
    cj:
      "所带班级在2016年高考中，语文成绩平均分高出其他班级8分之多，90%的学生考入985、211等名校。所教高考语文成绩在120+学员人数上百人。",
    ry: "2014年省级论文竞赛一等奖2015年创新作文大赛优秀辅导教师",
    ts:
      "我喜欢好多事情的：跑步，游泳，读古书，看电影。读古文，背古诗，走近古人，与当下对话，实在是人生幸事。希望每一位学员都能通过红子的带领，感受此间之乐。",
    tstag: "北师大硕士，学霸制造机",
    video:
      "https://player.bilibili.com/player.html?aid=82941370&cid=141896414&page=1",
    grade2: "高二、高三"
  },
  {
    code: "98",
    name: "杨红子",
    grade: "高三",
    sf: "语文",
    tags: "北师大本硕|5年教龄|语文解题达人",
    num: "77667",
    percent: "99.4%",
    info:
      "北京师范大学中文系本科教育学硕士<br/>10000+省级示范校大班授课经验<br/>6年教学经验,连续4年高三毕业班经验<br/>200多学员高考语文125+,古诗文满分学员300+<br/>多次获得省市教学大赛、教学论文比赛一等奖",
    mj:
      "语文学习有两条路，一条是阅读，一条是表达。有五种阅读方法，和三种表达技巧，帮助你高效阅读，精准表达。",
    cj:
      "所带班级在2016年高考中，语文成绩平均分高出其他班级8分之多，90%的学生考入985、211等名校。所教高考语文成绩在120+学员人数上百人。",
    ry: "2014年省级论文竞赛一等奖2015年创新作文大赛优秀辅导教师",
    ts:
      "我喜欢好多事情的：跑步，游泳，读古书，看电影。读古文，背古诗，走近古人，与当下对话，实在是人生幸事。希望每一位学员都能通过红子的带领，感受此间之乐。",
    tstag: "北师大硕士，学霸制造机",
    video:
      "https://player.bilibili.com/player.html?aid=82941370&cid=141896414&page=1",
    grade2: "高二、高三"
  },
  {
    code: "99",
    name: "徐浪",
    grade: "高一",
    sf: "物理",
    tags: "部属师范|话痨90后|物理逆袭",
    num: "66",
    percent: "97%",
    info: "华中师范大学毕业<br/>某省重点高中优秀教师",
    mj:
      "物理跟浪浪，学习最胖胖。错题点睛，举一反三，谁说物理就该题海战术；深入浅出，逐个击破，给你一双解析难题的慧眼。所谓难题，不过是基本模型的杂糅。透析每个模型，解题也能拥有庖丁解牛般的快感！",
    cj: "所带学员物理成绩稳步上升，教学风格深受学生喜爱。",
    ry:
      "2016年全国铁道团委青年志愿者优秀个人2016年校级奖学金2018年某省重点高中优秀教师",
    ts:
      "爱讲课、爱电影、爱运动。90后的年纪10后的心，有点小执着的中二少年。侃得了相对论，讲得出守恒律，聊得出薛定谔，谈得来电磁场。看似青铜，实为王者，带你在物理考场轻松吃鸡。",
    tstag: "省重点高中优秀教师",
    video: "",
    grade2: "高一"
  },
  {
    code: "100",
    name: "赵丽华",
    grade: "高一",
    sf: "物理",
    tags: "4年教龄|勤于总结|资深吃货",
    num: "14796",
    percent: "99.4%",
    info:
      "武汉大学本科、硕土毕业<br/>某线下培训机构高级物理讲师<br/>好未来旗下培训机构物理教研员、物理讲师<br/>企鹅辅导高中物理讲师",
    mj: "乐于总结，举一反三，重于方法论的输出，让刷题更有方向、效率。",
    cj:
      "大学本科起开始涉足教育行业，共与近80名高三学生一同学习成长，多年一对一、班课教学经验，有50%以上的学生考入双一流高校；2名学生考入加拿大顶尖大学；为基础薄弱的同学定制拿分策略，在最终的考试中取得巨大的提升，考入心仪的高校。",
    ry: "2016-2017年某知名线上教育机构优秀教师",
    ts:
      "学生眼中的我：外表高冷，实则是个搞笑的人。每次都可以露出那种尴尬又不失礼貌的微笑，时而还是个唠叨的大姐姐，但人超级nice。自己眼中的我：有些宅，但也很喜欢玩耍，喜欢看各种球类比赛，曾经是个追剧狂魔，但现在已是一个老阿姨，但心态还可以是00后哦。我想对你说：学习上，我们是师生，生活中，我们是陌生而又熟悉的朋友，让我们一同前行，达到梦想的彼岸，加油加油！！！",
    tstag: "武大硕士，高级物理讲师",
    video:
      "https://player.bilibili.com/player.html?aid=82941636&cid=141896876&page=1",
    grade2: "高一"
  },
  {
    code: "101",
    name: "傅磊",
    grade: "高一",
    sf: "物理",
    tags: "邻家大哥哥|物理科代表|高考物理教研",
    num: "35997",
    percent: "98.9%",
    info:
      "华南理工大学能源工程及其自动化学士<br/>顶尖教育机构<br/>对公项目部物理主讲教师<br/>授课时长超3000小时，高中物理教研负责人<br/>期中期末考“押题王；企鹅辅导小萌新",
    mj:
      "但从今天起，“物理物理、云里雾里”这个印象要被颠覆。你要做到：第一：每天起床大喊三句，“物理真的很简单”；第二：善于观察身边的现象，看哪些跟物理有关；第三：勤思考、多练习。",
    cj:
      "某顶尖K12教育机构对公项目部主讲教师，省属重点高级中学特约讲师，授课时长超过3000小时。带过各种层次的学员，其中思维活跃的学员长期处于年级前列，而基础不牢固的学生通过学习重拾物理自信，稳定提分。",
    ry:
      "2016年12月某顶尖K12教育机构“进步达人”2017年7月某顶尖K12教育机构“最佳团队”2018年4月某顶尖K12教育机构“特殊贡献奖”",
    ts:
      "虽然我的智力水平偏高，但是心理年龄只有18岁。喜欢所有你们喜欢的东西：唱歌、篮球，游戏，看书。最有成就感的时候是学生上完我的物理课，表现出“醍醐灌顶”的样子。帮助你们不再畏惧物理是我的使命。",
    tstag: "物理教研员，押题王",
    video:
      "https://player.bilibili.com/player.html?aid=82940687&cid=141895038&page=1",
    grade2: "高一、高二"
  },
  {
    code: "102",
    name: "傅磊",
    grade: "高二",
    sf: "物理",
    tags: "邻家大哥哥|物理科代表|高考物理教研",
    num: "35997",
    percent: "98.9%",
    info:
      "华南理工大学能源工程及其自动化学士<br/>顶尖教育机构<br/>对公项目部物理主讲教师<br/>授课时长超3000小时，高中物理教研负责人<br/>期中期末考“押题王；企鹅辅导小萌新",
    mj:
      "但从今天起，“物理物理、云里雾里”这个印象要被颠覆。你要做到：第一：每天起床大喊三句，“物理真的很简单”；第二：善于观察身边的现象，看哪些跟物理有关；第三：勤思考、多练习。",
    cj:
      "某顶尖K12教育机构对公项目部主讲教师，省属重点高级中学特约讲师，授课时长超过3000小时。带过各种层次的学员，其中思维活跃的学员长期处于年级前列，而基础不牢固的学生通过学习重拾物理自信，稳定提分。",
    ry:
      "2016年12月某顶尖K12教育机构“进步达人”2017年7月某顶尖K12教育机构“最佳团队”2018年4月某顶尖K12教育机构“特殊贡献奖”",
    ts:
      "虽然我的智力水平偏高，但是心理年龄只有18岁。喜欢所有你们喜欢的东西：唱歌、篮球，游戏，看书。最有成就感的时候是学生上完我的物理课，表现出“醍醐灌顶”的样子。帮助你们不再畏惧物理是我的使命。",
    tstag: "物理教研员，押题王",
    video:
      "https://player.bilibili.com/player.html?aid=82940687&cid=141895038&page=1",
    grade2: "高一、高二"
  },
  {
    code: "103",
    name: "李烨",
    grade: "高一",
    sf: "物理",
    tags: "高考物理满分|提分帮主|高考押题王",
    num: "77845",
    percent: "98.6%",
    info:
      "哈尔滨工业大学毕业<br/>企鹅辅导高三年级负责人<br/>企鹅辅导高中物理培训师<br/>企鹅辅导高中物理教研员<br/>5年教龄",
    mj: "学物理重在思考，次之练习，最次的是做大量的作业。",
    cj:
      "所教学生累计超过2000人，很多人考上211/985等高校，所教提高班学员提分者众多，多数能够进入本科学校。",
    ry: "2015年某知名培训机构“年度优秀教师”",
    ts:
      "爱好有：读书、看电影、做饭、开车等一切“自己动手，丰衣足食”的活动，动手能力和学习能力很强。学习理念是“做中学，学中做”和“活到老，学到老”。",
    tstag: "5年教龄，经验丰富",
    video:
      "https://player.bilibili.com/player.html?aid=82941224&cid=141896007&page=1",
    grade2: "高一、高三"
  },
  {
    code: "104",
    name: "李烨",
    grade: "高三",
    sf: "物理",
    tags: "高考物理满分|提分帮主|高考押题王",
    num: "77845",
    percent: "98.6%",
    info:
      "哈尔滨工业大学毕业<br/>企鹅辅导高三年级负责人<br/>企鹅辅导高中物理培训师<br/>企鹅辅导高中物理教研员<br/>5年教龄",
    mj: "学物理重在思考，次之练习，最次的是做大量的作业。",
    cj:
      "所教学生累计超过2000人，很多人考上211/985等高校，所教提高班学员提分者众多，多数能够进入本科学校。",
    ry: "2015年某知名培训机构“年度优秀教师”",
    ts:
      "爱好有：读书、看电影、做饭、开车等一切“自己动手，丰衣足食”的活动，动手能力和学习能力很强。学习理念是“做中学，学中做”和“活到老，学到老”。",
    tstag: "5年教龄，经验丰富",
    video:
      "https://player.bilibili.com/player.html?aid=82941224&cid=141896007&page=1",
    grade2: "高一、高三"
  },
  {
    code: "105",
    name: "吴遇琬",
    grade: "高一",
    sf: "数学",
    tags: "科班出身|竞赛经验|套路杀手",
    num: "906",
    percent: "98%",
    info:
      "数学与应用数学科班出身(公立学校经验)<br/>多年竞赛经验<br/>从教多年,所带学员多能考入985/211",
    mj:
      "其实数学题永远跳不出自己的框架，所有的题目你都可以当成套路题去解决。尤其是高中数学，它的知识点是很集中的，找到一个规律，培养一种思维，你就能解决一类题目，考试再也不难。",
    cj:
      "所带高三学生最高提分达63分；花两个月时间班级93%学生从学考B/C等级提升到A",
    ry: "2018年7月浙江省“互联网+”创新创业大赛银奖2019年5月校级优秀毕业生",
    ts:
      "我觉得学习数学就像在玩闯关游戏，是一个会上瘾的过程，在所有学科中，数学是最能给人带来成就感与满足感的，当你了解一个题，能去解决一类题，幸福感就会爆棚，我希望能陪大家一起KO一个又一个BOSS。也许生活会背叛你，但我和数学绝对不会。",
    tstag: "所带学员多能考入985/211",
    video:
      "https://player.bilibili.com/player.html?aid=82940885&cid=141895458&page=1",
    grade2: "高一"
  },
  {
    code: "106",
    name: "戴炜",
    grade: "高一",
    sf: "生物",
    tags: "13年教龄|名校教师|学生保送北大",
    num: "113226",
    percent: "98.2%",
    info:
      "13年教龄<br/>所教班级全部考入一本院校，多名学生进入top10名校<br/>2013年曾教过的学生以生物竞赛保送北大生物系",
    mj:
      "名校名师，善于利用简洁形象的模型快速解决高考疑难。我相信学习中自有方法论，我鼓励学生去掌握方法论，这才能真实提高学科能力，提高应试成绩。",
    cj:
      "所教班级全部考入一本院校，多名学生进入top10名校。2013年曾教过的学生以生物竞赛保送北大生物系。",
    ry: "2007年献课一等奖2015年省优秀班级班主任",
    ts:
      "作为一个老师，我教过很多东西：英语、摄影、羽毛球……当然，最重要的还是生物。这样跨学科地拓展会给学生带来莫大的裨益，你会看见一个更大的世界。在此过程中，我笃信做任何事都有着一个发现规律-掌握方法-做出成绩的过程，都有着一个成体系的方法论，我愿意和你一同走完这个过程。",
    tstag: "注重方法，快速解决高考疑难",
    video: "",
    grade2: "高一"
  },
  {
    code: "107",
    name: "黄令群",
    grade: "高一",
    sf: "英语",
    tags: "全能多面手|行走语法书|奇迹缔造者",
    num: "31547",
    percent: "99.2%",
    info:
      "高考英语140+分<br/>2014年全国大学生英语竞赛特等奖(全国前千分之一)<br/>CCTV希望之星英语风采大赛一等奖<br/>3年教龄:辅导多名学生英语成绩由班级倒数直冲班级前三",
    mj:
      "用逻辑攻克英语，没有学不好英语这回事儿用感性升华英语，站得比考试更高睥睨高考积累（Accumulation）-习得（Acquisition）-高分（Achievement），3A科学体系，全面打造王者英语",
    cj:
      "从科学与逻辑出发，重塑学生知识体系，锻造全新学习方法，带领学生厚积薄发，全面爱上英语，由班级倒数直冲班级前三，由班级中游升级竞赛小能手。",
    ry:
      "2013年4月全国大学生英语竞赛全国一等奖2013年5月希望之星英语风采大赛一等奖2014年4月全国大学生英语竞赛全国特等奖",
    ts:
      "铁杆球迷，拜仁死忠；资深乐迷，歌声动听；深陷科研，醉心语言。就像思考苹果落地一样，让我带领你对于看似最普通的问题提出质疑，深入思考，革新认知，刷新英语学习三观，全面提升综合素质，锻造个人核心竞争力！",
    tstag: "英语达人，用逻辑攻克英语",
    video:
      "https://player.bilibili.com/player.html?aid=82945902&cid=141904160&page=1",
    grade2: "高一"
  },
  {
    code: "108",
    name: "齐霁",
    grade: "高一",
    sf: "语文",
    tags: "9年教龄|提分能手|满分作文名师",
    num: "165352",
    percent: "98.6%",
    info:
      "北京师范大学文学硕士、9年教龄<br/>中高考作文满分,高考语文142分<br/>知名上市教育机构高端教师、知名教育机构教研负责人<br/>历年高考平均分超过112分<br/>指导百位学生考入清北等一流名校、上百位学生参加全国作文大赛获奖",
    mj:
      "语文也需要刷题？高效刷题有方法；作文学霸讲作文，自有独家妙招；语文不过“读”与“写”，读写同门有技巧！",
    cj:
      "自我2010年从教以来，线上线下所教学生人数累计超过5万人，重点大学学生人数数千人！清北等高校人数近百人！最快提分从一模到高考，语文提分67分。“春蕾杯”“语文报杯”等作文大赛，学生获奖人数近百人，其中一等奖超过20人！",
    ry: "2015年春蕾杯作文大赛优秀导师",
    ts: "简单的生活，用最好的态度对待最差的可能性。",
    tstag: "北师大硕士，高端教师",
    video:
      "https://player.bilibili.com/player.html?aid=82948306&cid=141908050&page=1",
    grade2: "高一、高三"
  },
  {
    code: "109",
    name: "齐霁",
    grade: "高三",
    sf: "语文",
    tags: "9年教龄|提分能手|满分作文名师",
    num: "165352",
    percent: "98.6%",
    info:
      "北京师范大学文学硕士、9年教龄<br/>中高考作文满分,高考语文142分<br/>知名上市教育机构高端教师、知名教育机构教研负责人<br/>历年高考平均分超过112分<br/>指导百位学生考入清北等一流名校、上百位学生参加全国作文大赛获奖",
    mj:
      "语文也需要刷题？高效刷题有方法；作文学霸讲作文，自有独家妙招；语文不过“读”与“写”，读写同门有技巧！",
    cj:
      "自我2010年从教以来，线上线下所教学生人数累计超过5万人，重点大学学生人数数千人！清北等高校人数近百人！最快提分从一模到高考，语文提分67分。“春蕾杯”“语文报杯”等作文大赛，学生获奖人数近百人，其中一等奖超过20人！",
    ry: "2015年春蕾杯作文大赛优秀导师",
    ts: "简单的生活，用最好的态度对待最差的可能性。",
    tstag: "北师大硕士，高端教师",
    video:
      "https://player.bilibili.com/player.html?aid=82948306&cid=141908050&page=1",
    grade2: "高一、高三"
  },
  {
    code: "110",
    name: "高兰",
    grade: "高二",
    sf: "化学",
    tags: "11年教龄|高考百事通|学科负责人",
    num: "70000",
    percent: "99.4%",
    info:
      "中南大学硕士研究生、高考化学满分<br/>10年教龄、6年毕业班经验<br/>企鹅铺导最资深化学老师，学生总人数过10w<br/>独立编写各年级讲义及《名师手写笔记》等教辅",
    mj:
      "五步法解决陌生氧化还原方程式的配平，原电池gay理论，主次矛盾法搞定溶液中离子浓度比较等等等等，简单又实用；小兰老师的课堂，幽默、生动、活泼而又不失内涵，总是脉络分明，永远干货满满。",
    cj:
      "11年教龄，所教学生累计超过4万人；学生成绩进步率100%，家长满意率100%，一本上线率高达95%。",
    ry:
      "2012年学而思培优“最佳新人奖”2014年学而思培优“年度优秀教师”2015年学而思培优“榜样教师”",
    ts:
      "永远18的小兰姐姐对同样十六七八岁的宝宝们说：人生，只有一次高中——唯一一次千万人共挤独木桥的机会，想想都好刺激！！！为什么不在最美的年华里造一造，多熬几次夜，多刷几篇题，做那个把别人挤下桥而自己顺利过桥的？年轻，一切皆有可能！",
    tstag: "中南大学硕士，化学满分学霸",
    video:
      "https://player.bilibili.com/player.html?aid=82941834&cid=141897192&page=1",
    grade2: "高二、高三"
  },
  {
    code: "111",
    name: "高兰",
    grade: "高三",
    sf: "化学",
    tags: "11年教龄|高考百事通|学科负责人",
    num: "70000",
    percent: "99.4%",
    info:
      "中南大学硕士研究生、高考化学满分<br/>10年教龄、6年毕业班经验<br/>企鹅铺导最资深化学老师，学生总人数过10w<br/>独立编写各年级讲义及《名师手写笔记》等教辅",
    mj:
      "五步法解决陌生氧化还原方程式的配平，原电池gay理论，主次矛盾法搞定溶液中离子浓度比较等等等等，简单又实用；小兰老师的课堂，幽默、生动、活泼而又不失内涵，总是脉络分明，永远干货满满。",
    cj:
      "11年教龄，所教学生累计超过4万人；学生成绩进步率100%，家长满意率100%，一本上线率高达95%。",
    ry:
      "2012年学而思培优“最佳新人奖”2014年学而思培优“年度优秀教师”2015年学而思培优“榜样教师”",
    ts:
      "永远18的小兰姐姐对同样十六七八岁的宝宝们说：人生，只有一次高中——唯一一次千万人共挤独木桥的机会，想想都好刺激！！！为什么不在最美的年华里造一造，多熬几次夜，多刷几篇题，做那个把别人挤下桥而自己顺利过桥的？年轻，一切皆有可能！",
    tstag: "中南大学硕士，化学满分学霸",
    video:
      "https://player.bilibili.com/player.html?aid=82941834&cid=141897192&page=1",
    grade2: "高二、高三"
  },
  {
    code: "112",
    name: "孔力",
    grade: "高二",
    sf: "物理",
    tags: "物理领路人|985院校|偶像实力派",
    num: "50158",
    percent: "99.2%",
    info:
      "毕业院校:中南大学<br/>高考成绩:610分(高考物理102分)<br/>擅长高中物理教学<br/>熟悉高考政策",
    mj:
      "一位循循善诱的良师，一本内容详实的笔记，一颗积极向上的决心；勤归纳，善总结，多练习。良师已有，你只需准备笔记，坚定决心，与Mr.孔携手奔向满分物理。",
    cj:
      "线上线下教学人数过千，学生多分布在深圳四大名校、长沙四大名校。所教学生物理成绩进步明显，在中高考取得满意成绩。大量考生考入深圳四大名校、长沙四大名校、985/211高校，深受家长学生的喜爱，是学生的物理领路人。",
    ry: "2015年某知名机构A级教师2017年某知名机构优秀教师",
    ts:
      "Mr.孔爱绘画，爱旅游，爱教学。生活在美丽的深圳，喜欢绘出日常中美好的景色，也喜欢把物理秘籍用最幽默的形式教授给深受物理之苦的学生。上知基腐宅，下知二次元，中晓鬼畜。喜欢伪装成00后。孔老师的课堂有秘籍，有欢乐，你还不快来！",
    tstag: "中南大学的优秀物理学者",
    video:
      "https://player.bilibili.com/player.html?aid=82940937&cid=141895578&page=1",
    grade2: "高二"
  },
  {
    code: "113",
    name: "孙岩",
    grade: "高一",
    sf: "英语",
    tags: "20年教龄|无敌英语|岩出必胜",
    num: "37312",
    percent: "98.3%",
    info:
      "全能导师,20年教龄<br/>腾讯企鹅辅导高中英语负责人<br/>原学而思高中英语教研组长、原新东方元老级资深教师<br/>北京外国语大学英语系、美国宾夕法尼亚大学访问学者<br/>北京海淀区十一学校特聘讲师",
    mj:
      "阅读还在看全文？太out了！随便挑挑捡捡就能得满分；完形填空简直送分题！眼不瞎就能全对；30课时，欢声笑语掌握4500必考单词~；百分之百原创内容，32课时，包你掌握全部英语应用语法！",
    cj:
      "20年教龄，桃李满天下，教授全国各地学员近10万次，各地高考英语成绩最高得分者很多出自孙名师课堂。20年授课经验，专业功底深厚，规律教学，方法独特。通过多年总结的无敌口诀法让学生在快乐的学习中轻松掌握知识。本着不仅提分就是硬道理，而且让学生真正掌握英语的听说读写译全方面能力！",
    ry: "1998年北京高校十大歌手称号",
    ts:
      "我喜欢一切美好的事物，爱好广泛。琴棋书画虽不精通，但是可以达到非专业水准。热爱生活，永远积极向上，人称正能量君！希望我的学生也能像我一样快乐，而且能传递快乐和幸福！",
    tstag: "全能导师，高中英语教研组长",
    video:
      "https://player.bilibili.com/player.html?aid=82941028&cid=141895674&page=1",
    grade2: "高一、高二"
  },
  {
    code: "114",
    name: "孙岩",
    grade: "高二",
    sf: "英语",
    tags: "20年教龄|无敌英语|岩出必胜",
    num: "37312",
    percent: "98.3%",
    info:
      "全能导师,20年教龄<br/>腾讯企鹅辅导高中英语负责人<br/>原学而思高中英语教研组长、原新东方元老级资深教师<br/>北京外国语大学英语系、美国宾夕法尼亚大学访问学者<br/>北京海淀区十一学校特聘讲师",
    mj:
      "阅读还在看全文？太out了！随便挑挑捡捡就能得满分；完形填空简直送分题！眼不瞎就能全对；30课时，欢声笑语掌握4500必考单词~；百分之百原创内容，32课时，包你掌握全部英语应用语法！",
    cj:
      "20年教龄，桃李满天下，教授全国各地学员近10万次，各地高考英语成绩最高得分者很多出自孙名师课堂。20年授课经验，专业功底深厚，规律教学，方法独特。通过多年总结的无敌口诀法让学生在快乐的学习中轻松掌握知识。本着不仅提分就是硬道理，而且让学生真正掌握英语的听说读写译全方面能力！",
    ry: "1998年北京高校十大歌手称号",
    ts:
      "我喜欢一切美好的事物，爱好广泛。琴棋书画虽不精通，但是可以达到非专业水准。热爱生活，永远积极向上，人称正能量君！希望我的学生也能像我一样快乐，而且能传递快乐和幸福！",
    tstag: "全能导师，高中英语教研组长",
    video:
      "https://player.bilibili.com/player.html?aid=82941028&cid=141895674&page=1",
    grade2: "高一、高二"
  },
  {
    code: "115",
    name: "许俊",
    grade: "高一",
    sf: "语文",
    tags: "30年教龄|寓教于乐|发表小说",
    num: "26778",
    percent: "99.1%",
    info:
      "毕业于河北大学；汉语言文学专业<br/>三十年教龄；20年左右在毕业班和补习班任教<br/>经验丰富；发表过文学、教育论文和中篇小说",
    mj:
      "万物皆有规律，方法决定一切！向方法要成绩，向题干要答案，敏锐抓住试题类型的普遍特点，总结规律，让你轻松、准确、全面、快速完成答案。准确预测2017年高考作文“读书阅读”题材，涉及三套试卷。",
    cj:
      "1989年从教，一直坚持在教学第一线，桃李满天下，许多学生考入清华、北大，指导学生获得圣陶杯全国中学生作文大赛一等奖，省级演讲一等奖，在各级报刊发表文章十几篇。徐韬，学校理科生第一名，高二期末总成绩超出第二名35分，语文成绩89分，字写得十分幼稚，经过高三一年的针对性训练，高考语文成绩118分，当年（2011）顺利考上北大。",
    ry:
      "2007年港文汇报发表论文《落花正是好时节》1989年-至今获得地市级优秀教师，省级模范班主任等多项荣誉",
    ts:
      "喜欢读书，举凡文学，历史，宗教，民俗，地理，乃至医卜星相，琴棋书画，都曾涉猎。知识丰富，在教学上更是如鱼得水。喜欢好莱坞电影，美剧，不喜欢韩剧，对国内影视剧极端不满，一直想写剧本，古代战争和上海滩题材，就是没有时间证明自己，有同好的学生可以交流啊。",
    tstag: "经验丰富，向方法要成绩",
    video:
      "https://player.bilibili.com/player.html?aid=82941580&cid=141896743&page=1",
    grade2: "高一"
  },
  {
    code: "116",
    name: "刘锟",
    grade: "高一",
    sf: "政治",
    tags: "高考阅卷经验|8年教龄|高考提分专家",
    num: "24173",
    percent: "98.7%",
    info:
      "高考阅卷经验<br/>8年教龄<br/>高考提分专家<br/>累计学员过千人，6000小时以上的授课经验<br/>连续3年压中高考主观大题。",
    mj:
      "展示系统化的思维导图，罗列精准化的备考考点，分层次针对性母题训练，手把手一步步落实巩固。",
    cj: "累计学员过千人，6000小时以上的授课经验。连续3年压中高考主观大题。",
    ry:
      "2013年太原新东方教育科技集团教学技能大赛中学部第一名2013年新东方集团优秀教师",
    ts:
      "世界上最艰难的工作是什么？思想。凡是值得思想的事情，没有不是人思考过的；我们必须做的只是试图重新加以思考而已。",
    tstag: "押题王者，数千学员的选择",
    video: "",
    grade2: "高一、高三"
  },
  {
    code: "117",
    name: "刘锟",
    grade: "高三",
    sf: "政治",
    tags: "高考阅卷经验|8年教龄|高考提分专家",
    num: "24173",
    percent: "98.7%",
    info:
      "高考阅卷经验<br/>8年教龄<br/>高考提分专家<br/>累计学员过千人，6000小时以上的授课经验<br/>连续3年压中高考主观大题。",
    mj:
      "展示系统化的思维导图，罗列精准化的备考考点，分层次针对性母题训练，手把手一步步落实巩固。",
    cj: "累计学员过千人，6000小时以上的授课经验。连续3年压中高考主观大题。",
    ry:
      "2013年太原新东方教育科技集团教学技能大赛中学部第一名2013年新东方集团优秀教师",
    ts:
      "世界上最艰难的工作是什么？思想。凡是值得思想的事情，没有不是人思考过的；我们必须做的只是试图重新加以思考而已。",
    tstag: "押题王者，数千学员的选择",
    video: "",
    grade2: "高一、高三"
  },
  {
    code: "118",
    name: "国石",
    grade: "高二",
    sf: "生物",
    tags: "10年教龄|5届毕业班|提分王",
    num: "34309",
    percent: "99.4%",
    info: "高中教师课堂教学大赛活动中，获教学能手称号<br/>10年教龄<br/>提分王",
    mj:
      "在我的生物课堂上，我会为大家详细讲解每一个知识点，修补知识体系中的每一个漏洞。让同学们在解题时能够游刃有余！",
    cj:
      "在十年的工作中，我曾先后五次担任高三毕业班把关教师。我所带的学生，不仅基本功扎实，成绩优秀而且还具有良好的品德修养。我很有亲和力，因此与学生的相处十分融洽。我一直以事业心和责任心为动力，全身心投入教育教学工作中，以良好的师德形象，独具特色的教育教学方法，在广大师生及家长中赢得了良好的声誉。",
    ry:
      "2013年高中教师课堂教学大赛活动中，获教学能手称号2014年全市师德先进个人2016年全市优秀教师",
    ts:
      "语言规范严谨、思路条理清晰、讲解细致入微。既注重基础知识的巩固，又进行适度的课外知识拓展。在解决问题的同时，更加注重对解题方法的提炼和学习能力的培养。感谢企鹅辅导提供了这样一个平台，让我们师生有缘相聚于此！也希望我们共同努力，让学习成绩更上一层楼！",
    tstag: "教学能手，优秀教师",
    video: "",
    grade2: "高二、高三"
  },
  {
    code: "119",
    name: "国石",
    grade: "高三",
    sf: "生物",
    tags: "10年教龄|5届毕业班|提分王",
    num: "34309",
    percent: "99.4%",
    info: "高中教师课堂教学大赛活动中，获教学能手称号<br/>10年教龄<br/>提分王",
    mj:
      "在我的生物课堂上，我会为大家详细讲解每一个知识点，修补知识体系中的每一个漏洞。让同学们在解题时能够游刃有余！",
    cj:
      "在十年的工作中，我曾先后五次担任高三毕业班把关教师。我所带的学生，不仅基本功扎实，成绩优秀而且还具有良好的品德修养。我很有亲和力，因此与学生的相处十分融洽。我一直以事业心和责任心为动力，全身心投入教育教学工作中，以良好的师德形象，独具特色的教育教学方法，在广大师生及家长中赢得了良好的声誉。",
    ry:
      "2013年高中教师课堂教学大赛活动中，获教学能手称号2014年全市师德先进个人2016年全市优秀教师",
    ts:
      "语言规范严谨、思路条理清晰、讲解细致入微。既注重基础知识的巩固，又进行适度的课外知识拓展。在解决问题的同时，更加注重对解题方法的提炼和学习能力的培养。感谢企鹅辅导提供了这样一个平台，让我们师生有缘相聚于此！也希望我们共同努力，让学习成绩更上一层楼！",
    tstag: "教学能手，优秀教师",
    video: "",
    grade2: "高二、高三"
  },
  {
    code: "120",
    name: "王莹",
    grade: "高一",
    sf: "历史",
    tags: "历史女神|艺考名师|提分小能手",
    num: "21527",
    percent: "99%",
    info:
      "历史学硕士学位提分小能手<br/>5年教龄<br/>学员成绩进步率100%，家长满意率100%。",
    mj: "",
    cj: "5年教龄，学员成绩进步率100%，家长满意率100%。",
    ry: "",
    ts:
      "喜爱书法、阅读，也爱shopping、旅游。历史老师不是“出土文物”，也有奔放热情。",
    tstag: "名校学历，久远教龄",
    video: "",
    grade2: "高一、高二"
  },
  {
    code: "121",
    name: "王莹",
    grade: "高二",
    sf: "历史",
    tags: "历史女神|艺考名师|提分小能手",
    num: "21527",
    percent: "99%",
    info:
      "历史学硕士学位提分小能手<br/>5年教龄<br/>学员成绩进步率100%，家长满意率100%。",
    mj: "",
    cj: "5年教龄，学员成绩进步率100%，家长满意率100%。",
    ry: "",
    ts:
      "喜爱书法、阅读，也爱shopping、旅游。历史老师不是“出土文物”，也有奔放热情。",
    tstag: "名校学历，久远教龄",
    video: "",
    grade2: "高一、高二"
  },
  {
    code: "122",
    name: "梁旭",
    grade: "高一",
    sf: "化学",
    tags: "高考化学教研|解题思路清奇|奇怪有趣",
    num: "83081",
    percent: "98.9%",
    info:
      "北京大学化学生物学实验室<br/>化学、生物双专业背景<br/>高考一线教研6年",
    mj: "化工流程套路解题电化学口诀术",
    cj:
      "教龄6年，编辑知识点总结7万余字。学生阶段曾为校辩论队主力队员，擅长将复杂问题拆解再重述。学生成绩提高率100%，家长满意度100%",
    ry: "2016年机构最佳教材编辑2017年机构人气教师",
    ts:
      "学习让你倍感压抑黑云压进心间，阴霾蹿入眼前雾里看花，失了方向教学让我倍感愉悦君为诸葛吾为风诸葛在等一阵风希望你等的就是我黑云我来拆成虹霓阴霾我来扣成水滴层层迷雾，我来吹出明路当你需要和风艳阳，我便予你和风艳阳",
    tstag: "北大名校双专业背景",
    video:
      "https://player.bilibili.com/player.html?aid=82942942&cid=141899118&page=1",
    grade2: "高一、高二"
  },
  {
    code: "123",
    name: "梁旭",
    grade: "高二",
    sf: "化学",
    tags: "高考化学教研|解题思路清奇|奇怪有趣",
    num: "83081",
    percent: "98.9%",
    info:
      "北京大学化学生物学实验室<br/>化学、生物双专业背景<br/>高考一线教研6年",
    mj: "化工流程套路解题电化学口诀术",
    cj:
      "教龄6年，编辑知识点总结7万余字。学生阶段曾为校辩论队主力队员，擅长将复杂问题拆解再重述。学生成绩提高率100%，家长满意度100%",
    ry: "2016年机构最佳教材编辑2017年机构人气教师",
    ts:
      "学习让你倍感压抑黑云压进心间，阴霾蹿入眼前雾里看花，失了方向教学让我倍感愉悦君为诸葛吾为风诸葛在等一阵风希望你等的就是我黑云我来拆成虹霓阴霾我来扣成水滴层层迷雾，我来吹出明路当你需要和风艳阳，我便予你和风艳阳",
    tstag: "北大名校双专业背景",
    video:
      "https://player.bilibili.com/player.html?aid=82942942&cid=141899118&page=1",
    grade2: "高一、高二"
  },
  {
    code: "124",
    name: "向莹",
    grade: "高一",
    sf: "化学",
    tags: "5年教龄|活泼生动|方法独到",
    num: "71486",
    percent: "99.4%",
    info:
      "中山大学化学学士(全国排名前十)<br/>澳门大学教育学硕士(全额奖学金保送)<br/>教学经验丰富,学生提分显著,多人考进985名校<br/>熟悉新高考改革政策及高考志愿填报<br/>多次受邀参与广州电视台及南方都市报的高考点评栏目",
    mj:
      "提倡简单高效学习，善于联系生活实例，帮助学生“化繁为简”，在总结快速解题方法的同时，培养良好的学习习惯。",
    cj:
      "5年教龄，累计辅导学生近2000人次，平均学生满意度95%以上，所辅导的学生多人考入985名校。",
    ry:
      "2016年某线下机构最受欢迎教师2017年某线下机构解题大赛第二名2018年某线下机构团队之光",
    ts: "",
    tstag: "中大名校学历，教学经验丰富",
    video:
      "https://player.bilibili.com/player.html?aid=82940772&cid=141895126&page=1",
    grade2: "高一、高二"
  },
  {
    code: "125",
    name: "向莹",
    grade: "高二",
    sf: "化学",
    tags: "5年教龄|活泼生动|方法独到",
    num: "71486",
    percent: "99.4%",
    info:
      "中山大学化学学士(全国排名前十)<br/>澳门大学教育学硕士(全额奖学金保送)<br/>教学经验丰富,学生提分显著,多人考进985名校<br/>熟悉新高考改革政策及高考志愿填报<br/>多次受邀参与广州电视台及南方都市报的高考点评栏目",
    mj:
      "提倡简单高效学习，善于联系生活实例，帮助学生“化繁为简”，在总结快速解题方法的同时，培养良好的学习习惯。",
    cj:
      "5年教龄，累计辅导学生近2000人次，平均学生满意度95%以上，所辅导的学生多人考入985名校。",
    ry:
      "2016年某线下机构最受欢迎教师2017年某线下机构解题大赛第二名2018年某线下机构团队之光",
    ts: "",
    tstag: "中大名校学历，教学经验丰富",
    video:
      "https://player.bilibili.com/player.html?aid=82940772&cid=141895126&page=1",
    grade2: "高一、高二"
  },
  {
    code: "126",
    name: "程子豪",
    grade: "高二",
    sf: "语文",
    tags: "人大才子|公考状元|提分担当",
    num: "15371",
    percent: "99.6%",
    info:
      "中国人民大学毕业<br/>公考笔试面试双第一<br/>所教尖子班学生数百人考入北大、清华、人大、浙大、复旦、交大等“双一流”顶级名校<br/>所教逆袭班和高考特训班学生语文成绩平均提升20分",
    mj:
      "采用“三通”教学法，通方法，通规律，通思维，从根本上解决因为学习方法不当、知识储备贫乏和思维能力不够导致的语文成绩提升难问题。如果你最恨背、背、背，我来教你轻松高效的记忆方法；如果你最怕读、读、读，我来带你探寻文章的微言大义，体验读懂后豁然开朗的快意；如果你最惧写、写、写，跟我一起做一场思维的游戏，无压力的写作让你下笔如有神，笑傲考场。连续多年切中高考全国卷和地方卷作文题，靠的不是侥幸，而是能把握时代主题，洞察命题规律。",
    cj:
      "所教尖子班学生数百人考入北大、清华、人大、浙大、复旦、交大等“双一流”顶级名校，所教逆袭班和高考特训班学生语文成绩平均提升20分。近年来，尤其是转入线上教育后，致力于初高中语文一体化的研究和实践，重点做好初高中的衔接和贯通，夯实基础，形成体系，帮助数千名学生考入当地重点中学，并且在进入高中后语文成绩持续提升，保持领先。",
    ry:
      "2011年5月北京市海淀区优秀青年教师2012年5月北京市海淀区先进教育工作者2013年6月北京市海淀区优秀共产党员",
    ts:
      "指点江山，激扬文字，以语言为翅膀自由飞翔！从小学起参加各类演讲比赛从未出过三甲；在唇枪舌剑的辩论赛上常常一剑封喉斩获“最佳辩手”；主持晚会、对话名人、掌控论坛，于千万人之前游刃有余、从容不迫。细思量却发现语言的力量不是为了获胜，而是为了传递情感，启迪思想，于是我选择做一名老师。身经百战，精通考试法则，从竞争比高考还要惨烈的公务员考试中突出重围，夺得笔试面试双第一。蓦然回首才领悟到真正的风光不是别人羡慕的眼神，而是自己内心的安宁，于是我选择弃政从教，坚守初心！愿我能用自己对母语发自灵魂的热爱点燃你对语文的热情，点亮你的诗意青春！",
    tstag: "民大硕士，通方法，通规律，通思维",
    video: "",
    grade2: "初三、高二"
  },
  {
    code: "127",
    name: "郭韬",
    grade: "高二",
    sf: "物理",
    tags: "逻辑清晰|高考刷题王|全能型学霸",
    num: "13824",
    percent: "99.4%",
    info: "毕业院校：西北大学<br/>六年教龄<br/>在学校、某知名教育机构任教",
    mj:
      "【物理韬韬的高中物理四步进阶计划】See（演绎推理）：从物理学基本定义与概念开始，利用形式逻辑的方式展开演绎，形成整个高中物理的知识框架；Know（刻意练习）：理解知识要点，掌握匹配题型的解题方法，利用“母题—子题”的刻意练习方式，形成对解题的应激反应；Think（归纳总结）：从高效练习中抽象出各大知识模块的一般性原理，形成高中物理的核心思维、学科素养与解题题感；Fit（举一反三）：能够利用已有完备的知识体系与解题思维，适应任何难度的考试，在各类经典或创新题型中游刃有余。",
    cj:
      "1、所教学生中参加高考的考上全国排名前二十的学生约15人，大部分考上985、211院校；2、物理竞赛和自招班学生的国家级与省级获奖率高达80%；3、所教A-Level国际班学生中，国外名校录取率高达70%，包括麻省理工学院、德国柏林工业大学、多伦多大学等，其中2016年剑桥大学主办的物理竞赛全球一等奖获得者一名。",
    ry:
      "2015年4月西安某补习学校“最受学生欢迎的老师”2016年3月西安新东方“2015年度十大新秀教师”2017年10月喜马拉雅FM“十大人气主播”",
    ts:
      "好为人师，物理教学是我的专业，但单独一门学科无法显示我的“才华”。我会把物理与数学融合在一起，打通数理两科的任督二脉。我也会带领你走向知识殿堂，见识每一个定律背后不得不知的故事；我是稀有的阅读沉迷者，上至天文地理下到生儿育女，无书不读。我也是狂热的足球迷，即便凌晨2：45我也会爬起来看主队精彩的表演；我醉心传统艺术，有机会我会向你展示我的书法造诣；我钟情经典老歌，两种情况我会陷入“王者模式”，一个在讲台上，一个在KTV里；我追最新的《权力的游戏》，我也看社会无比的《小猪佩奇》；我和死党们晚上吃鸡，我也玩老掉牙的超级玛丽；我开心地笑，我也悄悄地哭；我是一名平凡的物理老师，同时也是地球上唯一一名这样的物理老师。我会让你爱上物理，爱上知识，爱上成长，爱上生活，爱上所有一切与爱有关的篇章。如果你不认识我，没关系。天空虽没有鸟的痕迹，但我已飞过。知识与时光的专列即将起航，我是物理韬韬，天青色等烟雨，而我在等你",
    tstag: "名校毕业，6年教龄",
    video: "",
    grade2: "高二"
  },
  {
    code: "128",
    name: "任晓",
    grade: "高三",
    sf: "化学",
    tags: "10年教龄|8年毕业班|中高考提分王",
    num: "130122",
    percent: "99.6%",
    info:
      "北京航空航天大学<br/>9年教龄，高中化学教师，7年毕业班经验<br/>企鹅辅导累计11W+学员<br/>主持编写《高考核心必考点》、《化学解题秘籍》等多部教辅",
    mj:
      "学习固然需要记忆，但是如果只记忆而忽视了对知识背后规律的探究和总结，只会让你事倍功半；考试检验的不仅仅是知识的掌握，更是我们思维灵活性和逻辑能力的考察。老师相信，万事皆有方法，掌握了正确方法就可以让你更快成功，学习、考试也是如此。在8年的教学过程中，老师总结了不同阶段的学生在学习化学过程中常见的知识障碍和思维方法误区，希望能通过课堂传授给你，帮助到你的学习和考试。",
    cj:
      "从教8年来，累计有20余名学生升入北大清华；上百人升入211院校，更有多名学生出国到欧洲或北美留学。更重要的是帮助更多的学生找到了适合自己的学习方法，让大家对化学不在畏惧，让学习成为轻松快乐的事。",
    ry: "2012年9月好学乐知奖优秀教师2014年9月百佳教师",
    ts:
      "化学是一门有趣的学科，化学知识的学习绝不仅仅是为了应对考试，它给了我们另一种看待世界的方式，可以让我们在探究周围世界时不囿于表象，通过纷纭的线下探究内在的规律。我们一起：让化学回归化学。",
    tstag: "企鹅辅导累计1lW+学员",
    video:
      "https://player.bilibili.com/player.html?aid=82891424&cid=141813462&page=1",
    grade2: "初三、高三"
  },
  {
    code: "129",
    name: "孙筱媛",
    grade: "高二",
    sf: "英语",
    tags: "语言学硕士|2年教龄|提分小能手",
    num: "15895",
    percent: "97.4%",
    info:
      "香港浸会大学语言学专业毕业<br/>曾到新加坡国立大学进行访学与交流<br/>原新东方教师",
    mj: "教学思路清晰，语言生活有趣。以独特的视角带领语言学习者探索语言世界。",
    cj:
      "所带学员提分者众多，考入一本院校人数过半。多名学员获得全国创新英语作文大赛奖项。",
    ry: "2013年全运会优秀志愿者",
    ts: "喜爱阅读，美食，摄影，旅行，岛屿爱好者；期待遇到更多有趣的人。",
    tstag: "以独特的视角探索语言世界。",
    video:
      "https://player.bilibili.com/player.html?aid=82941102&cid=141895800&page=1",
    grade2: "高二、高三"
  },
  {
    code: "130",
    name: "孙筱媛",
    grade: "高三",
    sf: "英语",
    tags: "语言学硕士|2年教龄|提分小能手",
    num: "15895",
    percent: "97.4%",
    info:
      "香港浸会大学语言学专业毕业<br/>曾到新加坡国立大学进行访学与交流<br/>原新东方教师",
    mj: "教学思路清晰，语言生活有趣。以独特的视角带领语言学习者探索语言世界。",
    cj:
      "所带学员提分者众多，考入一本院校人数过半。多名学员获得全国创新英语作文大赛奖项。",
    ry: "2013年全运会优秀志愿者",
    ts: "喜爱阅读，美食，摄影，旅行，岛屿爱好者；期待遇到更多有趣的人。",
    tstag: "以独特的视角探索语言世界。",
    video:
      "https://player.bilibili.com/player.html?aid=82941102&cid=141895800&page=1",
    grade2: "高二、高三"
  },
  {
    code: "131",
    name: "李琳",
    grade: "高三",
    sf: "物理",
    tags: "北京大学|11年教龄|思维女神",
    num: "91166",
    percent: "99.5%",
    info:
      "毕业于北京大学物理学院<br/>在知名教育机构、在线教育机构任教<br/>学生人数超过10万<br/>学生成绩进步，考入清华北大等名校",
    mj:
      "结合实例“化繁为简”，抽象概念具体化，达到举一反三的效果；采用“滚动练习法”,强化知识图谱，查漏补缺；物理学习中最重要的是思维方式的学习，题目只是训练思维的一种手段，采用正确的物理学习方法，能使物理学习变得简单。",
    cj:
      "从教以来，累计授课人次过万人，学生成绩稳步提升，辅导上百名学生考入常春藤名校及国内北大清华等重点大学。",
    ry: "2012年学而思“优秀老师称号”",
    ts:
      "有着80后的年龄，90后的态度，00后的心情，希望生活中的我们都能年轻一些，和时代一起进步。",
    tstag: "学生考清华北大的选择",
    video:
      "https://player.bilibili.com/player.html?aid=82941293&cid=141896259&page=1",
    grade2: "高三"
  },
  {
    code: "132",
    name: "张志君",
    grade: "高一",
    sf: "数学",
    tags: "幽默风趣|模板总结王|5年教学经验",
    num: "73259",
    percent: "99.1%",
    info:
      "广州某大型教育集团学科负责人—深研高考<br/>曾多次参加高考点评,并多次作为高考大型讲座主讲人<br/>多名学生考入中科大、复旦大学等985/211大学",
    mj:
      "善于逻辑分析，不仅能教会学生如何做题，更重要是教会他们题目分析的方法，做到举一反三，深度钻研高考，对考试模板和题型成竹在胸。",
    cj:
      "5年教龄，多年高考教材研发和编纂经验，累计学员已过千人。家长和学生好评率100%",
    ry: "",
    ts:
      "别名老司机，风趣幽默，开车带你领略数学之美，使你的数学从[2,+∞)到[6,+无穷)",
    tstag: "教会学生做题，更教会他们分析的方法",
    video:
      "https://player.bilibili.com/player.html?aid=82941170&cid=141895910&page=1",
    grade2: "高一、高三"
  },
  {
    code: "133",
    name: "张志君",
    grade: "高三",
    sf: "数学",
    tags: "幽默风趣|模板总结王|5年教学经验",
    num: "73259",
    percent: "99.1%",
    info:
      "广州某大型教育集团学科负责人—深研高考<br/>曾多次参加高考点评,并多次作为高考大型讲座主讲人<br/>多名学生考入中科大、复旦大学等985/211大学",
    mj:
      "善于逻辑分析，不仅能教会学生如何做题，更重要是教会他们题目分析的方法，做到举一反三，深度钻研高考，对考试模板和题型成竹在胸。",
    cj:
      "5年教龄，多年高考教材研发和编纂经验，累计学员已过千人。家长和学生好评率100%",
    ry: "",
    ts:
      "别名老司机，风趣幽默，开车带你领略数学之美，使你的数学从[2,+∞)到[6,+无穷)",
    tstag: "教会学生做题，更教会他们分析的方法",
    video:
      "https://player.bilibili.com/player.html?aid=82941170&cid=141895910&page=1",
    grade2: "高一、高三"
  },
  {
    code: "134",
    name: "郝望月",
    grade: "高一",
    sf: "英语",
    tags: "提分小能手|作文押题王|高冷硬实力",
    num: "160825",
    percent: "99.2%",
    info:
      "10年教龄、坑王、解题技巧达人<br/>新东方教育集团优秀教师<br/>美国俄亥俄州州立大学访问学者<br/>OSUteachingadvancedprogram<br/>TLT英国剑桥英语教学能力证书",
    mj:
      "阅读理解•不是连连看找相似，你‘理解’对方向了吗；完型填空•坑你没商量的母语翻译；作文•带着脚链翩翩起舞；连续2年压中课标Ⅰ作文，造福无数考生",
    cj:
      "自2010年从教以来，所教学生人数累计超过数万人，重点大学学生人数数百人；保送清华、北大、外国语、香港大学等名校数十余人；平均经过2年的学习，英语水平能保证高考130分的人数占学生总数的1/2",
    ry:
      "2011年9月新东方教育科技集团优秀新教师2012年12月新东方教育科技集体优秀教师",
    ts:
      "英语不仅是考试，是工具，更是你完善人格，思想走向成熟的必经之路，让我们玩儿转考试，纵向突破玻璃天花板！",
    tstag: "10年教龄，解题技巧达人",
    video:
      "https://player.bilibili.com/player.html?aid=82941752&cid=141897080&page=1",
    grade2: "高一、高三"
  },
  {
    code: "135",
    name: "郝望月",
    grade: "高三",
    sf: "英语",
    tags: "提分小能手|作文押题王|高冷硬实力",
    num: "160825",
    percent: "99.2%",
    info:
      "10年教龄、坑王、解题技巧达人<br/>新东方教育集团优秀教师<br/>美国俄亥俄州州立大学访问学者<br/>OSUteachingadvancedprogram<br/>TLT英国剑桥英语教学能力证书",
    mj:
      "阅读理解•不是连连看找相似，你‘理解’对方向了吗；完型填空•坑你没商量的母语翻译；作文•带着脚链翩翩起舞；连续2年压中课标Ⅰ作文，造福无数考生",
    cj:
      "自2010年从教以来，所教学生人数累计超过数万人，重点大学学生人数数百人；保送清华、北大、外国语、香港大学等名校数十余人；平均经过2年的学习，英语水平能保证高考130分的人数占学生总数的1/2",
    ry:
      "2011年9月新东方教育科技集团优秀新教师2012年12月新东方教育科技集体优秀教师",
    ts:
      "英语不仅是考试，是工具，更是你完善人格，思想走向成熟的必经之路，让我们玩儿转考试，纵向突破玻璃天花板！",
    tstag: "10年教龄，解题技巧达人",
    video:
      "https://player.bilibili.com/player.html?aid=82941752&cid=141897080&page=1",
    grade2: "高一、高三"
  },
  {
    code: "136",
    name: "吴一炯",
    grade: "高二",
    sf: "数学",
    tags: "竞赛一等奖|985院校|4年教龄",
    num: "37268",
    percent: "99.5%",
    info:
      "北京航空航天大学<br/>2008全国高中数学联赛一等奖、2009全国高中数学联赛二等奖<br/>2014-2016北京学而思、2017-至今企鹅辅导<br/>累计授课4000+小时<br/>累计数十人进入清北复交",
    mj:
      "讲题目，更讲方法讲套路，更讲思维讲考经，更讲原理教会你用数学的思维理解生活。",
    cj:
      "在职期间绝大多数时间均为S级（最高级）教师。所教学生基本为班级前十名，优秀学生为年级前十名。大多数学生考入重点大学，优秀者进入清北复交。",
    ry: "",
    ts:
      "解的了方程，撸的了代码。近可用概率论让你珍爱生命，远离赌博退可用博弈论帮你俘获女神，收获珍爱听过都说好！",
    tstag: "竞赛获奖的王者，清北复交的选择",
    video:
      "https://player.bilibili.com/player.html?aid=82946892&cid=141905840&page=1",
    grade2: "高二、高三"
  },
  {
    code: "137",
    name: "吴一炯",
    grade: "高三",
    sf: "数学",
    tags: "竞赛一等奖|985院校|4年教龄",
    num: "37268",
    percent: "99.5%",
    info:
      "北京航空航天大学<br/>2008全国高中数学联赛一等奖、2009全国高中数学联赛二等奖<br/>2014-2016北京学而思、2017-至今企鹅辅导<br/>累计授课4000+小时<br/>累计数十人进入清北复交",
    mj:
      "讲题目，更讲方法讲套路，更讲思维讲考经，更讲原理教会你用数学的思维理解生活。",
    cj:
      "在职期间绝大多数时间均为S级（最高级）教师。所教学生基本为班级前十名，优秀学生为年级前十名。大多数学生考入重点大学，优秀者进入清北复交。",
    ry: "",
    ts:
      "解的了方程，撸的了代码。近可用概率论让你珍爱生命，远离赌博退可用博弈论帮你俘获女神，收获珍爱听过都说好！",
    tstag: "竞赛获奖的王者，清北复交的选择",
    video:
      "https://player.bilibili.com/player.html?aid=82946892&cid=141905840&page=1",
    grade2: "高二、高三"
  },
  {
    code: "138",
    name: "何超世",
    grade: "高一",
    sf: "数学",
    tags: "高分锻造能手|优雅套路王|6年教龄",
    num: "119235",
    percent: "98.8%",
    info:
      "原某大型上市教育集团高考数学课程主讲人<br/>6年教龄,20轮高考毕业班教学经验<br/>累计授课时长5000小时<br/>线下培训受益学员近万人，线上受益学员60000<br/>考入985/211学员甚多",
    mj:
      "①干货满满：95%的干货+少量调节课堂氛围的搞笑②内容扎实，紧扣考纲，深挖高考数学一般规律；题型分类全面，精选例题，直指应试，让每一位学员都成为“押题者”；③独家编撰《高考数学计算力训练手册》，解决同学们计算不过关的“痛”；④提炼真题规律，总结常考核心，独家开发《高考数学秒杀干货》，能有效提高同学们解题的速度和准度，深得学员们喜爱；培养数学思维，探究数学方法，提高解题能力，夺取高考高分。“数学超市”领你走进数学世界，掌握解题套路，自信赢得高分。",
    cj:
      "6年教龄，累积授课时长5000+小时，20+轮次高考毕业班教学经验。从教以来，培训学员近万人，众多学员考入985/211，学员成绩提高迅速，成绩3个月内提高几十分者比比皆是。用心做课程，用诚造精品；“让学生乐于学，学得会并且考得好”致力于终生从事教育事业，唯有爱与教学不可辜负",
    ry: "2016年西安新东方学校优秀教师",
    ts:
      '热爱传统文化，喜欢国学，热爱书法，酷爱武侠；当然了，也热爱运动，比如乒乓、篮球等。上得了课堂，下得了厨房；炒得来川菜，也读得懂南北方。""数学超市""不只是提分的老师，更是一种生活方式。',
    tstag: "20轮高考毕业班教学经验",
    video:
      "https://player.bilibili.com/player.html?aid=82940527&cid=141894621&page=1",
    grade2: "高一、高三"
  },
  {
    code: "139",
    name: "何超世",
    grade: "高三",
    sf: "数学",
    tags: "高分锻造能手|优雅套路王|6年教龄",
    num: "119235",
    percent: "98.8%",
    info:
      "原某大型上市教育集团高考数学课程主讲人<br/>6年教龄,20轮高考毕业班教学经验<br/>累计授课时长5000小时<br/>线下培训受益学员近万人，线上受益学员60000<br/>考入985/211学员甚多",
    mj:
      "①干货满满：95%的干货+少量调节课堂氛围的搞笑②内容扎实，紧扣考纲，深挖高考数学一般规律；题型分类全面，精选例题，直指应试，让每一位学员都成为“押题者”；③独家编撰《高考数学计算力训练手册》，解决同学们计算不过关的“痛”；④提炼真题规律，总结常考核心，独家开发《高考数学秒杀干货》，能有效提高同学们解题的速度和准度，深得学员们喜爱；培养数学思维，探究数学方法，提高解题能力，夺取高考高分。“数学超市”领你走进数学世界，掌握解题套路，自信赢得高分。",
    cj:
      "6年教龄，累积授课时长5000+小时，20+轮次高考毕业班教学经验。从教以来，培训学员近万人，众多学员考入985/211，学员成绩提高迅速，成绩3个月内提高几十分者比比皆是。用心做课程，用诚造精品；“让学生乐于学，学得会并且考得好”致力于终生从事教育事业，唯有爱与教学不可辜负",
    ry: "2016年西安新东方学校优秀教师",
    ts:
      '热爱传统文化，喜欢国学，热爱书法，酷爱武侠；当然了，也热爱运动，比如乒乓、篮球等。上得了课堂，下得了厨房；炒得来川菜，也读得懂南北方。""数学超市""不只是提分的老师，更是一种生活方式。',
    tstag: "20轮高考毕业班教学经验",
    video:
      "https://player.bilibili.com/player.html?aid=82940527&cid=141894621&page=1",
    grade2: "高一、高三"
  },
  {
    code: "140",
    name: "段小寒",
    grade: "高三",
    sf: "英语",
    tags: "翻译硕士|资深教研员|细致入微",
    num: "688",
    percent: "99%",
    info:
      "翻译硕士<br/>资深教研员<br/>有多名学生考入北京大学、清华大学、上海交通大学、浙江大学、南京大学、北京航空航天大学、北京邮电大学等名校。",
    mj: "语法、完型、阅读、写作，看似彼此孤立，实则相辅相成！",
    cj:
      "自从我2007年教学以来，有多名学生考入北京大学、清华大学、上海交通大学、浙江大学、南京大学、北京航空航天大学、北京邮电大学。",
    ry: "2011年6月某知名教育机构英语高端名师",
    ts:
      "成功之花，人们只看到了她的明艳，却不知她早已浸透了奋斗的泪泉、洒满了牺牲的血雨。",
    tstag: "英语高端名师",
    video: "",
    grade2: "高三"
  },
  {
    code: "141",
    name: "高歌",
    grade: "高二",
    sf: "英语",
    tags: "常青藤名校|高分缔造者|时间规划狂",
    num: "84452",
    percent: "99.6%",
    info:
      "毕业于美国顶级名校常春藤联盟之一的康奈尔大学(CornellUniversity)<br/>原就职于新东方科技集团优能总部<br/>负责高中英语VPS教材编写和研发<br/>落地支持全国58个新东方地方学校、英国剑桥TKT教师资格持有者<br/>编写出版《8天提升英语阋读理解力》",
    mj:
      "授课思路独特，语言风趣幽默。以独特的工科专业背景探索文科世界，以丰富的教学经验和风趣幽默的语言给同学们带来独到的英语语法学习体验。",
    cj:
      "善于培养学生的学习习惯，让学生们从点滴改变开始，厚积薄发。长期学习下来，学生成绩提升明显。学生遍布海内外名校。",
    ry:
      "2010年韩国釜山政府奖学金获得者2013年国家级奖学金获得者2015年入选AguaClara项目赴洪都拉斯工程师",
    ts: "世界上从没有好走的路，让我们在更高处相逢。",
    tstag: "学生遍布海内外名校",
    video: "",
    grade2: "高二、高三"
  },
  {
    code: "142",
    name: "高歌",
    grade: "高三",
    sf: "英语",
    tags: "常青藤名校|高分缔造者|时间规划狂",
    num: "84452",
    percent: "99.6%",
    info:
      "毕业于美国顶级名校常春藤联盟之一的康奈尔大学(CornellUniversity)<br/>原就职于新东方科技集团优能总部<br/>负责高中英语VPS教材编写和研发<br/>落地支持全国58个新东方地方学校、英国剑桥TKT教师资格持有者<br/>编写出版《8天提升英语阋读理解力》",
    mj:
      "授课思路独特，语言风趣幽默。以独特的工科专业背景探索文科世界，以丰富的教学经验和风趣幽默的语言给同学们带来独到的英语语法学习体验。",
    cj:
      "善于培养学生的学习习惯，让学生们从点滴改变开始，厚积薄发。长期学习下来，学生成绩提升明显。学生遍布海内外名校。",
    ry:
      "2010年韩国釜山政府奖学金获得者2013年国家级奖学金获得者2015年入选AguaClara项目赴洪都拉斯工程师",
    ts: "世界上从没有好走的路，让我们在更高处相逢。",
    tstag: "学生遍布海内外名校",
    video: "",
    grade2: "高二、高三"
  },
  {
    code: "143",
    name: "孙雨朦",
    grade: "高一",
    sf: "英语",
    tags: "邻家大姐姐|港大教育学|备考小能手",
    num: "5548",
    percent: "98.9%",
    info:
      '毕业于香港大学<br/>陪同翻译、北京大学政治发展与政府管理研究所<br/>2018ICOIE"BestPaperAward；2018ICETC并发表论文于ACMPress<br/>“外研社京东杯”全国大学生辩论赛华北赛区三等奖<br/>“外研社杯”全国大学生演讲比赛山东复赛区二等奖',
    mj:
      "盯着屏幕学习感觉昏昏欲睡？今天抄下的笔记明天就忘？应试提分的同时也要搞出新花样，高中英语不再是你迈不过去的坎儿，跟着Sherry在一路砍分的途中，让考试英语也变得实用有趣起来。",
    cj: "善于激发学生学习的兴趣，谁说高考英语学习痛苦不堪，辅导课也能“上瘾”！",
    ry:
      "2014年10月“外研社杯”全国大学生演讲比赛山东区二等奖2015年3月第十八届“外研社京东杯”全国大学生辩论赛华北赛区三等奖2018年7月论文作为共同作者在2018ICOIE获得第一名2019年3月论文第一作者发表至ACMPress",
    ts:
      "可动可静，喜欢看书，阅读量不大但是看得杂，摄影（P图小能手），绘画，尤其喜欢画自家的丑猫。运动上面，熬夜看得了球（闹钟响了继续睡），跑步的时候最喜欢看天下足球，射箭（因为想象精灵王子一样酷炫），游泳。学习英语其实没那么难，就像你的每一个新兴趣一样，“喜欢—上手练—搞定”！",
    tstag: "激发学生学习兴趣的帮手",
    video: "",
    grade2: "高一"
  },
  {
    code: "144",
    name: "孙强",
    grade: "高一",
    sf: "数学",
    tags: "高考状元名师|11年教龄|清北制造机",
    num: "93072",
    percent: "99%",
    info:
      "湖北黄冈名师<br/>12年教龄<br/>清北+985高校制造机<br/>重本率在85%以上<br/>全国高中数学联赛国家二等奖",
    mj:
      "讲课激情，注重数学解题方法与技巧的归纳总结，善于激发学生的学习兴趣及培养学生的思维，善于激励及赏识学生，每一堂课都会让学生在快乐中学习，在学习中收获！",
    cj:
      "11年教龄，累计培训学员近3000人；2014年带出一个文科高考状元；带出清华、北大8人；国外著名学院12人；211/985类院校逾百人；所带学员提分较快，教学满意度非常高！",
    ry:
      "2017年深圳市中启现代教育金钻级教师2009年-2016年深圳市鼎力教育钻石级教师（最高级别）2008年邦德教育金牌员工，专业成绩第一",
    ts:
      "我的学生宝贝，很高兴能与你一起学习，我呢，除了会上课外，还喜欢唱歌（有点年代感的啦）、足球、篮球等，我想我肯定有与你相同的爱好，对吧？那么我俩是不是有很多共同的话题呀？所以呢，除了我是老师这个身份外，我更希望能成为你们的知心大哥哥，是朋友！我在等着你的到来哟！",
    tstag: "黄冈名师，985名校制造机",
    video: "",
    grade2: "高一"
  },
  {
    code: "145",
    name: "范伟哲",
    grade: "高一",
    sf: "英语",
    tags: "1万课时|剑桥大学培训师|高考押题王",
    num: "72036",
    percent: "97.6%",
    info:
      "剑桥大学CELTP/Strainer国际培训师<br/>参与国家级科研项目“英语本土化研究”语料库建设<br/>天利三十八套撰稿人，新东方英语杂志撰稿人<br/>原新东方教师培训师、教学管理部总监、优能教学总监<br/>1万小时教学经验，每年高考学员平均提分30-50分",
    mj:
      "独创阅读20个做题原则，满分解决干扰项，包你做题快准狠！25个法则搞定满分完形！精炼高考真题核心错误60个，帮你反复锤炼错误敏感度~三步完成写作句子升级，解决篇章结构逻辑问题~研究多年高考语料库，独家提炼高考真题语料库核心900词，教你背准单词，辨析单词~",
    cj:
      "教龄10年，所教学生人数累计超过1万人，所带学生考入:清北复交，港大，央美等知名学校。擅长量化分析高考英语内容，通过多年对高考的研究，建立中高考英语语料库，将高考英语考点拆解到250个。上课风格轻松幽默，带领学生迅速解决英语各个考点，快速掌握做题技巧！",
    ry:
      "2012年8月2012年知名教育机构网络十大名师2013年5月《新东方英语中学版》杂志撰稿人2017年1月剑桥大学英语教学能力tkt认证2018年2月剑桥大学celtp/strainer国际培训师",
    ts:
      "竭尽全力去争夺梦想，却因一分之差改变人生。希望能尽自己的力量，摸索考题的规律，与出题人斗智斗勇，只为帮助实现学生心中的梦!希望我的学生都能考上理想的大学，踏进心中向往的学府！",
    tstag: "万时教学经验，量化分析",
    video: "",
    grade2: "高一"
  },
  {
    code: "146",
    name: "杨小晴",
    grade: "高一",
    sf: "语文",
    tags: "5年教龄 | 省示范名校 | 可盐可甜",
    num: "5164",
    percent: "98%",
    info:
      "五年教龄，学员平均提分20-35分<br/>原某知名教育平台，初高中语文教学教研老师<br/>省示范公立校，高中语文老师",
    mj: "学员平均提分20-35分",
    cj:
      "五年教龄，学员平均提分20-35分。高三一模够不到及格线的神秘男子，高考光速提分40，圆梦清华。",
    ry: "",
    ts: "学员平均提分20-35分",
    tstag: "",
    video: "",
    grade2: "高一、高二"
  },
  {
    code: "147",
    name: "赵星义",
    grade: "高一",
    sf: "物理",
    tags: "授课1万小时 | 教师培训师 | 金牌教师",
    num: "81861",
    percent: "97.5%",
    info:
      "毕业于北京邮电大学，10年教龄，授课10000小时<br/>原新东方教学培训师，首批金牌教师<br/>原新东方分校教学负责人，原新东方在线高中项目负责人<br/>原北京陈经纶学校竞赛培优教练<br/>2019所带高考学员70%考入211、985院校",
    mj: "所带学员各物理竞赛斩获一等奖",
    cj:
      "2010年从教以来，所教学员过万，重点大学学生人数超百人，2019年所带重点班级70%学员考入985，211学校！更有学员通过参加培训高中物理力学竞赛，高中应用物理竞赛斩获一等奖。",
    ry:
      "2017年<br/>某在线教育平台金牌教师<br/>2018年<br/>某在线教育平台教学培训师",
    ts: "所带学员各物理竞赛斩获一等奖",
    tstag: "",
    video:
      "https://player.bilibili.com/player.html?aid=83283543&cid=142480218&page=1",
    grade2: "高一、高三"
  },
  {
    code: "148",
    name: "肖嵘",
    grade: "高一",
    sf: "化学",
    tags: "九年教龄 | 化学大教主 | 爱吃瓜的猹",
    num: "65517",
    percent: "98%",
    info:
      "化学专业硕士<br/>9年教龄，授课时长5000+，平均提分30+<br/>企鹅辅导化学主讲教师，新东方在线特级教研员<br/>2011年集团优秀教师称号，2017腾讯视频考试解析主讲人<br/>线下教学7年，线下学生1万+，线上学生10万+",
    mj: "学生从不及格到满分的神奇转变<br/>",
    cj:
      "自我2011年从教以来，所教学生人数累计超过3万人，重点大学学生人数数百人！所教学生从化学不及格到化学满分！",
    ry:
      "2008年9月<br/>北京市北京奥运会及残奥会荣誉证书<br/>2010年3月<br/>北京科技大学科技园创业大赛一等奖<br/>2011年9月<br/>某知名教育集团优秀教师",
    ts: "学生从不及格到满分的神奇转变<br/>",
    tstag: "",
    video: "",
    grade2: "初三、高一"
  },
  {
    code: "149",
    name: "云杉",
    grade: "高一",
    sf: "地理",
    tags: "高考提分专家 | 13年教龄 | 严谨有实力",
    num: "64910",
    percent: "99.6%",
    info:
      "部署师范大学毕业 教育硕士<br/>13年一线地理教学经验<br/>6万+人次授课经验<br/>学生考入985高校",
    mj: "熟悉初高中所有地理课程",
    cj:
      "自我2006年从教以来，所教学生荣获地理大奖无数，重点大学学生人数数百人！<br/>更有学生从地理一问三不知，到进步为文科重点班班级前三名。<br/>因为，我熟悉从七年级（初一）到高三的所有地理课程，更了解你们中的大多数初中地理几乎为零，短时间内要提升，要面对高考，良师益友是必须的哦！",
    ry:
      "2011年6月<br/>荣获中国地理学会 全国优秀指导教师一等奖暨百名先进个人<br/>2012年6月<br/>市级赛教二等奖<br/>2016年4月<br/>被聘为“国培计划（2016）”地理学科教学专家团队成员",
    ts: "熟悉初高中所有地理课程",
    tstag: "",
    video:
      "https://player.bilibili.com/player.html?aid=83283622&cid=142480129&page=1",
    grade2: ""
  },
  {
    code: "150",
    name: "张小丽",
    grade: "三年级",
    sf: "语文",
    tags: "中文系本硕|才貌双全|小学语文通",
    num: " 21403",
    percent: "99.1%",
    info:
      "东南大学中文系学习并保研<br/>某知名辅导平台面授老师<br/>某知名线上教育平台语文老师、年级负责人",
    mj: "知名线上教育平台教师年级负责人",
    cj:
      "任教以来，带领学生数超万余人，考入重点中学和重点高中数百人，指导学生作文获校级、省级优秀作文",
    ry: "",
    ts: "知名线上教育平台教师年级负责人",
    tstag: "",
    video: "",
    grade2: ""
  },
  {
    code: "151",
    name: "余卓颖",
    grade: "三年级",
    sf: "数学",
    tags: "中考数学满分 | 孩子王 | 逻辑超强",
    num: "32262",
    percent: "96.9%",
    info: "学员上万，提分30+<br/>90%学员明显进步<br/>重点升学率名列前茅",
    mj: "学员上万，提分30+",
    cj:
      "6年教龄，累计学员过万；辅导学生结业考试成绩均在95分以上，90%顺利升入重点学校；学员80%竞赛获奖，达到年级前十。",
    ry:
      "2016年-2017年<br/>希望杯教练员<br/>2017年-2019年<br/>知名在线教育平台“优秀教师奖”<br/>2017年-2018年<br/>被评为“全国十大优秀讲师”",
    ts: "学员上万，提分30+",
    tstag: "",
    video: "",
    grade2: ""
  },
  {
    code: "152",
    name: "王亚茹",
    grade: "三年级",
    sf: "编程",
    tags: "竞赛教练 | 创作引导者 | 综艺达人",
    num: "2152",
    percent: "97.3%",
    info:
      "毕业于华南师范大学<br/>5年教龄<br/>丰富的教学经验<br/>奥数教练<br/>蓝桥杯教练<br/>",
    mj: "华师大<br/>5年教龄<br/>经验丰富",
    cj:
      "在卓越教育教小学奥数期间，我所带的班级是所有校区第一名                  <br/>在小码精灵带队参加蓝桥杯，我所带的学生全员晋级",
    ry: "2017年<br/>某知名教育机构微课大赛第一名",
    ts: "华师大<br/>5年教龄<br/>经验丰富",
    tstag: "",
    video: "",
    grade2: "三年级、四年级、五年级"
  },
  {
    code: "153",
    name: "祝彩霞",
    grade: "三年级",
    sf: "科学",
    tags: "科普发烧友 | 孩子王",
    num: "465",
    percent: "98.6%",
    info: "火星人俱乐部<br/>前开封大学计算机软件基础课兼职老师",
    mj: "让学生爱上科学<br/>让学学奠定基础",
    cj:
      "在火星人俱乐部从教以来所教学生累计数百人，学生通过课堂爱上科学、奠定理科基础。",
    ry: "",
    ts: "让学生爱上科学<br/>让学学奠定基础",
    tstag: "",
    video: "",
    grade2: "三年级、四年级、五年级"
  },
  {
    code: "154",
    name: "李萌",
    grade: "三年级",
    sf: "科学",
    tags: "实验爱好者 | 学生的朋友 | 自黑幽默",
    num: "389",
    percent: "98.7%",
    info: "高思教育科学课<br/>前是火星人俱乐部的成员<br/>授课累计数百次<br/>",
    mj: "远离枯燥知识<br/>还原本来样子",
    cj:
      "自2016年来，通过直播，双师，线下等多种形式进行授课，累计人次数百次。带领学生参加创客比赛，通过视频科普栏目的形式吸引更多人爱上科学。",
    ry:
      "2018年6月<br/>全国创客类大赛 优秀教练员<br/>2019年11月<br/>高思教育“双师优秀主讲”",
    ts: "远离枯燥知识<br/>还原本来样子",
    tstag: "",
    video: "",
    grade2: "三年级、四年级、五年级"
  },
  {
    code: "155",
    name: "余剑勇",
    grade: "六年级",
    sf: "语文",
    tags: "武大中文系 | 文综高分 | 古文执念狂",
    num: "67267",
    percent: "98.2%",
    info:
      "武汉大学中文系<br/>在线语文首位辅导老师、校验负责人<br/>语文优秀老师<br/>获“最佳人气奖”与“口碑之星”奖",
    mj: "武大中文系<br/>在线语文首位辅导老师",
    cj:
      "自2011年从教以来，所教学生人数2万+，重点中学学生人数数百人！学生在完成课堂学习之后，语文学习兴趣大增，语文学习方法更为科学，逐步建立起自己的语文学科思维。",
    ry:
      "2011年-2013年<br/>国家奖学金获得者、武汉大学校级多项科研组织者<br/>2016年<br/>获某在线机构“年度优秀老师”奖<br/>2017年<br/>获某在线机构“最佳人气奖”与“口碑之星”奖",
    ts: "武大中文系<br/>在线语文首位辅导老师",
    tstag: "",
    video: "",
    grade2: ""
  },
  {
    code: "156",
    name: "颜君",
    grade: "初一",
    sf: "英语",
    tags: "海外硕士 | 10年教龄 | 颜师出高徒",
    num: "73729",
    percent: "97%",
    info:
      "10年教龄、英语专业8级、雅思8.5<br/>累计培养10000+名中考英语高分得主成功晋级全国TOP100高中<br/>中考提分最高达69分<br/>原好未来金牌讲师，教研项目负责人<br/>原北京学教育中学总经理、原湖南诚教学教研总监",
    mj: "",
    cj:
      "从业十载，多位高中学员考进宾夕法尼亚大学、浙江大学、厦门大学等国内外顶尖学府，多位初中学员考进人大附中、实验中学、北京八中、长郡中学、南雅中学等全国重点高中，数十位小学学员顺利通过KET、PET及三一口语等国际知名英语水平测评。",
    ry:
      "2008年-2009年<br/>湖南省科技翻译大赛二等奖<br/>2009年-2010年<br/>国家二等奖学金<br/>2013年-2014年<br/>某知名在线教育平台金牌讲师",
    ts: "",
    tstag: "",
    video: "",
    grade2: ""
  },
  {
    code: "157",
    name: "闫静",
    grade: "一年级",
    sf: "科学",
    tags: "教育学硕士 | 7年教龄 | 戏精",
    num: "357",
    percent: "98.6%",
    info: "国家二级心理咨询师<br/>教育学硕士 <br/> 7年教龄",
    mj: "",
    cj: "",
    ry: "国家二级心理咨询师",
    ts: "",
    tstag: "",
    video: "",
    grade2: "一年级、二年级"
  },
  {
    code: "158",
    name: "祁丽亚",
    grade: "一年级",
    sf: "科学",
    tags: "北大学霸 | 科学实验爱好者",
    num: "69",
    percent: "98.5%",
    info:
      "北京大学的硕士博士<br/>哈佛大学工学学院访问学者 <br/> 科学实验爱好者",
    mj: "",
    cj: "",
    ry: "",
    ts: "",
    tstag: "",
    video: "",
    grade2: "一年级、二年级"
  }
];

var vconditions = [
  { grade: "初二", subject: "语文", dates:"秋季课", video: "37" },
  { grade: "初二", subject: "数学", dates:"秋季课", video: "39" },
  { grade: "初二", subject: "数学", dates:"秋季课", video: "42" },
  { grade: "初二", subject: "数学", dates:"秋季课", video: "46" },
  { grade: "初二", subject: "物理", dates:"秋季课", video: "53" },
  { grade: "初二", subject: "物理", dates:"秋季课", video: "61" },
  { grade: "初二", subject: "物理", dates:"秋季课", video: "64" },
  { grade: "初二", subject: "数学", dates:"秋季课", video: "70" },
  { grade: "初二", subject: "物理", dates:"秋季课", video: "73" },
  { grade: "初二", subject: "数学", dates:"秋季课", video: "86" },
  { grade: "初二", subject: "物理", dates:"秋季课", video: "89" },
  { grade: "初二", subject: "英语", dates:"秋季课", video: "90" },
  { grade: "初二", subject: "英语", dates:"秋季课", video: "91" },
  { grade: "初二", subject: "物理", dates:"秋季课", video: "93" },
  { grade: "初二", subject: "数学", dates:"秋季课", video: "94" },
  { grade: "初二", subject: "语文", dates:"秋季课", video: "95" },
  { grade: "初二", subject: "英语", dates:"秋季课", video: "96" },
  { grade: "初二", subject: "语文", dates:"秋季课", video: "97" },
  { grade: "初三", subject: "数学", dates:"秋季课", video: "43" },
  { grade: "初三", subject: "数学", dates:"秋季课", video: "47" },
  { grade: "初三", subject: "数学", dates:"秋季课", video: "50" },
  { grade: "初三", subject: "数学", dates:"秋季课", video: "51" },
  { grade: "初三", subject: "化学", dates:"秋季课", video: "66" },
  { grade: "初三", subject: "物理", dates:"秋季课", video: "68" },
  { grade: "初三", subject: "数学", dates:"秋季课", video: "69" },
  { grade: "初三", subject: "物理", dates:"秋季课", video: "72" },
  { grade: "初三", subject: "化学", dates:"秋季课", video: "75" },
  { grade: "初三", subject: "数学", dates:"秋季课", video: "76" },
  { grade: "初三", subject: "语文", dates:"秋季课", video: "80" },
  { grade: "初三", subject: "化学", dates:"秋季课", video: "82" },
  { grade: "初三", subject: "英语", dates:"秋季课", video: "98" },
  { grade: "初三", subject: "物理", dates:"秋季课", video: "99" },
  { grade: "初三", subject: "英语", dates:"秋季课", video: "100" },
  { grade: "初三", subject: "物理", dates:"秋季课", video: "101" },
  { grade: "初三", subject: "语文", dates:"秋季课", video: "102" },
  { grade: "初三", subject: "数学", dates:"秋季课", video: "103" },
  { grade: "初三", subject: "英语", dates:"秋季课", video: "104" },
  { grade: "初三", subject: "物理", dates:"秋季课", video: "105" },
  { grade: "初三", subject: "化学", dates:"秋季课", video: "189" },
  { grade: "初一", subject: "语文", dates:"秋季课", video: "35" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "38" },
  { grade: "初一", subject: "语文", dates:"秋季课", video: "40" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "41" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "44" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "45" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "48" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "49" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "56" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "57" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "58" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "59" },
  { grade: "初一", subject: "英语", dates:"秋季课", video: "60" },
  { grade: "初一", subject: "英语", dates:"秋季课", video: "62" },
  { grade: "初一", subject: "语文", dates:"秋季课", video: "65" },
  { grade: "初一", subject: "语文", dates:"秋季课", video: "67" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "71" },
  { grade: "初一", subject: "英语", dates:"秋季课", video: "74" },
  { grade: "初一", subject: "英语", dates:"秋季课", video: "77" },
  { grade: "初一", subject: "语文", dates:"秋季课", video: "78" },
  { grade: "初一", subject: "语文", dates:"秋季课", video: "79" },
  { grade: "初一", subject: "英语", dates:"秋季课", video: "83" },
  { grade: "初一", subject: "数学", dates:"秋季课", video: "84" },
  { grade: "初一", subject: "语文", dates:"秋季课", video: "85" },
  { grade: "初一", subject: "英语", dates:"秋季课", video: "188" },
  { grade: "高二", subject: "语文", dates:"秋季课", video: "106" },
  { grade: "高二", subject: "数学", dates:"秋季课", video: "108" },
  { grade: "高二", subject: "化学", dates:"秋季课", video: "110" },
  { grade: "高二", subject: "化学", dates:"秋季课", video: "111" },
  { grade: "高二", subject: "语文", dates:"秋季课", video: "115" },
  { grade: "高二", subject: "物理", dates:"秋季课", video: "120" },
  { grade: "高二", subject: "英语", dates:"秋季课", video: "131" },
  { grade: "高二", subject: "生物", dates:"秋季课", video: "135" },
  { grade: "高二", subject: "历史", dates:"秋季课", video: "139" },
  { grade: "高二", subject: "化学", dates:"秋季课", video: "141" },
  { grade: "高二", subject: "化学", dates:"秋季课", video: "142" },
  { grade: "高二", subject: "化学", dates:"秋季课", video: "143" },
  { grade: "高二", subject: "语文", dates:"秋季课", video: "144" },
  { grade: "高二", subject: "物理", dates:"秋季课", video: "145" },
  { grade: "高二", subject: "物理", dates:"秋季课", video: "146" },
  { grade: "高二", subject: "英语", dates:"秋季课", video: "147" },
  { grade: "高二", subject: "英语", dates:"秋季课", video: "148" },
  { grade: "高二", subject: "数学", dates:"秋季课", video: "149" },
  { grade: "高二", subject: "数学", dates:"秋季课", video: "150" },
  { grade: "高二", subject: "数学", dates:"秋季课", video: "151" },
  { grade: "高二", subject: "数学", dates:"秋季课", video: "152" },
  { grade: "高三", subject: "化学", dates:"秋季课", video: "128" },
  { grade: "高三", subject: "政治", dates:"秋季课", video: "134" },
  { grade: "高三", subject: "生物", dates:"秋季课", video: "137" },
  { grade: "高三", subject: "地理", dates:"秋季课", video: "140" },
  { grade: "高三", subject: "语文", dates:"秋季课", video: "153" },
  { grade: "高三", subject: "化学", dates:"秋季课", video: "154" },
  { grade: "高三", subject: "英语", dates:"秋季课", video: "155" },
  { grade: "高三", subject: "物理", dates:"秋季课", video: "156" },
  { grade: "高三", subject: "数学", dates:"秋季课", video: "157" },
  { grade: "高三", subject: "英语", dates:"秋季课", video: "158" },
  { grade: "高三", subject: "数学", dates:"秋季课", video: "159" },
  { grade: "高三", subject: "数学", dates:"秋季课", video: "160" },
  { grade: "高三", subject: "英语", dates:"秋季课", video: "161" },
  { grade: "高三", subject: "物理", dates:"秋季课", video: "162" },
  { grade: "高三", subject: "英语", dates:"秋季课", video: "163" },
  { grade: "高三", subject: "语文", dates:"秋季课", video: "164" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "107" },
  { grade: "高一", subject: "化学", dates:"秋季课", video: "109" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "112" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "113" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "114" },
  { grade: "高一", subject: "语文", dates:"秋季课", video: "118" },
  { grade: "高一", subject: "物理", dates:"秋季课", video: "119" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "122" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "124" },
  { grade: "高一", subject: "生物", dates:"秋季课", video: "125" },
  { grade: "高一", subject: "语文", dates:"秋季课", video: "127" },
  { grade: "高一", subject: "英语", dates:"秋季课", video: "130" },
  { grade: "高一", subject: "语文", dates:"秋季课", video: "132" },
  { grade: "高一", subject: "政治", dates:"秋季课", video: "133" },
  { grade: "高一", subject: "地理", dates:"秋季课", video: "136" },
  { grade: "高一", subject: "历史", dates:"秋季课", video: "138" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "165" },
  { grade: "高一", subject: "英语", dates:"秋季课", video: "166" },
  { grade: "高一", subject: "英语", dates:"秋季课", video: "167" },
  { grade: "高一", subject: "化学", dates:"秋季课", video: "168" },
  { grade: "高一", subject: "化学", dates:"秋季课", video: "169" },
  { grade: "高一", subject: "数学", dates:"秋季课", video: "170" },
  { grade: "高一", subject: "物理", dates:"秋季课", video: "171" },
  { grade: "高一", subject: "英语", dates:"秋季课", video: "172" },
  { grade: "高一", subject: "物理", dates:"秋季课", video: "173" },
  { grade: "高一", subject: "化学", dates:"秋季课", video: "174" },
  { grade: "高一", subject: "地理", dates:"秋季课", video: "175" },
  { grade: "六年级", subject: "英语",dates:"秋季课",  video: "4"},
  { grade: "六年级", subject: "数学",dates:"秋季课",  video: "12" },
  { grade: "六年级", subject: "语文",dates:"秋季课",  video: "18" },
  { grade: "六年级", subject: "数学",dates:"秋季课",  video: "19" },
  { grade: "六年级", subject: "数学",dates:"秋季课",  video: "20" },
  { grade: "六年级", subject: "语文",dates:"秋季课",  video: "23" },
  { grade: "六年级", subject: "数学",dates:"秋季课",  video: "33" },
  { grade: "六年级", subject: "数学",dates:"秋季课",  video: "34" },
  { grade: "六年级", subject: "语文",dates:"秋季课",  video: "187"},
  { grade: "三年级", subject: "语文",dates:"秋季课",  video: "1" },
  { grade: "三年级", subject: "语文",dates:"秋季课",  video: "15" },
  { grade: "三年级", subject: "数学",dates:"秋季课",  video: "24" },
  { grade: "三年级", subject: "数学",dates:"秋季课",  video: "29"},
  { grade: "三年级", subject: "数学",dates:"秋季课",  video: "176"},
  { grade: "三年级", subject: "英语",dates:"秋季课",  video: "177" },
  { grade: "三年级", subject: "编程",dates:"秋季课",  video: "178" },
  { grade: "三年级", subject: "科学",dates:"秋季课",  video: "179" },
  { grade: "三年级", subject: "科学",dates:"秋季课",  video: "180" },
  { grade: "四年级", subject: "英语",dates:"秋季课",  video: "6" },
  { grade: "四年级", subject: "数学",dates:"秋季课",  video: "13" },
  { grade: "四年级", subject: "语文",dates:"秋季课",  video: "16" },
  { grade: "四年级", subject: "语文",dates:"秋季课",  video: "17" },
  { grade: "四年级", subject: "英语",dates:"秋季课",  video: "22" },
  { grade: "四年级", subject: "数学",dates:"秋季课",  video: "26" },
  { grade: "四年级", subject: "数学",dates:"秋季课",  video: "27" },
  { grade: "四年级", subject: "数学",dates:"秋季课",  video: "28" },
  { grade: "四年级", subject: "数学",dates:"秋季课",  video: "30" },
  { grade: "四年级", subject: "编程",dates:"秋季课",  video: "181" },
  { grade: "四年级", subject: "科学",dates:"秋季课",  video: "182" },
  { grade: "四年级", subject: "科学",dates:"秋季课",  video: "183" },
  { grade: "五年级", subject: "语文",dates:"秋季课",  video: "5" },
  { grade: "五年级", subject: "英语",dates:"秋季课",  video: "7" },
  { grade: "五年级", subject: "语文",dates:"秋季课",  video: "8" },
  { grade: "五年级", subject: "语文",dates:"秋季课",  video: "9" },
  { grade: "五年级", subject: "语文",dates:"秋季课",  video: "10" },
  { grade: "五年级", subject: "数学",dates:"秋季课",  video: "11" },
  { grade: "五年级", subject: "数学",dates:"秋季课",  video: "14" },
  { grade: "五年级", subject: "数学",dates:"秋季课",  video: "31" },
  { grade: "五年级", subject: "数学",dates:"秋季课",  video: "32" },
  { grade: "五年级", subject: "编程",dates:"秋季课",  video: "184" },
  { grade: "五年级", subject: "科学",dates:"秋季课",  video: "185" },
  { grade: "五年级", subject: "科学",dates:"秋季课",  video: "186" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "42" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "46" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "53" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "61" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "64" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "70" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "73" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "86" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "89" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "90" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "91" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "93" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "94" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "95" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "96" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "97" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "43" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "47" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "50" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "51" },
  { grade: "初中", subject: "化学",dates:"秋季课",  video: "66" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "68" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "69" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "72" },
  { grade: "初中", subject: "化学",dates:"秋季课",  video: "75" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "76" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "80" },
  { grade: "初中", subject: "化学",dates:"秋季课",  video: "82" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "98" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "99" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "100" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "101" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "102" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "103" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "104" },
  { grade: "初中", subject: "物理",dates:"秋季课",  video: "105" },
  { grade: "初中", subject: "化学",dates:"秋季课",  video: "189" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "35" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "38" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "40" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "41" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "44" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "45" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "48" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "49" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "56" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "57" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "58" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "59" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "60" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "62" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "65" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "67" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "71" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "74" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "77" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "78" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "79" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "83" },
  { grade: "初中", subject: "数学",dates:"秋季课",  video: "84" },
  { grade: "初中", subject: "语文",dates:"秋季课",  video: "85" },
  { grade: "初中", subject: "英语",dates:"秋季课",  video: "188" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "106" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "108" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "110" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "111" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "115" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "120" },
  { grade: "高中", subject: "生物",dates:"秋季课",  video: "135" },
  { grade: "高中", subject: "历史",dates:"秋季课",  video: "139" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "141" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "142" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "143" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "144" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "145" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "146" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "148" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "149" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "150" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "151" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "152" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "128" },
  { grade: "高中", subject: "生物",dates:"秋季课",  video: "137" },
  { grade: "高中", subject: "地理",dates:"秋季课",  video: "140" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "153" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "154" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "155" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "156" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "157" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "158" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "159" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "160" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "161" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "162" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "163" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "164" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "107" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "109" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "112" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "113" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "114" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "118" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "119" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "122" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "124" },
  { grade: "高中", subject: "生物",dates:"秋季课",  video: "125" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "127" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "130" },
  { grade: "高中", subject: "语文",dates:"秋季课",  video: "132" },
  { grade: "高中", subject: "政治",dates:"秋季课",  video: "133" },
  { grade: "高中", subject: "地理",dates:"秋季课",  video: "136" },
  { grade: "高中", subject: "历史",dates:"秋季课",  video: "138" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "165" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "166" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "167" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "168" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "169" },
  { grade: "高中", subject: "数学",dates:"秋季课",  video: "170" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "171" },
  { grade: "高中", subject: "英语",dates:"秋季课",  video: "172" },
  { grade: "高中", subject: "物理",dates:"秋季课",  video: "173" },
  { grade: "高中", subject: "化学",dates:"秋季课",  video: "174" },
  { grade: "高中", subject: "地理",dates:"秋季课",  video: "175" },
  // { grade: "小学", video: "4" ,dates:"春季课"},
  { grade: "小学", subject: "英语",dates:"秋季课", video: "4"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "12" },
  { grade: "小学", subject: "语文",dates:"秋季课", video: "18" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "19" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "20"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "23"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "33" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "34"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "187"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "1"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "15" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "24" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "29" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "176"},
  { grade: "小学", subject: "英语",dates:"秋季课", video: "177" },
  { grade: "小学", subject: "英语",dates:"秋季课", video: "6"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "16"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "17" },
  { grade: "小学", subject: "英语",dates:"秋季课", video: "22"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "26" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "27" },
  { grade: "小学", subject: "数学",dates:"秋季课", video: "28"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "30" },
  { grade: "小学", subject: "语文",dates:"秋季课", video: "5" },
  { grade: "小学", subject: "英语",dates:"秋季课", video: "7"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "8"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "9"},
  { grade: "小学", subject: "语文",dates:"秋季课", video: "10"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "11"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "14"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "31"},
  { grade: "小学", subject: "数学",dates:"秋季课", video: "32" },
  { grade: "小学", subject: "编程",dates:"秋季课", video: "184"},
  { grade: "小学", subject: "科学",dates:"秋季课", video: "185" },
  { grade: "小学", subject: "科学",dates:"秋季课", video: "186" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "42" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "46"},
  { grade: "全部", subject: "物理",dates:"秋季课", video: "53" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "61" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "64" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "70" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "73" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "86" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "89" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "90" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "91" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "93" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "94" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "95" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "96" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "97" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "43" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "47" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "50" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "51" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "66" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "68" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "69" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "72" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "75" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "76" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "80" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "82" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "98" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "99" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "100" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "101" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "102" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "103" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "104" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "105" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "189" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "35" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "38" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "40" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "41" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "44" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "45" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "48" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "49" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "56" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "57" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "58" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "59" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "60" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "62" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "65" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "67" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "71" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "74" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "77" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "78" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "79" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "83" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "84" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "85" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "188" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "106" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "108" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "110" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "111" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "115" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "120" },
  { grade: "全部", subject: "生物",dates:"秋季课", video: "135" },
  { grade: "全部", subject: "历史",dates:"秋季课", video: "139" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "141" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "142" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "143" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "144" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "145" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "146" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "148" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "149" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "150" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "151" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "152" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "128" },
  { grade: "全部", subject: "生物",dates:"秋季课", video: "137" },
  { grade: "全部", subject: "地理",dates:"秋季课", video: "140" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "153" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "154" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "155" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "156" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "157" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "158" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "159" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "160" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "161" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "162" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "163" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "164" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "107" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "109" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "112" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "113" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "114" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "118" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "119" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "122" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "124" },
  { grade: "全部", subject: "生物",dates:"秋季课", video: "125" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "127" },
  { grade: "全部", subject: "语文",dates:"秋季课", video: "132" },
  { grade: "全部", subject: "政治",dates:"秋季课", video: "133" },
  { grade: "全部", subject: "地理",dates:"秋季课", video: "136" },
  { grade: "全部", subject: "历史",dates:"秋季课", video: "138" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "165" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "166" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "167" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "168" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "169" },
  { grade: "全部", subject: "数学",dates:"秋季课", video: "170" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "171" },
  { grade: "全部", subject: "英语",dates:"秋季课", video: "172" },
  { grade: "全部", subject: "物理",dates:"秋季课", video: "173" },
  { grade: "全部", subject: "化学",dates:"秋季课", video: "174" },
  { grade: "全部", subject: "地理",dates:"秋季课", video: "175" },
  { grade: "全部", subject: "英语", dates:"秋季课", video: "4" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "12" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "18" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "19" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "20" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "23" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "33" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "34" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "187" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "1" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "15" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "24" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "29" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "176" },
  { grade: "全部", subject: "英语", dates:"秋季课", video: "177" },
  { grade: "全部", subject: "英语", dates:"秋季课", video: "6" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "16" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "17" },
  { grade: "全部", subject: "英语", dates:"秋季课", video: "22" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "26" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "27" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "28" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "30" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "5" },
  { grade: "全部", subject: "英语", dates:"秋季课", video: "7" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "8" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "9" },
  { grade: "全部", subject: "语文", dates:"秋季课", video: "10" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "11" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "14" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "31" },
  { grade: "全部", subject: "数学", dates:"秋季课", video: "32" },
  { grade: "全部", subject: "编程", dates:"秋季课", video: "184"},
  { grade: "全部", subject: "科学", dates:"秋季课", video: "185"},
  { grade: "全部", subject: "科学", dates:"秋季课", video: "186"},

  { grade: '高中', subject: '语文', dates:'春季课', video: '190' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '191' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '192' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '193' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '194' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '195' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '196' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '197' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '198' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '199' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '200' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '201' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '202' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '203' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '204' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '205' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '206' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '207' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '208' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '209' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '210' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '211' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '212' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '213' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '214' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '215' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '216' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '217' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '218' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '219' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '220' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '221' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '222' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '223' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '224' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '225' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '226' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '227' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '228' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '229' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '230' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '231' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '232' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '233' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '234' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '235' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '236' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '237' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '238' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '239' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '240' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '241' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '242' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '243' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '244' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '245' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '246' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '247' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '248' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '249' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '250' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '251' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '252' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '253' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '254' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '255' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '256' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '257' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '258' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '259' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '260' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '261' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '262' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '263' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '264' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '265' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '266' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '267' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '268' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '269' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '270' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '271' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '272' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '273' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '274' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '275' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '276' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '277' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '278' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '279' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '280' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '281' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '282' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '283' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '284' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '285' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '286' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '287' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '288' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '289' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '290' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '291' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '292' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '293' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '294' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '295' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '296' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '297' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '298' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '299' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '300' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '301' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '302' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '303' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '304' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '305' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '306' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '307' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '308' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '309' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '310' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '311' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '312' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '313' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '314' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '315' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '316' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '317' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '318' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '319' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '320' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '321' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '322' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '323' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '324' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '325' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '326' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '327' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '328' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '329' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '330' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '331' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '332' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '333' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '334' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '335' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '336' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '337' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '338' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '339' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '340' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '341' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '342' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '343' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '344' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '345' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '346' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '347' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '348' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '349' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '350' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '351' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '352' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '353' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '354' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '355' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '356' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '357' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '358' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '359' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '360' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '361' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '362' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '363' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '364' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '365' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '366' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '367' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '368' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '369' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '370' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '371' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '372' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '373' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '374' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '375' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '376' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '377' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '378' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '379' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '380' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '381' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '382' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '383' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '384' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '385' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '386' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '387' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '388' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '389' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '390' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '391' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '392' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '393' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '394' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '395' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '396' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '397' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '398' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '399' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '400' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '401' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '402' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '403' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '404' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '405' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '406' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '407' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '408' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '409' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '410' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '411' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '412' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '413' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '414' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '415' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '416' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '417' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '418' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '419' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '420' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '421' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '422' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '423' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '424' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '425' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '426' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '427' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '428' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '429' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '430' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '431' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '432' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '433' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '434' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '435' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '436' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '437' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '438' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '439' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '440' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '441' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '442' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '443' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '444' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '445' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '446' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '447' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '448' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '449' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '450' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '451' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '452' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '453' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '454' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '455' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '456' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '457' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '458' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '459' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '460' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '461' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '462' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '463' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '464' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '465' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '466' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '467' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '468' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '469' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '470' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '471' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '472' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '473' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '474' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '475' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '476' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '477' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '478' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '479' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '480' },

  { grade: '高一', subject: '语文', dates:'春季课', video: '190' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '191' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '192' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '193' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '194' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '195' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '196' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '197' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '198' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '199' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '200' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '201' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '202' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '203' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '204' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '205' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '206' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '207' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '208' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '209' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '210' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '211' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '212' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '213' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '214' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '215' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '216' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '217' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '218' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '219' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '220' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '221' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '222' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '223' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '224' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '225' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '226' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '227' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '228' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '229' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '230' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '231' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '232' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '233' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '234' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '235' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '236' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '237' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '238' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '239' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '240' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '241' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '242' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '243' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '244' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '245' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '246' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '247' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '248' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '249' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '250' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '251' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '252' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '253' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '254' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '255' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '256' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '257' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '258' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '259' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '260' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '261' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '262' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '263' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '264' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '265' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '266' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '267' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '268' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '269' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '270' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '271' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '272' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '273' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '274' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '275' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '276' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '277' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '278' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '279' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '280' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '281' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '282' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '283' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '284' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '285' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '286' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '287' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '288' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '289' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '290' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '291' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '292' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '293' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '294' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '295' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '296' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '297' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '298' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '299' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '300' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '301' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '302' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '303' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '304' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '305' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '306' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '307' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '308' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '309' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '310' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '311' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '312' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '313' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '314' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '315' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '316' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '317' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '318' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '319' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '320' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '321' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '322' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '323' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '324' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '325' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '326' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '327' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '328' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '329' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '330' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '331' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '332' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '333' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '334' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '335' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '336' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '337' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '338' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '339' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '340' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '341' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '342' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '343' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '344' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '345' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '346' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '347' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '348' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '349' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '350' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '351' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '352' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '353' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '354' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '355' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '356' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '357' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '358' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '359' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '360' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '361' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '362' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '363' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '364' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '365' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '366' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '367' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '368' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '369' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '370' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '371' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '372' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '373' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '374' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '375' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '376' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '377' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '378' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '379' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '380' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '381' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '382' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '383' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '384' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '385' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '386' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '387' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '388' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '389' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '390' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '391' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '392' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '393' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '394' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '395' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '396' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '397' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '398' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '399' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '400' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '401' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '402' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '403' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '404' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '405' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '406' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '407' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '408' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '409' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '410' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '411' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '412' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '413' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '414' },
  { grade: '高二', subject: '生物', dates:'春季课', video: '415' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '416' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '417' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '418' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '419' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '420' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '421' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '422' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '423' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '424' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '425' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '426' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '427' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '428' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '429' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '430' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '431' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '432' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '433' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '434' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '435' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '436' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '437' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '438' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '439' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '440' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '441' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '442' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '443' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '444' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '445' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '446' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '447' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '448' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '449' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '450' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '451' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '452' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '453' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '454' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '455' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '456' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '457' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '458' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '459' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '460' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '461' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '462' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '463' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '464' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '465' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '466' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '467' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '468' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '469' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '470' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '471' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '472' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '473' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '474' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '475' },
  { grade: '高二', subject: '数学', dates:'春季课', video: '476' },
  { grade: '高二', subject: '物理', dates:'春季课', video: '477' },
  { grade: '高二', subject: '化学', dates:'春季课', video: '478' },
  { grade: '高二', subject: '英语', dates:'春季课', video: '479' },
  { grade: '高二', subject: '语文', dates:'春季课', video: '480' },


  { grade: '全部', subject: '语文', dates:'春季课', video: '190' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '191' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '192' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '193' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '194' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '195' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '196' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '197' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '198' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '199' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '200' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '201' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '202' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '203' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '204' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '205' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '206' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '207' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '208' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '209' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '210' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '211' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '212' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '213' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '214' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '215' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '216' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '217' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '218' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '219' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '220' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '221' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '222' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '223' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '224' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '225' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '226' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '227' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '228' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '229' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '230' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '231' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '232' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '233' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '234' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '235' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '236' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '237' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '238' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '239' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '240' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '241' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '242' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '243' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '244' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '245' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '246' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '247' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '248' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '249' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '250' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '251' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '252' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '253' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '254' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '255' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '256' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '257' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '258' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '259' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '260' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '261' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '262' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '263' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '264' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '265' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '266' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '267' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '268' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '269' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '270' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '271' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '272' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '273' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '274' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '275' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '276' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '277' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '278' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '279' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '280' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '281' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '282' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '283' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '284' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '285' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '286' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '287' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '288' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '289' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '290' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '291' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '292' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '293' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '294' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '295' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '296' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '297' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '298' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '299' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '300' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '301' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '302' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '303' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '304' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '305' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '306' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '307' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '308' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '309' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '310' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '311' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '312' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '313' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '314' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '315' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '316' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '317' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '318' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '319' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '320' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '321' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '322' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '323' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '324' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '325' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '326' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '327' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '328' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '329' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '330' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '331' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '332' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '333' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '334' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '335' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '336' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '337' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '338' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '339' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '340' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '341' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '342' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '343' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '344' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '345' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '346' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '347' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '348' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '349' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '350' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '351' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '352' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '353' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '354' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '355' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '356' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '357' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '358' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '359' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '360' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '361' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '362' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '363' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '364' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '365' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '366' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '367' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '368' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '369' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '370' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '371' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '372' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '373' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '374' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '375' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '376' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '377' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '378' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '379' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '380' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '381' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '382' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '383' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '384' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '385' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '386' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '387' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '388' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '389' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '390' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '391' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '392' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '393' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '394' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '395' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '396' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '397' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '398' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '399' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '400' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '401' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '402' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '403' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '404' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '405' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '406' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '407' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '408' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '409' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '410' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '411' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '412' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '413' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '414' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '415' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '416' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '417' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '418' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '419' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '420' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '421' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '422' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '423' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '424' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '425' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '426' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '427' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '428' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '429' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '430' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '431' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '432' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '433' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '434' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '435' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '436' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '437' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '438' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '439' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '440' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '441' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '442' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '443' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '444' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '445' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '446' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '447' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '448' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '449' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '450' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '451' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '452' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '453' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '454' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '455' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '456' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '457' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '458' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '459' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '460' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '461' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '462' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '463' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '464' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '465' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '466' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '467' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '468' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '469' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '470' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '471' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '472' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '473' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '474' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '475' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '476' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '477' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '478' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '479' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '480' },

  // {dates:"全部", grade: "全部", subject: "英语", video: "4" },

  // { subject: "语文", video: "18",dates:"春季课" },
  // { subject: "数学", video: "39",dates:"春季课" },
  // { grade: "小学",  video: "23",date:"秋季课"},
  // { grade: "小学", subject: "语文", video: "187"},
  // { grade: "三年级", subject: "语文", video: "1" ,dates:"全部"},
  // { grade: "三年级", subject: "语文", video: "15" ,dates:"全部"},
  // { dates:"全部",  grade: "三年级", subject:"全部"},
  // { dates:"春季课",grade:"小学",subject:"全部"},


  { grade: '初一', subject: '数学', dates:'春季课', video: '481' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '482' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '483' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '484' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '485' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '486' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '487' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '488' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '489' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '490' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '491' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '492' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '493' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '494' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '495' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '496' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '497' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '498' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '499' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '500' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '501' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '502' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '503' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '504' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '505' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '506' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '507' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '508' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '509' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '510' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '511' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '512' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '513' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '514' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '515' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '516' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '517' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '518' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '519' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '520' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '521' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '522' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '523' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '524' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '525' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '526' },
  { grade: '初一', subject: '政治', dates:'春季课', video: '527' },
  { grade: '初一', subject: '生物', dates:'春季课', video: '528' },
  { grade: '初一', subject: '生物', dates:'春季课', video: '529' },
  { grade: '初一', subject: '生物', dates:'春季课', video: '530' },
  { grade: '初一', subject: '生物', dates:'春季课', video: '531' },
  { grade: '初一', subject: '政治', dates:'春季课', video: '532' },
  { grade: '初一', subject: '生物', dates:'春季课', video: '533' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '534' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '535' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '536' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '537' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '538' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '539' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '540' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '541' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '542' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '543' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '544' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '545' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '546' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '547' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '548' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '549' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '550' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '551' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '552' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '553' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '554' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '555' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '556' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '557' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '558' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '559' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '560' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '561' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '562' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '563' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '564' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '565' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '566' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '567' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '568' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '569' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '570' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '571' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '572' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '573' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '574' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '575' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '576' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '577' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '578' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '579' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '580' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '581' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '582' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '583' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '584' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '585' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '586' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '587' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '588' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '589' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '590' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '591' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '592' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '593' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '594' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '595' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '596' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '597' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '598' },
  { grade: '初一', subject: '政治', dates:'春季课', video: '599' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '600' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '601' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '602' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '603' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '604' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '605' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '606' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '607' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '608' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '609' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '610' },
  { grade: '初一', subject: '语文', dates:'春季课', video: '611' },
  { grade: '初一', subject: '英语', dates:'春季课', video: '612' },
  { grade: '初一', subject: '数学', dates:'春季课', video: '613' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '614' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '615' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '616' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '617' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '618' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '619' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '620' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '621' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '622' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '623' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '624' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '625' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '626' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '627' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '628' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '629' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '630' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '631' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '632' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '633' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '634' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '635' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '636' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '637' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '638' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '639' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '640' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '641' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '642' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '643' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '644' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '645' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '646' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '647' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '648' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '649' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '650' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '651' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '652' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '653' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '654' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '655' },
  { grade: '初二', subject: '生物', dates:'春季课', video: '656' },
  { grade: '初二', subject: '生物', dates:'春季课', video: '657' },
  { grade: '初二', subject: '生物', dates:'春季课', video: '658' },
  { grade: '初二', subject: '生物', dates:'春季课', video: '659' },
  { grade: '初二', subject: '生物', dates:'春季课', video: '660' },
  { grade: '初二', subject: '生物', dates:'春季课', video: '661' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '662' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '663' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '664' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '665' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '666' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '667' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '668' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '669' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '670' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '671' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '672' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '673' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '674' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '676' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '677' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '678' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '679' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '680' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '681' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '682' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '683' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '684' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '685' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '686' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '687' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '688' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '689' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '690' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '691' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '692' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '693' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '694' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '695' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '696' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '697' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '698' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '699' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '700' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '701' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '702' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '703' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '704' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '705' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '706' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '707' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '708' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '709' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '710' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '711' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '712' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '713' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '714' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '715' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '716' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '717' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '718' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '719' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '720' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '721' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '722' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '723' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '724' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '725' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '726' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '727' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '728' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '729' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '730' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '731' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '732' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '733' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '734' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '735' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '736' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '737' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '738' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '739' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '740' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '741' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '742' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '743' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '744' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '745' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '746' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '747' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '748' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '749' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '750' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '751' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '752' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '753' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '754' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '755' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '756' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '757' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '758' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '759' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '760' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '761' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '762' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '763' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '764' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '765' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '766' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '767' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '768' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '769' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '770' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '771' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '772' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '773' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '774' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '775' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '776' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '777' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '778' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '779' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '780' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '781' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '782' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '783' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '784' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '785' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '786' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '787' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '788' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '789' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '790' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '791' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '792' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '793' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '794' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '795' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '796' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '797' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '798' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '799' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '800' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '801' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '802' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '803' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '804' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '805' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '806' },


  { grade: '初中', subject: '数学', dates:'春季课', video: '481' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '482' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '483' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '484' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '485' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '486' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '487' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '488' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '489' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '490' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '491' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '492' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '493' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '494' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '495' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '496' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '497' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '498' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '499' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '500' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '501' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '502' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '503' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '504' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '505' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '506' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '507' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '508' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '509' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '510' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '511' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '512' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '513' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '514' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '515' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '516' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '517' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '518' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '519' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '520' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '521' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '522' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '523' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '524' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '525' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '526' },
  { grade: '初中', subject: '政治', dates:'春季课', video: '527' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '528' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '529' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '530' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '531' },
  { grade: '初中', subject: '政治', dates:'春季课', video: '532' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '533' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '534' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '535' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '536' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '537' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '538' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '539' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '540' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '541' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '542' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '543' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '544' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '545' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '546' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '547' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '548' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '549' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '550' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '551' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '552' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '553' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '554' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '555' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '556' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '557' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '558' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '559' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '560' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '561' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '562' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '563' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '564' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '565' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '566' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '567' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '568' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '569' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '570' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '571' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '572' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '573' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '574' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '575' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '576' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '577' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '578' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '579' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '580' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '581' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '582' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '583' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '584' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '585' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '586' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '587' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '588' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '589' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '590' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '591' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '592' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '593' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '594' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '595' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '596' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '597' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '598' },
  { grade: '初中', subject: '政治', dates:'春季课', video: '599' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '600' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '601' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '602' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '603' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '604' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '605' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '606' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '607' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '608' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '609' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '610' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '611' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '612' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '613' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '614' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '615' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '616' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '617' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '618' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '619' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '620' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '621' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '622' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '623' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '624' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '625' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '626' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '627' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '628' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '629' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '630' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '631' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '632' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '633' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '634' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '635' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '636' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '637' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '638' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '639' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '640' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '641' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '642' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '643' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '644' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '645' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '646' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '647' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '648' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '649' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '650' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '651' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '652' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '653' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '654' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '655' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '656' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '657' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '658' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '659' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '660' },
  { grade: '初中', subject: '生物', dates:'春季课', video: '661' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '662' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '663' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '664' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '665' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '666' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '667' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '668' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '669' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '670' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '671' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '672' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '673' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '674' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '676' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '677' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '678' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '679' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '680' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '681' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '682' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '683' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '684' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '685' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '686' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '687' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '688' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '689' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '690' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '691' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '692' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '693' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '694' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '695' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '696' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '697' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '698' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '699' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '700' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '701' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '702' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '703' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '704' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '705' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '706' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '707' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '708' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '709' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '710' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '711' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '712' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '713' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '714' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '715' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '716' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '717' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '718' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '719' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '720' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '721' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '722' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '723' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '724' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '725' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '726' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '727' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '728' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '729' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '730' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '731' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '732' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '733' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '734' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '735' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '736' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '737' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '738' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '739' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '740' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '741' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '742' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '743' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '744' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '745' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '746' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '747' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '748' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '749' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '750' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '751' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '752' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '753' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '754' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '755' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '756' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '757' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '758' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '759' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '760' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '761' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '762' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '763' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '764' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '765' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '766' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '767' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '768' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '769' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '770' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '771' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '772' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '773' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '774' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '775' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '776' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '777' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '778' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '779' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '780' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '781' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '782' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '783' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '784' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '785' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '786' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '787' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '788' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '789' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '790' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '791' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '792' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '793' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '794' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '795' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '796' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '797' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '798' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '799' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '800' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '801' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '802' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '803' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '804' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '805' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '806' },


  { grade: '全部', subject: '数学', dates:'春季课', video: '481' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '482' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '483' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '484' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '485' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '486' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '487' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '488' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '489' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '490' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '491' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '492' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '493' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '494' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '495' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '496' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '497' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '498' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '499' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '500' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '501' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '502' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '503' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '504' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '505' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '506' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '507' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '508' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '509' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '510' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '511' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '512' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '513' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '514' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '515' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '516' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '517' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '518' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '519' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '520' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '521' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '522' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '523' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '524' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '525' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '526' },
  { grade: '全部', subject: '政治', dates:'春季课', video: '527' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '528' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '529' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '530' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '531' },
  { grade: '全部', subject: '政治', dates:'春季课', video: '532' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '533' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '534' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '535' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '536' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '537' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '538' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '539' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '540' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '541' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '542' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '543' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '544' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '545' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '546' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '547' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '548' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '549' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '550' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '551' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '552' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '553' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '554' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '555' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '556' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '557' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '558' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '559' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '560' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '561' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '562' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '563' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '564' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '565' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '566' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '567' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '568' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '569' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '570' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '571' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '572' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '573' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '574' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '575' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '576' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '577' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '578' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '579' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '580' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '581' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '582' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '583' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '584' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '585' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '586' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '587' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '588' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '589' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '590' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '591' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '592' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '593' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '594' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '595' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '596' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '597' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '598' },
  { grade: '全部', subject: '政治', dates:'春季课', video: '599' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '600' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '601' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '602' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '603' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '604' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '605' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '606' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '607' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '608' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '609' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '610' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '611' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '612' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '613' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '614' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '615' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '616' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '617' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '618' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '619' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '620' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '621' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '622' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '623' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '624' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '625' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '626' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '627' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '628' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '629' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '630' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '631' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '632' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '633' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '634' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '635' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '636' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '637' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '638' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '639' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '640' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '641' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '642' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '643' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '644' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '645' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '646' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '647' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '648' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '649' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '650' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '651' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '652' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '653' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '654' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '655' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '656' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '657' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '658' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '659' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '660' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '661' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '662' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '663' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '664' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '665' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '666' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '667' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '668' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '669' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '670' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '671' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '672' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '673' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '674' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '676' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '677' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '678' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '679' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '680' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '681' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '682' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '683' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '684' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '685' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '686' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '687' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '688' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '689' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '690' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '691' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '692' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '693' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '694' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '695' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '696' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '697' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '698' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '699' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '700' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '701' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '702' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '703' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '704' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '705' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '706' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '707' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '708' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '709' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '710' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '711' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '712' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '713' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '714' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '715' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '716' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '717' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '718' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '719' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '720' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '721' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '722' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '723' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '724' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '725' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '726' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '727' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '728' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '729' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '730' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '731' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '732' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '733' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '734' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '735' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '736' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '737' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '738' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '739' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '740' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '741' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '742' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '743' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '744' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '745' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '746' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '747' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '748' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '749' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '750' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '751' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '752' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '753' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '754' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '755' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '756' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '757' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '758' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '759' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '760' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '761' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '762' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '763' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '764' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '765' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '766' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '767' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '768' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '769' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '770' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '771' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '772' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '773' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '774' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '775' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '776' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '777' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '778' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '779' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '780' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '781' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '782' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '783' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '784' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '785' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '786' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '787' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '788' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '789' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '790' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '791' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '792' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '793' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '794' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '795' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '796' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '797' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '798' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '799' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '800' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '801' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '802' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '803' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '804' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '805' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '806' },


  { grade: '高一', subject: '英语', dates:'春季课', video: '807' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '808' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '809' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '810' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '811' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '812' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '813' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '814' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '815' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '816' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '817' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '818' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '819' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '820' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '821' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '822' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '823' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '824' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '825' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '826' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '827' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '828' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '829' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '830' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '831' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '832' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '833' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '834' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '835' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '836' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '837' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '838' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '839' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '840' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '841' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '842' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '843' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '844' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '845' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '846' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '847' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '848' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '849' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '850' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '851' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '852' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '853' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '854' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '855' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '856' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '857' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '858' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '859' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '860' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '861' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '862' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '863' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '864' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '865' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '866' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '867' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '868' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '869' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '870' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '871' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '872' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '873' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '874' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '875' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '876' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '877' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '878' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '879' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '880' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '881' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '882' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '883' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '884' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '885' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '886' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '887' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '888' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '889' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '890' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '891' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '892' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '893' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '894' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '895' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '896' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '897' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '898' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '899' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '900' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '901' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '902' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '903' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '904' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '905' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '906' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '907' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '908' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '909' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '910' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '911' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '912' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '913' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '914' },
  { grade: '高一', subject: '生物', dates:'春季课', video: '915' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '916' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '917' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '918' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '919' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '920' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '921' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '922' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '923' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '924' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '925' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '926' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '927' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '928' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '929' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '930' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '931' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '932' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '933' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '934' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '935' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '936' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '937' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '938' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '939' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '940' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '941' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '942' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '943' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '944' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '945' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '946' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '947' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '948' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '949' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '950' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '951' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '952' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '953' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '954' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '955' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '956' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '957' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '958' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '959' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '960' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '961' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '962' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '963' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '964' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '965' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '966' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '967' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '968' },
  { grade: '高一', subject: '数学', dates:'春季课', video: '969' },
  { grade: '高一', subject: '化学', dates:'春季课', video: '970' },
  { grade: '高一', subject: '英语', dates:'春季课', video: '971' },
  { grade: '高一', subject: '语文', dates:'春季课', video: '972' },
  { grade: '高一', subject: '物理', dates:'春季课', video: '973' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '974' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '975' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '976' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '977' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '978' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '979' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '980' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '981' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '982' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '983' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '984' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '985' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '986' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '987' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '988' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '989' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '990' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '991' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '992' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '993' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '994' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '995' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '996' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '997' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '998' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '999' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '1000' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '1001' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '1002' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '1003' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '1004' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '1005' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '1006' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '1007' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '1008' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '1009' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '1010' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '1011' },
  { grade: '初二', subject: '语文', dates:'春季课', video: '1012' },
  { grade: '初二', subject: '英语', dates:'春季课', video: '1013' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '1014' },
  { grade: '初二', subject: '物理', dates:'春季课', video: '1015' },
  { grade: '初二', subject: '数学', dates:'春季课', video: '1016' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1017' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1018' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1019' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1020' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1021' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1022' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1023' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1024' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1025' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1026' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1027' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1028' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1029' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1030' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1031' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1032' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1033' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1034' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1035' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1036' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '1037' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1038' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '1039' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1040' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1041' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '1042' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1043' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '1044' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1045' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1046' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '1047' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1048' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '1049' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1050' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1051' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '1052' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1053' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '1054' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1055' },
  { grade: '高三', subject: '数学', dates:'春季课', video: '1056' },
  { grade: '高三', subject: '语文', dates:'春季课', video: '1057' },
  { grade: '高三', subject: '英语', dates:'春季课', video: '1058' },
  { grade: '高三', subject: '物理', dates:'春季课', video: '1059' },
  { grade: '高三', subject: '化学', dates:'春季课', video: '1060' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '1061' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1062' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1063' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1064' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1065' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1066' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '1067' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1068' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1069' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1070' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1071' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1072' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1073' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '1074' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1075' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1076' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1077' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1078' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1079' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1080' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '1081' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1082' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1083' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '1084' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1085' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1086' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1087' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '1088' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1089' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1090' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1091' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1092' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1093' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1094' },
  { grade: '初三', subject: '语文', dates:'春季课', video: '1095' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1096' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1097' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1098' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1099' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1100' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1101' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1102' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1103' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1104' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1105' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1106' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1107' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1108' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1109' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1110' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1111' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1112' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1113' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1114' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1115' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1116' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1117' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1118' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1119' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1120' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1121' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1122' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1123' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1124' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1125' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1126' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1127' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1128' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1129' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1130' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1131' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1132' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1133' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1134' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1135' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1136' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1137' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1138' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1139' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1140' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1141' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1142' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1143' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1144' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1145' },
  { grade: '初三', subject: '物理', dates:'春季课', video: '1146' },
  { grade: '初三', subject: '化学', dates:'春季课', video: '1147' },
  { grade: '初三', subject: '数学', dates:'春季课', video: '1148' },
  { grade: '初三', subject: '英语', dates:'春季课', video: '1149' },




  { grade: '高中', subject: '英语', dates:'春季课', video: '807' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '808' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '809' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '810' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '811' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '812' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '813' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '814' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '815' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '816' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '817' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '818' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '819' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '820' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '821' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '822' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '823' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '824' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '825' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '826' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '827' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '828' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '829' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '830' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '831' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '832' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '833' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '834' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '835' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '836' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '837' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '838' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '839' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '840' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '841' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '842' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '843' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '844' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '845' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '846' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '847' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '848' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '849' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '850' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '851' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '852' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '853' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '854' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '855' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '856' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '857' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '858' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '859' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '860' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '861' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '862' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '863' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '864' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '865' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '866' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '867' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '868' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '869' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '870' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '871' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '872' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '873' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '874' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '875' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '876' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '877' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '878' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '879' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '880' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '881' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '882' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '883' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '884' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '885' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '886' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '887' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '888' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '889' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '890' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '891' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '892' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '893' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '894' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '895' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '896' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '897' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '898' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '899' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '900' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '901' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '902' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '903' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '904' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '905' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '906' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '907' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '908' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '909' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '910' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '911' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '912' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '913' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '914' },
  { grade: '高中', subject: '生物', dates:'春季课', video: '915' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '916' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '917' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '918' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '919' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '920' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '921' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '922' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '923' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '924' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '925' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '926' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '927' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '928' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '929' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '930' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '931' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '932' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '933' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '934' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '935' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '936' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '937' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '938' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '939' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '940' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '941' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '942' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '943' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '944' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '945' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '946' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '947' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '948' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '949' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '950' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '951' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '952' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '953' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '954' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '955' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '956' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '957' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '958' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '959' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '960' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '961' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '962' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '963' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '964' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '965' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '966' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '967' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '968' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '969' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '970' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '971' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '972' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '973' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '974' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '975' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '976' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '977' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '978' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '979' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '980' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '981' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '982' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '983' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '984' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '985' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '986' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '987' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '988' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '989' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '990' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '991' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '992' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '993' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '994' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '995' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '996' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '997' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '998' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '999' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1000' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1001' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1002' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1003' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1004' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1005' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1006' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1007' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1008' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1009' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1010' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1011' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1012' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1013' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1014' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1015' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1016' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1017' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1018' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1019' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1020' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1021' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1022' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1023' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1024' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1025' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1026' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1027' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1028' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1029' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1030' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1031' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1032' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1033' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1034' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1035' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1036' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '1037' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1038' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '1039' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1040' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1041' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '1042' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1043' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '1044' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1045' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1046' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '1047' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1048' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '1049' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1050' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1051' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '1052' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1053' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '1054' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1055' },
  { grade: '高中', subject: '数学', dates:'春季课', video: '1056' },
  { grade: '高中', subject: '语文', dates:'春季课', video: '1057' },
  { grade: '高中', subject: '英语', dates:'春季课', video: '1058' },
  { grade: '高中', subject: '物理', dates:'春季课', video: '1059' },
  { grade: '高中', subject: '化学', dates:'春季课', video: '1060' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1061' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1062' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1063' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1064' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1065' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1066' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1067' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1068' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1069' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1070' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1071' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1072' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1073' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1074' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1075' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1076' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1077' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1078' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1079' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1080' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1081' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1082' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1083' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1084' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1085' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1086' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1087' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1088' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1089' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1090' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1091' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1092' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1093' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1094' },
  { grade: '初中', subject: '语文', dates:'春季课', video: '1095' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1096' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1097' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1098' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1099' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1100' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1101' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1102' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1103' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1104' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1105' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1106' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1107' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1108' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1109' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1110' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1111' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1112' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1113' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1114' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1115' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1116' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1117' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1118' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1119' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1120' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1121' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1122' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1123' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1124' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1125' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1126' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1127' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1128' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1129' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1130' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1131' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1132' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1133' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1134' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1135' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1136' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1137' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1138' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1139' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1140' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1141' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1142' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1143' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1144' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1145' },
  { grade: '初中', subject: '物理', dates:'春季课', video: '1146' },
  { grade: '初中', subject: '化学', dates:'春季课', video: '1147' },
  { grade: '初中', subject: '数学', dates:'春季课', video: '1148' },
  { grade: '初中', subject: '英语', dates:'春季课', video: '1149' },

  { grade: '全部', subject: '英语', dates:'春季课', video: '807' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '808' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '809' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '810' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '811' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '812' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '813' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '814' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '815' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '816' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '817' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '818' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '819' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '820' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '821' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '822' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '823' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '824' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '825' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '826' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '827' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '828' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '829' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '830' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '831' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '832' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '833' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '834' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '835' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '836' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '837' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '838' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '839' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '840' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '841' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '842' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '843' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '844' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '845' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '846' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '847' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '848' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '849' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '850' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '851' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '852' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '853' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '854' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '855' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '856' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '857' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '858' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '859' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '860' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '861' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '862' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '863' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '864' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '865' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '866' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '867' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '868' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '869' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '870' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '871' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '872' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '873' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '874' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '875' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '876' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '877' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '878' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '879' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '880' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '881' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '882' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '883' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '884' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '885' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '886' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '887' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '888' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '889' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '890' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '891' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '892' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '893' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '894' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '895' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '896' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '897' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '898' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '899' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '900' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '901' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '902' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '903' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '904' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '905' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '906' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '907' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '908' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '909' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '910' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '911' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '912' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '913' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '914' },
  { grade: '全部', subject: '生物', dates:'春季课', video: '915' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '916' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '917' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '918' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '919' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '920' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '921' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '922' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '923' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '924' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '925' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '926' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '927' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '928' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '929' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '930' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '931' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '932' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '933' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '934' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '935' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '936' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '937' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '938' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '939' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '940' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '941' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '942' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '943' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '944' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '945' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '946' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '947' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '948' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '949' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '950' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '951' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '952' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '953' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '954' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '955' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '956' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '957' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '958' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '959' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '960' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '961' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '962' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '963' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '964' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '965' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '966' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '967' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '968' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '969' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '970' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '971' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '972' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '973' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '974' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '975' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '976' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '977' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '978' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '979' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '980' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '981' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '982' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '983' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '984' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '985' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '986' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '987' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '988' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '989' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '990' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '991' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '992' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '993' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '994' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '995' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '996' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '997' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '998' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '999' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1000' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1001' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1002' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1003' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1004' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1005' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1006' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1007' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1008' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1009' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1010' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1011' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1012' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1013' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1014' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1015' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1016' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1017' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1018' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1019' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1020' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1021' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1022' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1023' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1024' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1025' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1026' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1027' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1028' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1029' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1030' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1031' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1032' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1033' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1034' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1035' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1036' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1037' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1038' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1039' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1040' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1041' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1042' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1043' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1044' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1045' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1046' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1047' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1048' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1049' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1050' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1051' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1052' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1053' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1054' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1055' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1056' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1057' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1058' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1059' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1060' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1061' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1062' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1063' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1064' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1065' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1066' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1067' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1068' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1069' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1070' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1071' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1072' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1073' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1074' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1075' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1076' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1077' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1078' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1079' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1080' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1081' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1082' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1083' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1084' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1085' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1086' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1087' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1088' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1089' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1090' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1091' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1092' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1093' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1094' },
  { grade: '全部', subject: '语文', dates:'春季课', video: '1095' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1096' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1097' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1098' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1099' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1100' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1101' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1102' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1103' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1104' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1105' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1106' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1107' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1108' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1109' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1110' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1111' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1112' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1113' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1114' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1115' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1116' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1117' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1118' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1119' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1120' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1121' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1122' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1123' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1124' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1125' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1126' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1127' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1128' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1129' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1130' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1131' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1132' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1133' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1134' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1135' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1136' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1137' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1138' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1139' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1140' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1141' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1142' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1143' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1144' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1145' },
  { grade: '全部', subject: '物理', dates:'春季课', video: '1146' },
  { grade: '全部', subject: '化学', dates:'春季课', video: '1147' },
  { grade: '全部', subject: '数学', dates:'春季课', video: '1148' },
  { grade: '全部', subject: '英语', dates:'春季课', video: '1149' },

];

var tconditions = [
  { grade: "初二", subject: "物理", teacher: "44" ,dates:"春季课"},
  { grade: "初二", subject: "物理", teacher: "53" },
  { grade: "初二", subject: "物理", teacher: "54" },
  { grade: "初二", subject: "英语", teacher: "56" },
  { grade: "初二", subject: "物理", teacher: "58" },
  { grade: "初二", subject: "数学", teacher: "60" },
  { grade: "初二", subject: "语文", teacher: "63" },
  { grade: "初二", subject: "物理", teacher: "76" },
  { grade: "初二", subject: "物理", teacher: "82" },
  { grade: "初三", subject: "化学", teacher: "42" },
  { grade: "初三", subject: "英语", teacher: "47" },
  { grade: "初三", subject: "数学", teacher: "50" },
  { grade: "初三", subject: "物理", teacher: "62" },
  { grade: "初三", subject: "语文", teacher: "67" },
  { grade: "初三", subject: "数学", teacher: "71" },
  { grade: "初三", subject: "英语", teacher: "73" },
  { grade: "初三", subject: "数学", teacher: "77" },
  { grade: "初三", subject: "数学", teacher: "80" },
  { grade: "初三", subject: "化学", teacher: "81" },
  { grade: "初三", subject: "物理", teacher: "86" },
  { grade: "初一", subject: "英语", teacher: "33" },
  { grade: "初一", subject: "数学", teacher: "35" },
  { grade: "初一", subject: "数学", teacher: "38" },
  { grade: "初一", subject: "数学", teacher: "43" },
  { grade: "初一", subject: "数学", teacher: "51" },
  { grade: "初一", subject: "英语", teacher: "57" },
  { grade: "初一", subject: "英语", teacher: "61" },
  { grade: "初一", subject: "语文", teacher: "64" },
  { grade: "初一", subject: "语文", teacher: "68" },
  { grade: "初一", subject: "数学", teacher: "69" },
  { grade: "初一", subject: "语文", teacher: "74" },
  { grade: "初一", subject: "数学", teacher: "75" },
  { grade: "初一", subject: "语文", teacher: "84" },
  { grade: "初一", subject: "英语", teacher: "85" },
  { grade: "初一", subject: "英语", teacher: "156" },
  { grade: "高二", subject: "化学", teacher: "92" },
  { grade: "高二", subject: "语文", teacher: "97" },
  { grade: "高二", subject: "化学", teacher: "110" },
  { grade: "高二", subject: "物理", teacher: "112" },
  { grade: "高二", subject: "历史", teacher: "121" },
  { grade: "高二", subject: "化学", teacher: "123" },
  { grade: "高二", subject: "语文", teacher: "126" },
  { grade: "高二", subject: "物理", teacher: "127" },
  { grade: "高二", subject: "英语", teacher: "141" },
  { grade: "高三", subject: "政治", teacher: "117" },
  { grade: "高三", subject: "生物", teacher: "119" },
  { grade: "高三", subject: "化学", teacher: "128" },
  { grade: "高三", subject: "英语", teacher: "130" },
  { grade: "高三", subject: "物理", teacher: "131" },
  { grade: "高三", subject: "数学", teacher: "133" },
  { grade: "高三", subject: "英语", teacher: "135" },
  { grade: "高三", subject: "数学", teacher: "137" },
  { grade: "高三", subject: "英语", teacher: "140" },
  { grade: "高一", subject: "语文", teacher: "87" },
  { grade: "高一", subject: "数学", teacher: "89" },
  { grade: "高一", subject: "数学", teacher: "93" },
  { grade: "高一", subject: "数学", teacher: "94" },
  { grade: "高一", subject: "数学", teacher: "95" },
  { grade: "高一", subject: "物理", teacher: "99" },
  { grade: "高一", subject: "物理", teacher: "100" },
  { grade: "高一", subject: "物理", teacher: "101" },
  { grade: "高一", subject: "物理", teacher: "103" },
  { grade: "高一", subject: "数学", teacher: "105" },
  { grade: "高一", subject: "生物", teacher: "106" },
  { grade: "高一", subject: "英语", teacher: "107" },
  { grade: "高一", subject: "语文", teacher: "108" },
  { grade: "高一", subject: "英语", teacher: "113" },
  { grade: "高一", subject: "语文", teacher: "115" },
  { grade: "高一", subject: "化学", teacher: "124" },
  { grade: "高一", subject: "数学", teacher: "138" },
  { grade: "高一", subject: "英语", teacher: "143" },
  { grade: "高一", subject: "数学", teacher: "144" },
  { grade: "高一", subject: "英语", teacher: "145" },
  { grade: "高一", subject: "语文", teacher: "146" },
  { grade: "高一", subject: "物理", teacher: "147" },
  { grade: "高一", subject: "化学", teacher: "148" },
  { grade: "高一", subject: "地理", teacher: "149" },
  { grade: "六年级", subject: "英语", teacher: "4" },
  { grade: "六年级", subject: "语文", teacher: "18" },
  { grade: "六年级", subject: "数学", teacher: "19" },
  { grade: "六年级", subject: "数学", teacher: "29" },
  { grade: "六年级", subject: "语文", teacher: "155" },
  { grade: "三年级", subject: "语文", teacher: "1" },
  { grade: "三年级", subject: "语文", teacher: "14" },
  { grade: "三年级", subject: "数学", teacher: "25" },
  { grade: "三年级", subject: "语文", teacher: "150" },
  { grade: "三年级", subject: "数学", teacher: "151" },
  { grade: "三年级", subject: "编程", teacher: "152" },
  { grade: "三年级", subject: "科学", teacher: "153" },
  { grade: "三年级", subject: "科学", teacher: "154" },
  { grade: "四年级", subject: "数学", teacher: "2" },
  { grade: "四年级", subject: "英语", teacher: "6" },
  { grade: "四年级", subject: "数学", teacher: "12" },
  { grade: "四年级", subject: "语文", teacher: "15" },
  { grade: "四年级", subject: "语文", teacher: "16" },
  { grade: "四年级", subject: "英语", teacher: "20" },
  { grade: "四年级", subject: "英语", teacher: "21" },
  { grade: "四年级", subject: "数学", teacher: "24" },
  { grade: "五年级", subject: "语文", teacher: "5" },
  { grade: "五年级", subject: "语文", teacher: "8" },
  { grade: "五年级", subject: "语文", teacher: "9" },
  { grade: "五年级", subject: "数学", teacher: "10" },
  { grade: "五年级", subject: "数学", teacher: "28" },
  { grade: "一年级", subject: "英语", teacher: "30" },
  { grade: "一年级", subject: "数学", teacher: "32" },
  { grade: "一年级", subject: "科学", teacher: "157" },
  { grade: "一年级", subject: "科学", teacher: "158" },
  { grade: "初中", subject: "物理", teacher: "44" },
  { grade: "初中", subject: "物理", teacher: "53" },
  { grade: "初中", subject: "物理", teacher: "54" },
  { grade: "初中", subject: "英语", teacher: "56" },
  { grade: "初中", subject: "物理", teacher: "58" },
  { grade: "初中", subject: "数学", teacher: "60" },
  { grade: "初中", subject: "语文", teacher: "63" },
  { grade: "初中", subject: "物理", teacher: "76" },
  { grade: "初中", subject: "物理", teacher: "82" },
  { grade: "初中", subject: "化学", teacher: "42" },
  { grade: "初中", subject: "英语", teacher: "47" },
  { grade: "初中", subject: "数学", teacher: "50" },
  { grade: "初中", subject: "物理", teacher: "62" },
  { grade: "初中", subject: "语文", teacher: "67" },
  { grade: "初中", subject: "数学", teacher: "71" },
  { grade: "初中", subject: "英语", teacher: "73" },
  { grade: "初中", subject: "数学", teacher: "77" },
  { grade: "初中", subject: "数学", teacher: "80" },
  { grade: "初中", subject: "化学", teacher: "81" },
  { grade: "初中", subject: "物理", teacher: "86" },
  { grade: "初中", subject: "英语", teacher: "33" },
  { grade: "初中", subject: "数学", teacher: "35" },
  { grade: "初中", subject: "数学", teacher: "38" },
  { grade: "初中", subject: "数学", teacher: "43" },
  { grade: "初中", subject: "数学", teacher: "51" },
  { grade: "初中", subject: "英语", teacher: "57" },
  { grade: "初中", subject: "英语", teacher: "61" },
  { grade: "初中", subject: "语文", teacher: "64" },
  { grade: "初中", subject: "语文", teacher: "68" },
  { grade: "初中", subject: "数学", teacher: "69" },
  { grade: "初中", subject: "语文", teacher: "74" },
  { grade: "初中", subject: "数学", teacher: "75" },
  { grade: "初中", subject: "语文", teacher: "84" },
  { grade: "初中", subject: "英语", teacher: "85" },
  { grade: "初中", subject: "英语", teacher: "156" },
  { grade: "高中", subject: "化学", teacher: "92" },
  { grade: "高中", subject: "语文", teacher: "97" },
  { grade: "高中", subject: "化学", teacher: "110" },
  { grade: "高中", subject: "物理", teacher: "112" },
  { grade: "高中", subject: "历史", teacher: "121" },
  { grade: "高中", subject: "化学", teacher: "123" },
  { grade: "高中", subject: "语文", teacher: "126" },
  { grade: "高中", subject: "物理", teacher: "127" },
  { grade: "高中", subject: "英语", teacher: "141" },
  { grade: "高中", subject: "政治", teacher: "117" },
  { grade: "高中", subject: "生物", teacher: "119" },
  { grade: "高中", subject: "化学", teacher: "128" },
  { grade: "高中", subject: "英语", teacher: "130" },
  { grade: "高中", subject: "物理", teacher: "131" },
  { grade: "高中", subject: "数学", teacher: "133" },
  { grade: "高中", subject: "英语", teacher: "135" },
  { grade: "高中", subject: "数学", teacher: "137" },
  { grade: "高中", subject: "英语", teacher: "140" },
  { grade: "高中", subject: "语文", teacher: "87" },
  { grade: "高中", subject: "数学", teacher: "89" },
  { grade: "高中", subject: "数学", teacher: "93" },
  { grade: "高中", subject: "数学", teacher: "94" },
  { grade: "高中", subject: "数学", teacher: "95" },
  { grade: "高中", subject: "物理", teacher: "99" },
  { grade: "高中", subject: "物理", teacher: "100" },
  { grade: "高中", subject: "物理", teacher: "101" },
  { grade: "高中", subject: "物理", teacher: "103" },
  { grade: "高中", subject: "数学", teacher: "105" },
  { grade: "高中", subject: "生物", teacher: "106" },
  { grade: "高中", subject: "英语", teacher: "107" },
  { grade: "高中", subject: "语文", teacher: "108" },
  { grade: "高中", subject: "英语", teacher: "113" },
  { grade: "高中", subject: "语文", teacher: "115" },
  { grade: "高中", subject: "化学", teacher: "124" },
  { grade: "高中", subject: "数学", teacher: "138" },
  { grade: "高中", subject: "英语", teacher: "143" },
  { grade: "高中", subject: "数学", teacher: "144" },
  { grade: "高中", subject: "英语", teacher: "145" },
  { grade: "高中", subject: "语文", teacher: "146" },
  { grade: "高中", subject: "物理", teacher: "147" },
  { grade: "高中", subject: "化学", teacher: "148" },
  { grade: "高中", subject: "地理", teacher: "149" },
  { grade: "小学", subject: "英语", teacher: "4" },
  { grade: "小学", subject: "语文", teacher: "18" },
  { grade: "小学", subject: "数学", teacher: "19" },
  { grade: "小学", subject: "数学", teacher: "29" },
  { grade: "小学", subject: "语文", teacher: "155" },
  { grade: "小学", subject: "语文", teacher: "1" },
  { grade: "小学", subject: "语文", teacher: "14" },
  { grade: "小学", subject: "数学", teacher: "25" },
  { grade: "小学", subject: "语文", teacher: "150" },
  { grade: "小学", subject: "数学", teacher: "151" },
  { grade: "小学", subject: "编程", teacher: "152" },
  { grade: "小学", subject: "科学", teacher: "153" },
  { grade: "小学", subject: "科学", teacher: "154" },
  { grade: "小学", subject: "数学", teacher: "2" },
  { grade: "小学", subject: "英语", teacher: "6" },
  { grade: "小学", subject: "数学", teacher: "12" },
  { grade: "小学", subject: "语文", teacher: "15" },
  { grade: "小学", subject: "语文", teacher: "16" },
  { grade: "小学", subject: "英语", teacher: "20" },
  { grade: "小学", subject: "英语", teacher: "21" },
  { grade: "小学", subject: "数学", teacher: "24" },
  { grade: "小学", subject: "语文", teacher: "5" },
  { grade: "小学", subject: "语文", teacher: "8" },
  { grade: "小学", subject: "语文", teacher: "9" },
  { grade: "小学", subject: "数学", teacher: "10" },
  { grade: "小学", subject: "数学", teacher: "28" },
  { grade: "小学", subject: "英语", teacher: "30" },
  { grade: "小学", subject: "数学", teacher: "32" },
  { grade: "小学", subject: "科学", teacher: "157" },
  { grade: "小学", subject: "科学", teacher: "158" },
  { grade: "全部", subject: "物理", teacher: "44" },
  { grade: "全部", subject: "物理", teacher: "53" },
  { grade: "全部", subject: "物理", teacher: "54" },
  { grade: "全部", subject: "英语", teacher: "56" },
  { grade: "全部", subject: "物理", teacher: "58" },
  { grade: "全部", subject: "数学", teacher: "60" },
  { grade: "全部", subject: "语文", teacher: "63" },
  { grade: "全部", subject: "物理", teacher: "76" },
  { grade: "全部", subject: "物理", teacher: "82" },
  { grade: "全部", subject: "化学", teacher: "42" },
  { grade: "全部", subject: "英语", teacher: "47" },
  { grade: "全部", subject: "数学", teacher: "50" },
  { grade: "全部", subject: "物理", teacher: "62" },
  { grade: "全部", subject: "语文", teacher: "67" },
  { grade: "全部", subject: "数学", teacher: "71" },
  { grade: "全部", subject: "英语", teacher: "73" },
  { grade: "全部", subject: "数学", teacher: "77" },
  { grade: "全部", subject: "数学", teacher: "80" },
  { grade: "全部", subject: "化学", teacher: "81" },
  { grade: "全部", subject: "物理", teacher: "86" },
  { grade: "全部", subject: "英语", teacher: "33" },
  { grade: "全部", subject: "数学", teacher: "35" },
  { grade: "全部", subject: "数学", teacher: "38" },
  { grade: "全部", subject: "数学", teacher: "43" },
  { grade: "全部", subject: "数学", teacher: "51" },
  { grade: "全部", subject: "英语", teacher: "57" },
  { grade: "全部", subject: "英语", teacher: "61" },
  { grade: "全部", subject: "语文", teacher: "64" },
  { grade: "全部", subject: "语文", teacher: "68" },
  { grade: "全部", subject: "数学", teacher: "69" },
  { grade: "全部", subject: "语文", teacher: "74" },
  { grade: "全部", subject: "数学", teacher: "75" },
  { grade: "全部", subject: "语文", teacher: "84" },
  { grade: "全部", subject: "英语", teacher: "85" },
  { grade: "全部", subject: "英语", teacher: "156" },
  { grade: "全部", subject: "化学", teacher: "92" },
  { grade: "全部", subject: "语文", teacher: "97" },
  { grade: "全部", subject: "化学", teacher: "110" },
  { grade: "全部", subject: "物理", teacher: "112" },
  { grade: "全部", subject: "历史", teacher: "121" },
  { grade: "全部", subject: "化学", teacher: "123" },
  { grade: "全部", subject: "语文", teacher: "126" },
  { grade: "全部", subject: "物理", teacher: "127" },
  { grade: "全部", subject: "英语", teacher: "141" },
  { grade: "全部", subject: "政治", teacher: "117" },
  { grade: "全部", subject: "生物", teacher: "119" },
  { grade: "全部", subject: "化学", teacher: "128" },
  { grade: "全部", subject: "英语", teacher: "130" },
  { grade: "全部", subject: "物理", teacher: "131" },
  { grade: "全部", subject: "数学", teacher: "133" },
  { grade: "全部", subject: "英语", teacher: "135" },
  { grade: "全部", subject: "数学", teacher: "137" },
  { grade: "全部", subject: "英语", teacher: "140" },
  { grade: "全部", subject: "语文", teacher: "87" },
  { grade: "全部", subject: "数学", teacher: "89" },
  { grade: "全部", subject: "数学", teacher: "93" },
  { grade: "全部", subject: "数学", teacher: "94" },
  { grade: "全部", subject: "数学", teacher: "95" },
  { grade: "全部", subject: "物理", teacher: "99" },
  { grade: "全部", subject: "物理", teacher: "100" },
  { grade: "全部", subject: "物理", teacher: "101" },
  { grade: "全部", subject: "物理", teacher: "103" },
  { grade: "全部", subject: "数学", teacher: "105" },
  { grade: "全部", subject: "生物", teacher: "106" },
  { grade: "全部", subject: "英语", teacher: "107" },
  { grade: "全部", subject: "语文", teacher: "108" },
  { grade: "全部", subject: "英语", teacher: "113" },
  { grade: "全部", subject: "语文", teacher: "115" },
  { grade: "全部", subject: "化学", teacher: "124" },
  { grade: "全部", subject: "数学", teacher: "138" },
  { grade: "全部", subject: "英语", teacher: "143" },
  { grade: "全部", subject: "数学", teacher: "144" },
  { grade: "全部", subject: "英语", teacher: "145" },
  { grade: "全部", subject: "语文", teacher: "146" },
  { grade: "全部", subject: "物理", teacher: "147" },
  { grade: "全部", subject: "化学", teacher: "148" },
  { grade: "全部", subject: "地理", teacher: "149" },
  { grade: "全部", subject: "英语", teacher: "4" },
  { grade: "全部", subject: "语文", teacher: "18" },
  { grade: "全部", subject: "数学", teacher: "19" },
  { grade: "全部", subject: "数学", teacher: "29" },
  { grade: "全部", subject: "语文", teacher: "155" },
  { grade: "全部", subject: "语文", teacher: "1" },
  { grade: "全部", subject: "语文", teacher: "14" },
  { grade: "全部", subject: "数学", teacher: "25" },
  { grade: "全部", subject: "语文", teacher: "150" },
  { grade: "全部", subject: "数学", teacher: "151" },
  { grade: "全部", subject: "编程", teacher: "152" },
  { grade: "全部", subject: "科学", teacher: "153" },
  { grade: "全部", subject: "科学", teacher: "154" },
  { grade: "全部", subject: "数学", teacher: "2" },
  { grade: "全部", subject: "英语", teacher: "6" },
  { grade: "全部", subject: "数学", teacher: "12" },
  { grade: "全部", subject: "语文", teacher: "15" },
  { grade: "全部", subject: "语文", teacher: "16" },
  { grade: "全部", subject: "英语", teacher: "20" },
  { grade: "全部", subject: "英语", teacher: "21" },
  { grade: "全部", subject: "数学", teacher: "24" },
  { grade: "全部", subject: "语文", teacher: "5" },
  { grade: "全部", subject: "语文", teacher: "8" },
  { grade: "全部", subject: "语文", teacher: "9" },
  { grade: "全部", subject: "数学", teacher: "10" },
  { grade: "全部", subject: "数学", teacher: "28" },
  { grade: "全部", subject: "英语", teacher: "30" },
  { grade: "全部", subject: "数学", teacher: "32" },
  { grade: "全部", subject: "科学", teacher: "157" },
  { grade: "全部", subject: "科学", teacher: "158" }
];

var fortissimo = [
  {
    name: "周也丁",
    school: "长郡月亮岛学校",
    level: "长沙市前十",
    type: "fortissimo"
  },
  {
    name: "姜文博",
    school: "肇东市第七中学",
    level: "肇东市前十",
    type: "fortissimo"
  },
  {
    name: "朱迅",
    school: "萧县实验中学",
    level: "宿州市前十",
    type: "fortissimo"
  },
  {
    name: "金熙哲",
    school: "汤原县第一中学",
    level: "佳木斯市前十",
    type: "fortissimo"
  }
];
var cf = [
  {
    name: "裴慧莹",
    school: "曲阜市实验学校",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "申长硕",
    school: "李僧固初级中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "孟意凡",
    school: "福安中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "何超仪",
    school: "福建省宁化第六中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "李一杰",
    school: "溧阳市上兴中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "罗文炜",
    school: "永安市第二中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "谢菲",
    school: "广州市天荣中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "开元",
    school: "北京市广渠门中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "赵文钰",
    school: "旗城学校",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "许圣思",
    school: "黑龙江哈尔滨松北区对青山镇第一中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "王灿",
    school: "康驿镇第一中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "何娥娥",
    school: "神木市锦界初级中学",
    level: "全校前十",
    type: "cf"
  },
  {
    name: "高淼",
    school: "崇庆中学附属初中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "姚明雨",
    school: "南充市长乐初级中学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "邵逸轩",
    school: "温州市龙湾区外国语学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "彭馨钰",
    school: "乐山市第五中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "马端廷",
    school: "万达中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈俊宇",
    school: "江苏省大丰区实验初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李泽亮",
    school: "馆陶县陶山中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "黄语欣",
    school: "新都区柏水中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘佳琦",
    school: "重庆实验外国语学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张宁",
    school: "江苏省南通市如皋市磨头镇初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "孙朋雨",
    school: "沧州市第八中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "王佳怡",
    school: "邯郸市丛台区新联防中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈奕璇",
    school: "日照市海曲中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "曹欣怡",
    school: "江苏省启东市开发区中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "艾佳欣",
    school: "攸县三中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "杨靓颖",
    school: "都江堰市柳街中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张一鸣",
    school: "宁波市曙光中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "宋雨琳",
    school: "合肥市第四十二中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘昀铮",
    school: "大庆市第四十六中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈辰",
    school: "兰陵县第三中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "鲍亮亮",
    school: "胡陈乡初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "王嘉琦",
    school: "湖北省十堰市实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "赵馨怡",
    school: "绵阳东辰国际学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈蕾",
    school: "攸县鸾山中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "熊馨",
    school: "绍兴中国轻纺城中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "邵子琦",
    school: "白山市第六中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "潘爽",
    school: "龙泉市第三中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈宏烨",
    school: "江门市景贤学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "祝天予",
    school: "湖北省武汉市江夏区第一初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李金豪",
    school: "吴江区实验初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李诗韵",
    school: "大同市第一中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "王婧羽",
    school: "舟山市东海中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "潘祥瑜",
    school: "广东省湛江市廉江和寮镇第一初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "韩艺冰",
    school: "河北省唐山市迁安市第三初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "秦殊涵",
    school: "十堰市实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张瑞麒",
    school: "金华市南苑中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "季雨薇",
    school: "海安海陵中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "谷晓芳",
    school: "鹿城实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "肖一舰",
    school: "建宁实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "何文星",
    school: "杭州市余杭区中泰中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "邹继涵",
    school: "大庆市三永学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "沈磊",
    school: "房县七河初中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "汤艳君",
    school: "石花镇中心学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "周彦希",
    school: "陬市镇中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "邵麟婷",
    school: "四川师大附中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "何宇琦",
    school: "四川师范大学附属中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "岑欣旖",
    school: "绵阳东辰国际学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张以诺",
    school: "惠州市惠阳区惠高附属实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈思玉",
    school: "崇庆中学附属初中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "赵南哲",
    school: "无锡市大桥实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "杨梓彤",
    school: "郓城县程屯镇初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "董乃绮",
    school: "山东省日照市新营中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "杨扬",
    school: "兰州市天庆实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "王钰刚",
    school: "中山市火炬高新技术产业开发区第一中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "汪雅如",
    school: "陵城区第二中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "林怡翔",
    school: "金荷中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "邝昂",
    school: "韶关市浈江区风采实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘培名",
    school: "吉林省长春市净月区净月实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "梁释文",
    school: "实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "凌潇楠",
    school: "南京市金陵汇文中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "朱云峰",
    school: "莱卡恒昇中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "杨金金",
    school: "重庆市丰都中学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "蒋奥洋",
    school: "四川省成都市龙泉驿区同安中学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张馨幻",
    school: "成都市玉林中学(石羊校区)",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李泽坤",
    school: "北京市海淀区理工附中分校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "何梓欣",
    school: "枫溪区云光中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘家宝",
    school: "湖南省邵阳市隆回县九龙学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘科显",
    school: "唐山市第二十七中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李祉璇",
    school: "山西省阳泉市盂县第二中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "喻言",
    school: "武汉市第三寄宿中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李金莉",
    school: "高州市华侨中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "程嘉文",
    school: "九江市第十一中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "尤亦勇",
    school: "淮北市梅苑学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "谭乐琪",
    school: "广州市增城区中新中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "冀嘉玮",
    school: "山西省晋中市榆次区第九中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "王婧",
    school: "长春市第八十二中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "吴淑旻",
    school: "龙泉中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张乐瑶",
    school: "翠园中学初中部",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "欧阳清宇",
    school: "合肥市五十中新校天鹅湖校区",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李娜",
    school: "大北涧沽镇中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "谭志龙",
    school: "广丰新实中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "莫雅璐",
    school: "桂林市逸仙中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张艺缘",
    school: "沂新中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "王淑厅",
    school: "万柏林区第三中学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "马烨培",
    school: "广州市真光实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "林秋韵",
    school: "深圳市宝安区文汇学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李健娇",
    school: "长沙县开慧镇开慧中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈智鑫",
    school: "韶山市实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "梁建湖",
    school: "三都县第三中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李洁",
    school: "珠海市第十一中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "高宇玥",
    school: "山西省太原市古交市第十二中学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "唐雨鑫",
    school: "珠海市红旗中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "姚添耀",
    school: "汕头市潮阳金培学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "肖雄",
    school: "湖北省考感市汉川西江中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "谢茂铭",
    school: "赣州市南康区第五中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "杨姝钰",
    school: "兰州市第八十二中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "巫琳楷",
    school: "新余市第一中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "郑涵蕊",
    school: "福州黎明中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈豪豪",
    school: "兴义市阳光书院",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李嘉明",
    school: "黄山市黄山区乌石中心学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李佳恩",
    school: "武汉市育才中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘峰旭",
    school: "肇东市第七中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "辛凯阳",
    school: "深圳市福田区上步中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘彦伶",
    school: "昆明实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "龙熠",
    school: "莲塘五中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "谢明宇",
    school: "二中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "宋阳樊",
    school: "下村镇初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈睿杰",
    school: "武汉英格中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘乐心",
    school: "十堰市第二中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "闫佳明",
    school: "甘南州合作二中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李朋育",
    school: "河南省安阳市林州市陵阳镇初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "萨娅·赛立克",
    school: "乌鲁木齐市幸福中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李奕霖",
    school: "南充市第一中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "孙祺泰",
    school: "日照市新营中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "何文焕",
    school: "高州市分界第一中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "杨梦园",
    school: "刘店镇第一初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "赖俊",
    school: "于都县第二实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "陈琳",
    school: "电白春华学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "许怡婷",
    school: "庞村三中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "刘知非",
    school: "河南省郑州市豫翔实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "金欣",
    school: "邵阳市湘郡铭志学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李晓烨",
    school: "兰州东方学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "郭瀛",
    school: "赣州三中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "李宗谕",
    school: "南宁市天桃实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "孙雨凡",
    school: "辉县市第一初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "沈明玉",
    school: "宿州市第九中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "王浩天",
    school: "马鞍山二中实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "施梦雨",
    school: "芜湖市善瑞中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "卢锴",
    school: "广州市西关培英中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张灿",
    school: "海南省万宁市新中初级中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张宗杰",
    school: "新都第四中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "向阳佳琪",
    school: "新乡市一中实验学校",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "许远航",
    school: "双城区希勤乡中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "康洺浩",
    school: "巴州石油一中",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "张瑞麟",
    school: "金华市南苑中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "路言",
    school: "怀远实验中学",
    level: "被省重点高中录取",
    type: "cf"
  },
  {
    name: "章希瑶",
    school: "江西省第六中学",
    level: "被省重点高中录取",
    type: "cf"
  }
];
var ry = [
  {
    name: "张环",
    school: "东莞市南开实验学校",
    level: "单科满分",
    type: "ry"
  },
  {
    name: "白欢欢",
    school: "湖南省湘西自治州龙山县第二中学",
    level: "单科满分",
    type: "ry"
  },
  {
    name: "邓亮",
    school: "灰山港镇中学",
    level: "全校前二十",
    type: "ry"
  },
  {
    name: "汤旭",
    school: "浙江省湖州市长兴县洪桥逸夫中学",
    level: "全校前二十",
    type: "ry"
  },
  {
    name: "朱小曼",
    school: "佛冈县大陂中学",
    level: "全校前二十",
    type: "ry"
  },
  {
    name: "李徐",
    school: "深圳市南山区前海学校",
    level: "单科满分",
    type: "ry"
  },
  {
    name: "李倩",
    school: "沙雅二中",
    level: "全校前二十",
    type: "ry"
  },
  {
    name: "陈冠文",
    school: "深圳市宝安区文汇学校",
    level: "单科满分",
    type: "ry"
  },
  {
    name: "李思聪",
    school: "东海县实验中学",
    level: "单科满分",
    type: "ry"
  },
  {
    name: "张思灵",
    school: "福田区彩田学校",
    level: "单科满分",
    type: "ry"
  },
  {
    name: "张永漩",
    school: "深圳市南山区第二外国语学校集团学府中学",
    level: "单科满分",
    type: "ry"
  }
];
var cj = [
  {
    name: "王宋子瑜",
    school: "石家庄市41中",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "付阳阳",
    school: "兰州市第十一中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "谢达辉",
    school: "沙石中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "吴杭聪",
    school: "鹿峰中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "陈建希",
    school: "湛江市第二中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "邱瀚萱",
    school: "安远县第三中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "屠煜晴",
    school: "江苏省邳州市运河中学初中部",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "张婉苗",
    school: "凯里五中",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "王倩怡",
    school: "东岗镇一中",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "吴天裔",
    school: "辽河油田沈采初级中学",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "杨文达",
    school: "第三十六中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "阮麟淇",
    school: "二十九中",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "龙俊宇",
    school: "益师艺术实验学校",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "陈希哲",
    school: "沙溪镇初级中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "林欢婷",
    school: "福州江南水都中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "陆雅婷",
    school: "深圳市西乡中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "郭乐怡",
    school: "福州市第十一中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "沈基宏",
    school: "宁波市镇海区仁爱中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "黄逸楠",
    school: "安徽无为第二中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "范子蕾",
    school: "广州市江南外国语学校",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "刘吉蕊",
    school: "龙潭中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "黄慧",
    school: "麻城思源实验学校",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "林子怡",
    school: "深圳市桂园中学",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "张远昊橦",
    school: "佛山华英学校",
    level: "中考总分较一模进步30分以上",
    type: "cj"
  },
  {
    name: "王子木",
    school: "北京汇文中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  },
  {
    name: "何紫杨",
    school: "德庆县莫村中学",
    level: "中考单科较一模进步10分以上",
    type: "cj"
  }
];
export default {
  _videosData: function() {
    return _videos;
  },
  _teachersData: function() {
    return _teachers;
  },
  _vconditionsData: function() {
    return vconditions;
  },
  _tconditionsData: function() {
    return tconditions;
  },
  _fortissimo: function() {
    return fortissimo;
  },
  _cf: function() {
    return cf;
  },
  _ry: function() {
    return ry;
  },
  _cj: function() {
    return cj;
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/json/data.js
// module id = null
// module chunks = 